(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea1c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea1c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bTB0U", function(module, exports) {
module.exports = function() {
    if (this.options.debug && console) {
        if (typeof console.log === "function") console.log.apply(console, arguments);
        else if (console.log) console.log(arguments);
    }
};

});

parcelRegister("6l3E4", function(module, exports) {
var $49d78820ac9bfdb7$var$attrState = "data-pjax-state";
module.exports = function(el) {
    switch(el.tagName.toLowerCase()){
        case "a":
            // only attach link if el does not already have link attached
            if (!el.hasAttribute($49d78820ac9bfdb7$var$attrState)) this.attachLink(el);
            break;
        case "form":
            // only attach link if el does not already have link attached
            if (!el.hasAttribute($49d78820ac9bfdb7$var$attrState)) this.attachForm(el);
            break;
        default:
            throw "Pjax can only be applied on <a> or <form> submit";
    }
};

});

parcelRegister("4Qp2J", function(module, exports) {

var $fcCTJ = parcelRequire("fcCTJ");

var $8kgSr = parcelRequire("8kgSr");
var $386f71c9915ec15b$var$attrState = "data-pjax-state";
var $386f71c9915ec15b$var$linkAction = function(el, event) {
    if ($386f71c9915ec15b$var$isDefaultPrevented(event)) return;
    // Since loadUrl modifies options and we may add our own modifications below,
    // clone it so the changes don't persist
    var options = $8kgSr(this.options);
    var attrValue = $386f71c9915ec15b$var$checkIfShouldAbort(el, event);
    if (attrValue) {
        el.setAttribute($386f71c9915ec15b$var$attrState, attrValue);
        return;
    }
    event.preventDefault();
    // don’t do "nothing" if user try to reload the page by clicking the same link twice
    if (this.options.currentUrlFullReload && el.href === window.location.href.split("#")[0]) {
        el.setAttribute($386f71c9915ec15b$var$attrState, "reload");
        this.reload();
        return;
    }
    el.setAttribute($386f71c9915ec15b$var$attrState, "load");
    options.triggerElement = el;
    this.loadUrl(el.href, options);
};
function $386f71c9915ec15b$var$checkIfShouldAbort(el, event) {
    // Don’t break browser special behavior on links (like page in new window)
    if (event.which > 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return "modifier";
    // we do test on href now to prevent unexpected behavior if for some reason
    // user have href that can be dynamically updated
    // Ignore external links.
    if (el.protocol !== window.location.protocol || el.host !== window.location.host) return "external";
    // Ignore anchors on the same page (keep native behavior)
    if (el.hash && el.href.replace(el.hash, "") === window.location.href.replace(location.hash, "")) return "anchor";
    // Ignore empty anchor "foo.html#"
    if (el.href === window.location.href.split("#")[0] + "#") return "anchor-empty";
}
var $386f71c9915ec15b$var$isDefaultPrevented = function(event) {
    return event.defaultPrevented || event.returnValue === false;
};
module.exports = function(el) {
    var that = this;
    el.setAttribute($386f71c9915ec15b$var$attrState, "");
    $fcCTJ(el, "click", function(event) {
        $386f71c9915ec15b$var$linkAction.call(that, el, event);
    });
    $fcCTJ(el, "keyup", (function(event) {
        if (event.keyCode === 13) $386f71c9915ec15b$var$linkAction.call(that, el, event);
    }).bind(this));
};

});
parcelRegister("fcCTJ", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");
module.exports = function(els, events, listener, useCapture) {
    events = typeof events === "string" ? events.split(" ") : events;
    events.forEach(function(e) {
        $fRaLx(els, function(el) {
            el.addEventListener(e, listener, useCapture);
        });
    });
};

});
parcelRegister("fRaLx", function(module, exports) {
/* global HTMLCollection: true */ module.exports = function(els, fn, context) {
    if (els instanceof HTMLCollection || els instanceof NodeList || els instanceof Array) return Array.prototype.forEach.call(els, fn, context);
    // assume simple DOM element
    return fn.call(context, els);
};

});


parcelRegister("8kgSr", function(module, exports) {
module.exports = function(obj) {
    /* istanbul ignore if */ if (null === obj || "object" !== typeof obj) return obj;
    var copy = obj.constructor();
    for(var attr in obj)if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    return copy;
};

});


parcelRegister("crAW0", function(module, exports) {

var $fcCTJ = parcelRequire("fcCTJ");

var $8kgSr = parcelRequire("8kgSr");
var $90f4a81510e65f6a$var$attrState = "data-pjax-state";
var $90f4a81510e65f6a$var$formAction = function(el, event) {
    if ($90f4a81510e65f6a$var$isDefaultPrevented(event)) return;
    // Since loadUrl modifies options and we may add our own modifications below,
    // clone it so the changes don't persist
    var options = $8kgSr(this.options);
    // Initialize requestOptions
    options.requestOptions = {
        requestUrl: el.getAttribute("action") || window.location.href,
        requestMethod: el.getAttribute("method") || "GET"
    };
    // create a testable virtual link of the form action
    var virtLinkElement = document.createElement("a");
    virtLinkElement.setAttribute("href", options.requestOptions.requestUrl);
    var attrValue = $90f4a81510e65f6a$var$checkIfShouldAbort(virtLinkElement, options);
    if (attrValue) {
        el.setAttribute($90f4a81510e65f6a$var$attrState, attrValue);
        return;
    }
    event.preventDefault();
    if (el.enctype === "multipart/form-data") options.requestOptions.formData = new FormData(el);
    else options.requestOptions.requestParams = $90f4a81510e65f6a$var$parseFormElements(el);
    el.setAttribute($90f4a81510e65f6a$var$attrState, "submit");
    options.triggerElement = el;
    this.loadUrl(virtLinkElement.href, options);
};
function $90f4a81510e65f6a$var$parseFormElements(el) {
    var requestParams = [];
    var formElements = el.elements;
    for(var i = 0; i < formElements.length; i++){
        var element = formElements[i];
        var tagName = element.tagName.toLowerCase();
        // jscs:disable disallowImplicitTypeConversion
        if (!!element.name && element.attributes !== undefined && tagName !== "button") {
            // jscs:enable disallowImplicitTypeConversion
            var type = element.attributes.type;
            if (!type || type.value !== "checkbox" && type.value !== "radio" || element.checked) {
                // Build array of values to submit
                var values = [];
                if (tagName === "select") {
                    var opt;
                    for(var j = 0; j < element.options.length; j++){
                        opt = element.options[j];
                        if (opt.selected && !opt.disabled) values.push(opt.hasAttribute("value") ? opt.value : opt.text);
                    }
                } else values.push(element.value);
                for(var k = 0; k < values.length; k++)requestParams.push({
                    name: encodeURIComponent(element.name),
                    value: encodeURIComponent(values[k])
                });
            }
        }
    }
    return requestParams;
}
function $90f4a81510e65f6a$var$checkIfShouldAbort(virtLinkElement, options) {
    // Ignore external links.
    if (virtLinkElement.protocol !== window.location.protocol || virtLinkElement.host !== window.location.host) return "external";
    // Ignore click if we are on an anchor on the same page
    if (virtLinkElement.hash && virtLinkElement.href.replace(virtLinkElement.hash, "") === window.location.href.replace(location.hash, "")) return "anchor";
    // Ignore empty anchor "foo.html#"
    if (virtLinkElement.href === window.location.href.split("#")[0] + "#") return "anchor-empty";
    // if declared as a full reload, just normally submit the form
    if (options.currentUrlFullReload && virtLinkElement.href === window.location.href.split("#")[0]) return "reload";
}
var $90f4a81510e65f6a$var$isDefaultPrevented = function(event) {
    return event.defaultPrevented || event.returnValue === false;
};
module.exports = function(el) {
    var that = this;
    el.setAttribute($90f4a81510e65f6a$var$attrState, "");
    $fcCTJ(el, "submit", function(event) {
        $90f4a81510e65f6a$var$formAction.call(that, el, event);
    });
};

});

parcelRegister("duhL3", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");
module.exports = function(selectors, cb, context, DOMcontext) {
    DOMcontext = DOMcontext || document;
    selectors.forEach(function(selector) {
        $fRaLx(DOMcontext.querySelectorAll(selector), cb, context);
    });
};

});

parcelRegister("loXQO", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");

var $7RZTV = parcelRequire("7RZTV");
module.exports = function(switches, switchesOptions, selectors, fromEl, toEl, options) {
    var switchesQueue = [];
    selectors.forEach(function(selector) {
        var newEls = fromEl.querySelectorAll(selector);
        var oldEls = toEl.querySelectorAll(selector);
        if (this.log) this.log("Pjax switch", selector, newEls, oldEls);
        if (newEls.length !== oldEls.length) throw "DOM doesn\u2019t look the same on new loaded page: \u2019" + selector + "\u2019 - new " + newEls.length + ", old " + oldEls.length;
        $fRaLx(newEls, function(newEl, i) {
            var oldEl = oldEls[i];
            if (this.log) this.log("newEl", newEl, "oldEl", oldEl);
            var callback = switches[selector] ? switches[selector].bind(this, oldEl, newEl, options, switchesOptions[selector]) : $7RZTV.outerHTML.bind(this, oldEl, newEl, options);
            switchesQueue.push(callback);
        }, this);
    }, this);
    this.state.numPendingSwitches = switchesQueue.length;
    switchesQueue.forEach(function(queuedSwitch) {
        queuedSwitch();
    });
};

});
parcelRegister("7RZTV", function(module, exports) {

var $fcCTJ = parcelRequire("fcCTJ");
module.exports = {
    outerHTML: function(oldEl, newEl) {
        oldEl.outerHTML = newEl.outerHTML;
        this.onSwitch();
    },
    innerHTML: function(oldEl, newEl) {
        oldEl.innerHTML = newEl.innerHTML;
        if (newEl.className === "") oldEl.removeAttribute("class");
        else oldEl.className = newEl.className;
        this.onSwitch();
    },
    switchElementsAlt: function(oldEl, newEl) {
        oldEl.innerHTML = newEl.innerHTML;
        // Copy attributes from the new element to the old one
        if (newEl.hasAttributes()) {
            var attrs = newEl.attributes;
            for(var i = 0; i < attrs.length; i++)oldEl.attributes.setNamedItem(attrs[i].cloneNode());
        }
        this.onSwitch();
    },
    // Equivalent to outerHTML(), but doesn't require switchElementsAlt() for <head> and <body>
    replaceNode: function(oldEl, newEl) {
        oldEl.parentNode.replaceChild(newEl, oldEl);
        this.onSwitch();
    },
    sideBySide: function(oldEl, newEl, options, switchOptions) {
        var forEach = Array.prototype.forEach;
        var elsToRemove = [];
        var elsToAdd = [];
        var fragToAppend = document.createDocumentFragment();
        var animationEventNames = "animationend webkitAnimationEnd MSAnimationEnd oanimationend";
        var animatedElsNumber = 0;
        var sexyAnimationEnd = (function(e) {
            if (e.target !== e.currentTarget) // end triggered by an animation on a child
            return;
            animatedElsNumber--;
            if (animatedElsNumber <= 0 && elsToRemove) {
                elsToRemove.forEach(function(el) {
                    // browsing quickly can make the el
                    // already removed by last page update ?
                    if (el.parentNode) el.parentNode.removeChild(el);
                });
                elsToAdd.forEach(function(el) {
                    el.className = el.className.replace(el.getAttribute("data-pjax-classes"), "");
                    el.removeAttribute("data-pjax-classes");
                });
                elsToAdd = null; // free memory
                elsToRemove = null; // free memory
                // this is to trigger some repaint (example: picturefill)
                this.onSwitch();
            }
        }).bind(this);
        switchOptions = switchOptions || {};
        forEach.call(oldEl.childNodes, function(el) {
            elsToRemove.push(el);
            if (el.classList && !el.classList.contains("js-Pjax-remove")) {
                // for fast switch, clean element that just have been added, & not cleaned yet.
                if (el.hasAttribute("data-pjax-classes")) {
                    el.className = el.className.replace(el.getAttribute("data-pjax-classes"), "");
                    el.removeAttribute("data-pjax-classes");
                }
                el.classList.add("js-Pjax-remove");
                if (switchOptions.callbacks && switchOptions.callbacks.removeElement) switchOptions.callbacks.removeElement(el);
                if (switchOptions.classNames) el.className += " " + switchOptions.classNames.remove + " " + (options.backward ? switchOptions.classNames.backward : switchOptions.classNames.forward);
                animatedElsNumber++;
                $fcCTJ(el, animationEventNames, sexyAnimationEnd, true);
            }
        });
        forEach.call(newEl.childNodes, function(el) {
            if (el.classList) {
                var addClasses = "";
                if (switchOptions.classNames) addClasses = " js-Pjax-add " + switchOptions.classNames.add + " " + (options.backward ? switchOptions.classNames.forward : switchOptions.classNames.backward);
                if (switchOptions.callbacks && switchOptions.callbacks.addElement) switchOptions.callbacks.addElement(el);
                el.className += addClasses;
                el.setAttribute("data-pjax-classes", addClasses);
                elsToAdd.push(el);
                fragToAppend.appendChild(el);
                animatedElsNumber++;
                $fcCTJ(el, animationEventNames, sexyAnimationEnd, true);
            }
        });
        // pass all className of the parent
        oldEl.className = newEl.className;
        oldEl.appendChild(fragToAppend);
    }
};

});


parcelRegister("8BsJe", function(module, exports) {

var $cukYX = parcelRequire("cukYX");
module.exports = function(request) {
    if (request && request.readyState < 4) {
        request.onreadystatechange = $cukYX;
        request.abort();
    }
};

});
parcelRegister("cukYX", function(module, exports) {
module.exports = function() {};

});


parcelRegister("aBk3q", function(module, exports) {

var $KUIr8 = parcelRequire("KUIr8");
module.exports = function(location, options, callback) {
    options = options || {};
    var queryString;
    var requestOptions = options.requestOptions || {};
    var requestMethod = (requestOptions.requestMethod || "GET").toUpperCase();
    var requestParams = requestOptions.requestParams || null;
    var formData = requestOptions.formData || null;
    var requestPayload = null;
    var request = new XMLHttpRequest();
    var timeout = options.timeout || 0;
    request.onreadystatechange = function() {
        if (request.readyState === 4) {
            if (request.status === 200) callback(request.responseText, request, location, options);
            else if (request.status !== 0) callback(null, request, location, options);
        }
    };
    request.onerror = function(e) {
        console.log(e);
        callback(null, request, location, options);
    };
    request.ontimeout = function() {
        callback(null, request, location, options);
    };
    // Prepare the request payload for forms, if available
    if (requestParams && requestParams.length) {
        // Build query string
        queryString = requestParams.map(function(param) {
            return param.name + "=" + param.value;
        }).join("&");
        switch(requestMethod){
            case "GET":
                // Reset query string to avoid an issue with repeat submissions where checkboxes that were
                // previously checked are incorrectly preserved
                location = location.split("?")[0];
                // Append new query string
                location += "?" + queryString;
                break;
            case "POST":
                // Send query string as request payload
                requestPayload = queryString;
                break;
        }
    } else if (formData) requestPayload = formData;
    // Add a timestamp as part of the query string if cache busting is enabled
    if (options.cacheBust) location = $KUIr8(location, "t", Date.now());
    request.open(requestMethod, location, true);
    request.timeout = timeout;
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.setRequestHeader("X-PJAX", "true");
    request.setRequestHeader("X-PJAX-Selectors", JSON.stringify(options.selectors));
    // Send the proper header information for POST forms
    if (requestPayload && requestMethod === "POST" && !formData) request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    request.send(requestPayload);
    return request;
};

});
parcelRegister("KUIr8", function(module, exports) {
module.exports = function(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) return uri.replace(re, "$1" + key + "=" + value + "$2");
    else return uri + separator + key + "=" + value;
};

});


parcelRegister("3vRmN", function(module, exports) {

var $8kgSr = parcelRequire("8kgSr");

var $e36no = parcelRequire("e36no");

var $ep84Q = parcelRequire("ep84Q");
module.exports = function(responseText, request, href, options) {
    options = $8kgSr(options || this.options);
    options.request = request;
    // Fail if unable to load HTML via AJAX
    if (responseText === false) {
        $ep84Q(document, "pjax:complete pjax:error", options);
        return;
    }
    // push scroll position to history
    var currentState = window.history.state || {};
    window.history.replaceState({
        url: currentState.url || window.location.href,
        title: currentState.title || document.title,
        uid: currentState.uid || $e36no(),
        scrollPos: [
            document.documentElement.scrollLeft || document.body.scrollLeft,
            document.documentElement.scrollTop || document.body.scrollTop
        ]
    }, document.title, window.location.href);
    // Check for redirects
    var oldHref = href;
    if (request.responseURL) {
        if (href !== request.responseURL) href = request.responseURL;
    } else if (request.getResponseHeader("X-PJAX-URL")) href = request.getResponseHeader("X-PJAX-URL");
    else if (request.getResponseHeader("X-XHR-Redirected-To")) href = request.getResponseHeader("X-XHR-Redirected-To");
    // Add back the hash if it was removed
    var a = document.createElement("a");
    a.href = oldHref;
    var oldHash = a.hash;
    a.href = href;
    if (oldHash && !a.hash) {
        a.hash = oldHash;
        href = a.href;
    }
    this.state.href = href;
    this.state.options = options;
    try {
        this.loadContent(responseText, options);
    } catch (e) {
        $ep84Q(document, "pjax:error", options);
        if (!this.options.debug) {
            if (console && console.error) console.error("Pjax switch fail: ", e);
            return this.latestChance(href);
        } else throw e;
    }
};

});
parcelRegister("e36no", function(module, exports) {
module.exports = function() {
    var counter = 0;
    return function() {
        var id = "pjax" + new Date().getTime() + "_" + counter;
        counter++;
        return id;
    };
}();

});

parcelRegister("ep84Q", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");
module.exports = function(els, events, opts) {
    events = typeof events === "string" ? events.split(" ") : events;
    events.forEach(function(e) {
        var event;
        event = document.createEvent("HTMLEvents");
        event.initEvent(e, true, true);
        event.eventName = e;
        if (opts) Object.keys(opts).forEach(function(key) {
            event[key] = opts[key];
        });
        $fRaLx(els, function(el) {
            var domFix = false;
            if (!el.parentNode && el !== document && el !== window) {
                // THANK YOU IE (9/10/11)
                // dispatchEvent doesn't work if the element is not in the DOM
                domFix = true;
                document.body.appendChild(el);
            }
            el.dispatchEvent(event);
            if (domFix) el.parentNode.removeChild(el);
        });
    });
};

});


parcelRegister("cODYy", function(module, exports) {
module.exports = function() {
    // Borrowed wholesale from https://github.com/defunkt/jquery-pjax
    return window.history && window.history.pushState && window.history.replaceState && // pushState isn’t reliable on iOS until 5.
    !navigator.userAgent.match(/((iPod|iPhone|iPad).+\bOS\s+[1-4]\D|WebApps\/.+CFNetwork)/);
};

});

parcelRegister("8YGgm", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("t1juM")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("ivqFp")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("t1juM")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("8dqiK")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("cDLKH")).createPopper; });

var $9sBMA = parcelRequire("9sBMA");

var $kCPJq = parcelRequire("kCPJq");

var $t1juM = parcelRequire("t1juM");
var $ivqFp = parcelRequire("ivqFp");

var $8dqiK = parcelRequire("8dqiK");

var $cDLKH = parcelRequire("cDLKH");
$parcel$exportWildcard(module.exports, $9sBMA);
$parcel$exportWildcard(module.exports, $kCPJq);

});
parcelRegister("9sBMA", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $6e3409677f3554d3$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $6e3409677f3554d3$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $6e3409677f3554d3$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $6e3409677f3554d3$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $6e3409677f3554d3$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $6e3409677f3554d3$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $6e3409677f3554d3$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $6e3409677f3554d3$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $6e3409677f3554d3$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $6e3409677f3554d3$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $6e3409677f3554d3$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $6e3409677f3554d3$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $6e3409677f3554d3$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $6e3409677f3554d3$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $6e3409677f3554d3$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $6e3409677f3554d3$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $6e3409677f3554d3$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $6e3409677f3554d3$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $6e3409677f3554d3$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $6e3409677f3554d3$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $6e3409677f3554d3$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $6e3409677f3554d3$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $6e3409677f3554d3$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $6e3409677f3554d3$export$d087d3878fdf71d5; });
var $6e3409677f3554d3$export$1e95b668f3b82d = "top";
var $6e3409677f3554d3$export$40e543e69a8b3fbb = "bottom";
var $6e3409677f3554d3$export$79ffe56a765070d2 = "right";
var $6e3409677f3554d3$export$eabcd2c8791e7bf4 = "left";
var $6e3409677f3554d3$export$dfb5619354ba860 = "auto";
var $6e3409677f3554d3$export$aec2ce47c367b8c3 = [
    $6e3409677f3554d3$export$1e95b668f3b82d,
    $6e3409677f3554d3$export$40e543e69a8b3fbb,
    $6e3409677f3554d3$export$79ffe56a765070d2,
    $6e3409677f3554d3$export$eabcd2c8791e7bf4
];
var $6e3409677f3554d3$export$b3571188c770cc5a = "start";
var $6e3409677f3554d3$export$bd5df0f255a350f8 = "end";
var $6e3409677f3554d3$export$390fd549c5303b4d = "clippingParents";
var $6e3409677f3554d3$export$d7b7311ec04a3e8f = "viewport";
var $6e3409677f3554d3$export$ae5ab1c730825774 = "popper";
var $6e3409677f3554d3$export$ca50aac9f3ba507f = "reference";
var $6e3409677f3554d3$export$368f9a87e87fa4e1 = /*#__PURE__*/ $6e3409677f3554d3$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $6e3409677f3554d3$export$b3571188c770cc5a,
        placement + "-" + $6e3409677f3554d3$export$bd5df0f255a350f8
    ]);
}, []);
var $6e3409677f3554d3$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($6e3409677f3554d3$export$aec2ce47c367b8c3, [
    $6e3409677f3554d3$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $6e3409677f3554d3$export$b3571188c770cc5a,
        placement + "-" + $6e3409677f3554d3$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $6e3409677f3554d3$export$421679a7c3d56e = "beforeRead";
var $6e3409677f3554d3$export$aafa59e2e03f2942 = "read";
var $6e3409677f3554d3$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $6e3409677f3554d3$export$c65e99957a05207c = "beforeMain";
var $6e3409677f3554d3$export$f22da7240b7add18 = "main";
var $6e3409677f3554d3$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $6e3409677f3554d3$export$8d4d2d70e7d46032 = "beforeWrite";
var $6e3409677f3554d3$export$68d8715fc104d294 = "write";
var $6e3409677f3554d3$export$70a6e5159acce2e6 = "afterWrite";
var $6e3409677f3554d3$export$d087d3878fdf71d5 = [
    $6e3409677f3554d3$export$421679a7c3d56e,
    $6e3409677f3554d3$export$aafa59e2e03f2942,
    $6e3409677f3554d3$export$6964f6c886723980,
    $6e3409677f3554d3$export$c65e99957a05207c,
    $6e3409677f3554d3$export$f22da7240b7add18,
    $6e3409677f3554d3$export$bab79516f2d662fe,
    $6e3409677f3554d3$export$8d4d2d70e7d46032,
    $6e3409677f3554d3$export$68d8715fc104d294,
    $6e3409677f3554d3$export$70a6e5159acce2e6
];

});

parcelRegister("kCPJq", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("gy0RQ")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("d1SXy")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("i7xoL")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("7j3jV")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("bJk6k")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("iIbxA")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("hLLXp")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("bwXYi")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("7oqYt")).default; });

var $gy0RQ = parcelRequire("gy0RQ");

var $d1SXy = parcelRequire("d1SXy");

var $i7xoL = parcelRequire("i7xoL");

var $7j3jV = parcelRequire("7j3jV");

var $bJk6k = parcelRequire("bJk6k");

var $iIbxA = parcelRequire("iIbxA");

var $hLLXp = parcelRequire("hLLXp");

var $bwXYi = parcelRequire("bwXYi");

var $7oqYt = parcelRequire("7oqYt");

});
parcelRegister("gy0RQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c07e8eca0d7372$export$2e2bcd8739ae039; });

var $gNNyC = parcelRequire("gNNyC");

var $4yey3 = parcelRequire("4yey3");
// and applies them to the HTMLElements such as popper and arrow
function $c0c07e8eca0d7372$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $4yey3.isHTMLElement)(element) || !(0, $gNNyC.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $c0c07e8eca0d7372$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $4yey3.isHTMLElement)(element) || !(0, $gNNyC.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $c0c07e8eca0d7372$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $c0c07e8eca0d7372$var$applyStyles,
    effect: $c0c07e8eca0d7372$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRegister("gNNyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b7a9fe7060c226$export$2e2bcd8739ae039; });
function $c3b7a9fe7060c226$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("4yey3", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $35059f64866235ee$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $35059f64866235ee$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $35059f64866235ee$export$af51f0f06c0f328a; });

var $cYZ7h = parcelRequire("cYZ7h");
function $35059f64866235ee$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $cYZ7h.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $35059f64866235ee$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $cYZ7h.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $35059f64866235ee$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $cYZ7h.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("cYZ7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $973a7f130c9ec43f$export$2e2bcd8739ae039; });
function $973a7f130c9ec43f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("d1SXy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97c60028dd08149b$export$2e2bcd8739ae039; });

var $bjbdL = parcelRequire("bjbdL");

var $jXC8u = parcelRequire("jXC8u");

var $lwNTw = parcelRequire("lwNTw");

var $gWO4o = parcelRequire("gWO4o");

var $9M8WM = parcelRequire("9M8WM");

var $fsgwo = parcelRequire("fsgwo");

var $93Awv = parcelRequire("93Awv");

var $lkZpD = parcelRequire("lkZpD");

var $9sBMA = parcelRequire("9sBMA");
var $97c60028dd08149b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $93Awv.default)(typeof padding !== "number" ? padding : (0, $lkZpD.default)(padding, (0, $9sBMA.basePlacements)));
};
function $97c60028dd08149b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $bjbdL.default)(state.placement);
    var axis = (0, $9M8WM.default)(basePlacement);
    var isVertical = [
        (0, $9sBMA.left),
        (0, $9sBMA.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $97c60028dd08149b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $jXC8u.default)(arrowElement);
    var minProp = axis === "y" ? (0, $9sBMA.top) : (0, $9sBMA.left);
    var maxProp = axis === "y" ? (0, $9sBMA.bottom) : (0, $9sBMA.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $gWO4o.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $fsgwo.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $97c60028dd08149b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lwNTw.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $97c60028dd08149b$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $97c60028dd08149b$var$arrow,
    effect: $97c60028dd08149b$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("bjbdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83ba2c548bad33b9$export$2e2bcd8739ae039; });

function $83ba2c548bad33b9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("jXC8u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8811c053fe33463$export$2e2bcd8739ae039; });

var $iYLNX = parcelRequire("iYLNX");
function $e8811c053fe33463$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $iYLNX.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("iYLNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd12e9a555a8f685$export$2e2bcd8739ae039; });

var $4yey3 = parcelRequire("4yey3");

var $9pEtR = parcelRequire("9pEtR");

var $cYZ7h = parcelRequire("cYZ7h");

var $dXRpq = parcelRequire("dXRpq");
function $dd12e9a555a8f685$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $4yey3.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9pEtR.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9pEtR.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $4yey3.isElement)(element) ? (0, $cYZ7h.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $dXRpq.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("9pEtR", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $6da5d97298b86516$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $6da5d97298b86516$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $6da5d97298b86516$export$2077e0241d6afd3c; });
var $6da5d97298b86516$export$8960430cfd85939f = Math.max;
var $6da5d97298b86516$export$96ec731ed4dcb222 = Math.min;
var $6da5d97298b86516$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("dXRpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2aa36fa050ffe9c$export$2e2bcd8739ae039; });

var $7Lz1R = parcelRequire("7Lz1R");
function $a2aa36fa050ffe9c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $7Lz1R.default)());
}

});
parcelRegister("7Lz1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a781834fcf97823$export$2e2bcd8739ae039; });
function $5a781834fcf97823$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("lwNTw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fac34a254f26607f$export$2e2bcd8739ae039; });

var $4yey3 = parcelRequire("4yey3");
function $fac34a254f26607f$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $4yey3.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("gWO4o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c568e6f96d71ec07$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");

var $gNNyC = parcelRequire("gNNyC");

var $1eqAZ = parcelRequire("1eqAZ");

var $4yey3 = parcelRequire("4yey3");

var $fGs4b = parcelRequire("fGs4b");

var $cxf4H = parcelRequire("cxf4H");

var $7Lz1R = parcelRequire("7Lz1R");
function $c568e6f96d71ec07$var$getTrueOffsetParent(element) {
    if (!(0, $4yey3.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1eqAZ.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $c568e6f96d71ec07$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $7Lz1R.default)());
    var isIE = /Trident/i.test((0, $7Lz1R.default)());
    if (isIE && (0, $4yey3.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1eqAZ.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $cxf4H.default)(element);
    if ((0, $4yey3.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $4yey3.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $gNNyC.default)(currentNode)) < 0){
        var css = (0, $1eqAZ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $c568e6f96d71ec07$export$2e2bcd8739ae039(element) {
    var window = (0, $cYZ7h.default)(element);
    var offsetParent = $c568e6f96d71ec07$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fGs4b.default)(offsetParent) && (0, $1eqAZ.default)(offsetParent).position === "static")offsetParent = $c568e6f96d71ec07$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $gNNyC.default)(offsetParent) === "html" || (0, $gNNyC.default)(offsetParent) === "body" && (0, $1eqAZ.default)(offsetParent).position === "static")) return window;
    return offsetParent || $c568e6f96d71ec07$var$getContainingBlock(element) || window;
}

});
parcelRegister("1eqAZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e5bba94d248b9b5$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");
function $0e5bba94d248b9b5$export$2e2bcd8739ae039(element) {
    return (0, $cYZ7h.default)(element).getComputedStyle(element);
}

});

parcelRegister("fGs4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6b08cb14821c798$export$2e2bcd8739ae039; });

var $gNNyC = parcelRequire("gNNyC");
function $b6b08cb14821c798$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $gNNyC.default)(element)) >= 0;
}

});

parcelRegister("cxf4H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $920442a01184663c$export$2e2bcd8739ae039; });

var $gNNyC = parcelRequire("gNNyC");

var $eNF9s = parcelRequire("eNF9s");

var $4yey3 = parcelRequire("4yey3");
function $920442a01184663c$export$2e2bcd8739ae039(element) {
    if ((0, $gNNyC.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $4yey3.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eNF9s.default)(element) // fallback
    );
}

});
parcelRegister("eNF9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac65902612ec3259$export$2e2bcd8739ae039; });

var $4yey3 = parcelRequire("4yey3");
function $ac65902612ec3259$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $4yey3.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("9M8WM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71df897313ad6c55$export$2e2bcd8739ae039; });
function $71df897313ad6c55$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("fsgwo", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $b406495afd3242df$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $b406495afd3242df$export$86c8af6d3ef0b4a; });

var $9pEtR = parcelRequire("9pEtR");
function $b406495afd3242df$export$f28d906d67a997f3(min, value, max) {
    return (0, $9pEtR.max)(min, (0, $9pEtR.min)(value, max));
}
function $b406495afd3242df$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b406495afd3242df$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("93Awv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6980b9a5972dc4f1$export$2e2bcd8739ae039; });

var $8IvhE = parcelRequire("8IvhE");
function $6980b9a5972dc4f1$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8IvhE.default)(), paddingObject);
}

});
parcelRegister("8IvhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $658ab3189ce2447e$export$2e2bcd8739ae039; });
function $658ab3189ce2447e$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("lkZpD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f88b1a76cf5b59b4$export$2e2bcd8739ae039; });
function $f88b1a76cf5b59b4$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("i7xoL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d312c9ac7170e530$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $gWO4o = parcelRequire("gWO4o");

var $cYZ7h = parcelRequire("cYZ7h");

var $eNF9s = parcelRequire("eNF9s");

var $1eqAZ = parcelRequire("1eqAZ");

var $bjbdL = parcelRequire("bjbdL");

var $lc7d9 = parcelRequire("lc7d9");

var $9pEtR = parcelRequire("9pEtR");
var $d312c9ac7170e530$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $d312c9ac7170e530$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9pEtR.round)(x * dpr) / dpr || 0,
        y: (0, $9pEtR.round)(y * dpr) / dpr || 0
    };
}
function $d312c9ac7170e530$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $9sBMA.left);
    var sideY = (0, $9sBMA.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $gWO4o.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $cYZ7h.default)(popper)) {
            offsetParent = (0, $eNF9s.default)(popper);
            if ((0, $1eqAZ.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $9sBMA.top) || (placement === (0, $9sBMA.left) || placement === (0, $9sBMA.right)) && variation === (0, $9sBMA.end)) {
            sideY = (0, $9sBMA.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $9sBMA.left) || (placement === (0, $9sBMA.top) || placement === (0, $9sBMA.bottom)) && variation === (0, $9sBMA.end)) {
            sideX = (0, $9sBMA.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $d312c9ac7170e530$var$unsetSides);
    var _ref4 = roundOffsets === true ? $d312c9ac7170e530$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $cYZ7h.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $d312c9ac7170e530$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $bjbdL.default)(state.placement),
        variation: (0, $lc7d9.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $d312c9ac7170e530$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $d312c9ac7170e530$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d312c9ac7170e530$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $d312c9ac7170e530$var$computeStyles,
    data: {}
};

});
parcelRegister("lc7d9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e04feedb1551d9$export$2e2bcd8739ae039; });
function $f6e04feedb1551d9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("7j3jV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $551ce215a2a4b545$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");
var $551ce215a2a4b545$var$passive = {
    passive: true
};
function $551ce215a2a4b545$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $cYZ7h.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $551ce215a2a4b545$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $551ce215a2a4b545$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $551ce215a2a4b545$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $551ce215a2a4b545$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $551ce215a2a4b545$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $551ce215a2a4b545$var$effect,
    data: {}
};

});

parcelRegister("bJk6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88a37d59b97cb963$export$2e2bcd8739ae039; });

var $3RiOR = parcelRequire("3RiOR");

var $bjbdL = parcelRequire("bjbdL");

var $71NRZ = parcelRequire("71NRZ");

var $ivqFp = parcelRequire("ivqFp");

var $gvuY2 = parcelRequire("gvuY2");

var $9sBMA = parcelRequire("9sBMA");

var $lc7d9 = parcelRequire("lc7d9");
function $88a37d59b97cb963$var$getExpandedFallbackPlacements(placement) {
    if ((0, $bjbdL.default)(placement) === (0, $9sBMA.auto)) return [];
    var oppositePlacement = (0, $3RiOR.default)(placement);
    return [
        (0, $71NRZ.default)(placement),
        oppositePlacement,
        (0, $71NRZ.default)(oppositePlacement)
    ];
}
function $88a37d59b97cb963$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $bjbdL.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3RiOR.default)(preferredPlacement)
    ] : $88a37d59b97cb963$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $bjbdL.default)(placement) === (0, $9sBMA.auto) ? (0, $gvuY2.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $bjbdL.default)(placement);
        var isStartVariation = (0, $lc7d9.default)(placement) === (0, $9sBMA.start);
        var isVertical = [
            (0, $9sBMA.top),
            (0, $9sBMA.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $ivqFp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $9sBMA.right) : (0, $9sBMA.left) : isStartVariation ? (0, $9sBMA.bottom) : (0, $9sBMA.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3RiOR.default)(mainVariationSide);
        var altVariationSide = (0, $3RiOR.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $88a37d59b97cb963$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $88a37d59b97cb963$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3RiOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cf4eb790d2d2598$export$2e2bcd8739ae039; });
var $2cf4eb790d2d2598$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $2cf4eb790d2d2598$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2cf4eb790d2d2598$var$hash[matched];
    });
}

});

parcelRegister("71NRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51df4f875ef64cce$export$2e2bcd8739ae039; });
var $51df4f875ef64cce$var$hash = {
    start: "end",
    end: "start"
};
function $51df4f875ef64cce$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $51df4f875ef64cce$var$hash[matched];
    });
}

});

parcelRegister("ivqFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d78fceb84677fc94$export$2e2bcd8739ae039; });

var $iTvvq = parcelRequire("iTvvq");

var $eNF9s = parcelRequire("eNF9s");

var $iYLNX = parcelRequire("iYLNX");

var $igI1D = parcelRequire("igI1D");

var $cKet7 = parcelRequire("cKet7");

var $9sBMA = parcelRequire("9sBMA");

var $4yey3 = parcelRequire("4yey3");

var $93Awv = parcelRequire("93Awv");

var $lkZpD = parcelRequire("lkZpD");
function $d78fceb84677fc94$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $9sBMA.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $9sBMA.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $9sBMA.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $93Awv.default)(typeof padding !== "number" ? padding : (0, $lkZpD.default)(padding, (0, $9sBMA.basePlacements)));
    var altContext = elementContext === (0, $9sBMA.popper) ? (0, $9sBMA.reference) : (0, $9sBMA.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $iTvvq.default)((0, $4yey3.isElement)(element) ? element : element.contextElement || (0, $eNF9s.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $iYLNX.default)(state.elements.reference);
    var popperOffsets = (0, $igI1D.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $cKet7.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $9sBMA.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $9sBMA.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $9sBMA.right),
                (0, $9sBMA.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $9sBMA.top),
                (0, $9sBMA.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("iTvvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc15cd7a6f0044c3$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $fW0kF = parcelRequire("fW0kF");

var $1PTg9 = parcelRequire("1PTg9");

var $8BYmY = parcelRequire("8BYmY");

var $gWO4o = parcelRequire("gWO4o");

var $eNF9s = parcelRequire("eNF9s");

var $1eqAZ = parcelRequire("1eqAZ");

var $4yey3 = parcelRequire("4yey3");

var $iYLNX = parcelRequire("iYLNX");

var $cxf4H = parcelRequire("cxf4H");

var $lwNTw = parcelRequire("lwNTw");

var $gNNyC = parcelRequire("gNNyC");

var $cKet7 = parcelRequire("cKet7");

var $9pEtR = parcelRequire("9pEtR");
function $dc15cd7a6f0044c3$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $iYLNX.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $dc15cd7a6f0044c3$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $9sBMA.viewport) ? (0, $cKet7.default)((0, $fW0kF.default)(element, strategy)) : (0, $4yey3.isElement)(clippingParent) ? $dc15cd7a6f0044c3$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $cKet7.default)((0, $1PTg9.default)((0, $eNF9s.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $dc15cd7a6f0044c3$var$getClippingParents(element) {
    var clippingParents = (0, $8BYmY.default)((0, $cxf4H.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $1eqAZ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $4yey3.isHTMLElement)(element) ? (0, $gWO4o.default)(element) : element;
    if (!(0, $4yey3.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $4yey3.isElement)(clippingParent) && (0, $lwNTw.default)(clippingParent, clipperElement) && (0, $gNNyC.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $dc15cd7a6f0044c3$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $dc15cd7a6f0044c3$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $dc15cd7a6f0044c3$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9pEtR.max)(rect.top, accRect.top);
        accRect.right = (0, $9pEtR.min)(rect.right, accRect.right);
        accRect.bottom = (0, $9pEtR.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9pEtR.max)(rect.left, accRect.left);
        return accRect;
    }, $dc15cd7a6f0044c3$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("fW0kF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b99c87cd4b8f9ce7$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");

var $eNF9s = parcelRequire("eNF9s");

var $37LVq = parcelRequire("37LVq");

var $dXRpq = parcelRequire("dXRpq");
function $b99c87cd4b8f9ce7$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $cYZ7h.default)(element);
    var html = (0, $eNF9s.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $dXRpq.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $37LVq.default)(element),
        y: y
    };
}

});
parcelRegister("37LVq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2467337e98f2dda2$export$2e2bcd8739ae039; });

var $iYLNX = parcelRequire("iYLNX");

var $eNF9s = parcelRequire("eNF9s");

var $8KllJ = parcelRequire("8KllJ");
function $2467337e98f2dda2$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $iYLNX.default)((0, $eNF9s.default)(element)).left + (0, $8KllJ.default)(element).scrollLeft;
}

});
parcelRegister("8KllJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65e32e3225b6b5c7$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");
function $65e32e3225b6b5c7$export$2e2bcd8739ae039(node) {
    var win = (0, $cYZ7h.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("1PTg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15656b45bbde3e62$export$2e2bcd8739ae039; });

var $eNF9s = parcelRequire("eNF9s");

var $1eqAZ = parcelRequire("1eqAZ");

var $37LVq = parcelRequire("37LVq");

var $8KllJ = parcelRequire("8KllJ");

var $9pEtR = parcelRequire("9pEtR");
function $15656b45bbde3e62$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eNF9s.default)(element);
    var winScroll = (0, $8KllJ.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9pEtR.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9pEtR.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $37LVq.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1eqAZ.default)(body || html).direction === "rtl") x += (0, $9pEtR.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("8BYmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64509b90c746566f$export$2e2bcd8739ae039; });

var $4AuVl = parcelRequire("4AuVl");

var $cxf4H = parcelRequire("cxf4H");

var $cYZ7h = parcelRequire("cYZ7h");

var $58ZkD = parcelRequire("58ZkD");
function $64509b90c746566f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4AuVl.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $cYZ7h.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $58ZkD.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($64509b90c746566f$export$2e2bcd8739ae039((0, $cxf4H.default)(target)));
}

});
parcelRegister("4AuVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3572831447a8b90a$export$2e2bcd8739ae039; });

var $cxf4H = parcelRequire("cxf4H");

var $58ZkD = parcelRequire("58ZkD");

var $gNNyC = parcelRequire("gNNyC");

var $4yey3 = parcelRequire("4yey3");
function $3572831447a8b90a$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $gNNyC.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $4yey3.isHTMLElement)(node) && (0, $58ZkD.default)(node)) return node;
    return $3572831447a8b90a$export$2e2bcd8739ae039((0, $cxf4H.default)(node));
}

});
parcelRegister("58ZkD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bed4651df2a8581$export$2e2bcd8739ae039; });

var $1eqAZ = parcelRequire("1eqAZ");
function $3bed4651df2a8581$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1eqAZ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("cKet7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94750115aa04ee16$export$2e2bcd8739ae039; });
function $94750115aa04ee16$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("igI1D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4cbdf230537aa07$export$2e2bcd8739ae039; });

var $bjbdL = parcelRequire("bjbdL");

var $lc7d9 = parcelRequire("lc7d9");

var $9M8WM = parcelRequire("9M8WM");

var $9sBMA = parcelRequire("9sBMA");
function $d4cbdf230537aa07$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $bjbdL.default)(placement) : null;
    var variation = placement ? (0, $lc7d9.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $9sBMA.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $9sBMA.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $9sBMA.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $9sBMA.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9M8WM.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $9sBMA.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $9sBMA.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("gvuY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0479014a72b6f48$export$2e2bcd8739ae039; });

var $lc7d9 = parcelRequire("lc7d9");

var $9sBMA = parcelRequire("9sBMA");

var $ivqFp = parcelRequire("ivqFp");

var $bjbdL = parcelRequire("bjbdL");
function $c0479014a72b6f48$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $9sBMA.placements) : _options$allowedAutoP;
    var variation = (0, $lc7d9.default)(placement);
    var placements = variation ? flipVariations ? (0, $9sBMA.variationPlacements) : (0, $9sBMA.variationPlacements).filter(function(placement) {
        return (0, $lc7d9.default)(placement) === variation;
    }) : (0, $9sBMA.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ivqFp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $bjbdL.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("iIbxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f549c999f38676$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $ivqFp = parcelRequire("ivqFp");
function $d9f549c999f38676$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d9f549c999f38676$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $9sBMA.top),
        (0, $9sBMA.right),
        (0, $9sBMA.bottom),
        (0, $9sBMA.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d9f549c999f38676$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ivqFp.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $ivqFp.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d9f549c999f38676$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d9f549c999f38676$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d9f549c999f38676$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d9f549c999f38676$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d9f549c999f38676$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $d9f549c999f38676$var$hide
};

});

parcelRegister("hLLXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cefc06bfa1823e2e$export$2e2bcd8739ae039; });

var $bjbdL = parcelRequire("bjbdL");

var $9sBMA = parcelRequire("9sBMA");
function $cefc06bfa1823e2e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $bjbdL.default)(placement);
    var invertDistance = [
        (0, $9sBMA.left),
        (0, $9sBMA.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $9sBMA.left),
        (0, $9sBMA.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $cefc06bfa1823e2e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $9sBMA.placements).reduce(function(acc, placement) {
        acc[placement] = $cefc06bfa1823e2e$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cefc06bfa1823e2e$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $cefc06bfa1823e2e$var$offset
};

});

parcelRegister("bwXYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $865133f4ac58b287$export$2e2bcd8739ae039; });

var $igI1D = parcelRequire("igI1D");
function $865133f4ac58b287$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $igI1D.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $865133f4ac58b287$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $865133f4ac58b287$var$popperOffsets,
    data: {}
};

});

parcelRegister("7oqYt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $561fb2dc20a3be19$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $bjbdL = parcelRequire("bjbdL");

var $9M8WM = parcelRequire("9M8WM");

var $4hf6V = parcelRequire("4hf6V");

var $fsgwo = parcelRequire("fsgwo");

var $jXC8u = parcelRequire("jXC8u");

var $gWO4o = parcelRequire("gWO4o");

var $ivqFp = parcelRequire("ivqFp");

var $lc7d9 = parcelRequire("lc7d9");

var $8IvhE = parcelRequire("8IvhE");

var $9pEtR = parcelRequire("9pEtR");
function $561fb2dc20a3be19$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ivqFp.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $bjbdL.default)(state.placement);
    var variation = (0, $lc7d9.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9M8WM.default)(basePlacement);
    var altAxis = (0, $4hf6V.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $9sBMA.top) : (0, $9sBMA.left);
        var altSide = mainAxis === "y" ? (0, $9sBMA.bottom) : (0, $9sBMA.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $9sBMA.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $9sBMA.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $jXC8u.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $8IvhE.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $fsgwo.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $gWO4o.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $fsgwo.within)(tether ? (0, $9pEtR.min)(min, tetherMin) : min, offset, tether ? (0, $9pEtR.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $9sBMA.top) : (0, $9sBMA.left);
        var _altSide = mainAxis === "x" ? (0, $9sBMA.bottom) : (0, $9sBMA.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $9sBMA.top),
            (0, $9sBMA.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $fsgwo.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $fsgwo.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $561fb2dc20a3be19$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $561fb2dc20a3be19$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("4hf6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31d4789c33a2e502$export$2e2bcd8739ae039; });
function $31d4789c33a2e502$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});



parcelRegister("t1juM", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $0573ba5ede1168b6$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $0573ba5ede1168b6$export$8f7491d57c8f97a9; });

var $13nAE = parcelRequire("13nAE");

var $jXC8u = parcelRequire("jXC8u");

var $8BYmY = parcelRequire("8BYmY");

var $gWO4o = parcelRequire("gWO4o");

var $8wz9t = parcelRequire("8wz9t");

var $edfR5 = parcelRequire("edfR5");

var $kVCZe = parcelRequire("kVCZe");

var $ivqFp = parcelRequire("ivqFp");

var $4yey3 = parcelRequire("4yey3");
var $0573ba5ede1168b6$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $0573ba5ede1168b6$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $0573ba5ede1168b6$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0573ba5ede1168b6$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $0573ba5ede1168b6$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $4yey3.isElement)(reference) ? (0, $8BYmY.default)(reference) : reference.contextElement ? (0, $8BYmY.default)(reference.contextElement) : [],
                    popper: (0, $8BYmY.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8wz9t.default)((0, $kVCZe.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$0573ba5ede1168b6$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $13nAE.default)(reference, (0, $gWO4o.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $jXC8u.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $edfR5.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0573ba5ede1168b6$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0573ba5ede1168b6$export$8f7491d57c8f97a9 = /*#__PURE__*/ $0573ba5ede1168b6$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("13nAE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c485ec09dace92c$export$2e2bcd8739ae039; });

var $iYLNX = parcelRequire("iYLNX");

var $9S94R = parcelRequire("9S94R");

var $gNNyC = parcelRequire("gNNyC");

var $4yey3 = parcelRequire("4yey3");

var $37LVq = parcelRequire("37LVq");

var $eNF9s = parcelRequire("eNF9s");

var $58ZkD = parcelRequire("58ZkD");

var $9pEtR = parcelRequire("9pEtR");
function $0c485ec09dace92c$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9pEtR.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9pEtR.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $0c485ec09dace92c$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $4yey3.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $4yey3.isHTMLElement)(offsetParent) && $0c485ec09dace92c$var$isElementScaled(offsetParent);
    var documentElement = (0, $eNF9s.default)(offsetParent);
    var rect = (0, $iYLNX.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gNNyC.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $58ZkD.default)(documentElement)) scroll = (0, $9S94R.default)(offsetParent);
        if ((0, $4yey3.isHTMLElement)(offsetParent)) {
            offsets = (0, $iYLNX.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $37LVq.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("9S94R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $730032c3ec74ae75$export$2e2bcd8739ae039; });

var $8KllJ = parcelRequire("8KllJ");

var $cYZ7h = parcelRequire("cYZ7h");

var $4yey3 = parcelRequire("4yey3");

var $duXx8 = parcelRequire("duXx8");
function $730032c3ec74ae75$export$2e2bcd8739ae039(node) {
    if (node === (0, $cYZ7h.default)(node) || !(0, $4yey3.isHTMLElement)(node)) return (0, $8KllJ.default)(node);
    else return (0, $duXx8.default)(node);
}

});
parcelRegister("duXx8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d3c41cc50e3b556$export$2e2bcd8739ae039; });
function $9d3c41cc50e3b556$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("8wz9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634c944904fc82cf$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");
function $634c944904fc82cf$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $634c944904fc82cf$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $634c944904fc82cf$var$order(modifiers); // order based on phase
    return (0, $9sBMA.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("edfR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a58e9417d8d60d4d$export$2e2bcd8739ae039; });
function $a58e9417d8d60d4d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kVCZe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3c75f6f726b786e$export$2e2bcd8739ae039; });
function $f3c75f6f726b786e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("8dqiK", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $5fb3f086684b6047$export$8f7491d57c8f97a9; });

var $t1juM = parcelRequire("t1juM");

var $7j3jV = parcelRequire("7j3jV");

var $bwXYi = parcelRequire("bwXYi");

var $i7xoL = parcelRequire("i7xoL");

var $gy0RQ = parcelRequire("gy0RQ");

var $hLLXp = parcelRequire("hLLXp");

var $bJk6k = parcelRequire("bJk6k");

var $7oqYt = parcelRequire("7oqYt");

var $d1SXy = parcelRequire("d1SXy");

var $iIbxA = parcelRequire("iIbxA");


var $5fb3f086684b6047$export$d34966752335dd47 = [
    (0, $7j3jV.default),
    (0, $bwXYi.default),
    (0, $i7xoL.default),
    (0, $gy0RQ.default),
    (0, $hLLXp.default),
    (0, $bJk6k.default),
    (0, $7oqYt.default),
    (0, $d1SXy.default),
    (0, $iIbxA.default)
];
var $5fb3f086684b6047$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $t1juM.popperGenerator)({
    defaultModifiers: $5fb3f086684b6047$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("cDLKH", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $933e2b27c632eb0b$export$8f7491d57c8f97a9; });

var $t1juM = parcelRequire("t1juM");

var $7j3jV = parcelRequire("7j3jV");

var $bwXYi = parcelRequire("bwXYi");

var $i7xoL = parcelRequire("i7xoL");

var $gy0RQ = parcelRequire("gy0RQ");
var $933e2b27c632eb0b$export$d34966752335dd47 = [
    (0, $7j3jV.default),
    (0, $bwXYi.default),
    (0, $i7xoL.default),
    (0, $gy0RQ.default)
];
var $933e2b27c632eb0b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $t1juM.popperGenerator)({
    defaultModifiers: $933e2b27c632eb0b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


// Copyright (C) Konrad Gadzinowski
var $d26b75c87b693463$exports = {};
var $c074f7368ab96ac2$exports = {};

var $fRaLx = parcelRequire("fRaLx");
var $fd350b254dbe85cc$exports = {};
$fd350b254dbe85cc$exports = function(el) {
    var code = el.text || el.textContent || el.innerHTML || "";
    var src = el.src || "";
    var parent = el.parentNode || document.querySelector("head") || document.documentElement;
    var script = document.createElement("script");
    if (code.match("document.write")) {
        if (console && console.log) console.log("Script contains document.write. Can\u2019t be executed correctly. Code skipped ", el);
        return false;
    }
    script.type = "text/javascript";
    script.id = el.id;
    /* istanbul ignore if */ if (src !== "") {
        script.src = src;
        script.async = false; // force synchronous loading of peripheral JS
    }
    if (code !== "") try {
        script.appendChild(document.createTextNode(code));
    } catch (e) {
        /* istanbul ignore next */ // old IEs have funky script nodes
        script.text = code;
    }
    // execute
    parent.appendChild(script);
    // avoid pollution only in head or body tags
    if ((parent instanceof HTMLHeadElement || parent instanceof HTMLBodyElement) && parent.contains(script)) parent.removeChild(script);
    return true;
};


// Finds and executes scripts (used for newly added elements)
// Needed since innerHTML does not run scripts
$c074f7368ab96ac2$exports = function(el) {
    if (el.tagName.toLowerCase() === "script") $fd350b254dbe85cc$exports(el);
    $fRaLx(el.querySelectorAll("script"), function(script) {
        if (!script.type || script.type.toLowerCase() === "text/javascript") {
            if (script.parentNode) script.parentNode.removeChild(script);
            $fd350b254dbe85cc$exports(script);
        }
    });
};



var $fRaLx = parcelRequire("fRaLx");
var $c5f66b3403c99df5$exports = {};
/* global _gaq: true, ga: true */ 
var $7RZTV = parcelRequire("7RZTV");
$c5f66b3403c99df5$exports = function(options) {
    options = options || {};
    options.elements = options.elements || "a[href], form[action]";
    options.selectors = options.selectors || [
        "title",
        ".js-Pjax"
    ];
    options.switches = options.switches || {};
    options.switchesOptions = options.switchesOptions || {};
    options.history = typeof options.history === "undefined" ? true : options.history;
    options.analytics = typeof options.analytics === "function" || options.analytics === false ? options.analytics : $c5f66b3403c99df5$var$defaultAnalytics;
    options.scrollTo = typeof options.scrollTo === "undefined" ? 0 : options.scrollTo;
    options.scrollRestoration = typeof options.scrollRestoration !== "undefined" ? options.scrollRestoration : true;
    options.cacheBust = typeof options.cacheBust === "undefined" ? true : options.cacheBust;
    options.debug = options.debug || false;
    options.timeout = options.timeout || 0;
    options.currentUrlFullReload = typeof options.currentUrlFullReload === "undefined" ? false : options.currentUrlFullReload;
    // We can’t replace body.outerHTML or head.outerHTML.
    // It creates a bug where a new body or head are created in the DOM.
    // If you set head.outerHTML, a new body tag is appended, so the DOM has 2 body nodes, and vice versa
    if (!options.switches.head) options.switches.head = $7RZTV.switchElementsAlt;
    if (!options.switches.body) options.switches.body = $7RZTV.switchElementsAlt;
    return options;
};
/* istanbul ignore next */ function $c5f66b3403c99df5$var$defaultAnalytics() {
    if (window._gaq) _gaq.push([
        "_trackPageview"
    ]);
    if (window.ga) ga("send", "pageview", {
        page: location.pathname,
        title: document.title
    });
}



var $7RZTV = parcelRequire("7RZTV");

var $e36no = parcelRequire("e36no");

var $fcCTJ = parcelRequire("fcCTJ");

var $ep84Q = parcelRequire("ep84Q");

var $8kgSr = parcelRequire("8kgSr");
var $1a81c48da2d345f6$exports = {};
$1a81c48da2d345f6$exports = function contains(doc, selectors, el) {
    for(var i = 0; i < selectors.length; i++){
        var selectedEls = doc.querySelectorAll(selectors[i]);
        for(var j = 0; j < selectedEls.length; j++){
            if (selectedEls[j].contains(el)) return true;
        }
    }
    return false;
};


var $66781b42dee1c947$exports = {};
$66781b42dee1c947$exports = function(target) {
    if (target == null) return null;
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        if (source != null) {
            for(var key in source)// Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(source, key)) to[key] = source[key];
        }
    }
    return to;
};



var $cukYX = parcelRequire("cukYX");
var $d26b75c87b693463$var$Pjax = function(options) {
    this.state = {
        numPendingSwitches: 0,
        href: null,
        options: null
    };
    this.options = $c5f66b3403c99df5$exports(options);
    this.log("Pjax options", this.options);
    if (this.options.scrollRestoration && "scrollRestoration" in history) history.scrollRestoration = "manual";
    this.maxUid = this.lastUid = $e36no();
    this.parseDOM(document);
    $fcCTJ(window, "popstate", (function(st) {
        if (st.state) {
            var opt = $8kgSr(this.options);
            opt.url = st.state.url;
            opt.title = st.state.title;
            // Since state already exists, prevent it from being pushed again
            opt.history = false;
            opt.scrollPos = st.state.scrollPos;
            if (st.state.uid < this.lastUid) opt.backward = true;
            else opt.forward = true;
            this.lastUid = st.state.uid;
            // @todo implement history cache here, based on uid
            this.loadUrl(st.state.url, opt);
        }
    }).bind(this));
};
$d26b75c87b693463$var$Pjax.switches = $7RZTV;









$d26b75c87b693463$var$Pjax.prototype = {
    log: (parcelRequire("bTB0U")),
    getElements: function(el) {
        return el.querySelectorAll(this.options.elements);
    },
    parseDOM: function(el) {
        var parseElement = (parcelRequire("6l3E4"));
        $fRaLx(this.getElements(el), parseElement, this);
    },
    refresh: function(el) {
        this.parseDOM(el || document);
    },
    reload: function() {
        window.location.reload();
    },
    attachLink: (parcelRequire("4Qp2J")),
    attachForm: (parcelRequire("crAW0")),
    forEachSelectors: function(cb, context, DOMcontext) {
        return (parcelRequire("duhL3")).bind(this)(this.options.selectors, cb, context, DOMcontext);
    },
    switchSelectors: function(selectors, fromEl, toEl, options) {
        return (parcelRequire("loXQO")).bind(this)(this.options.switches, this.options.switchesOptions, selectors, fromEl, toEl, options);
    },
    latestChance: function(href) {
        window.location = href;
    },
    onSwitch: function() {
        $ep84Q(window, "resize scroll");
        this.state.numPendingSwitches--;
        // debounce calls, so we only run this once after all switches are finished.
        if (this.state.numPendingSwitches === 0) this.afterAllSwitches();
    },
    loadContent: function(html, options) {
        if (typeof html !== "string") {
            $ep84Q(document, "pjax:complete pjax:error", options);
            return;
        }
        var tmpEl = document.implementation.createHTMLDocument("pjax");
        // parse HTML attributes to copy them
        // since we are forced to use documentElement.innerHTML (outerHTML can't be used for <html>)
        var htmlRegex = /<html[^>]+>/gi;
        var htmlAttribsRegex = /\s?[a-z:]+(?:=['"][^'">]+['"])*/gi;
        var matches = html.match(htmlRegex);
        if (matches && matches.length) {
            matches = matches[0].match(htmlAttribsRegex);
            if (matches.length) {
                matches.shift();
                matches.forEach(function(htmlAttrib) {
                    var attr = htmlAttrib.trim().split("=");
                    if (attr.length === 1) tmpEl.documentElement.setAttribute(attr[0], true);
                    else tmpEl.documentElement.setAttribute(attr[0], attr[1].slice(1, -1));
                });
            }
        }
        tmpEl.documentElement.innerHTML = html;
        this.log("load content", tmpEl.documentElement.attributes, tmpEl.documentElement.innerHTML.length);
        // Clear out any focused controls before inserting new page contents.
        if (document.activeElement && $1a81c48da2d345f6$exports(document, this.options.selectors, document.activeElement)) try {
            document.activeElement.blur();
        } catch (e) {} // eslint-disable-line no-empty
        this.switchSelectors(this.options.selectors, tmpEl, document, options);
    },
    abortRequest: (parcelRequire("8BsJe")),
    doRequest: (parcelRequire("aBk3q")),
    handleResponse: (parcelRequire("3vRmN")),
    loadUrl: function(href, options) {
        options = typeof options === "object" ? $66781b42dee1c947$exports({}, this.options, options) : $8kgSr(this.options);
        this.log("load href", href, options);
        // Abort any previous request
        this.abortRequest(this.request);
        $ep84Q(document, "pjax:send", options);
        // Do the request
        this.request = this.doRequest(href, options, this.handleResponse.bind(this));
    },
    afterAllSwitches: function() {
        // FF bug: Won’t autofocus fields that are inserted via JS.
        // This behavior is incorrect. So if theres no current focus, autofocus
        // the last field.
        //
        // http://www.w3.org/html/wg/drafts/html/master/forms.html
        var autofocusEl = Array.prototype.slice.call(document.querySelectorAll("[autofocus]")).pop();
        if (autofocusEl && document.activeElement !== autofocusEl) autofocusEl.focus();
        // execute scripts when DOM have been completely updated
        this.options.selectors.forEach(function(selector) {
            $fRaLx(document.querySelectorAll(selector), function(el) {
                $c074f7368ab96ac2$exports(el);
            });
        });
        var state = this.state;
        if (state.options.history) {
            if (!window.history.state) {
                this.lastUid = this.maxUid = $e36no();
                window.history.replaceState({
                    url: window.location.href,
                    title: document.title,
                    uid: this.maxUid,
                    scrollPos: [
                        0,
                        0
                    ]
                }, document.title);
            }
            // Update browser history
            this.lastUid = this.maxUid = $e36no();
            window.history.pushState({
                url: state.href,
                title: state.options.title,
                uid: this.maxUid,
                scrollPos: [
                    0,
                    0
                ]
            }, state.options.title, state.href);
        }
        this.forEachSelectors(function(el) {
            this.parseDOM(el);
        }, this);
        // Fire Events
        $ep84Q(document, "pjax:complete pjax:success", state.options);
        if (typeof state.options.analytics === "function") state.options.analytics();
        if (state.options.history) {
            // First parse url and check for hash to override scroll
            var a = document.createElement("a");
            a.href = this.state.href;
            if (a.hash) {
                var name = a.hash.slice(1);
                name = decodeURIComponent(name);
                var curtop = 0;
                var target = document.getElementById(name) || document.getElementsByName(name)[0];
                if (target) {
                    // http://stackoverflow.com/questions/8111094/cross-browser-javascript-function-to-find-actual-position-of-an-element-in-page
                    if (target.offsetParent) do {
                        curtop += target.offsetTop;
                        target = target.offsetParent;
                    }while (target);
                }
                window.scrollTo(0, curtop);
            } else if (state.options.scrollTo !== false) {
                // Scroll page to top on new page load
                if (state.options.scrollTo.length > 1) window.scrollTo(state.options.scrollTo[0], state.options.scrollTo[1]);
                else window.scrollTo(0, state.options.scrollTo);
            }
        } else if (state.options.scrollRestoration && state.options.scrollPos) window.scrollTo(state.options.scrollPos[0], state.options.scrollPos[1]);
        this.state = {
            numPendingSwitches: 0,
            href: null,
            options: null
        };
    }
};

$d26b75c87b693463$var$Pjax.isSupported = (parcelRequire("cODYy"));
// arguably could do `if( require("./lib/is-supported")()) {` but that might be a little to simple
if ($d26b75c87b693463$var$Pjax.isSupported()) $d26b75c87b693463$exports = $d26b75c87b693463$var$Pjax;
else {
    var $d26b75c87b693463$var$stupidPjax = $cukYX;
    for(var $d26b75c87b693463$var$key in $d26b75c87b693463$var$Pjax.prototype)if ($d26b75c87b693463$var$Pjax.prototype.hasOwnProperty($d26b75c87b693463$var$key) && typeof $d26b75c87b693463$var$Pjax.prototype[$d26b75c87b693463$var$key] === "function") $d26b75c87b693463$var$stupidPjax[$d26b75c87b693463$var$key] = $cukYX;
    $d26b75c87b693463$exports = $d26b75c87b693463$var$stupidPjax;
}



var $e7f07339a0167292$exports = {};

/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $e7f07339a0167292$exports = factory((parcelRequire("8YGgm")));
})($e7f07339a0167292$exports, function(Popper) {
    "use strict";
    function _interopNamespaceDefault(e) {
        const n = Object.create(null, {
            [Symbol.toStringTag]: {
                value: "Module"
            }
        });
        if (e) {
            for(const k in e)if (k !== "default") {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: ()=>e[k]
                });
            }
        }
        n.default = e;
        return Object.freeze(n);
    }
    const Popper__namespace = /*#__PURE__*/ _interopNamespaceDefault(Popper);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const elementMap = new Map();
    const Data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = "transitionend";
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ const parseSelector = (selector)=>{
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = (object)=>{
        if (object === null || object === undefined) return `${object}`;
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ const getUID = (prefix)=>{
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
        // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(",")[0];
        transitionDelay = transitionDelay.split(",")[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (object)=>{
        if (!object || typeof object !== "object") return false;
        if (typeof object.jquery !== "undefined") object = object[0];
        return typeof object.nodeType !== "undefined";
    };
    const getElement = (object)=>{
        // it's a jQuery object or a node element
        if (isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === "string" && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
        // Handle `details` element as its content may falsie appear visible when it is closed
        const closedDetails = element.closest("details:not([open])");
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            const summary = element.closest("summary");
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    const findShadowRoot = (element)=>{
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === "function") {
            const root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    const noop = ()=>{};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = ()=>{
        if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                for (const callback of DOMContentLoadedCallbacks)callback();
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === "rtl";
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
        return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        const listLength = list.length;
        let index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    const nativeEvents = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        const uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
                if (domElement !== target) continue;
                hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        };
    }
    function findHandler(events, callable, delegationSelector = null) {
        return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        const isDelegated = typeof handler === "string";
        // TODO: tooltip passes `false` instead of selector, so we need to check
        const callable = isDelegated ? delegationFunction : handler || delegationFunction;
        let typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            const wrapFunction = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        const events = getElementEvents(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ""));
        const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, "");
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off (element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== "string" || !element) return;
            const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getElementEvents(element);
            const storeElementEvent = events[typeEvent] || {};
            const isNamespace = originalTypeEvent.startsWith(".");
            if (typeof callable !== "undefined") {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
                const handlerKey = keyHandlers.replace(stripUidRegex, "");
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        },
        trigger (element, event, args) {
            if (typeof event !== "string" || !element) return null;
            const $ = getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            let jQueryEvent = null;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            const evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj, meta = {}) {
        for (const [key, value] of Object.entries(meta))try {
            obj[key] = value;
        } catch (_unused) {
            Object.defineProperty(obj, key, {
                configurable: true,
                get () {
                    return value;
                }
            });
        }
        return obj;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === "" || value === "null") return null;
        if (typeof value !== "string") return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
            for (const key of bsKeys){
                let pureKey = key.replace(/^bs/, "");
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            }
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ class Config {
        // Getters
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            return config;
        }
        _mergeConfigObj(config, element) {
            const jsonConfig = isElement(element) ? Manipulator.getDataAttribute(element, "config") : {}; // try to parse
            return {
                ...this.constructor.Default,
                ...typeof jsonConfig === "object" ? jsonConfig : {},
                ...isElement(element) ? Manipulator.getDataAttributes(element) : {},
                ...typeof config === "object" ? config : {}
            };
        }
        _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
            for (const [property, expectedTypes] of Object.entries(configTypes)){
                const value = config[property];
                const valueType = isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
            }
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const VERSION = "5.3.3";
    /**
   * Class definition
   */ class BaseComponent extends Config {
        // Public
        dispose() {
            Data.remove(this._element, this.constructor.DATA_KEY);
            EventHandler.off(this._element, this.constructor.EVENT_KEY);
            for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
        }
        _queueCallback(callback, element, isAnimated = true) {
            executeAfterTransition(callback, element, isAnimated);
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config, this._element);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        // Static
        static getInstance(element) {
            return Data.get(getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(name) {
            return `${name}${this.EVENT_KEY}`;
        }
        constructor(element, config){
            super();
            element = getElement(element);
            if (!element) return;
            this._element = element;
            this._config = this._getConfig(config);
            Data.set(this._element, this.constructor.DATA_KEY, this);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttribute = element.getAttribute("href");
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
            selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(",").map((sel)=>parseSelector(sel)).join(",") : null;
    };
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
            return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
        },
        getSelectorFromElement (element) {
            const selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const enableDismissTrigger = (component, method = "hide")=>{
        const clickEvent = `click.dismiss${component.EVENT_KEY}`;
        const name = component.NAME;
        EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            if (isDisabled(this)) return;
            const target = SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
            const instance = component.getOrCreateInstance(target);
            // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$f = "alert";
    const DATA_KEY$a = "bs.alert";
    const EVENT_KEY$b = `.${DATA_KEY$a}`;
    const EVENT_CLOSE = `close${EVENT_KEY$b}`;
    const EVENT_CLOSED = `closed${EVENT_KEY$b}`;
    const CLASS_NAME_FADE$5 = "fade";
    const CLASS_NAME_SHOW$8 = "show";
    /**
   * Class definition
   */ class Alert extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$f;
        }
        // Public
        close() {
            const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
            if (closeEvent.defaultPrevented) return;
            this._element.classList.remove(CLASS_NAME_SHOW$8);
            const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
            this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
        }
        // Private
        _destroyElement() {
            this._element.remove();
            EventHandler.trigger(this._element, EVENT_CLOSED);
            this.dispose();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Alert.getOrCreateInstance(this);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Alert, "close");
    /**
   * jQuery
   */ defineJQueryPlugin(Alert);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$e = "button";
    const DATA_KEY$9 = "bs.button";
    const EVENT_KEY$a = `.${DATA_KEY$9}`;
    const DATA_API_KEY$6 = ".data-api";
    const CLASS_NAME_ACTIVE$3 = "active";
    const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
    const EVENT_CLICK_DATA_API$6 = `click${EVENT_KEY$a}${DATA_API_KEY$6}`;
    /**
   * Class definition
   */ class Button extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$e;
        }
        // Public
        toggle() {
            // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
            this._element.setAttribute("aria-pressed", this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Button.getOrCreateInstance(this);
                if (config === "toggle") data[config]();
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, (event)=>{
        event.preventDefault();
        const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
        const data = Button.getOrCreateInstance(button);
        data.toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Button);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/swipe.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$d = "swipe";
    const EVENT_KEY$9 = ".bs.swipe";
    const EVENT_TOUCHSTART = `touchstart${EVENT_KEY$9}`;
    const EVENT_TOUCHMOVE = `touchmove${EVENT_KEY$9}`;
    const EVENT_TOUCHEND = `touchend${EVENT_KEY$9}`;
    const EVENT_POINTERDOWN = `pointerdown${EVENT_KEY$9}`;
    const EVENT_POINTERUP = `pointerup${EVENT_KEY$9}`;
    const POINTER_TYPE_TOUCH = "touch";
    const POINTER_TYPE_PEN = "pen";
    const CLASS_NAME_POINTER_EVENT = "pointer-event";
    const SWIPE_THRESHOLD = 40;
    const Default$c = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    };
    const DefaultType$c = {
        endCallback: "(function|null)",
        leftCallback: "(function|null)",
        rightCallback: "(function|null)"
    };
    /**
   * Class definition
   */ class Swipe extends Config {
        // Getters
        static get Default() {
            return Default$c;
        }
        static get DefaultType() {
            return DefaultType$c;
        }
        static get NAME() {
            return NAME$d;
        }
        // Public
        dispose() {
            EventHandler.off(this._element, EVENT_KEY$9);
        }
        // Private
        _start(event) {
            if (!this._supportPointerEvents) {
                this._deltaX = event.touches[0].clientX;
                return;
            }
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
        }
        _end(event) {
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
            this._handleSwipe();
            execute(this._config.endCallback);
        }
        _move(event) {
            this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
        }
        _handleSwipe() {
            const absDeltaX = Math.abs(this._deltaX);
            if (absDeltaX <= SWIPE_THRESHOLD) return;
            const direction = absDeltaX / this._deltaX;
            this._deltaX = 0;
            if (!direction) return;
            execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
        }
        _initEvents() {
            if (this._supportPointerEvents) {
                EventHandler.on(this._element, EVENT_POINTERDOWN, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_POINTERUP, (event)=>this._end(event));
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                EventHandler.on(this._element, EVENT_TOUCHSTART, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_TOUCHMOVE, (event)=>this._move(event));
                EventHandler.on(this._element, EVENT_TOUCHEND, (event)=>this._end(event));
            }
        }
        _eventIsPointerPenTouch(event) {
            return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
        }
        // Static
        static isSupported() {
            return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
        }
        constructor(element, config){
            super();
            this._element = element;
            if (!element || !Swipe.isSupported()) return;
            this._config = this._getConfig(config);
            this._deltaX = 0;
            this._supportPointerEvents = Boolean(window.PointerEvent);
            this._initEvents();
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$c = "carousel";
    const DATA_KEY$8 = "bs.carousel";
    const EVENT_KEY$8 = `.${DATA_KEY$8}`;
    const DATA_API_KEY$5 = ".data-api";
    const ARROW_LEFT_KEY$1 = "ArrowLeft";
    const ARROW_RIGHT_KEY$1 = "ArrowRight";
    const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    const ORDER_NEXT = "next";
    const ORDER_PREV = "prev";
    const DIRECTION_LEFT = "left";
    const DIRECTION_RIGHT = "right";
    const EVENT_SLIDE = `slide${EVENT_KEY$8}`;
    const EVENT_SLID = `slid${EVENT_KEY$8}`;
    const EVENT_KEYDOWN$1 = `keydown${EVENT_KEY$8}`;
    const EVENT_MOUSEENTER$1 = `mouseenter${EVENT_KEY$8}`;
    const EVENT_MOUSELEAVE$1 = `mouseleave${EVENT_KEY$8}`;
    const EVENT_DRAG_START = `dragstart${EVENT_KEY$8}`;
    const EVENT_LOAD_DATA_API$3 = `load${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const EVENT_CLICK_DATA_API$5 = `click${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const CLASS_NAME_CAROUSEL = "carousel";
    const CLASS_NAME_ACTIVE$2 = "active";
    const CLASS_NAME_SLIDE = "slide";
    const CLASS_NAME_END = "carousel-item-end";
    const CLASS_NAME_START = "carousel-item-start";
    const CLASS_NAME_NEXT = "carousel-item-next";
    const CLASS_NAME_PREV = "carousel-item-prev";
    const SELECTOR_ACTIVE = ".active";
    const SELECTOR_ITEM = ".carousel-item";
    const SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
    const SELECTOR_ITEM_IMG = ".carousel-item img";
    const SELECTOR_INDICATORS = ".carousel-indicators";
    const SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
    const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
    const KEY_TO_DIRECTION = {
        [ARROW_LEFT_KEY$1]: DIRECTION_RIGHT,
        [ARROW_RIGHT_KEY$1]: DIRECTION_LEFT
    };
    const Default$b = {
        interval: 5000,
        keyboard: true,
        pause: "hover",
        ride: false,
        touch: true,
        wrap: true
    };
    const DefaultType$b = {
        interval: "(number|boolean)",
        // TODO:v6 remove boolean support
        keyboard: "boolean",
        pause: "(string|boolean)",
        ride: "(boolean|string)",
        touch: "boolean",
        wrap: "boolean"
    };
    /**
   * Class definition
   */ class Carousel extends BaseComponent {
        // Getters
        static get Default() {
            return Default$b;
        }
        static get DefaultType() {
            return DefaultType$b;
        }
        static get NAME() {
            return NAME$c;
        }
        // Public
        next() {
            this._slide(ORDER_NEXT);
        }
        nextWhenVisible() {
            // FIXME TODO use `document.visibilityState`
            // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && isVisible(this._element)) this.next();
        }
        prev() {
            this._slide(ORDER_PREV);
        }
        pause() {
            if (this._isSliding) triggerTransitionEnd(this._element);
            this._clearInterval();
        }
        cycle() {
            this._clearInterval();
            this._updateInterval();
            this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
        }
        _maybeEnableCycle() {
            if (!this._config.ride) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.cycle());
                return;
            }
            this.cycle();
        }
        to(index) {
            const items = this._getItems();
            if (index > items.length - 1 || index < 0) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.to(index));
                return;
            }
            const activeIndex = this._getItemIndex(this._getActive());
            if (activeIndex === index) return;
            const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
            this._slide(order, items[index]);
        }
        dispose() {
            if (this._swipeHelper) this._swipeHelper.dispose();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            config.defaultInterval = config.interval;
            return config;
        }
        _addEventListeners() {
            if (this._config.keyboard) EventHandler.on(this._element, EVENT_KEYDOWN$1, (event)=>this._keydown(event));
            if (this._config.pause === "hover") {
                EventHandler.on(this._element, EVENT_MOUSEENTER$1, ()=>this.pause());
                EventHandler.on(this._element, EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
            }
            if (this._config.touch && Swipe.isSupported()) this._addTouchEventListeners();
        }
        _addTouchEventListeners() {
            for (const img of SelectorEngine.find(SELECTOR_ITEM_IMG, this._element))EventHandler.on(img, EVENT_DRAG_START, (event)=>event.preventDefault());
            const endCallBack = ()=>{
                if (this._config.pause !== "hover") return;
                // If it's a touch-enabled device, mouseenter/leave are fired as
                // part of the mouse compatibility events on first tap - the carousel
                // would stop cycling until user tapped out of it;
                // here, we listen for touchend, explicitly pause the carousel
                // (as if it's the second time we tap on it, mouseenter compat event
                // is NOT fired) and after a timeout (to allow for mouse compatibility
                // events to fire) we explicitly restart cycling
                this.pause();
                if (this.touchTimeout) clearTimeout(this.touchTimeout);
                this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
            };
            const swipeConfig = {
                leftCallback: ()=>this._slide(this._directionToOrder(DIRECTION_LEFT)),
                rightCallback: ()=>this._slide(this._directionToOrder(DIRECTION_RIGHT)),
                endCallback: endCallBack
            };
            this._swipeHelper = new Swipe(this._element, swipeConfig);
        }
        _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            const direction = KEY_TO_DIRECTION[event.key];
            if (direction) {
                event.preventDefault();
                this._slide(this._directionToOrder(direction));
            }
        }
        _getItemIndex(element) {
            return this._getItems().indexOf(element);
        }
        _setActiveIndicatorElement(index) {
            if (!this._indicatorsElement) return;
            const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
            activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
            activeIndicator.removeAttribute("aria-current");
            const newActiveIndicator = SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
            if (newActiveIndicator) {
                newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
                newActiveIndicator.setAttribute("aria-current", "true");
            }
        }
        _updateInterval() {
            const element = this._activeElement || this._getActive();
            if (!element) return;
            const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
            this._config.interval = elementInterval || this._config.defaultInterval;
        }
        _slide(order, element = null) {
            if (this._isSliding) return;
            const activeElement = this._getActive();
            const isNext = order === ORDER_NEXT;
            const nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
            if (nextElement === activeElement) return;
            const nextElementIndex = this._getItemIndex(nextElement);
            const triggerEvent = (eventName)=>{
                return EventHandler.trigger(this._element, eventName, {
                    relatedTarget: nextElement,
                    direction: this._orderToDirection(order),
                    from: this._getItemIndex(activeElement),
                    to: nextElementIndex
                });
            };
            const slideEvent = triggerEvent(EVENT_SLIDE);
            if (slideEvent.defaultPrevented) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            // TODO: change tests that use empty divs to avoid this check
            return;
            const isCycling = Boolean(this._interval);
            this.pause();
            this._isSliding = true;
            this._setActiveIndicatorElement(nextElementIndex);
            this._activeElement = nextElement;
            const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
            const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
            nextElement.classList.add(orderClassName);
            reflow(nextElement);
            activeElement.classList.add(directionalClassName);
            nextElement.classList.add(directionalClassName);
            const completeCallBack = ()=>{
                nextElement.classList.remove(directionalClassName, orderClassName);
                nextElement.classList.add(CLASS_NAME_ACTIVE$2);
                activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                this._isSliding = false;
                triggerEvent(EVENT_SLID);
            };
            this._queueCallback(completeCallBack, activeElement, this._isAnimated());
            if (isCycling) this.cycle();
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_SLIDE);
        }
        _getActive() {
            return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
        }
        _getItems() {
            return SelectorEngine.find(SELECTOR_ITEM, this._element);
        }
        _clearInterval() {
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
        }
        _directionToOrder(direction) {
            if (isRTL()) return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
            return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
        }
        _orderToDirection(order) {
            if (isRTL()) return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
            return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Carousel.getOrCreateInstance(this, config);
                if (typeof config === "number") {
                    data.to(config);
                    return;
                }
                if (typeof config === "string") {
                    if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._interval = null;
            this._activeElement = null;
            this._isSliding = false;
            this.touchTimeout = null;
            this._swipeHelper = null;
            this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
            this._addEventListeners();
            if (this._config.ride === CLASS_NAME_CAROUSEL) this.cycle();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
        event.preventDefault();
        const carousel = Carousel.getOrCreateInstance(target);
        const slideIndex = this.getAttribute("data-bs-slide-to");
        if (slideIndex) {
            carousel.to(slideIndex);
            carousel._maybeEnableCycle();
            return;
        }
        if (Manipulator.getDataAttribute(this, "slide") === "next") {
            carousel.next();
            carousel._maybeEnableCycle();
            return;
        }
        carousel.prev();
        carousel._maybeEnableCycle();
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$3, ()=>{
        const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
        for (const carousel of carousels)Carousel.getOrCreateInstance(carousel);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Carousel);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$b = "collapse";
    const DATA_KEY$7 = "bs.collapse";
    const EVENT_KEY$7 = `.${DATA_KEY$7}`;
    const DATA_API_KEY$4 = ".data-api";
    const EVENT_SHOW$6 = `show${EVENT_KEY$7}`;
    const EVENT_SHOWN$6 = `shown${EVENT_KEY$7}`;
    const EVENT_HIDE$6 = `hide${EVENT_KEY$7}`;
    const EVENT_HIDDEN$6 = `hidden${EVENT_KEY$7}`;
    const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$7}${DATA_API_KEY$4}`;
    const CLASS_NAME_SHOW$7 = "show";
    const CLASS_NAME_COLLAPSE = "collapse";
    const CLASS_NAME_COLLAPSING = "collapsing";
    const CLASS_NAME_COLLAPSED = "collapsed";
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = "collapse-horizontal";
    const WIDTH = "width";
    const HEIGHT = "height";
    const SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
    const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
    const Default$a = {
        parent: null,
        toggle: true
    };
    const DefaultType$a = {
        parent: "(null|element)",
        toggle: "boolean"
    };
    /**
   * Class definition
   */ class Collapse extends BaseComponent {
        // Getters
        static get Default() {
            return Default$a;
        }
        static get DefaultType() {
            return DefaultType$a;
        }
        static get NAME() {
            return NAME$b;
        }
        // Public
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let activeChildren = [];
            // find active children
            if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                    toggle: false
                }));
            if (activeChildren.length && activeChildren[0]._isTransitioning) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
            if (startEvent.defaultPrevented) return;
            for (const activeInstance of activeChildren)activeInstance.hide();
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
                this._element.style[dimension] = "";
                EventHandler.trigger(this._element, EVENT_SHOWN$6);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
            for (const trigger of this._triggerArray){
                const element = SelectorEngine.getElementFromSelector(trigger);
                if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler.trigger(this._element, EVENT_HIDDEN$6);
            };
            this._element.style[dimension] = "";
            this._queueCallback(complete, this._element, true);
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW$7);
        }
        // Private
        _configAfterMerge(config) {
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = getElement(config.parent);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
            for (const element of children){
                const selected = SelectorEngine.getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            }
        }
        _getFirstLevelChildren(selector) {
            const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            // remove children if greater depth
            return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            for (const element of triggerArray){
                element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                element.setAttribute("aria-expanded", isOpen);
            }
        }
        // Static
        static jQueryInterface(config) {
            const _config = {};
            if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
            return this.each(function() {
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._isTransitioning = false;
            this._triggerArray = [];
            const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
            for (const elem of toggleList){
                const selector = SelectorEngine.getSelectorFromElement(elem);
                const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
                if (selector !== null && filterElement.length) this._triggerArray.push(elem);
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
        for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
            toggle: false
        }).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Collapse);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$a = "dropdown";
    const DATA_KEY$6 = "bs.dropdown";
    const EVENT_KEY$6 = `.${DATA_KEY$6}`;
    const DATA_API_KEY$3 = ".data-api";
    const ESCAPE_KEY$2 = "Escape";
    const TAB_KEY$1 = "Tab";
    const ARROW_UP_KEY$1 = "ArrowUp";
    const ARROW_DOWN_KEY$1 = "ArrowDown";
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    const EVENT_HIDE$5 = `hide${EVENT_KEY$6}`;
    const EVENT_HIDDEN$5 = `hidden${EVENT_KEY$6}`;
    const EVENT_SHOW$5 = `show${EVENT_KEY$6}`;
    const EVENT_SHOWN$5 = `shown${EVENT_KEY$6}`;
    const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const CLASS_NAME_SHOW$6 = "show";
    const CLASS_NAME_DROPUP = "dropup";
    const CLASS_NAME_DROPEND = "dropend";
    const CLASS_NAME_DROPSTART = "dropstart";
    const CLASS_NAME_DROPUP_CENTER = "dropup-center";
    const CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
    const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    const SELECTOR_DATA_TOGGLE_SHOWN = `${SELECTOR_DATA_TOGGLE$3}.${CLASS_NAME_SHOW$6}`;
    const SELECTOR_MENU = ".dropdown-menu";
    const SELECTOR_NAVBAR = ".navbar";
    const SELECTOR_NAVBAR_NAV = ".navbar-nav";
    const SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    const PLACEMENT_TOP = isRTL() ? "top-end" : "top-start";
    const PLACEMENT_TOPEND = isRTL() ? "top-start" : "top-end";
    const PLACEMENT_BOTTOM = isRTL() ? "bottom-end" : "bottom-start";
    const PLACEMENT_BOTTOMEND = isRTL() ? "bottom-start" : "bottom-end";
    const PLACEMENT_RIGHT = isRTL() ? "left-start" : "right-start";
    const PLACEMENT_LEFT = isRTL() ? "right-start" : "left-start";
    const PLACEMENT_TOPCENTER = "top";
    const PLACEMENT_BOTTOMCENTER = "bottom";
    const Default$9 = {
        autoClose: true,
        boundary: "clippingParents",
        display: "dynamic",
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: "toggle"
    };
    const DefaultType$9 = {
        autoClose: "(boolean|string)",
        boundary: "(string|element)",
        display: "string",
        offset: "(array|string|function)",
        popperConfig: "(null|object|function)",
        reference: "(string|element|object)"
    };
    /**
   * Class definition
   */ class Dropdown extends BaseComponent {
        // Getters
        static get Default() {
            return Default$9;
        }
        static get DefaultType() {
            return DefaultType$9;
        }
        static get NAME() {
            return NAME$a;
        }
        // Public
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (isDisabled(this._element) || this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
            if (showEvent.defaultPrevented) return;
            this._createPopper();
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))EventHandler.on(element, "mouseover", noop);
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            this._menu.classList.add(CLASS_NAME_SHOW$6);
            this._element.classList.add(CLASS_NAME_SHOW$6);
            EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
        }
        hide() {
            if (isDisabled(this._element) || !this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            this._completeHide(relatedTarget);
        }
        dispose() {
            if (this._popper) this._popper.destroy();
            super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper) this._popper.update();
        }
        // Private
        _completeHide(relatedTarget) {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
            if (hideEvent.defaultPrevented) return;
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, "mouseover", noop);
            if (this._popper) this._popper.destroy();
            this._menu.classList.remove(CLASS_NAME_SHOW$6);
            this._element.classList.remove(CLASS_NAME_SHOW$6);
            this._element.setAttribute("aria-expanded", "false");
            Manipulator.removeDataAttribute(this._menu, "popper");
            EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
        }
        _getConfig(config) {
            config = super._getConfig(config);
            if (typeof config.reference === "object" && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
            throw new TypeError(`${NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return config;
        }
        _createPopper() {
            if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
            let referenceElement = this._element;
            if (this._config.reference === "parent") referenceElement = this._parent;
            else if (isElement(this._config.reference)) referenceElement = getElement(this._config.reference);
            else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
            const popperConfig = this._getPopperConfig();
            this._popper = Popper__namespace.createPopper(referenceElement, this._menu, popperConfig);
        }
        _isShown() {
            return this._menu.classList.contains(CLASS_NAME_SHOW$6);
        }
        _getPlacement() {
            const parentDropdown = this._parent;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
            // We need to trim the value because custom properties can also include spaces
            const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
        }
        _detectNavbar() {
            return this._element.closest(SELECTOR_NAVBAR) !== null;
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
            if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _getPopperConfig() {
            const defaultBsPopperConfig = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            };
            // Disable Popper if we have a static display or Dropdown is in Navbar
            if (this._inNavbar || this._config.display === "static") {
                Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
                defaultBsPopperConfig.modifiers = [
                    {
                        name: "applyStyles",
                        enabled: false
                    }
                ];
            }
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ])
            };
        }
        _selectMenuItem({ key: key, target: target }) {
            const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>isVisible(element));
            if (!items.length) return;
            // if target isn't included in items (e.g. when expanding the dropdown)
            // allow cycling to get the last item in case key equals ARROW_UP_KEY
            getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Dropdown.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        static clearMenus(event) {
            if (event.button === RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== TAB_KEY$1) return;
            const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
            for (const toggle of openToggles){
                const context = Dropdown.getInstance(toggle);
                if (!context || context._config.autoClose === false) continue;
                const composedPath = event.composedPath();
                const isMenuTarget = composedPath.includes(context._menu);
                if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
                // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                const relatedTarget = {
                    relatedTarget: context._element
                };
                if (event.type === "click") relatedTarget.clickEvent = event;
                context._completeHide(relatedTarget);
            }
        }
        static dataApiKeydownHandler(event) {
            // If not an UP | DOWN | ESCAPE key => not a dropdown command
            // If input/textarea && if key is other than ESCAPE => not a dropdown command
            const isInput = /input|textarea/i.test(event.target.tagName);
            const isEscapeEvent = event.key === ESCAPE_KEY$2;
            const isUpOrDownEvent = [
                ARROW_UP_KEY$1,
                ARROW_DOWN_KEY$1
            ].includes(event.key);
            if (!isUpOrDownEvent && !isEscapeEvent) return;
            if (isInput && !isEscapeEvent) return;
            event.preventDefault();
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
            const instance = Dropdown.getOrCreateInstance(getToggleButton);
            if (isUpOrDownEvent) {
                event.stopPropagation();
                instance.show();
                instance._selectMenuItem(event);
                return;
            }
            if (instance._isShown()) {
                // else is escape and we check if it is shown
                event.stopPropagation();
                instance.hide();
                getToggleButton.focus();
            }
        }
        constructor(element, config){
            super(element, config);
            this._popper = null;
            this._parent = this._element.parentNode; // dropdown wrapper
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
            this._inNavbar = this._detectNavbar();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Dropdown);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$9 = "backdrop";
    const CLASS_NAME_FADE$4 = "fade";
    const CLASS_NAME_SHOW$5 = "show";
    const EVENT_MOUSEDOWN = `mousedown.bs.${NAME$9}`;
    const Default$8 = {
        className: "modal-backdrop",
        clickCallback: null,
        isAnimated: false,
        isVisible: true,
        // if false, we use the backdrop helper without adding any element to the dom
        rootElement: "body" // give the choice to place backdrop under different elements
    };
    const DefaultType$8 = {
        className: "string",
        clickCallback: "(function|null)",
        isAnimated: "boolean",
        isVisible: "boolean",
        rootElement: "(element|string)"
    };
    /**
   * Class definition
   */ class Backdrop extends Config {
        // Getters
        static get Default() {
            return Default$8;
        }
        static get DefaultType() {
            return DefaultType$8;
        }
        static get NAME() {
            return NAME$9;
        }
        // Public
        show(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._append();
            const element = this._getElement();
            if (this._config.isAnimated) reflow(element);
            element.classList.add(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                execute(callback);
            });
        }
        hide(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._getElement().classList.remove(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                this.dispose();
                execute(callback);
            });
        }
        dispose() {
            if (!this._isAppended) return;
            EventHandler.off(this._element, EVENT_MOUSEDOWN);
            this._element.remove();
            this._isAppended = false;
        }
        // Private
        _getElement() {
            if (!this._element) {
                const backdrop = document.createElement("div");
                backdrop.className = this._config.className;
                if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE$4);
                this._element = backdrop;
            }
            return this._element;
        }
        _configAfterMerge(config) {
            // use getElement() with the default "body" to get a fresh Element on each instantiation
            config.rootElement = getElement(config.rootElement);
            return config;
        }
        _append() {
            if (this._isAppended) return;
            const element = this._getElement();
            this._config.rootElement.append(element);
            EventHandler.on(element, EVENT_MOUSEDOWN, ()=>{
                execute(this._config.clickCallback);
            });
            this._isAppended = true;
        }
        _emulateAnimation(callback) {
            executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isAppended = false;
            this._element = null;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$8 = "focustrap";
    const DATA_KEY$5 = "bs.focustrap";
    const EVENT_KEY$5 = `.${DATA_KEY$5}`;
    const EVENT_FOCUSIN$2 = `focusin${EVENT_KEY$5}`;
    const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$5}`;
    const TAB_KEY = "Tab";
    const TAB_NAV_FORWARD = "forward";
    const TAB_NAV_BACKWARD = "backward";
    const Default$7 = {
        autofocus: true,
        trapElement: null // The element to trap focus inside of
    };
    const DefaultType$7 = {
        autofocus: "boolean",
        trapElement: "element"
    };
    /**
   * Class definition
   */ class FocusTrap extends Config {
        // Getters
        static get Default() {
            return Default$7;
        }
        static get DefaultType() {
            return DefaultType$7;
        }
        static get NAME() {
            return NAME$8;
        }
        // Public
        activate() {
            if (this._isActive) return;
            if (this._config.autofocus) this._config.trapElement.focus();
            EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
            EventHandler.on(document, EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
            EventHandler.on(document, EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
            this._isActive = true;
        }
        deactivate() {
            if (!this._isActive) return;
            this._isActive = false;
            EventHandler.off(document, EVENT_KEY$5);
        }
        // Private
        _handleFocusin(event) {
            const { trapElement: trapElement } = this._config;
            if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
            const elements = SelectorEngine.focusableChildren(trapElement);
            if (elements.length === 0) trapElement.focus();
            else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
            else elements[0].focus();
        }
        _handleKeydown(event) {
            if (event.key !== TAB_KEY) return;
            this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isActive = false;
            this._lastTabNavDirection = null;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
    const SELECTOR_STICKY_CONTENT = ".sticky-top";
    const PROPERTY_PADDING = "padding-right";
    const PROPERTY_MARGIN = "margin-right";
    /**
   * Class definition
   */ class ScrollBarHelper {
        // Public
        getWidth() {
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
            const documentWidth = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - documentWidth);
        }
        hide() {
            const width = this.getWidth();
            this._disableOverFlow();
            // give padding to element to balance the hidden scrollbar width
            this._setElementAttributes(this._element, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
            this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
        }
        reset() {
            this._resetElementAttributes(this._element, "overflow");
            this._resetElementAttributes(this._element, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
        }
        isOverflowing() {
            return this.getWidth() > 0;
        }
        // Private
        _disableOverFlow() {
            this._saveInitialAttribute(this._element, "overflow");
            this._element.style.overflow = "hidden";
        }
        _setElementAttributes(selector, styleProperty, callback) {
            const scrollbarWidth = this.getWidth();
            const manipulationCallBack = (element)=>{
                if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                this._saveInitialAttribute(element, styleProperty);
                const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _saveInitialAttribute(element, styleProperty) {
            const actualValue = element.style.getPropertyValue(styleProperty);
            if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
        }
        _resetElementAttributes(selector, styleProperty) {
            const manipulationCallBack = (element)=>{
                const value = Manipulator.getDataAttribute(element, styleProperty);
                // We only want to remove the property if the value is `null`; the value can also be zero
                if (value === null) {
                    element.style.removeProperty(styleProperty);
                    return;
                }
                Manipulator.removeDataAttribute(element, styleProperty);
                element.style.setProperty(styleProperty, value);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _applyManipulationCallback(selector, callBack) {
            if (isElement(selector)) {
                callBack(selector);
                return;
            }
            for (const sel of SelectorEngine.find(selector, this._element))callBack(sel);
        }
        constructor(){
            this._element = document.body;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$7 = "modal";
    const DATA_KEY$4 = "bs.modal";
    const EVENT_KEY$4 = `.${DATA_KEY$4}`;
    const DATA_API_KEY$2 = ".data-api";
    const ESCAPE_KEY$1 = "Escape";
    const EVENT_HIDE$4 = `hide${EVENT_KEY$4}`;
    const EVENT_HIDE_PREVENTED$1 = `hidePrevented${EVENT_KEY$4}`;
    const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$4}`;
    const EVENT_SHOW$4 = `show${EVENT_KEY$4}`;
    const EVENT_SHOWN$4 = `shown${EVENT_KEY$4}`;
    const EVENT_RESIZE$1 = `resize${EVENT_KEY$4}`;
    const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$4}`;
    const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$4}`;
    const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$4}`;
    const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$4}${DATA_API_KEY$2}`;
    const CLASS_NAME_OPEN = "modal-open";
    const CLASS_NAME_FADE$3 = "fade";
    const CLASS_NAME_SHOW$4 = "show";
    const CLASS_NAME_STATIC = "modal-static";
    const OPEN_SELECTOR$1 = ".modal.show";
    const SELECTOR_DIALOG = ".modal-dialog";
    const SELECTOR_MODAL_BODY = ".modal-body";
    const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
    const Default$6 = {
        backdrop: true,
        focus: true,
        keyboard: true
    };
    const DefaultType$6 = {
        backdrop: "(boolean|string)",
        focus: "boolean",
        keyboard: "boolean"
    };
    /**
   * Class definition
   */ class Modal extends BaseComponent {
        // Getters
        static get Default() {
            return Default$6;
        }
        static get DefaultType() {
            return DefaultType$6;
        }
        static get NAME() {
            return NAME$7;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown || this._isTransitioning) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._isTransitioning = true;
            this._scrollBar.hide();
            document.body.classList.add(CLASS_NAME_OPEN);
            this._adjustDialog();
            this._backdrop.show(()=>this._showElement(relatedTarget));
        }
        hide() {
            if (!this._isShown || this._isTransitioning) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
            if (hideEvent.defaultPrevented) return;
            this._isShown = false;
            this._isTransitioning = true;
            this._focustrap.deactivate();
            this._element.classList.remove(CLASS_NAME_SHOW$4);
            this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
        }
        dispose() {
            EventHandler.off(window, EVENT_KEY$4);
            EventHandler.off(this._dialog, EVENT_KEY$4);
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        handleUpdate() {
            this._adjustDialog();
        }
        // Private
        _initializeBackDrop() {
            return new Backdrop({
                isVisible: Boolean(this._config.backdrop),
                // 'static' option will be translated to true, and booleans will keep their value,
                isAnimated: this._isAnimated()
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _showElement(relatedTarget) {
            // try to append dynamic modal
            if (!document.body.contains(this._element)) document.body.append(this._element);
            this._element.style.display = "block";
            this._element.removeAttribute("aria-hidden");
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            this._element.scrollTop = 0;
            const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
            if (modalBody) modalBody.scrollTop = 0;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW$4);
            const transitionComplete = ()=>{
                if (this._config.focus) this._focustrap.activate();
                this._isTransitioning = false;
                EventHandler.trigger(this._element, EVENT_SHOWN$4, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, (event)=>{
                if (event.key !== ESCAPE_KEY$1) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                this._triggerBackdropTransition();
            });
            EventHandler.on(window, EVENT_RESIZE$1, ()=>{
                if (this._isShown && !this._isTransitioning) this._adjustDialog();
            });
            EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, (event)=>{
                // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                EventHandler.one(this._element, EVENT_CLICK_DISMISS, (event2)=>{
                    if (this._element !== event.target || this._element !== event2.target) return;
                    if (this._config.backdrop === "static") {
                        this._triggerBackdropTransition();
                        return;
                    }
                    if (this._config.backdrop) this.hide();
                });
            });
        }
        _hideModal() {
            this._element.style.display = "none";
            this._element.setAttribute("aria-hidden", true);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            this._isTransitioning = false;
            this._backdrop.hide(()=>{
                document.body.classList.remove(CLASS_NAME_OPEN);
                this._resetAdjustments();
                this._scrollBar.reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$4);
            });
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_FADE$3);
        }
        _triggerBackdropTransition() {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
            if (hideEvent.defaultPrevented) return;
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const initialOverflowY = this._element.style.overflowY;
            // return if the following background transition hasn't yet completed
            if (initialOverflowY === "hidden" || this._element.classList.contains(CLASS_NAME_STATIC)) return;
            if (!isModalOverflowing) this._element.style.overflowY = "hidden";
            this._element.classList.add(CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.classList.remove(CLASS_NAME_STATIC);
                this._queueCallback(()=>{
                    this._element.style.overflowY = initialOverflowY;
                }, this._dialog);
            }, this._dialog);
            this._element.focus();
        }
        /**
     * The following methods are used to handle overflowing modals
     */ _adjustDialog() {
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const scrollbarWidth = this._scrollBar.getWidth();
            const isBodyOverflowing = scrollbarWidth > 0;
            if (isBodyOverflowing && !isModalOverflowing) {
                const property = isRTL() ? "paddingLeft" : "paddingRight";
                this._element.style[property] = `${scrollbarWidth}px`;
            }
            if (!isBodyOverflowing && isModalOverflowing) {
                const property = isRTL() ? "paddingRight" : "paddingLeft";
                this._element.style[property] = `${scrollbarWidth}px`;
            }
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = "";
            this._element.style.paddingRight = "";
        }
        // Static
        static jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                const data = Modal.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](relatedTarget);
            });
        }
        constructor(element, config){
            super(element, config);
            this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._isShown = false;
            this._isTransitioning = false;
            this._scrollBar = new ScrollBarHelper();
            this._addEventListeners();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        EventHandler.one(target, EVENT_SHOW$4, (showEvent)=>{
            if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
            return;
            EventHandler.one(target, EVENT_HIDDEN$4, ()=>{
                if (isVisible(this)) this.focus();
            });
        });
        // avoid conflict when clicking modal toggler while another one is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
        if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
        const data = Modal.getOrCreateInstance(target);
        data.toggle(this);
    });
    enableDismissTrigger(Modal);
    /**
   * jQuery
   */ defineJQueryPlugin(Modal);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap offcanvas.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$6 = "offcanvas";
    const DATA_KEY$3 = "bs.offcanvas";
    const EVENT_KEY$3 = `.${DATA_KEY$3}`;
    const DATA_API_KEY$1 = ".data-api";
    const EVENT_LOAD_DATA_API$2 = `load${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const ESCAPE_KEY = "Escape";
    const CLASS_NAME_SHOW$3 = "show";
    const CLASS_NAME_SHOWING$1 = "showing";
    const CLASS_NAME_HIDING = "hiding";
    const CLASS_NAME_BACKDROP = "offcanvas-backdrop";
    const OPEN_SELECTOR = ".offcanvas.show";
    const EVENT_SHOW$3 = `show${EVENT_KEY$3}`;
    const EVENT_SHOWN$3 = `shown${EVENT_KEY$3}`;
    const EVENT_HIDE$3 = `hide${EVENT_KEY$3}`;
    const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$3}`;
    const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$3}`;
    const EVENT_RESIZE = `resize${EVENT_KEY$3}`;
    const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$3}`;
    const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
    const Default$5 = {
        backdrop: true,
        keyboard: true,
        scroll: false
    };
    const DefaultType$5 = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        scroll: "boolean"
    };
    /**
   * Class definition
   */ class Offcanvas extends BaseComponent {
        // Getters
        static get Default() {
            return Default$5;
        }
        static get DefaultType() {
            return DefaultType$5;
        }
        static get NAME() {
            return NAME$6;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._backdrop.show();
            if (!this._config.scroll) new ScrollBarHelper().hide();
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            this._element.classList.add(CLASS_NAME_SHOWING$1);
            const completeCallBack = ()=>{
                if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
                this._element.classList.add(CLASS_NAME_SHOW$3);
                this._element.classList.remove(CLASS_NAME_SHOWING$1);
                EventHandler.trigger(this._element, EVENT_SHOWN$3, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(completeCallBack, this._element, true);
        }
        hide() {
            if (!this._isShown) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
            if (hideEvent.defaultPrevented) return;
            this._focustrap.deactivate();
            this._element.blur();
            this._isShown = false;
            this._element.classList.add(CLASS_NAME_HIDING);
            this._backdrop.hide();
            const completeCallback = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
                this._element.removeAttribute("aria-modal");
                this._element.removeAttribute("role");
                if (!this._config.scroll) new ScrollBarHelper().reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$3);
            };
            this._queueCallback(completeCallback, this._element, true);
        }
        dispose() {
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        // Private
        _initializeBackDrop() {
            const clickCallback = ()=>{
                if (this._config.backdrop === "static") {
                    EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
                    return;
                }
                this.hide();
            };
            // 'static' option will be translated to true, and booleans will keep their value
            const isVisible = Boolean(this._config.backdrop);
            return new Backdrop({
                className: CLASS_NAME_BACKDROP,
                isVisible: isVisible,
                isAnimated: true,
                rootElement: this._element.parentNode,
                clickCallback: isVisible ? clickCallback : null
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, (event)=>{
                if (event.key !== ESCAPE_KEY) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
            });
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Offcanvas.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
        constructor(element, config){
            super(element, config);
            this._isShown = false;
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._addEventListeners();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        EventHandler.one(target, EVENT_HIDDEN$3, ()=>{
            // focus on trigger when it is closed
            if (isVisible(this)) this.focus();
        });
        // avoid conflict when clicking a toggler of an offcanvas, while another is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
        if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
        const data = Offcanvas.getOrCreateInstance(target);
        data.toggle(this);
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$2, ()=>{
        for (const selector of SelectorEngine.find(OPEN_SELECTOR))Offcanvas.getOrCreateInstance(selector).show();
    });
    EventHandler.on(window, EVENT_RESIZE, ()=>{
        for (const element of SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") Offcanvas.getOrCreateInstance(element).hide();
    });
    enableDismissTrigger(Offcanvas);
    /**
   * jQuery
   */ defineJQueryPlugin(Offcanvas);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ // js-docs-start allow-list
    const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    const DefaultAllowlist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    // js-docs-end allow-list
    const uriAttributes = new Set([
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ]);
    /**
   * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
   * contexts.
   *
   * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
   */ // eslint-disable-next-line unicorn/better-regex
    const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
    const allowedAttribute = (attribute, allowedAttributeList)=>{
        const attributeName = attribute.nodeName.toLowerCase();
        if (allowedAttributeList.includes(attributeName)) {
            if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
            return true;
        }
        // Check if a regular expression validates the attribute.
        return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
    };
    function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
        if (!unsafeHtml.length) return unsafeHtml;
        if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
        const domParser = new window.DOMParser();
        const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
        const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
        for (const element of elements){
            const elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            const attributeList = [].concat(...element.attributes);
            const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
            for (const attribute of attributeList)if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/template-factory.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$5 = "TemplateFactory";
    const Default$4 = {
        allowList: DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: "",
        html: false,
        sanitize: true,
        sanitizeFn: null,
        template: "<div></div>"
    };
    const DefaultType$4 = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
    };
    const DefaultContentType = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
    };
    /**
   * Class definition
   */ class TemplateFactory extends Config {
        // Getters
        static get Default() {
            return Default$4;
        }
        static get DefaultType() {
            return DefaultType$4;
        }
        static get NAME() {
            return NAME$5;
        }
        // Public
        getContent() {
            return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
        }
        hasContent() {
            return this.getContent().length > 0;
        }
        changeContent(content) {
            this._checkContent(content);
            this._config.content = {
                ...this._config.content,
                ...content
            };
            return this;
        }
        toHtml() {
            const templateWrapper = document.createElement("div");
            templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
            for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
            const template = templateWrapper.children[0];
            const extraClass = this._resolvePossibleFunction(this._config.extraClass);
            if (extraClass) template.classList.add(...extraClass.split(" "));
            return template;
        }
        // Private
        _typeCheckConfig(config) {
            super._typeCheckConfig(config);
            this._checkContent(config.content);
        }
        _checkContent(arg) {
            for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
                selector: selector,
                entry: content
            }, DefaultContentType);
        }
        _setContent(template, content, selector) {
            const templateElement = SelectorEngine.findOne(selector, template);
            if (!templateElement) return;
            content = this._resolvePossibleFunction(content);
            if (!content) {
                templateElement.remove();
                return;
            }
            if (isElement(content)) {
                this._putElementInTemplate(getElement(content), templateElement);
                return;
            }
            if (this._config.html) {
                templateElement.innerHTML = this._maybeSanitize(content);
                return;
            }
            templateElement.textContent = content;
        }
        _maybeSanitize(arg) {
            return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                this
            ]);
        }
        _putElementInTemplate(element, templateElement) {
            if (this._config.html) {
                templateElement.innerHTML = "";
                templateElement.append(element);
                return;
            }
            templateElement.textContent = element.textContent;
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$4 = "tooltip";
    const DISALLOWED_ATTRIBUTES = new Set([
        "sanitize",
        "allowList",
        "sanitizeFn"
    ]);
    const CLASS_NAME_FADE$2 = "fade";
    const CLASS_NAME_MODAL = "modal";
    const CLASS_NAME_SHOW$2 = "show";
    const SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
    const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
    const EVENT_MODAL_HIDE = "hide.bs.modal";
    const TRIGGER_HOVER = "hover";
    const TRIGGER_FOCUS = "focus";
    const TRIGGER_CLICK = "click";
    const TRIGGER_MANUAL = "manual";
    const EVENT_HIDE$2 = "hide";
    const EVENT_HIDDEN$2 = "hidden";
    const EVENT_SHOW$2 = "show";
    const EVENT_SHOWN$2 = "shown";
    const EVENT_INSERTED = "inserted";
    const EVENT_CLICK$1 = "click";
    const EVENT_FOCUSIN$1 = "focusin";
    const EVENT_FOCUSOUT$1 = "focusout";
    const EVENT_MOUSEENTER = "mouseenter";
    const EVENT_MOUSELEAVE = "mouseleave";
    const AttachmentMap = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: isRTL() ? "left" : "right",
        BOTTOM: "bottom",
        LEFT: isRTL() ? "right" : "left"
    };
    const Default$3 = {
        allowList: DefaultAllowlist,
        animation: true,
        boundary: "clippingParents",
        container: false,
        customClass: "",
        delay: 0,
        fallbackPlacements: [
            "top",
            "right",
            "bottom",
            "left"
        ],
        html: false,
        offset: [
            0,
            6
        ],
        placement: "top",
        popperConfig: null,
        sanitize: true,
        sanitizeFn: null,
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: "",
        trigger: "hover focus"
    };
    const DefaultType$3 = {
        allowList: "object",
        animation: "boolean",
        boundary: "(string|element)",
        container: "(string|element|boolean)",
        customClass: "(string|function)",
        delay: "(number|object)",
        fallbackPlacements: "array",
        html: "boolean",
        offset: "(array|string|function)",
        placement: "(string|function)",
        popperConfig: "(null|object|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        selector: "(string|boolean)",
        template: "string",
        title: "(string|element|function)",
        trigger: "string"
    };
    /**
   * Class definition
   */ class Tooltip extends BaseComponent {
        // Getters
        static get Default() {
            return Default$3;
        }
        static get DefaultType() {
            return DefaultType$3;
        }
        static get NAME() {
            return NAME$4;
        }
        // Public
        enable() {
            this._isEnabled = true;
        }
        disable() {
            this._isEnabled = false;
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        }
        toggle() {
            if (!this._isEnabled) return;
            this._activeTrigger.click = !this._activeTrigger.click;
            if (this._isShown()) {
                this._leave();
                return;
            }
            this._enter();
        }
        dispose() {
            clearTimeout(this._timeout);
            EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
            if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
            this._disposePopper();
            super.dispose();
        }
        show() {
            if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
            if (!(this._isWithContent() && this._isEnabled)) return;
            const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
            const shadowRoot = findShadowRoot(this._element);
            const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
            if (showEvent.defaultPrevented || !isInTheDom) return;
            // TODO: v6 remove this or make it optional
            this._disposePopper();
            const tip = this._getTipElement();
            this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
            const { container: container } = this._config;
            if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                container.append(tip);
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
            }
            this._popper = this._createPopper(tip);
            tip.classList.add(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.on(element, "mouseover", noop);
            const complete = ()=>{
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN$2));
                if (this._isHovered === false) this._leave();
                this._isHovered = false;
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        hide() {
            if (!this._isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
            if (hideEvent.defaultPrevented) return;
            const tip = this._getTipElement();
            tip.classList.remove(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, "mouseover", noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            this._isHovered = null; // it is a trick to support manual triggering
            const complete = ()=>{
                if (this._isWithActiveTrigger()) return;
                if (!this._isHovered) this._disposePopper();
                this._element.removeAttribute("aria-describedby");
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN$2));
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        update() {
            if (this._popper) this._popper.update();
        }
        // Protected
        _isWithContent() {
            return Boolean(this._getTitle());
        }
        _getTipElement() {
            if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
            return this.tip;
        }
        _createTipElement(content) {
            const tip = this._getTemplateFactory(content).toHtml();
            // TODO: remove this check in v6
            if (!tip) return null;
            tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
            // TODO: v6 the following can be achieved with CSS only
            tip.classList.add(`bs-${this.constructor.NAME}-auto`);
            const tipId = getUID(this.constructor.NAME).toString();
            tip.setAttribute("id", tipId);
            if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE$2);
            return tip;
        }
        setContent(content) {
            this._newContent = content;
            if (this._isShown()) {
                this._disposePopper();
                this.show();
            }
        }
        _getTemplateFactory(content) {
            if (this._templateFactory) this._templateFactory.changeContent(content);
            else this._templateFactory = new TemplateFactory({
                ...this._config,
                content: // the `content` var has to be after `this._config`
                // to override config.content in case of popover
                content,
                extraClass: this._resolvePossibleFunction(this._config.customClass)
            });
            return this._templateFactory;
        }
        _getContentForTemplate() {
            return {
                [SELECTOR_TOOLTIP_INNER]: this._getTitle()
            };
        }
        _getTitle() {
            return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
        }
        // Private
        _initializeOnDelegatedTarget(event) {
            return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
        }
        _isAnimated() {
            return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
        }
        _isShown() {
            return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
        }
        _createPopper(tip) {
            const placement = execute(this._config.placement, [
                this,
                tip,
                this._element
            ]);
            const attachment = AttachmentMap[placement.toUpperCase()];
            return Popper__namespace.createPopper(this._element, tip, this._getPopperConfig(attachment));
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
            if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                this._element
            ]);
        }
        _getPopperConfig(attachment) {
            const defaultBsPopperConfig = {
                placement: attachment,
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            fallbackPlacements: this._config.fallbackPlacements
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "arrow",
                        options: {
                            element: `.${this.constructor.NAME}-arrow`
                        }
                    },
                    {
                        name: "preSetPlacement",
                        enabled: true,
                        phase: "beforeMain",
                        fn: (data)=>{
                            // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                            // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                            this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                        }
                    }
                ]
            };
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ])
            };
        }
        _setListeners() {
            const triggers = this._config.trigger.split(" ");
            for (const trigger of triggers){
                if (trigger === "click") EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context.toggle();
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
                    const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
                    EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                        context._enter();
                    });
                    EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                        context._leave();
                    });
                }
            }
            this._hideModalHandler = ()=>{
                if (this._element) this.hide();
            };
            EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        }
        _fixTitle() {
            const title = this._element.getAttribute("title");
            if (!title) return;
            if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
            this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
            this._element.removeAttribute("title");
        }
        _enter() {
            if (this._isShown() || this._isHovered) {
                this._isHovered = true;
                return;
            }
            this._isHovered = true;
            this._setTimeout(()=>{
                if (this._isHovered) this.show();
            }, this._config.delay.show);
        }
        _leave() {
            if (this._isWithActiveTrigger()) return;
            this._isHovered = false;
            this._setTimeout(()=>{
                if (!this._isHovered) this.hide();
            }, this._config.delay.hide);
        }
        _setTimeout(handler, timeout) {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(handler, timeout);
        }
        _isWithActiveTrigger() {
            return Object.values(this._activeTrigger).includes(true);
        }
        _getConfig(config) {
            const dataAttributes = Manipulator.getDataAttributes(this._element);
            for (const dataAttribute of Object.keys(dataAttributes))if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
            config = {
                ...dataAttributes,
                ...typeof config === "object" && config ? config : {}
            };
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            config.container = config.container === false ? document.body : getElement(config.container);
            if (typeof config.delay === "number") config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === "number") config.title = config.title.toString();
            if (typeof config.content === "number") config.content = config.content.toString();
            return config;
        }
        _getDelegateConfig() {
            const config = {};
            for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
            config.selector = false;
            config.trigger = "manual";
            // In the future can be replaced with:
            // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
            // `Object.fromEntries(keysWithDifferentValues)`
            return config;
        }
        _disposePopper() {
            if (this._popper) {
                this._popper.destroy();
                this._popper = null;
            }
            if (this.tip) {
                this.tip.remove();
                this.tip = null;
            }
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tooltip.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element, config){
            if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
            super(element, config);
            // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._isHovered = null;
            this._activeTrigger = {};
            this._popper = null;
            this._templateFactory = null;
            this._newContent = null;
            // Protected
            this.tip = null;
            this._setListeners();
            if (!this._config.selector) this._fixTitle();
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Tooltip);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$3 = "popover";
    const SELECTOR_TITLE = ".popover-header";
    const SELECTOR_CONTENT = ".popover-body";
    const Default$2 = {
        ...Tooltip.Default,
        content: "",
        offset: [
            0,
            8
        ],
        placement: "right",
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: "click"
    };
    const DefaultType$2 = {
        ...Tooltip.DefaultType,
        content: "(null|string|element|function)"
    };
    /**
   * Class definition
   */ class Popover extends Tooltip {
        // Getters
        static get Default() {
            return Default$2;
        }
        static get DefaultType() {
            return DefaultType$2;
        }
        static get NAME() {
            return NAME$3;
        }
        // Overrides
        _isWithContent() {
            return this._getTitle() || this._getContent();
        }
        // Private
        _getContentForTemplate() {
            return {
                [SELECTOR_TITLE]: this._getTitle(),
                [SELECTOR_CONTENT]: this._getContent()
            };
        }
        _getContent() {
            return this._resolvePossibleFunction(this._config.content);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Popover.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Popover);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$2 = "scrollspy";
    const DATA_KEY$2 = "bs.scrollspy";
    const EVENT_KEY$2 = `.${DATA_KEY$2}`;
    const DATA_API_KEY = ".data-api";
    const EVENT_ACTIVATE = `activate${EVENT_KEY$2}`;
    const EVENT_CLICK = `click${EVENT_KEY$2}`;
    const EVENT_LOAD_DATA_API$1 = `load${EVENT_KEY$2}${DATA_API_KEY}`;
    const CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    const CLASS_NAME_ACTIVE$1 = "active";
    const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    const SELECTOR_TARGET_LINKS = "[href]";
    const SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    const SELECTOR_NAV_LINKS = ".nav-link";
    const SELECTOR_NAV_ITEMS = ".nav-item";
    const SELECTOR_LIST_ITEMS = ".list-group-item";
    const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_NAV_ITEMS} > ${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`;
    const SELECTOR_DROPDOWN = ".dropdown";
    const SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
    const Default$1 = {
        offset: null,
        // TODO: v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: "0px 0px -25%",
        smoothScroll: false,
        target: null,
        threshold: [
            0.1,
            0.5,
            1
        ]
    };
    const DefaultType$1 = {
        offset: "(number|null)",
        // TODO v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: "string",
        smoothScroll: "boolean",
        target: "element",
        threshold: "array"
    };
    /**
   * Class definition
   */ class ScrollSpy extends BaseComponent {
        // Getters
        static get Default() {
            return Default$1;
        }
        static get DefaultType() {
            return DefaultType$1;
        }
        static get NAME() {
            return NAME$2;
        }
        // Public
        refresh() {
            this._initializeTargetsAndObservables();
            this._maybeEnableSmoothScroll();
            if (this._observer) this._observer.disconnect();
            else this._observer = this._getNewObserver();
            for (const section of this._observableSections.values())this._observer.observe(section);
        }
        dispose() {
            this._observer.disconnect();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
            config.target = getElement(config.target) || document.body;
            // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
            config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
            if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
            return config;
        }
        _maybeEnableSmoothScroll() {
            if (!this._config.smoothScroll) return;
            // unregister any previous listeners
            EventHandler.off(this._config.target, EVENT_CLICK);
            EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, (event)=>{
                const observableSection = this._observableSections.get(event.target.hash);
                if (observableSection) {
                    event.preventDefault();
                    const root = this._rootElement || window;
                    const height = observableSection.offsetTop - this._element.offsetTop;
                    if (root.scrollTo) {
                        root.scrollTo({
                            top: height,
                            behavior: "smooth"
                        });
                        return;
                    }
                    // Chrome 60 doesn't support `scrollTo`
                    root.scrollTop = height;
                }
            });
        }
        _getNewObserver() {
            const options = {
                root: this._rootElement,
                threshold: this._config.threshold,
                rootMargin: this._config.rootMargin
            };
            return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
        }
        // The logic of selection
        _observerCallback(entries) {
            const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
            const activate = (entry)=>{
                this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                this._process(targetElement(entry));
            };
            const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
            const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
            this._previousScrollData.parentScrollTop = parentScrollTop;
            for (const entry of entries){
                if (!entry.isIntersecting) {
                    this._activeTarget = null;
                    this._clearActiveClass(targetElement(entry));
                    continue;
                }
                const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                // if we are scrolling down, pick the bigger offsetTop
                if (userScrollsDown && entryIsLowerThanPrevious) {
                    activate(entry);
                    // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                    if (!parentScrollTop) return;
                    continue;
                }
                // if we are scrolling up, pick the smallest offsetTop
                if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
            }
        }
        _initializeTargetsAndObservables() {
            this._targetLinks = new Map();
            this._observableSections = new Map();
            const targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
            for (const anchor of targetLinks){
                // ensure that the anchor has an id and is not disabled
                if (!anchor.hash || isDisabled(anchor)) continue;
                const observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                // ensure that the observableSection exists & is visible
                if (isVisible(observableSection)) {
                    this._targetLinks.set(decodeURI(anchor.hash), anchor);
                    this._observableSections.set(anchor.hash, observableSection);
                }
            }
        }
        _process(target) {
            if (this._activeTarget === target) return;
            this._clearActiveClass(this._config.target);
            this._activeTarget = target;
            target.classList.add(CLASS_NAME_ACTIVE$1);
            this._activateParents(target);
            EventHandler.trigger(this._element, EVENT_ACTIVATE, {
                relatedTarget: target
            });
        }
        _activateParents(target) {
            // Activate dropdown parents
            if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
                SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
                return;
            }
            for (const listGroup of SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
            for (const item of SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS))item.classList.add(CLASS_NAME_ACTIVE$1);
        }
        _clearActiveClass(parent) {
            parent.classList.remove(CLASS_NAME_ACTIVE$1);
            const activeNodes = SelectorEngine.find(`${SELECTOR_TARGET_LINKS}.${CLASS_NAME_ACTIVE$1}`, parent);
            for (const node of activeNodes)node.classList.remove(CLASS_NAME_ACTIVE$1);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = ScrollSpy.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element, config){
            super(element, config);
            // this._element is the observablesContainer and config.target the menu links wrapper
            this._targetLinks = new Map();
            this._observableSections = new Map();
            this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
            this._activeTarget = null;
            this._observer = null;
            this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            };
            this.refresh(); // initialize
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(window, EVENT_LOAD_DATA_API$1, ()=>{
        for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY))ScrollSpy.getOrCreateInstance(spy);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(ScrollSpy);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$1 = "tab";
    const DATA_KEY$1 = "bs.tab";
    const EVENT_KEY$1 = `.${DATA_KEY$1}`;
    const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
    const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
    const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
    const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY$1}`;
    const EVENT_KEYDOWN = `keydown${EVENT_KEY$1}`;
    const EVENT_LOAD_DATA_API = `load${EVENT_KEY$1}`;
    const ARROW_LEFT_KEY = "ArrowLeft";
    const ARROW_RIGHT_KEY = "ArrowRight";
    const ARROW_UP_KEY = "ArrowUp";
    const ARROW_DOWN_KEY = "ArrowDown";
    const HOME_KEY = "Home";
    const END_KEY = "End";
    const CLASS_NAME_ACTIVE = "active";
    const CLASS_NAME_FADE$1 = "fade";
    const CLASS_NAME_SHOW$1 = "show";
    const CLASS_DROPDOWN = "dropdown";
    const SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    const SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
    const NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${SELECTOR_DROPDOWN_TOGGLE})`;
    const SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
    const SELECTOR_OUTER = ".nav-item, .list-group-item";
    const SELECTOR_INNER = `.nav-link${NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${NOT_SELECTOR_DROPDOWN_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
    const SELECTOR_INNER_ELEM = `${SELECTOR_INNER}, ${SELECTOR_DATA_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
    /**
   * Class definition
   */ class Tab extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$1;
        }
        // Public
        show() {
            // Shows this elem and deactivate the active sibling if exists
            const innerElem = this._element;
            if (this._elemIsActive(innerElem)) return;
            // Search for active tab on same parent to deactivate it
            const active = this._getActiveElem();
            const hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
                relatedTarget: innerElem
            }) : null;
            const showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
                relatedTarget: active
            });
            if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
            this._deactivate(active, innerElem);
            this._activate(innerElem, active);
        }
        // Private
        _activate(element, relatedElem) {
            if (!element) return;
            element.classList.add(CLASS_NAME_ACTIVE);
            this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
            const complete = ()=>{
                if (element.getAttribute("role") !== "tab") {
                    element.classList.add(CLASS_NAME_SHOW$1);
                    return;
                }
                element.removeAttribute("tabindex");
                element.setAttribute("aria-selected", true);
                this._toggleDropDown(element, true);
                EventHandler.trigger(element, EVENT_SHOWN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _deactivate(element, relatedElem) {
            if (!element) return;
            element.classList.remove(CLASS_NAME_ACTIVE);
            element.blur();
            this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
            const complete = ()=>{
                if (element.getAttribute("role") !== "tab") {
                    element.classList.remove(CLASS_NAME_SHOW$1);
                    return;
                }
                element.setAttribute("aria-selected", false);
                element.setAttribute("tabindex", "-1");
                this._toggleDropDown(element, false);
                EventHandler.trigger(element, EVENT_HIDDEN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _keydown(event) {
            if (![
                ARROW_LEFT_KEY,
                ARROW_RIGHT_KEY,
                ARROW_UP_KEY,
                ARROW_DOWN_KEY,
                HOME_KEY,
                END_KEY
            ].includes(event.key)) return;
            event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
            event.preventDefault();
            const children = this._getChildren().filter((element)=>!isDisabled(element));
            let nextActiveElement;
            if ([
                HOME_KEY,
                END_KEY
            ].includes(event.key)) nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
            else {
                const isNext = [
                    ARROW_RIGHT_KEY,
                    ARROW_DOWN_KEY
                ].includes(event.key);
                nextActiveElement = getNextActiveElement(children, event.target, isNext, true);
            }
            if (nextActiveElement) {
                nextActiveElement.focus({
                    preventScroll: true
                });
                Tab.getOrCreateInstance(nextActiveElement).show();
            }
        }
        _getChildren() {
            // collection of inner elements
            return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
        }
        _getActiveElem() {
            return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
        }
        _setInitialAttributes(parent, children) {
            this._setAttributeIfNotExists(parent, "role", "tablist");
            for (const child of children)this._setInitialAttributesOnChild(child);
        }
        _setInitialAttributesOnChild(child) {
            child = this._getInnerElement(child);
            const isActive = this._elemIsActive(child);
            const outerElem = this._getOuterElement(child);
            child.setAttribute("aria-selected", isActive);
            if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
            if (!isActive) child.setAttribute("tabindex", "-1");
            this._setAttributeIfNotExists(child, "role", "tab");
            // set attributes to the related panel too
            this._setInitialAttributesOnTargetPanel(child);
        }
        _setInitialAttributesOnTargetPanel(child) {
            const target = SelectorEngine.getElementFromSelector(child);
            if (!target) return;
            this._setAttributeIfNotExists(target, "role", "tabpanel");
            if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
        }
        _toggleDropDown(element, open) {
            const outerElem = this._getOuterElement(element);
            if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
            const toggle = (selector, className)=>{
                const element = SelectorEngine.findOne(selector, outerElem);
                if (element) element.classList.toggle(className, open);
            };
            toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
            toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
            outerElem.setAttribute("aria-expanded", open);
        }
        _setAttributeIfNotExists(element, attribute, value) {
            if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
        }
        _elemIsActive(elem) {
            return elem.classList.contains(CLASS_NAME_ACTIVE);
        }
        // Try to get the inner element (usually the .nav-link)
        _getInnerElement(elem) {
            return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
        }
        // Try to get the outer element (usually the .nav-item)
        _getOuterElement(elem) {
            return elem.closest(SELECTOR_OUTER) || elem;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tab.getOrCreateInstance(this);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element){
            super(element);
            this._parent = this._element.closest(SELECTOR_TAB_PANEL);
            if (!this._parent) return;
            // Set up initial aria attributes
            this._setInitialAttributes(this._parent, this._getChildren());
            EventHandler.on(this._element, EVENT_KEYDOWN, (event)=>this._keydown(event));
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        Tab.getOrCreateInstance(this).show();
    });
    /**
   * Initialize on focus
   */ EventHandler.on(window, EVENT_LOAD_DATA_API, ()=>{
        for (const element of SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE))Tab.getOrCreateInstance(element);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Tab);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap toast.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = "toast";
    const DATA_KEY = "bs.toast";
    const EVENT_KEY = `.${DATA_KEY}`;
    const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
    const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
    const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
    const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const CLASS_NAME_FADE = "fade";
    const CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_SHOWING = "showing";
    const DefaultType = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    const Default = {
        animation: true,
        autohide: true,
        delay: 5000
    };
    /**
   * Class definition
   */ class Toast extends BaseComponent {
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        show() {
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
            if (showEvent.defaultPrevented) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            const complete = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOWING);
                EventHandler.trigger(this._element, EVENT_SHOWN);
                this._maybeScheduleHide();
            };
            this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        hide() {
            if (!this.isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
            if (hideEvent.defaultPrevented) return;
            const complete = ()=>{
                this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
                this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
                EventHandler.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        dispose() {
            this._clearTimeout();
            if (this.isShown()) this._element.classList.remove(CLASS_NAME_SHOW);
            super.dispose();
        }
        isShown() {
            return this._element.classList.contains(CLASS_NAME_SHOW);
        }
        // Private
        _maybeScheduleHide() {
            if (!this._config.autohide) return;
            if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
            this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay);
        }
        _onInteraction(event, isInteracting) {
            switch(event.type){
                case "mouseover":
                case "mouseout":
                    this._hasMouseInteraction = isInteracting;
                    break;
                case "focusin":
                case "focusout":
                    this._hasKeyboardInteraction = isInteracting;
                    break;
            }
            if (isInteracting) {
                this._clearTimeout();
                return;
            }
            const nextElement = event.relatedTarget;
            if (this._element === nextElement || this._element.contains(nextElement)) return;
            this._maybeScheduleHide();
        }
        _setListeners() {
            EventHandler.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
            EventHandler.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
        }
        _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Toast.getOrCreateInstance(this, config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config](this);
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._timeout = null;
            this._hasMouseInteraction = false;
            this._hasKeyboardInteraction = false;
            this._setListeners();
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Toast);
    /**
   * jQuery
   */ defineJQueryPlugin(Toast);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap index.umd.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const index_umd = {
        Alert: Alert,
        Button: Button,
        Carousel: Carousel,
        Collapse: Collapse,
        Dropdown: Dropdown,
        Modal: Modal,
        Offcanvas: Offcanvas,
        Popover: Popover,
        ScrollSpy: ScrollSpy,
        Tab: Tab,
        Toast: Toast,
        Tooltip: Tooltip
    };
    return index_umd;
});




var $bfd143f5026247cb$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else $bfd143f5026247cb$exports = factory();
})($bfd143f5026247cb$exports, function() {
    var NProgress = {};
    NProgress.version = "0.2.0";
    var Settings = NProgress.settings = {
        minimum: 0.08,
        easing: "ease",
        positionUsing: "",
        speed: 200,
        trickle: true,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: true,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: "body",
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */ NProgress.configure = function(options) {
        var key, value;
        for(key in options){
            value = options[key];
            if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
        }
        return this;
    };
    /**
   * Last number.
   */ NProgress.status = null;
    /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */ NProgress.set = function(n) {
        var started = NProgress.isStarted();
        n = clamp(n, Settings.minimum, 1);
        NProgress.status = n === 1 ? null : n;
        var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
        progress.offsetWidth; /* Repaint */ 
        queue(function(next) {
            // Set positionUsing if it hasn't already been set
            if (Settings.positionUsing === "") Settings.positionUsing = NProgress.getPositioningCSS();
            // Add transition
            css(bar, barPositionCSS(n, speed, ease));
            if (n === 1) {
                // Fade out
                css(progress, {
                    transition: "none",
                    opacity: 1
                });
                progress.offsetWidth; /* Repaint */ 
                setTimeout(function() {
                    css(progress, {
                        transition: "all " + speed + "ms linear",
                        opacity: 0
                    });
                    setTimeout(function() {
                        NProgress.remove();
                        next();
                    }, speed);
                }, speed);
            } else setTimeout(next, speed);
        });
        return this;
    };
    NProgress.isStarted = function() {
        return typeof NProgress.status === "number";
    };
    /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */ NProgress.start = function() {
        if (!NProgress.status) NProgress.set(0);
        var work = function() {
            setTimeout(function() {
                if (!NProgress.status) return;
                NProgress.trickle();
                work();
            }, Settings.trickleSpeed);
        };
        if (Settings.trickle) work();
        return this;
    };
    /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */ NProgress.done = function(force) {
        if (!force && !NProgress.status) return this;
        return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
    };
    /**
   * Increments by a random amount.
   */ NProgress.inc = function(amount) {
        var n = NProgress.status;
        if (!n) return NProgress.start();
        else {
            if (typeof amount !== "number") amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
            n = clamp(n + amount, 0, 0.994);
            return NProgress.set(n);
        }
    };
    NProgress.trickle = function() {
        return NProgress.inc(Math.random() * Settings.trickleRate);
    };
    /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */ (function() {
        var initial = 0, current = 0;
        NProgress.promise = function($promise) {
            if (!$promise || $promise.state() === "resolved") return this;
            if (current === 0) NProgress.start();
            initial++;
            current++;
            $promise.always(function() {
                current--;
                if (current === 0) {
                    initial = 0;
                    NProgress.done();
                } else NProgress.set((initial - current) / initial);
            });
            return this;
        };
    })();
    /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */ NProgress.render = function(fromStart) {
        if (NProgress.isRendered()) return document.getElementById("nprogress");
        addClass(document.documentElement, "nprogress-busy");
        var progress = document.createElement("div");
        progress.id = "nprogress";
        progress.innerHTML = Settings.template;
        var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? "-100" : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
        css(bar, {
            transition: "all 0 linear",
            transform: "translate3d(" + perc + "%,0,0)"
        });
        if (!Settings.showSpinner) {
            spinner = progress.querySelector(Settings.spinnerSelector);
            spinner && removeElement(spinner);
        }
        if (parent != document.body) addClass(parent, "nprogress-custom-parent");
        parent.appendChild(progress);
        return progress;
    };
    /**
   * Removes the element. Opposite of render().
   */ NProgress.remove = function() {
        removeClass(document.documentElement, "nprogress-busy");
        removeClass(document.querySelector(Settings.parent), "nprogress-custom-parent");
        var progress = document.getElementById("nprogress");
        progress && removeElement(progress);
    };
    /**
   * Checks if the progress bar is rendered.
   */ NProgress.isRendered = function() {
        return !!document.getElementById("nprogress");
    };
    /**
   * Determine which positioning CSS rule to use.
   */ NProgress.getPositioningCSS = function() {
        // Sniff on document.body.style
        var bodyStyle = document.body.style;
        // Sniff prefixes
        var vendorPrefix = "WebkitTransform" in bodyStyle ? "Webkit" : "MozTransform" in bodyStyle ? "Moz" : "msTransform" in bodyStyle ? "ms" : "OTransform" in bodyStyle ? "O" : "";
        if (vendorPrefix + "Perspective" in bodyStyle) // Modern browsers with 3D support, e.g. Webkit, IE10
        return "translate3d";
        else if (vendorPrefix + "Transform" in bodyStyle) // Browsers without 3D support, e.g. IE9
        return "translate";
        else // Browsers without translate() support, e.g. IE7-8
        return "margin";
    };
    /**
   * Helpers
   */ function clamp(n, min, max) {
        if (n < min) return min;
        if (n > max) return max;
        return n;
    }
    /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */ function toBarPerc(n) {
        return (-1 + n) * 100;
    }
    /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */ function barPositionCSS(n, speed, ease) {
        var barCSS;
        if (Settings.positionUsing === "translate3d") barCSS = {
            transform: "translate3d(" + toBarPerc(n) + "%,0,0)"
        };
        else if (Settings.positionUsing === "translate") barCSS = {
            transform: "translate(" + toBarPerc(n) + "%,0)"
        };
        else barCSS = {
            "margin-left": toBarPerc(n) + "%"
        };
        barCSS.transition = "all " + speed + "ms " + ease;
        return barCSS;
    }
    /**
   * (Internal) Queues a function to be executed.
   */ var queue = function() {
        var pending = [];
        function next() {
            var fn = pending.shift();
            if (fn) fn(next);
        }
        return function(fn) {
            pending.push(fn);
            if (pending.length == 1) next();
        };
    }();
    /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */ var css = function() {
        var cssPrefixes = [
            "Webkit",
            "O",
            "Moz",
            "ms"
        ], cssProps = {};
        function camelCase(string) {
            return string.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(match, letter) {
                return letter.toUpperCase();
            });
        }
        function getVendorProp(name) {
            var style = document.body.style;
            if (name in style) return name;
            var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
            while(i--){
                vendorName = cssPrefixes[i] + capName;
                if (vendorName in style) return vendorName;
            }
            return name;
        }
        function getStyleProp(name) {
            name = camelCase(name);
            return cssProps[name] || (cssProps[name] = getVendorProp(name));
        }
        function applyCss(element, prop, value) {
            prop = getStyleProp(prop);
            element.style[prop] = value;
        }
        return function(element, properties) {
            var args = arguments, prop, value;
            if (args.length == 2) for(prop in properties){
                value = properties[prop];
                if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
            }
            else applyCss(element, args[1], args[2]);
        };
    }();
    /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */ function hasClass(element, name) {
        var list = typeof element == "string" ? element : classList(element);
        return list.indexOf(" " + name + " ") >= 0;
    }
    /**
   * (Internal) Adds a class to an element.
   */ function addClass(element, name) {
        var oldList = classList(element), newList = oldList + name;
        if (hasClass(oldList, name)) return;
        // Trim the opening space.
        element.className = newList.substring(1);
    }
    /**
   * (Internal) Removes a class from an element.
   */ function removeClass(element, name) {
        var oldList = classList(element), newList;
        if (!hasClass(element, name)) return;
        // Replace the class name.
        newList = oldList.replace(" " + name + " ", " ");
        // Trim the opening and closing spaces.
        element.className = newList.substring(1, newList.length - 1);
    }
    /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */ function classList(element) {
        return (" " + (element.className || "") + " ").replace(/\s+/gi, " ");
    }
    /**
   * (Internal) Removes an element from the DOM.
   */ function removeElement(element) {
        element && element.parentNode && element.parentNode.removeChild(element);
    }
    return NProgress;
});


// Copyright (C) Konrad Gadzinowski
class $b75b7c1126578ead$export$9701f5bc74a805e5 {
    constructor(){
        this.pages = new Array();
        this.addPage = (page)=>{
            this.pages.push(page);
        };
        this.setPjax = (pjax)=>{
            this.pjax = pjax;
        };
        this.getCurrentPageId = ()=>{
            if (!this.currentPage) return "";
            return this.currentPage.getPageId();
        };
        this.setupPage = ()=>{
            this.closePage();
            let page = this.executeCurrentPageLogic();
            if (page) this.currentPage = page;
        };
        this.closePage = ()=>{
            if (this.currentPage) {
                this.currentPage.onPageClose();
                this.currentPage = null;
            }
        };
        this.executeCurrentPageLogic = ()=>{
            const pageIdElement = document.querySelector("#pageId");
            if (!pageIdElement) return;
            const pageId = pageIdElement.innerText;
            pageIdElement.parentNode.removeChild(pageIdElement);
            if (!pageId || pageId.length === 0) return;
            for(let i = 0; i < this.pages.length; i++){
                let page = this.pages[i];
                if (pageId == page.getPageId()) {
                    page.execute(this.pjax);
                    return page;
                }
            }
            return null;
        };
        this.pages = new Array();
    }
}


// Copyright (C) Konrad Gadzinowski
class $54f37c9212c86cf8$export$a7fed597f4b8afd8 {
}
$54f37c9212c86cf8$export$a7fed597f4b8afd8.setupForms = ()=>{
    // Validate forms
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(".needs-validation");
    // Loop over them and prevent submission
    for (const form of forms){
        var _form_querySelectorAll;
        // In Firefox, check validity on submit button click. You can't prevent form submit event on Firefox.
        const submitButtons = (_form_querySelectorAll = form.querySelectorAll("button[type=submit]")) !== null && _form_querySelectorAll !== void 0 ? _form_querySelectorAll : [];
        for (const button of submitButtons)// Handle submit event
        button.addEventListener("click", (event)=>{
            form.classList.add("was-validated");
            // Validate form
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            return true;
        }, true);
        // Handle submit event
        form.addEventListener("submit", (event)=>{
            form.classList.add("was-validated");
            // Validate form
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            // If valid block all submit buttons, so that they can't be clicked again
            const submitButtons = form.querySelectorAll("button[type=submit]");
            for (const button of submitButtons){
                button.type = "button";
                button.disabled = "true";
            }
        }, true);
    }
};




class $63b595d905f6b553$export$9bbedc1992a787b4 {
    constructor(onPageLoaded){
        this.initiated = false;
        this.start = (pages)=>{
            if (this.initiated) return;
            this.initiated = true;
            this.setupPjax();
            this.pagesCtrl = new (0, $b75b7c1126578ead$export$9701f5bc74a805e5)();
            if (!!pages) for (const page of pages)this.pagesCtrl.addPage(page);
        };
        this.setupPjax = ()=>{
            document.addEventListener("DOMContentLoaded", ()=>{
                this.pjax = new (0, (/*@__PURE__*/$parcel$interopDefault($d26b75c87b693463$exports)))({
                    elements: 'a:not([target="_blank"]):not(.noPjax)[href], form.pjax',
                    selectors: [
                        "title",
                        "header",
                        "main",
                        "footer",
                        "style"
                    ],
                    cacheBust: false
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).configure({
                    parent: "body",
                    showSpinner: false
                });
                this.pagesCtrl.setPjax(this.pjax);
                this.pagesCtrl.setupPage();
                (0, $54f37c9212c86cf8$export$a7fed597f4b8afd8).setupForms();
                if (!!this.onPageLoaded) this.onPageLoaded();
            });
            document.addEventListener("pjax:send", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).start();
            });
            document.addEventListener("pjax:complete", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).done();
            });
            document.addEventListener("pjax:error", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).done();
            });
            document.addEventListener("pjax:success", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).done();
                this.pagesCtrl.setupPage();
                (0, $54f37c9212c86cf8$export$a7fed597f4b8afd8).setupForms();
                if (!!this.onPageLoaded) this.onPageLoaded();
            });
        };
        this.onPageLoaded = onPageLoaded;
    }
}


// Copyright (C) Konrad Gadzinowski
class $a30b3a9a137baaed$export$1d8a493107fb4b3a {
}
$a30b3a9a137baaed$export$1d8a493107fb4b3a.toClipboard = (text)=>{
    if (!navigator.clipboard) {
        $a30b3a9a137baaed$export$1d8a493107fb4b3a.copyToClipboardFallback(text);
        return;
    }
    navigator.clipboard.writeText(text).then(()=>{
    // Ignore
    }, (error)=>{
        $a30b3a9a137baaed$export$1d8a493107fb4b3a.copyToClipboardFallback(text);
    });
};
$a30b3a9a137baaed$export$1d8a493107fb4b3a.copyToClipboardFallback = (text)=>{
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    // Rewmember existing selection
    const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    // If a selection existed before copying, unselect everything on the HTML document and restore the original selection
    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
};


class $a5749f8efb25cf9e$export$593bf50f5d507e87 {
    constructor(app){
        this.getPageId = ()=>{
            return "page-verify-emails";
        };
        this.execute = ()=>{
            const typeSelect = document.querySelector("select[name='type']");
            typeSelect.addEventListener("change", (event)=>{
                this.app.pjax.loadUrl(location.pathname + "?type=" + event.target.value);
            });
            // Add copy email button
            const copyButtons = document.querySelectorAll(".btn-copy");
            for (const button of copyButtons)button.addEventListener("click", (event)=>{
                const email = event.target.getAttribute("data-email");
                (0, $a30b3a9a137baaed$export$1d8a493107fb4b3a).toClipboard(email);
            });
        };
        this.onPageClose = ()=>{};
        this.app = app;
    }
}


var $9b19a0a83ad61f86$exports = {};
var $4f2b320d6577794c$exports = {};
// shim for using process in browser
var $4f2b320d6577794c$var$process = $4f2b320d6577794c$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4f2b320d6577794c$var$cachedSetTimeout;
var $4f2b320d6577794c$var$cachedClearTimeout;
function $4f2b320d6577794c$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4f2b320d6577794c$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4f2b320d6577794c$var$cachedSetTimeout = setTimeout;
        else $4f2b320d6577794c$var$cachedSetTimeout = $4f2b320d6577794c$var$defaultSetTimout;
    } catch (e) {
        $4f2b320d6577794c$var$cachedSetTimeout = $4f2b320d6577794c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4f2b320d6577794c$var$cachedClearTimeout = clearTimeout;
        else $4f2b320d6577794c$var$cachedClearTimeout = $4f2b320d6577794c$var$defaultClearTimeout;
    } catch (e) {
        $4f2b320d6577794c$var$cachedClearTimeout = $4f2b320d6577794c$var$defaultClearTimeout;
    }
})();
function $4f2b320d6577794c$var$runTimeout(fun) {
    if ($4f2b320d6577794c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4f2b320d6577794c$var$cachedSetTimeout === $4f2b320d6577794c$var$defaultSetTimout || !$4f2b320d6577794c$var$cachedSetTimeout) && setTimeout) {
        $4f2b320d6577794c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4f2b320d6577794c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4f2b320d6577794c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4f2b320d6577794c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4f2b320d6577794c$var$runClearTimeout(marker) {
    if ($4f2b320d6577794c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4f2b320d6577794c$var$cachedClearTimeout === $4f2b320d6577794c$var$defaultClearTimeout || !$4f2b320d6577794c$var$cachedClearTimeout) && clearTimeout) {
        $4f2b320d6577794c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4f2b320d6577794c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4f2b320d6577794c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4f2b320d6577794c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4f2b320d6577794c$var$queue = [];
var $4f2b320d6577794c$var$draining = false;
var $4f2b320d6577794c$var$currentQueue;
var $4f2b320d6577794c$var$queueIndex = -1;
function $4f2b320d6577794c$var$cleanUpNextTick() {
    if (!$4f2b320d6577794c$var$draining || !$4f2b320d6577794c$var$currentQueue) return;
    $4f2b320d6577794c$var$draining = false;
    if ($4f2b320d6577794c$var$currentQueue.length) $4f2b320d6577794c$var$queue = $4f2b320d6577794c$var$currentQueue.concat($4f2b320d6577794c$var$queue);
    else $4f2b320d6577794c$var$queueIndex = -1;
    if ($4f2b320d6577794c$var$queue.length) $4f2b320d6577794c$var$drainQueue();
}
function $4f2b320d6577794c$var$drainQueue() {
    if ($4f2b320d6577794c$var$draining) return;
    var timeout = $4f2b320d6577794c$var$runTimeout($4f2b320d6577794c$var$cleanUpNextTick);
    $4f2b320d6577794c$var$draining = true;
    var len = $4f2b320d6577794c$var$queue.length;
    while(len){
        $4f2b320d6577794c$var$currentQueue = $4f2b320d6577794c$var$queue;
        $4f2b320d6577794c$var$queue = [];
        while(++$4f2b320d6577794c$var$queueIndex < len)if ($4f2b320d6577794c$var$currentQueue) $4f2b320d6577794c$var$currentQueue[$4f2b320d6577794c$var$queueIndex].run();
        $4f2b320d6577794c$var$queueIndex = -1;
        len = $4f2b320d6577794c$var$queue.length;
    }
    $4f2b320d6577794c$var$currentQueue = null;
    $4f2b320d6577794c$var$draining = false;
    $4f2b320d6577794c$var$runClearTimeout(timeout);
}
$4f2b320d6577794c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4f2b320d6577794c$var$queue.push(new $4f2b320d6577794c$var$Item(fun, args));
    if ($4f2b320d6577794c$var$queue.length === 1 && !$4f2b320d6577794c$var$draining) $4f2b320d6577794c$var$runTimeout($4f2b320d6577794c$var$drainQueue);
};
// v8 likes predictible objects
function $4f2b320d6577794c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4f2b320d6577794c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4f2b320d6577794c$var$process.title = "browser";
$4f2b320d6577794c$var$process.browser = true;
$4f2b320d6577794c$var$process.env = {};
$4f2b320d6577794c$var$process.argv = [];
$4f2b320d6577794c$var$process.version = ""; // empty string to avoid regexp issues
$4f2b320d6577794c$var$process.versions = {};
function $4f2b320d6577794c$var$noop() {}
$4f2b320d6577794c$var$process.on = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.addListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.once = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.off = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.removeListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.removeAllListeners = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.emit = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.prependListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.prependOnceListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.listeners = function(name) {
    return [];
};
$4f2b320d6577794c$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4f2b320d6577794c$var$process.cwd = function() {
    return "/";
};
$4f2b320d6577794c$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4f2b320d6577794c$var$process.umask = function() {
    return 0;
};


"classList" in document.createElement("_") || !function(a) {
    "use strict";
    if ("Element" in a) {
        var b = "classList", c = "prototype", d = a.Element[c], e = Object, f = String[c].trim || function() {
            return this.replace(/^\s+|\s+$/g, "");
        }, g = Array[c].indexOf || function(a) {
            for(var b = 0, c = this.length; c > b; b++)if (b in this && this[b] === a) return b;
            return -1;
        }, h = function(a, b) {
            this.name = a, this.code = DOMException[a], this.message = b;
        }, i = function(a, b) {
            if ("" === b) throw new h("SYNTAX_ERR", "An invalid or illegal string was specified");
            if (/\s/.test(b)) throw new h("INVALID_CHARACTER_ERR", "String contains an invalid character");
            return g.call(a, b);
        }, j = function(a) {
            for(var b = f.call(a.getAttribute("class") || ""), c = b ? b.split(/\s+/) : [], d = 0, e = c.length; e > d; d++)this.push(c[d]);
            this._updateClassName = function() {
                a.setAttribute("class", this.toString());
            };
        }, k = j[c] = [], l = function() {
            return new j(this);
        };
        if (h[c] = Error[c], k.item = function(a) {
            return this[a] || null;
        }, k.contains = function(a) {
            return a += "", -1 !== i(this, a);
        }, k.add = function() {
            var a, b = arguments, c = 0, d = b.length, e = !1;
            do a = b[c] + "", -1 === i(this, a) && (this.push(a), e = !0);
            while (++c < d);
            e && this._updateClassName();
        }, k.remove = function() {
            var a, b, c = arguments, d = 0, e = c.length, f = !1;
            do for(a = c[d] + "", b = i(this, a); -1 !== b;)this.splice(b, 1), f = !0, b = i(this, a);
            while (++d < e);
            f && this._updateClassName();
        }, k.toggle = function(a, b) {
            a += "";
            var c = this.contains(a), d = c ? b !== !0 && "remove" : b !== !1 && "add";
            return d && this[d](a), b === !0 || b === !1 ? b : !c;
        }, k.toString = function() {
            return this.join(" ");
        }, e.defineProperty) {
            var m = {
                get: l,
                enumerable: !0,
                configurable: !0
            };
            try {
                e.defineProperty(d, b, m);
            } catch (n) {
                -2146823252 === n.number && (m.enumerable = !1, e.defineProperty(d, b, m));
            }
        } else e[c].__defineGetter__ && d.__defineGetter__(b, l);
    }
}(self), function(a) {
    "use strict";
    if (a.URL = a.URL || a.webkitURL, a.Blob && a.URL) try {
        return void new Blob;
    } catch (b) {}
    var c = a.BlobBuilder || a.WebKitBlobBuilder || a.MozBlobBuilder || function(a) {
        var b = function(a) {
            return Object.prototype.toString.call(a).match(/^\[object\s(.*)\]$/)[1];
        }, c = function() {
            this.data = [];
        }, d = function(a, b, c) {
            this.data = a, this.size = a.length, this.type = b, this.encoding = c;
        }, e = c.prototype, f = d.prototype, g = a.FileReaderSync, h = function(a) {
            this.code = this[this.name = a];
        }, i = "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "), j = i.length, k = a.URL || a.webkitURL || a, l = k.createObjectURL, m = k.revokeObjectURL, n = k, o = a.btoa, p = a.atob, q = a.ArrayBuffer, r = a.Uint8Array, s = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
        for(d.fake = f.fake = !0; j--;)h.prototype[i[j]] = j + 1;
        return k.createObjectURL || (n = a.URL = function(a) {
            var b, c = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            return c.href = a, "origin" in c || ("data:" === c.protocol.toLowerCase() ? c.origin = null : (b = a.match(s), c.origin = b && b[1])), c;
        }), n.createObjectURL = function(a) {
            var b, c = a.type;
            return null === c && (c = "application/octet-stream"), a instanceof d ? (b = "data:" + c, "base64" === a.encoding ? b + ";base64," + a.data : "URI" === a.encoding ? b + "," + decodeURIComponent(a.data) : o ? b + ";base64," + o(a.data) : b + "," + encodeURIComponent(a.data)) : l ? l.call(k, a) : void 0;
        }, n.revokeObjectURL = function(a) {
            "data:" !== a.substring(0, 5) && m && m.call(k, a);
        }, e.append = function(a) {
            var c = this.data;
            if (r && (a instanceof q || a instanceof r)) {
                for(var e = "", f = new r(a), i = 0, j = f.length; j > i; i++)e += String.fromCharCode(f[i]);
                c.push(e);
            } else if ("Blob" === b(a) || "File" === b(a)) {
                if (!g) throw new h("NOT_READABLE_ERR");
                var k = new g;
                c.push(k.readAsBinaryString(a));
            } else a instanceof d ? "base64" === a.encoding && p ? c.push(p(a.data)) : "URI" === a.encoding ? c.push(decodeURIComponent(a.data)) : "raw" === a.encoding && c.push(a.data) : ("string" != typeof a && (a += ""), c.push(unescape(encodeURIComponent(a))));
        }, e.getBlob = function(a) {
            return arguments.length || (a = null), new d(this.data.join(""), a, "raw");
        }, e.toString = function() {
            return "[object BlobBuilder]";
        }, f.slice = function(a, b, c) {
            var e = arguments.length;
            return 3 > e && (c = null), new d(this.data.slice(a, e > 1 ? b : this.data.length), c, this.encoding);
        }, f.toString = function() {
            return "[object Blob]";
        }, f.close = function() {
            this.size = 0, delete this.data;
        }, c;
    }(a);
    a.Blob = function(a, b) {
        var d = b ? b.type || "" : "", e = new c;
        if (a) for(var f = 0, g = a.length; g > f; f++)Uint8Array && a[f] instanceof Uint8Array ? e.append(a[f].buffer) : e.append(a[f]);
        var h = e.getBlob(d);
        return !h.slice && h.webkitSlice && (h.slice = h.webkitSlice), h;
    };
    var d = Object.getPrototypeOf || function(a) {
        return a.__proto__;
    };
    a.Blob.prototype = d(new a.Blob);
}("undefined" != typeof self && self || "undefined" != typeof window && window || $9b19a0a83ad61f86$exports.content || $9b19a0a83ad61f86$exports), function(a, b) {
    "use strict";
    var c = "undefined" != typeof $4f2b320d6577794c$exports && $4f2b320d6577794c$exports && $4f2b320d6577794c$exports.versions && $4f2b320d6577794c$exports.versions.electron;
    c || false ? "function" == typeof define && define.amd ? define(function() {
        return b;
    }) : a.MediumEditor = b : $9b19a0a83ad61f86$exports = b;
}($9b19a0a83ad61f86$exports, function() {
    "use strict";
    function a(a, b) {
        return this.init(a, b);
    }
    return a.extensions = {}, function(b) {
        function c(a, b) {
            var c, d = Array.prototype.slice.call(arguments, 2);
            b = b || {};
            for(var e = 0; e < d.length; e++){
                var f = d[e];
                if (f) for(c in f)f.hasOwnProperty(c) && "undefined" != typeof f[c] && (a || b.hasOwnProperty(c) === !1) && (b[c] = f[c]);
            }
            return b;
        }
        var d = !1;
        try {
            var e = document.createElement("div"), f = document.createTextNode(" ");
            e.appendChild(f), d = e.contains(f);
        } catch (g) {}
        var h = {
            isIE: "Microsoft Internet Explorer" === navigator.appName || "Netscape" === navigator.appName && null !== new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})").exec(navigator.userAgent),
            isEdge: null !== /Edge\/\d+/.exec(navigator.userAgent),
            isFF: navigator.userAgent.toLowerCase().indexOf("firefox") > -1,
            isMac: b.navigator.platform.toUpperCase().indexOf("MAC") >= 0,
            keyCode: {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                SPACE: 32,
                DELETE: 46,
                K: 75,
                M: 77,
                V: 86
            },
            isMetaCtrlKey: function(a) {
                return !!(h.isMac && a.metaKey || !h.isMac && a.ctrlKey);
            },
            isKey: function(a, b) {
                var c = h.getKeyCode(a);
                return !1 === Array.isArray(b) ? c === b : -1 !== b.indexOf(c);
            },
            getKeyCode: function(a) {
                var b = a.which;
                return null === b && (b = null !== a.charCode ? a.charCode : a.keyCode), b;
            },
            blockContainerElementNames: [
                "p",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "pre",
                "ul",
                "li",
                "ol",
                "address",
                "article",
                "aside",
                "audio",
                "canvas",
                "dd",
                "dl",
                "dt",
                "fieldset",
                "figcaption",
                "figure",
                "footer",
                "form",
                "header",
                "hgroup",
                "main",
                "nav",
                "noscript",
                "output",
                "section",
                "video",
                "table",
                "thead",
                "tbody",
                "tfoot",
                "tr",
                "th",
                "td"
            ],
            emptyElementNames: [
                "br",
                "col",
                "colgroup",
                "hr",
                "img",
                "input",
                "source",
                "wbr"
            ],
            extend: function() {
                var a = [
                    !0
                ].concat(Array.prototype.slice.call(arguments));
                return c.apply(this, a);
            },
            defaults: function() {
                var a = [
                    !1
                ].concat(Array.prototype.slice.call(arguments));
                return c.apply(this, a);
            },
            createLink: function(a, b, c, d) {
                var e = a.createElement("a");
                return h.moveTextRangeIntoElement(b[0], b[b.length - 1], e), e.setAttribute("href", c), d && ("_blank" === d && e.setAttribute("rel", "noopener noreferrer"), e.setAttribute("target", d)), e;
            },
            findOrCreateMatchingTextNodes: function(a, b, c) {
                for(var d = a.createTreeWalker(b, NodeFilter.SHOW_ALL, null, !1), e = [], f = 0, g = !1, i = null, j = null; null !== (i = d.nextNode());)if (!(i.nodeType > 3)) {
                    if (3 === i.nodeType) {
                        if (!g && c.start < f + i.nodeValue.length && (g = !0, j = h.splitStartNodeIfNeeded(i, c.start, f)), g && h.splitEndNodeIfNeeded(i, j, c.end, f), g && f === c.end) break;
                        if (g && f > c.end + 1) throw new Error("PerformLinking overshot the target!");
                        g && e.push(j || i), f += i.nodeValue.length, null !== j && (f += j.nodeValue.length, d.nextNode()), j = null;
                    } else "img" === i.tagName.toLowerCase() && (!g && c.start <= f && (g = !0), g && e.push(i));
                }
                return e;
            },
            splitStartNodeIfNeeded: function(a, b, c) {
                return b !== c ? a.splitText(b - c) : null;
            },
            splitEndNodeIfNeeded: function(a, b, c, d) {
                var e, f;
                e = d + a.nodeValue.length + (b ? b.nodeValue.length : 0) - 1, f = c - d - (b ? a.nodeValue.length : 0), e >= c && d !== e && 0 !== f && (b || a).splitText(f);
            },
            splitByBlockElements: function(b) {
                if (3 !== b.nodeType && 1 !== b.nodeType) return [];
                var c = [], d = a.util.blockContainerElementNames.join(",");
                if (3 === b.nodeType || 0 === b.querySelectorAll(d).length) return [
                    b
                ];
                for(var e = 0; e < b.childNodes.length; e++){
                    var f = b.childNodes[e];
                    if (3 === f.nodeType) c.push(f);
                    else if (1 === f.nodeType) {
                        var g = f.querySelectorAll(d);
                        0 === g.length ? c.push(f) : c = c.concat(a.util.splitByBlockElements(f));
                    }
                }
                return c;
            },
            findAdjacentTextNodeWithContent: function(a, b, c) {
                var d, e = !1, f = c.createNodeIterator(a, NodeFilter.SHOW_TEXT, null, !1);
                for(d = f.nextNode(); d;){
                    if (d === b) e = !0;
                    else if (e && 3 === d.nodeType && d.nodeValue && d.nodeValue.trim().length > 0) break;
                    d = f.nextNode();
                }
                return d;
            },
            findPreviousSibling: function(a) {
                if (!a || h.isMediumEditorElement(a)) return !1;
                for(var b = a.previousSibling; !b && !h.isMediumEditorElement(a.parentNode);)a = a.parentNode, b = a.previousSibling;
                return b;
            },
            isDescendant: function(a, b, c) {
                if (!a || !b) return !1;
                if (a === b) return !!c;
                if (1 !== a.nodeType) return !1;
                if (d || 3 !== b.nodeType) return a.contains(b);
                for(var e = b.parentNode; null !== e;){
                    if (e === a) return !0;
                    e = e.parentNode;
                }
                return !1;
            },
            isElement: function(a) {
                return !(!a || 1 !== a.nodeType);
            },
            throttle: function(a, b) {
                var c, d, e, f = 50, g = null, h = 0, i = function() {
                    h = Date.now(), g = null, e = a.apply(c, d), g || (c = d = null);
                };
                return b || 0 === b || (b = f), function() {
                    var f = Date.now(), j = b - (f - h);
                    return c = this, d = arguments, 0 >= j || j > b ? (g && (clearTimeout(g), g = null), h = f, e = a.apply(c, d), g || (c = d = null)) : g || (g = setTimeout(i, j)), e;
                };
            },
            traverseUp: function(a, b) {
                if (!a) return !1;
                do {
                    if (1 === a.nodeType) {
                        if (b(a)) return a;
                        if (h.isMediumEditorElement(a)) return !1;
                    }
                    a = a.parentNode;
                }while (a);
                return !1;
            },
            htmlEntities: function(a) {
                return String(a).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
            },
            insertHTMLCommand: function(b, c) {
                var d, e, f, g, i, j, k, l = !1, m = [
                    "insertHTML",
                    !1,
                    c
                ];
                if (!a.util.isEdge && b.queryCommandSupported("insertHTML")) try {
                    return b.execCommand.apply(b, m);
                } catch (n) {}
                if (d = b.getSelection(), d.rangeCount) {
                    if (e = d.getRangeAt(0), k = e.commonAncestorContainer, h.isMediumEditorElement(k) && !k.firstChild) e.selectNode(k.appendChild(b.createTextNode("")));
                    else if (3 === k.nodeType && 0 === e.startOffset && e.endOffset === k.nodeValue.length || 3 !== k.nodeType && k.innerHTML === e.toString()) {
                        for(; !h.isMediumEditorElement(k) && k.parentNode && 1 === k.parentNode.childNodes.length && !h.isMediumEditorElement(k.parentNode);)k = k.parentNode;
                        e.selectNode(k);
                    }
                    for(e.deleteContents(), f = b.createElement("div"), f.innerHTML = c, g = b.createDocumentFragment(); f.firstChild;)i = f.firstChild, j = g.appendChild(i);
                    e.insertNode(g), j && (e = e.cloneRange(), e.setStartAfter(j), e.collapse(!0), a.selection.selectRange(b, e)), l = !0;
                }
                return b.execCommand.callListeners && b.execCommand.callListeners(m, l), l;
            },
            execFormatBlock: function(b, c) {
                var d, e = h.getTopBlockContainer(a.selection.getSelectionStart(b));
                if ("blockquote" === c) {
                    if (e && (d = Array.prototype.slice.call(e.childNodes), d.some(function(a) {
                        return h.isBlockContainer(a);
                    }))) return b.execCommand("outdent", !1, null);
                    if (h.isIE) return b.execCommand("indent", !1, c);
                }
                if (e && c === e.nodeName.toLowerCase() && (c = "p"), h.isIE && (c = "<" + c + ">"), e && "blockquote" === e.nodeName.toLowerCase()) {
                    if (h.isIE && "<p>" === c) return b.execCommand("outdent", !1, c);
                    if ((h.isFF || h.isEdge) && "p" === c) return d = Array.prototype.slice.call(e.childNodes), d.some(function(a) {
                        return !h.isBlockContainer(a);
                    }) && b.execCommand("formatBlock", !1, c), b.execCommand("outdent", !1, c);
                }
                return b.execCommand("formatBlock", !1, c);
            },
            setTargetBlank: function(a, b) {
                var c, d = b || !1;
                if ("a" === a.nodeName.toLowerCase()) a.target = "_blank", a.rel = "noopener noreferrer";
                else for(a = a.getElementsByTagName("a"), c = 0; c < a.length; c += 1)!1 !== d && d !== a[c].attributes.href.value || (a[c].target = "_blank", a[c].rel = "noopener noreferrer");
            },
            removeTargetBlank: function(a, b) {
                var c;
                if ("a" === a.nodeName.toLowerCase()) a.removeAttribute("target"), a.removeAttribute("rel");
                else for(a = a.getElementsByTagName("a"), c = 0; c < a.length; c += 1)b === a[c].attributes.href.value && (a[c].removeAttribute("target"), a[c].removeAttribute("rel"));
            },
            addClassToAnchors: function(a, b) {
                var c, d, e = b.split(" ");
                if ("a" === a.nodeName.toLowerCase()) for(d = 0; d < e.length; d += 1)a.classList.add(e[d]);
                else {
                    var f = a.getElementsByTagName("a");
                    if (0 === f.length) {
                        var g = h.getClosestTag(a, "a");
                        a = g ? [
                            g
                        ] : [];
                    } else a = f;
                    for(c = 0; c < a.length; c += 1)for(d = 0; d < e.length; d += 1)a[c].classList.add(e[d]);
                }
            },
            isListItem: function(a) {
                if (!a) return !1;
                if ("li" === a.nodeName.toLowerCase()) return !0;
                for(var b = a.parentNode, c = b.nodeName.toLowerCase(); "li" === c || !h.isBlockContainer(b) && "div" !== c;){
                    if ("li" === c) return !0;
                    if (b = b.parentNode, !b) return !1;
                    c = b.nodeName.toLowerCase();
                }
                return !1;
            },
            cleanListDOM: function(b, c) {
                if ("li" === c.nodeName.toLowerCase()) {
                    var d = c.parentElement;
                    "p" === d.parentElement.nodeName.toLowerCase() && (h.unwrap(d.parentElement, b), a.selection.moveCursor(b, c.firstChild, c.firstChild.textContent.length));
                }
            },
            splitOffDOMTree: function(a, b, c) {
                for(var d = b, e = null, f = !c; d !== a;){
                    var g, h = d.parentNode, i = h.cloneNode(!1), j = f ? d : h.firstChild;
                    for(e && (f ? i.appendChild(e) : g = e), e = i; j;){
                        var k = j.nextSibling;
                        j === d ? (j.hasChildNodes() ? j = j.cloneNode(!1) : j.parentNode.removeChild(j), j.textContent && e.appendChild(j), j = f ? k : null) : (j.parentNode.removeChild(j), (j.hasChildNodes() || j.textContent) && e.appendChild(j), j = k);
                    }
                    g && e.appendChild(g), d = h;
                }
                return e;
            },
            moveTextRangeIntoElement: function(a, b, c) {
                if (!a || !b) return !1;
                var d = h.findCommonRoot(a, b);
                if (!d) return !1;
                if (b === a) {
                    var e = a.parentNode, f = a.nextSibling;
                    return e.removeChild(a), c.appendChild(a), f ? e.insertBefore(c, f) : e.appendChild(c), c.hasChildNodes();
                }
                for(var g, i, j, k = [], l = 0; l < d.childNodes.length; l++)if (j = d.childNodes[l], g) {
                    if (h.isDescendant(j, b, !0)) {
                        i = j;
                        break;
                    }
                    k.push(j);
                } else h.isDescendant(j, a, !0) && (g = j);
                var m = i.nextSibling, n = d.ownerDocument.createDocumentFragment();
                return g === a ? (g.parentNode.removeChild(g), n.appendChild(g)) : n.appendChild(h.splitOffDOMTree(g, a)), k.forEach(function(a) {
                    a.parentNode.removeChild(a), n.appendChild(a);
                }), i === b ? (i.parentNode.removeChild(i), n.appendChild(i)) : n.appendChild(h.splitOffDOMTree(i, b, !0)), c.appendChild(n), i.parentNode === d ? d.insertBefore(c, i) : m ? d.insertBefore(c, m) : d.appendChild(c), c.hasChildNodes();
            },
            depthOfNode: function(a) {
                for(var b = 0, c = a; null !== c.parentNode;)c = c.parentNode, b++;
                return b;
            },
            findCommonRoot: function(a, b) {
                for(var c = h.depthOfNode(a), d = h.depthOfNode(b), e = a, f = b; c !== d;)c > d ? (e = e.parentNode, c -= 1) : (f = f.parentNode, d -= 1);
                for(; e !== f;)e = e.parentNode, f = f.parentNode;
                return e;
            },
            isElementAtBeginningOfBlock: function(a) {
                for(var b, c; !h.isBlockContainer(a) && !h.isMediumEditorElement(a);){
                    for(c = a; c = c.previousSibling;)if (b = 3 === c.nodeType ? c.nodeValue : c.textContent, b.length > 0) return !1;
                    a = a.parentNode;
                }
                return !0;
            },
            isMediumEditorElement: function(a) {
                return a && a.getAttribute && !!a.getAttribute("data-medium-editor-element");
            },
            getContainerEditorElement: function(a) {
                return h.traverseUp(a, function(a) {
                    return h.isMediumEditorElement(a);
                });
            },
            isBlockContainer: function(a) {
                return a && 3 !== a.nodeType && -1 !== h.blockContainerElementNames.indexOf(a.nodeName.toLowerCase());
            },
            getClosestBlockContainer: function(a) {
                return h.traverseUp(a, function(a) {
                    return h.isBlockContainer(a) || h.isMediumEditorElement(a);
                });
            },
            getTopBlockContainer: function(a) {
                var b = h.isBlockContainer(a) ? a : !1;
                return h.traverseUp(a, function(a) {
                    return h.isBlockContainer(a) && (b = a), !b && h.isMediumEditorElement(a) ? (b = a, !0) : !1;
                }), b;
            },
            getFirstSelectableLeafNode: function(a) {
                for(; a && a.firstChild;)a = a.firstChild;
                if (a = h.traverseUp(a, function(a) {
                    return -1 === h.emptyElementNames.indexOf(a.nodeName.toLowerCase());
                }), "table" === a.nodeName.toLowerCase()) {
                    var b = a.querySelector("th, td");
                    b && (a = b);
                }
                return a;
            },
            getFirstTextNode: function(a) {
                return h.warn("getFirstTextNode is deprecated and will be removed in version 6.0.0"), h._getFirstTextNode(a);
            },
            _getFirstTextNode: function(a) {
                if (3 === a.nodeType) return a;
                for(var b = 0; b < a.childNodes.length; b++){
                    var c = h._getFirstTextNode(a.childNodes[b]);
                    if (null !== c) return c;
                }
                return null;
            },
            ensureUrlHasProtocol: function(a) {
                return -1 === a.indexOf("://") ? "http://" + a : a;
            },
            warn: function() {
                void 0 !== b.console && "function" == typeof b.console.warn && b.console.warn.apply(b.console, arguments);
            },
            deprecated: function(a, b, c) {
                var d = a + " is deprecated, please use " + b + " instead.";
                c && (d += " Will be removed in " + c), h.warn(d);
            },
            deprecatedMethod: function(a, b, c, d) {
                h.deprecated(a, b, d), "function" == typeof this[b] && this[b].apply(this, c);
            },
            cleanupAttrs: function(a, b) {
                b.forEach(function(b) {
                    a.removeAttribute(b);
                });
            },
            cleanupTags: function(a, b) {
                -1 !== b.indexOf(a.nodeName.toLowerCase()) && a.parentNode.removeChild(a);
            },
            unwrapTags: function(b, c) {
                -1 !== c.indexOf(b.nodeName.toLowerCase()) && a.util.unwrap(b, document);
            },
            getClosestTag: function(a, b) {
                return h.traverseUp(a, function(a) {
                    return a.nodeName.toLowerCase() === b.toLowerCase();
                });
            },
            unwrap: function(a, b) {
                for(var c = b.createDocumentFragment(), d = Array.prototype.slice.call(a.childNodes), e = 0; e < d.length; e++)c.appendChild(d[e]);
                c.childNodes.length ? a.parentNode.replaceChild(c, a) : a.parentNode.removeChild(a);
            },
            guid: function() {
                function a() {
                    return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
                }
                return a() + a() + "-" + a() + "-" + a() + "-" + a() + "-" + a() + a() + a();
            }
        };
        a.util = h;
    }(window), function() {
        var b = function(b) {
            a.util.extend(this, b);
        };
        b.extend = function(b) {
            var c, d = this;
            c = b && b.hasOwnProperty("constructor") ? b.constructor : function() {
                return d.apply(this, arguments);
            }, a.util.extend(c, d);
            var e = function() {
                this.constructor = c;
            };
            return e.prototype = d.prototype, c.prototype = new e, b && a.util.extend(c.prototype, b), c;
        }, b.prototype = {
            init: function() {},
            base: void 0,
            name: void 0,
            checkState: void 0,
            destroy: void 0,
            queryCommandState: void 0,
            isActive: void 0,
            isAlreadyApplied: void 0,
            setActive: void 0,
            setInactive: void 0,
            getInteractionElements: void 0,
            window: void 0,
            document: void 0,
            getEditorElements: function() {
                return this.base.elements;
            },
            getEditorId: function() {
                return this.base.id;
            },
            getEditorOption: function(a) {
                return this.base.options[a];
            }
        }, [
            "execAction",
            "on",
            "off",
            "subscribe",
            "trigger"
        ].forEach(function(a) {
            b.prototype[a] = function() {
                return this.base[a].apply(this.base, arguments);
            };
        }), a.Extension = b;
    }(), function() {
        function b(b) {
            return a.util.isBlockContainer(b) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
        var c = {
            findMatchingSelectionParent: function(b, c) {
                var d, e, f = c.getSelection();
                return 0 === f.rangeCount ? !1 : (d = f.getRangeAt(0), e = d.commonAncestorContainer, a.util.traverseUp(e, b));
            },
            getSelectionElement: function(b) {
                return this.findMatchingSelectionParent(function(b) {
                    return a.util.isMediumEditorElement(b);
                }, b);
            },
            exportSelection: function(a, b) {
                if (!a) return null;
                var c = null, d = b.getSelection();
                if (d.rangeCount > 0) {
                    var e, f = d.getRangeAt(0), g = f.cloneRange();
                    g.selectNodeContents(a), g.setEnd(f.startContainer, f.startOffset), e = g.toString().length, c = {
                        start: e,
                        end: e + f.toString().length
                    }, this.doesRangeStartWithImages(f, b) && (c.startsWithImage = !0);
                    var h = this.getTrailingImageCount(a, c, f.endContainer, f.endOffset);
                    if (h && (c.trailingImageCount = h), 0 !== e) {
                        var i = this.getIndexRelativeToAdjacentEmptyBlocks(b, a, f.startContainer, f.startOffset);
                        -1 !== i && (c.emptyBlocksIndex = i);
                    }
                }
                return c;
            },
            importSelection: function(a, b, c, d) {
                if (a && b) {
                    var e = c.createRange();
                    e.setStart(b, 0), e.collapse(!0);
                    var f, g = b, h = [], i = 0, j = !1, k = !1, l = 0, m = !1, n = !1, o = null;
                    for((d || a.startsWithImage || "undefined" != typeof a.emptyBlocksIndex) && (n = !0); !m && g;)if (g.nodeType > 3) g = h.pop();
                    else {
                        if (3 !== g.nodeType || k) {
                            if (a.trailingImageCount && k && ("img" === g.nodeName.toLowerCase() && l++, l === a.trailingImageCount)) {
                                for(var p = 0; g.parentNode.childNodes[p] !== g;)p++;
                                e.setEnd(g.parentNode, p + 1), m = !0;
                            }
                            if (!m && 1 === g.nodeType) for(var q = g.childNodes.length - 1; q >= 0;)h.push(g.childNodes[q]), q -= 1;
                        } else f = i + g.length, !j && a.start >= i && a.start <= f && (n || a.start < f ? (e.setStart(g, a.start - i), j = !0) : o = g), j && a.end >= i && a.end <= f && (a.trailingImageCount ? k = !0 : (e.setEnd(g, a.end - i), m = !0)), i = f;
                        m || (g = h.pop());
                    }
                    !j && o && (e.setStart(o, o.length), e.setEnd(o, o.length)), "undefined" != typeof a.emptyBlocksIndex && (e = this.importSelectionMoveCursorPastBlocks(c, b, a.emptyBlocksIndex, e)), d && (e = this.importSelectionMoveCursorPastAnchor(a, e)), this.selectRange(c, e);
                }
            },
            importSelectionMoveCursorPastAnchor: function(b, c) {
                var d = function(a) {
                    return "a" === a.nodeName.toLowerCase();
                };
                if (b.start === b.end && 3 === c.startContainer.nodeType && c.startOffset === c.startContainer.nodeValue.length && a.util.traverseUp(c.startContainer, d)) {
                    for(var e = c.startContainer, f = c.startContainer.parentNode; null !== f && "a" !== f.nodeName.toLowerCase();)f.childNodes[f.childNodes.length - 1] !== e ? f = null : (e = f, f = f.parentNode);
                    if (null !== f && "a" === f.nodeName.toLowerCase()) {
                        for(var g = null, h = 0; null === g && h < f.parentNode.childNodes.length; h++)f.parentNode.childNodes[h] === f && (g = h);
                        c.setStart(f.parentNode, g + 1), c.collapse(!0);
                    }
                }
                return c;
            },
            importSelectionMoveCursorPastBlocks: function(c, d, e, f) {
                var g, h, i = c.createTreeWalker(d, NodeFilter.SHOW_ELEMENT, b, !1), j = f.startContainer, k = 0;
                for(e = e || 1, g = 3 === j.nodeType && a.util.isBlockContainer(j.previousSibling) ? j.previousSibling : a.util.getClosestBlockContainer(j); i.nextNode();)if (h) {
                    if (h = i.currentNode, k++, k === e) break;
                    if (h.textContent.length > 0) break;
                } else g === i.currentNode && (h = i.currentNode);
                return h || (h = g), f.setStart(a.util.getFirstSelectableLeafNode(h), 0), f;
            },
            getIndexRelativeToAdjacentEmptyBlocks: function(c, d, e, f) {
                if (e.textContent.length > 0 && f > 0) return -1;
                var g = e;
                if (3 !== g.nodeType && (g = e.childNodes[f]), g) {
                    if (!a.util.isElementAtBeginningOfBlock(g)) return -1;
                    var h = a.util.findPreviousSibling(g);
                    if (!h) return -1;
                    if (h.nodeValue) return -1;
                }
                for(var i = a.util.getClosestBlockContainer(e), j = c.createTreeWalker(d, NodeFilter.SHOW_ELEMENT, b, !1), k = 0; j.nextNode();){
                    var l = "" === j.currentNode.textContent;
                    if ((l || k > 0) && (k += 1), j.currentNode === i) return k;
                    l || (k = 0);
                }
                return k;
            },
            doesRangeStartWithImages: function(a, b) {
                if (0 !== a.startOffset || 1 !== a.startContainer.nodeType) return !1;
                if ("img" === a.startContainer.nodeName.toLowerCase()) return !0;
                var c = a.startContainer.querySelector("img");
                if (!c) return !1;
                for(var d = b.createTreeWalker(a.startContainer, NodeFilter.SHOW_ALL, null, !1); d.nextNode();){
                    var e = d.currentNode;
                    if (e === c) break;
                    if (e.nodeValue) return !1;
                }
                return !0;
            },
            getTrailingImageCount: function(a, b, c, d) {
                if (0 === d || 1 !== c.nodeType) return 0;
                if ("img" !== c.nodeName.toLowerCase() && !c.querySelector("img")) return 0;
                for(var e = c.childNodes[d - 1]; e.hasChildNodes();)e = e.lastChild;
                for(var f, g = a, h = [], i = 0, j = !1, k = !1, l = !1, m = 0; !l && g;)if (g.nodeType > 3) g = h.pop();
                else {
                    if (3 !== g.nodeType || k) {
                        if ("img" === g.nodeName.toLowerCase() && m++, g === e) l = !0;
                        else if (1 === g.nodeType) for(var n = g.childNodes.length - 1; n >= 0;)h.push(g.childNodes[n]), n -= 1;
                    } else m = 0, f = i + g.length, !j && b.start >= i && b.start <= f && (j = !0), j && b.end >= i && b.end <= f && (k = !0), i = f;
                    l || (g = h.pop());
                }
                return m;
            },
            selectionContainsContent: function(a) {
                var b = a.getSelection();
                if (!b || b.isCollapsed || !b.rangeCount) return !1;
                if ("" !== b.toString().trim()) return !0;
                var c = this.getSelectedParentElement(b.getRangeAt(0));
                return !(!c || !("img" === c.nodeName.toLowerCase() || 1 === c.nodeType && c.querySelector("img")));
            },
            selectionInContentEditableFalse: function(a) {
                var b, c = this.findMatchingSelectionParent(function(a) {
                    var c = a && a.getAttribute("contenteditable");
                    return "true" === c && (b = !0), "#text" !== a.nodeName && "false" === c;
                }, a);
                return !b && c;
            },
            getSelectionHtml: function(a) {
                var b, c, d, e = "", f = a.getSelection();
                if (f.rangeCount) {
                    for(d = a.createElement("div"), b = 0, c = f.rangeCount; c > b; b += 1)d.appendChild(f.getRangeAt(b).cloneContents());
                    e = d.innerHTML;
                }
                return e;
            },
            getCaretOffsets: function(a, b) {
                var c, d;
                return b || (b = window.getSelection().getRangeAt(0)), c = b.cloneRange(), d = b.cloneRange(), c.selectNodeContents(a), c.setEnd(b.endContainer, b.endOffset), d.selectNodeContents(a), d.setStart(b.endContainer, b.endOffset), {
                    left: c.toString().length,
                    right: d.toString().length
                };
            },
            rangeSelectsSingleNode: function(a) {
                var b = a.startContainer;
                return b === a.endContainer && b.hasChildNodes() && a.endOffset === a.startOffset + 1;
            },
            getSelectedParentElement: function(a) {
                return a ? this.rangeSelectsSingleNode(a) && 3 !== a.startContainer.childNodes[a.startOffset].nodeType ? a.startContainer.childNodes[a.startOffset] : 3 === a.startContainer.nodeType ? a.startContainer.parentNode : a.startContainer : null;
            },
            getSelectedElements: function(a) {
                var b, c, d, e = a.getSelection();
                if (!e.rangeCount || e.isCollapsed || !e.getRangeAt(0).commonAncestorContainer) return [];
                if (b = e.getRangeAt(0), 3 === b.commonAncestorContainer.nodeType) {
                    for(c = [], d = b.commonAncestorContainer; d.parentNode && 1 === d.parentNode.childNodes.length;)c.push(d.parentNode), d = d.parentNode;
                    return c;
                }
                return [].filter.call(b.commonAncestorContainer.getElementsByTagName("*"), function(a) {
                    return "function" == typeof e.containsNode ? e.containsNode(a, !0) : !0;
                });
            },
            selectNode: function(a, b) {
                var c = b.createRange();
                c.selectNodeContents(a), this.selectRange(b, c);
            },
            select: function(a, b, c, d, e) {
                var f = a.createRange();
                return f.setStart(b, c), d ? f.setEnd(d, e) : f.collapse(!0), this.selectRange(a, f), f;
            },
            clearSelection: function(a, b) {
                b ? a.getSelection().collapseToStart() : a.getSelection().collapseToEnd();
            },
            moveCursor: function(a, b, c) {
                this.select(a, b, c);
            },
            getSelectionRange: function(a) {
                var b = a.getSelection();
                return 0 === b.rangeCount ? null : b.getRangeAt(0);
            },
            selectRange: function(a, b) {
                var c = a.getSelection();
                c.removeAllRanges(), c.addRange(b);
            },
            getSelectionStart: function(a) {
                var b = a.getSelection().anchorNode, c = b && 3 === b.nodeType ? b.parentNode : b;
                return c;
            }
        };
        a.selection = c;
    }(), function() {
        function b(b, c) {
            return b ? b.some(function(b) {
                if ("function" != typeof b.getInteractionElements) return !1;
                var d = b.getInteractionElements();
                return d ? (Array.isArray(d) || (d = [
                    d
                ]), d.some(function(b) {
                    return a.util.isDescendant(b, c, !0);
                })) : !1;
            }) : !1;
        }
        var c = function(a) {
            this.base = a, this.options = this.base.options, this.events = [], this.disabledEvents = {}, this.customEvents = {}, this.listeners = {};
        };
        c.prototype = {
            InputEventOnContenteditableSupported: !a.util.isIE && !a.util.isEdge,
            attachDOMEvent: function(b, c, d, e) {
                var f = this.base.options.contentWindow, g = this.base.options.ownerDocument;
                b = a.util.isElement(b) || [
                    f,
                    g
                ].indexOf(b) > -1 ? [
                    b
                ] : b, Array.prototype.forEach.call(b, (function(a) {
                    a.addEventListener(c, d, e), this.events.push([
                        a,
                        c,
                        d,
                        e
                    ]);
                }).bind(this));
            },
            detachDOMEvent: function(b, c, d, e) {
                var f, g, h = this.base.options.contentWindow, i = this.base.options.ownerDocument;
                b && (b = a.util.isElement(b) || [
                    h,
                    i
                ].indexOf(b) > -1 ? [
                    b
                ] : b, Array.prototype.forEach.call(b, (function(a) {
                    f = this.indexOfListener(a, c, d, e), -1 !== f && (g = this.events.splice(f, 1)[0], g[0].removeEventListener(g[1], g[2], g[3]));
                }).bind(this)));
            },
            indexOfListener: function(a, b, c, d) {
                var e, f, g;
                for(e = 0, f = this.events.length; f > e; e += 1)if (g = this.events[e], g[0] === a && g[1] === b && g[2] === c && g[3] === d) return e;
                return -1;
            },
            detachAllDOMEvents: function() {
                for(var a = this.events.pop(); a;)a[0].removeEventListener(a[1], a[2], a[3]), a = this.events.pop();
            },
            detachAllEventsFromElement: function(a) {
                for(var b = this.events.filter(function(b) {
                    return b && b[0].getAttribute && b[0].getAttribute("medium-editor-index") === a.getAttribute("medium-editor-index");
                }), c = 0, d = b.length; d > c; c++){
                    var e = b[c];
                    this.detachDOMEvent(e[0], e[1], e[2], e[3]);
                }
            },
            attachAllEventsToElement: function(a) {
                this.listeners.editableInput && (this.contentCache[a.getAttribute("medium-editor-index")] = a.innerHTML), this.eventsCache && this.eventsCache.forEach(function(b) {
                    this.attachDOMEvent(a, b.name, b.handler.bind(this));
                }, this);
            },
            enableCustomEvent: function(a) {
                void 0 !== this.disabledEvents[a] && delete this.disabledEvents[a];
            },
            disableCustomEvent: function(a) {
                this.disabledEvents[a] = !0;
            },
            attachCustomEvent: function(a, b) {
                this.setupListener(a), this.customEvents[a] || (this.customEvents[a] = []), this.customEvents[a].push(b);
            },
            detachCustomEvent: function(a, b) {
                var c = this.indexOfCustomListener(a, b);
                -1 !== c && this.customEvents[a].splice(c, 1);
            },
            indexOfCustomListener: function(a, b) {
                return this.customEvents[a] && this.customEvents[a].length ? this.customEvents[a].indexOf(b) : -1;
            },
            detachAllCustomEvents: function() {
                this.customEvents = {};
            },
            triggerCustomEvent: function(a, b, c) {
                this.customEvents[a] && !this.disabledEvents[a] && this.customEvents[a].forEach(function(a) {
                    a(b, c);
                });
            },
            destroy: function() {
                this.detachAllDOMEvents(), this.detachAllCustomEvents(), this.detachExecCommand(), this.base.elements && this.base.elements.forEach(function(a) {
                    a.removeAttribute("data-medium-focused");
                });
            },
            attachToExecCommand: function() {
                this.execCommandListener || (this.execCommandListener = (function(a) {
                    this.handleDocumentExecCommand(a);
                }).bind(this), this.wrapExecCommand(), this.options.ownerDocument.execCommand.listeners.push(this.execCommandListener));
            },
            detachExecCommand: function() {
                var a = this.options.ownerDocument;
                if (this.execCommandListener && a.execCommand.listeners) {
                    var b = a.execCommand.listeners.indexOf(this.execCommandListener);
                    -1 !== b && a.execCommand.listeners.splice(b, 1), a.execCommand.listeners.length || this.unwrapExecCommand();
                }
            },
            wrapExecCommand: function() {
                var a = this.options.ownerDocument;
                if (!a.execCommand.listeners) {
                    var b = function(b, c) {
                        a.execCommand.listeners && a.execCommand.listeners.forEach(function(a) {
                            a({
                                command: b[0],
                                value: b[2],
                                args: b,
                                result: c
                            });
                        });
                    }, c = function() {
                        var c = a.execCommand.orig.apply(this, arguments);
                        if (!a.execCommand.listeners) return c;
                        var d = Array.prototype.slice.call(arguments);
                        return b(d, c), c;
                    };
                    c.orig = a.execCommand, c.listeners = [], c.callListeners = b, a.execCommand = c;
                }
            },
            unwrapExecCommand: function() {
                var a = this.options.ownerDocument;
                a.execCommand.orig && (a.execCommand = a.execCommand.orig);
            },
            setupListener: function(a) {
                if (!this.listeners[a]) {
                    switch(a){
                        case "externalInteraction":
                            this.attachDOMEvent(this.options.ownerDocument.body, "mousedown", this.handleBodyMousedown.bind(this), !0), this.attachDOMEvent(this.options.ownerDocument.body, "click", this.handleBodyClick.bind(this), !0), this.attachDOMEvent(this.options.ownerDocument.body, "focus", this.handleBodyFocus.bind(this), !0);
                            break;
                        case "blur":
                            this.setupListener("externalInteraction");
                            break;
                        case "focus":
                            this.setupListener("externalInteraction");
                            break;
                        case "editableInput":
                            this.contentCache = {}, this.base.elements.forEach(function(a) {
                                this.contentCache[a.getAttribute("medium-editor-index")] = a.innerHTML;
                            }, this), this.InputEventOnContenteditableSupported && this.attachToEachElement("input", this.handleInput), this.InputEventOnContenteditableSupported || (this.setupListener("editableKeypress"), this.keypressUpdateInput = !0, this.attachDOMEvent(document, "selectionchange", this.handleDocumentSelectionChange.bind(this)), this.attachToExecCommand());
                            break;
                        case "editableClick":
                            this.attachToEachElement("click", this.handleClick);
                            break;
                        case "editableBlur":
                            this.attachToEachElement("blur", this.handleBlur);
                            break;
                        case "editableKeypress":
                            this.attachToEachElement("keypress", this.handleKeypress);
                            break;
                        case "editableKeyup":
                            this.attachToEachElement("keyup", this.handleKeyup);
                            break;
                        case "editableKeydown":
                            this.attachToEachElement("keydown", this.handleKeydown);
                            break;
                        case "editableKeydownSpace":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableKeydownEnter":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableKeydownTab":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableKeydownDelete":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableMouseover":
                            this.attachToEachElement("mouseover", this.handleMouseover);
                            break;
                        case "editableDrag":
                            this.attachToEachElement("dragover", this.handleDragging), this.attachToEachElement("dragleave", this.handleDragging);
                            break;
                        case "editableDrop":
                            this.attachToEachElement("drop", this.handleDrop);
                            break;
                        case "editablePaste":
                            this.attachToEachElement("paste", this.handlePaste);
                    }
                    this.listeners[a] = !0;
                }
            },
            attachToEachElement: function(a, b) {
                this.eventsCache || (this.eventsCache = []), this.base.elements.forEach(function(c) {
                    this.attachDOMEvent(c, a, b.bind(this));
                }, this), this.eventsCache.push({
                    name: a,
                    handler: b
                });
            },
            cleanupElement: function(a) {
                var b = a.getAttribute("medium-editor-index");
                b && (this.detachAllEventsFromElement(a), this.contentCache && delete this.contentCache[b]);
            },
            focusElement: function(a) {
                a.focus(), this.updateFocus(a, {
                    target: a,
                    type: "focus"
                });
            },
            updateFocus: function(c, d) {
                var e, f = this.base.getFocusedElement();
                f && "click" === d.type && this.lastMousedownTarget && (a.util.isDescendant(f, this.lastMousedownTarget, !0) || b(this.base.extensions, this.lastMousedownTarget)) && (e = f), e || this.base.elements.some(function(b) {
                    return !e && a.util.isDescendant(b, c, !0) && (e = b), !!e;
                }, this);
                var g = !a.util.isDescendant(f, c, !0) && !b(this.base.extensions, c);
                e !== f && (f && g && (f.removeAttribute("data-medium-focused"), this.triggerCustomEvent("blur", d, f)), e && (e.setAttribute("data-medium-focused", !0), this.triggerCustomEvent("focus", d, e))), g && this.triggerCustomEvent("externalInteraction", d);
            },
            updateInput: function(a, b) {
                if (this.contentCache) {
                    var c = a.getAttribute("medium-editor-index"), d = a.innerHTML;
                    d !== this.contentCache[c] && this.triggerCustomEvent("editableInput", b, a), this.contentCache[c] = d;
                }
            },
            handleDocumentSelectionChange: function(b) {
                if (b.currentTarget && b.currentTarget.activeElement) {
                    var c, d = b.currentTarget.activeElement;
                    this.base.elements.some(function(b) {
                        return a.util.isDescendant(b, d, !0) ? (c = b, !0) : !1;
                    }, this), c && this.updateInput(c, {
                        target: d,
                        currentTarget: c
                    });
                }
            },
            handleDocumentExecCommand: function() {
                var a = this.base.getFocusedElement();
                a && this.updateInput(a, {
                    target: a,
                    currentTarget: a
                });
            },
            handleBodyClick: function(a) {
                this.updateFocus(a.target, a);
            },
            handleBodyFocus: function(a) {
                this.updateFocus(a.target, a);
            },
            handleBodyMousedown: function(a) {
                this.lastMousedownTarget = a.target;
            },
            handleInput: function(a) {
                this.updateInput(a.currentTarget, a);
            },
            handleClick: function(a) {
                this.triggerCustomEvent("editableClick", a, a.currentTarget);
            },
            handleBlur: function(a) {
                this.triggerCustomEvent("editableBlur", a, a.currentTarget);
            },
            handleKeypress: function(a) {
                if (this.triggerCustomEvent("editableKeypress", a, a.currentTarget), this.keypressUpdateInput) {
                    var b = {
                        target: a.target,
                        currentTarget: a.currentTarget
                    };
                    setTimeout((function() {
                        this.updateInput(b.currentTarget, b);
                    }).bind(this), 0);
                }
            },
            handleKeyup: function(a) {
                this.triggerCustomEvent("editableKeyup", a, a.currentTarget);
            },
            handleMouseover: function(a) {
                this.triggerCustomEvent("editableMouseover", a, a.currentTarget);
            },
            handleDragging: function(a) {
                this.triggerCustomEvent("editableDrag", a, a.currentTarget);
            },
            handleDrop: function(a) {
                this.triggerCustomEvent("editableDrop", a, a.currentTarget);
            },
            handlePaste: function(a) {
                this.triggerCustomEvent("editablePaste", a, a.currentTarget);
            },
            handleKeydown: function(b) {
                return this.triggerCustomEvent("editableKeydown", b, b.currentTarget), a.util.isKey(b, a.util.keyCode.SPACE) ? this.triggerCustomEvent("editableKeydownSpace", b, b.currentTarget) : a.util.isKey(b, a.util.keyCode.ENTER) || b.ctrlKey && a.util.isKey(b, a.util.keyCode.M) ? this.triggerCustomEvent("editableKeydownEnter", b, b.currentTarget) : a.util.isKey(b, a.util.keyCode.TAB) ? this.triggerCustomEvent("editableKeydownTab", b, b.currentTarget) : a.util.isKey(b, [
                    a.util.keyCode.DELETE,
                    a.util.keyCode.BACKSPACE
                ]) ? this.triggerCustomEvent("editableKeydownDelete", b, b.currentTarget) : void 0;
            }
        }, a.Events = c;
    }(), function() {
        var b = a.Extension.extend({
            action: void 0,
            aria: void 0,
            tagNames: void 0,
            style: void 0,
            useQueryState: void 0,
            contentDefault: void 0,
            contentFA: void 0,
            classList: void 0,
            attrs: void 0,
            constructor: function(c) {
                b.isBuiltInButton(c) ? a.Extension.call(this, this.defaults[c]) : a.Extension.call(this, c);
            },
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.button = this.createButton(), this.on(this.button, "click", this.handleClick.bind(this));
            },
            getButton: function() {
                return this.button;
            },
            getAction: function() {
                return "function" == typeof this.action ? this.action(this.base.options) : this.action;
            },
            getAria: function() {
                return "function" == typeof this.aria ? this.aria(this.base.options) : this.aria;
            },
            getTagNames: function() {
                return "function" == typeof this.tagNames ? this.tagNames(this.base.options) : this.tagNames;
            },
            createButton: function() {
                var a = this.document.createElement("button"), b = this.contentDefault, c = this.getAria(), d = this.getEditorOption("buttonLabels");
                return a.classList.add("medium-editor-action"), a.classList.add("medium-editor-action-" + this.name), this.classList && this.classList.forEach(function(b) {
                    a.classList.add(b);
                }), a.setAttribute("data-action", this.getAction()), c && (a.setAttribute("title", c), a.setAttribute("aria-label", c)), this.attrs && Object.keys(this.attrs).forEach(function(b) {
                    a.setAttribute(b, this.attrs[b]);
                }, this), "fontawesome" === d && this.contentFA && (b = this.contentFA), a.innerHTML = b, a;
            },
            handleClick: function(a) {
                a.preventDefault(), a.stopPropagation();
                var b = this.getAction();
                b && this.execAction(b);
            },
            isActive: function() {
                return this.button.classList.contains(this.getEditorOption("activeButtonClass"));
            },
            setInactive: function() {
                this.button.classList.remove(this.getEditorOption("activeButtonClass")), delete this.knownState;
            },
            setActive: function() {
                this.button.classList.add(this.getEditorOption("activeButtonClass")), delete this.knownState;
            },
            queryCommandState: function() {
                var a = null;
                return this.useQueryState && (a = this.base.queryCommandState(this.getAction())), a;
            },
            isAlreadyApplied: function(a) {
                var b, c, d = !1, e = this.getTagNames();
                return this.knownState === !1 || this.knownState === !0 ? this.knownState : (e && e.length > 0 && (d = -1 !== e.indexOf(a.nodeName.toLowerCase())), !d && this.style && (b = this.style.value.split("|"), c = this.window.getComputedStyle(a, null).getPropertyValue(this.style.prop), b.forEach(function(a) {
                    this.knownState || (d = -1 !== c.indexOf(a), (d || "text-decoration" !== this.style.prop) && (this.knownState = d));
                }, this)), d);
            }
        });
        b.isBuiltInButton = function(b) {
            return "string" == typeof b && a.extensions.button.prototype.defaults.hasOwnProperty(b);
        }, a.extensions.button = b;
    }(), function() {
        a.extensions.button.prototype.defaults = {
            bold: {
                name: "bold",
                action: "bold",
                aria: "bold",
                tagNames: [
                    "b",
                    "strong"
                ],
                style: {
                    prop: "font-weight",
                    value: "700|bold"
                },
                useQueryState: !0,
                contentDefault: "<b>B</b>",
                contentFA: '<i class="fa fa-bold"></i>'
            },
            italic: {
                name: "italic",
                action: "italic",
                aria: "italic",
                tagNames: [
                    "i",
                    "em"
                ],
                style: {
                    prop: "font-style",
                    value: "italic"
                },
                useQueryState: !0,
                contentDefault: "<b><i>I</i></b>",
                contentFA: '<i class="fa fa-italic"></i>'
            },
            underline: {
                name: "underline",
                action: "underline",
                aria: "underline",
                tagNames: [
                    "u"
                ],
                style: {
                    prop: "text-decoration",
                    value: "underline"
                },
                useQueryState: !0,
                contentDefault: "<b><u>U</u></b>",
                contentFA: '<i class="fa fa-underline"></i>'
            },
            strikethrough: {
                name: "strikethrough",
                action: "strikethrough",
                aria: "strike through",
                tagNames: [
                    "strike"
                ],
                style: {
                    prop: "text-decoration",
                    value: "line-through"
                },
                useQueryState: !0,
                contentDefault: "<s>A</s>",
                contentFA: '<i class="fa fa-strikethrough"></i>'
            },
            superscript: {
                name: "superscript",
                action: "superscript",
                aria: "superscript",
                tagNames: [
                    "sup"
                ],
                contentDefault: "<b>x<sup>1</sup></b>",
                contentFA: '<i class="fa fa-superscript"></i>'
            },
            subscript: {
                name: "subscript",
                action: "subscript",
                aria: "subscript",
                tagNames: [
                    "sub"
                ],
                contentDefault: "<b>x<sub>1</sub></b>",
                contentFA: '<i class="fa fa-subscript"></i>'
            },
            image: {
                name: "image",
                action: "image",
                aria: "image",
                tagNames: [
                    "img"
                ],
                contentDefault: "<b>image</b>",
                contentFA: '<i class="fa fa-picture-o"></i>'
            },
            html: {
                name: "html",
                action: "html",
                aria: "evaluate html",
                tagNames: [
                    "iframe",
                    "object"
                ],
                contentDefault: "<b>html</b>",
                contentFA: '<i class="fa fa-code"></i>'
            },
            orderedlist: {
                name: "orderedlist",
                action: "insertorderedlist",
                aria: "ordered list",
                tagNames: [
                    "ol"
                ],
                useQueryState: !0,
                contentDefault: "<b>1.</b>",
                contentFA: '<i class="fa fa-list-ol"></i>'
            },
            unorderedlist: {
                name: "unorderedlist",
                action: "insertunorderedlist",
                aria: "unordered list",
                tagNames: [
                    "ul"
                ],
                useQueryState: !0,
                contentDefault: "<b>&bull;</b>",
                contentFA: '<i class="fa fa-list-ul"></i>'
            },
            indent: {
                name: "indent",
                action: "indent",
                aria: "indent",
                tagNames: [],
                contentDefault: "<b>&rarr;</b>",
                contentFA: '<i class="fa fa-indent"></i>'
            },
            outdent: {
                name: "outdent",
                action: "outdent",
                aria: "outdent",
                tagNames: [],
                contentDefault: "<b>&larr;</b>",
                contentFA: '<i class="fa fa-outdent"></i>'
            },
            justifyCenter: {
                name: "justifyCenter",
                action: "justifyCenter",
                aria: "center justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "center"
                },
                contentDefault: "<b>C</b>",
                contentFA: '<i class="fa fa-align-center"></i>'
            },
            justifyFull: {
                name: "justifyFull",
                action: "justifyFull",
                aria: "full justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "justify"
                },
                contentDefault: "<b>J</b>",
                contentFA: '<i class="fa fa-align-justify"></i>'
            },
            justifyLeft: {
                name: "justifyLeft",
                action: "justifyLeft",
                aria: "left justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "left"
                },
                contentDefault: "<b>L</b>",
                contentFA: '<i class="fa fa-align-left"></i>'
            },
            justifyRight: {
                name: "justifyRight",
                action: "justifyRight",
                aria: "right justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "right"
                },
                contentDefault: "<b>R</b>",
                contentFA: '<i class="fa fa-align-right"></i>'
            },
            removeFormat: {
                name: "removeFormat",
                aria: "remove formatting",
                action: "removeFormat",
                contentDefault: "<b>X</b>",
                contentFA: '<i class="fa fa-eraser"></i>'
            },
            quote: {
                name: "quote",
                action: "append-blockquote",
                aria: "blockquote",
                tagNames: [
                    "blockquote"
                ],
                contentDefault: "<b>&ldquo;</b>",
                contentFA: '<i class="fa fa-quote-right"></i>'
            },
            pre: {
                name: "pre",
                action: "append-pre",
                aria: "preformatted text",
                tagNames: [
                    "pre"
                ],
                contentDefault: "<b>0101</b>",
                contentFA: '<i class="fa fa-code fa-lg"></i>'
            },
            h1: {
                name: "h1",
                action: "append-h1",
                aria: "header type one",
                tagNames: [
                    "h1"
                ],
                contentDefault: "<b>H1</b>",
                contentFA: '<i class="fa fa-header"><sup>1</sup>'
            },
            h2: {
                name: "h2",
                action: "append-h2",
                aria: "header type two",
                tagNames: [
                    "h2"
                ],
                contentDefault: "<b>H2</b>",
                contentFA: '<i class="fa fa-header"><sup>2</sup>'
            },
            h3: {
                name: "h3",
                action: "append-h3",
                aria: "header type three",
                tagNames: [
                    "h3"
                ],
                contentDefault: "<b>H3</b>",
                contentFA: '<i class="fa fa-header"><sup>3</sup>'
            },
            h4: {
                name: "h4",
                action: "append-h4",
                aria: "header type four",
                tagNames: [
                    "h4"
                ],
                contentDefault: "<b>H4</b>",
                contentFA: '<i class="fa fa-header"><sup>4</sup>'
            },
            h5: {
                name: "h5",
                action: "append-h5",
                aria: "header type five",
                tagNames: [
                    "h5"
                ],
                contentDefault: "<b>H5</b>",
                contentFA: '<i class="fa fa-header"><sup>5</sup>'
            },
            h6: {
                name: "h6",
                action: "append-h6",
                aria: "header type six",
                tagNames: [
                    "h6"
                ],
                contentDefault: "<b>H6</b>",
                contentFA: '<i class="fa fa-header"><sup>6</sup>'
            }
        };
    }(), function() {
        var b = a.extensions.button.extend({
            init: function() {
                a.extensions.button.prototype.init.apply(this, arguments);
            },
            formSaveLabel: "&#10003;",
            formCloseLabel: "&times;",
            activeClass: "medium-editor-toolbar-form-active",
            hasForm: !0,
            getForm: function() {},
            isDisplayed: function() {
                return this.hasForm ? this.getForm().classList.contains(this.activeClass) : !1;
            },
            showForm: function() {
                this.hasForm && this.getForm().classList.add(this.activeClass);
            },
            hideForm: function() {
                this.hasForm && this.getForm().classList.remove(this.activeClass);
            },
            showToolbarDefaultActions: function() {
                var a = this.base.getExtensionByName("toolbar");
                a && a.showToolbarDefaultActions();
            },
            hideToolbarDefaultActions: function() {
                var a = this.base.getExtensionByName("toolbar");
                a && a.hideToolbarDefaultActions();
            },
            setToolbarPosition: function() {
                var a = this.base.getExtensionByName("toolbar");
                a && a.setToolbarPosition();
            }
        });
        a.extensions.form = b;
    }(), function() {
        var b = a.extensions.form.extend({
            customClassOption: null,
            customClassOptionText: "Button",
            linkValidation: !1,
            placeholderText: "Paste or type a link",
            targetCheckbox: !1,
            targetCheckboxText: "Open in new window",
            name: "anchor",
            action: "createLink",
            aria: "link",
            tagNames: [
                "a"
            ],
            contentDefault: "<b>#</b>",
            contentFA: '<i class="fa fa-link"></i>',
            init: function() {
                a.extensions.form.prototype.init.apply(this, arguments), this.subscribe("editableKeydown", this.handleKeydown.bind(this));
            },
            handleClick: function(b) {
                b.preventDefault(), b.stopPropagation();
                var c = a.selection.getSelectionRange(this.document);
                return "a" === c.startContainer.nodeName.toLowerCase() || "a" === c.endContainer.nodeName.toLowerCase() || a.util.getClosestTag(a.selection.getSelectedParentElement(c), "a") ? this.execAction("unlink") : (this.isDisplayed() || this.showForm(), !1);
            },
            handleKeydown: function(b) {
                a.util.isKey(b, a.util.keyCode.K) && a.util.isMetaCtrlKey(b) && !b.shiftKey && this.handleClick(b);
            },
            getForm: function() {
                return this.form || (this.form = this.createForm()), this.form;
            },
            getTemplate: function() {
                var a = [
                    '<input type="text" class="medium-editor-toolbar-input" placeholder="',
                    this.placeholderText,
                    '">'
                ];
                return a.push('<a href="#" class="medium-editor-toolbar-save">', "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-check"></i>' : this.formSaveLabel, "</a>"), a.push('<a href="#" class="medium-editor-toolbar-close">', "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-times"></i>' : this.formCloseLabel, "</a>"), this.targetCheckbox && a.push('<div class="medium-editor-toolbar-form-row">', '<input type="checkbox" class="medium-editor-toolbar-anchor-target" id="medium-editor-toolbar-anchor-target-field-' + this.getEditorId() + '">', '<label for="medium-editor-toolbar-anchor-target-field-' + this.getEditorId() + '">', this.targetCheckboxText, "</label>", "</div>"), this.customClassOption && a.push('<div class="medium-editor-toolbar-form-row">', '<input type="checkbox" class="medium-editor-toolbar-anchor-button">', "<label>", this.customClassOptionText, "</label>", "</div>"), a.join("");
            },
            isDisplayed: function() {
                return a.extensions.form.prototype.isDisplayed.apply(this);
            },
            hideForm: function() {
                a.extensions.form.prototype.hideForm.apply(this), this.getInput().value = "";
            },
            showForm: function(b) {
                var c = this.getInput(), d = this.getAnchorTargetCheckbox(), e = this.getAnchorButtonCheckbox();
                if (b = b || {
                    value: ""
                }, "string" == typeof b && (b = {
                    value: b
                }), this.base.saveSelection(), this.hideToolbarDefaultActions(), a.extensions.form.prototype.showForm.apply(this), this.setToolbarPosition(), c.value = b.value, c.focus(), d && (d.checked = "_blank" === b.target), e) {
                    var f = b.buttonClass ? b.buttonClass.split(" ") : [];
                    e.checked = -1 !== f.indexOf(this.customClassOption);
                }
            },
            destroy: function() {
                return this.form ? (this.form.parentNode && this.form.parentNode.removeChild(this.form), void delete this.form) : !1;
            },
            getFormOpts: function() {
                var a = this.getAnchorTargetCheckbox(), b = this.getAnchorButtonCheckbox(), c = {
                    value: this.getInput().value.trim()
                };
                return this.linkValidation && (c.value = this.checkLinkFormat(c.value)), c.target = "_self", a && a.checked && (c.target = "_blank"), b && b.checked && (c.buttonClass = this.customClassOption), c;
            },
            doFormSave: function() {
                var a = this.getFormOpts();
                this.completeFormSave(a);
            },
            completeFormSave: function(a) {
                this.base.restoreSelection(), this.execAction(this.action, a), this.base.checkSelection();
            },
            ensureEncodedUri: function(a) {
                return a === decodeURI(a) ? encodeURI(a) : a;
            },
            ensureEncodedUriComponent: function(a) {
                return a === decodeURIComponent(a) ? encodeURIComponent(a) : a;
            },
            ensureEncodedParam: function(a) {
                var b = a.split("="), c = b[0], d = b[1];
                return c + (void 0 === d ? "" : "=" + this.ensureEncodedUriComponent(d));
            },
            ensureEncodedQuery: function(a) {
                return a.split("&").map(this.ensureEncodedParam.bind(this)).join("&");
            },
            checkLinkFormat: function(a) {
                var b = /^([a-z]+:)?\/\/|^(mailto|tel|maps):|^\#/i, c = b.test(a), d = "", e = /^\+?\s?\(?(?:\d\s?\-?\)?){3,20}$/, f = a.match(/^(.*?)(?:\?(.*?))?(?:#(.*))?$/), g = f[1], h = f[2], i = f[3];
                if (e.test(a)) return "tel:" + a;
                if (!c) {
                    var j = g.split("/")[0];
                    (j.match(/.+(\.|:).+/) || "localhost" === j) && (d = "http://");
                }
                return d + this.ensureEncodedUri(g) + (void 0 === h ? "" : "?" + this.ensureEncodedQuery(h)) + (void 0 === i ? "" : "#" + i);
            },
            doFormCancel: function() {
                this.base.restoreSelection(), this.base.checkSelection();
            },
            attachFormEvents: function(a) {
                var b = a.querySelector(".medium-editor-toolbar-close"), c = a.querySelector(".medium-editor-toolbar-save"), d = a.querySelector(".medium-editor-toolbar-input");
                this.on(a, "click", this.handleFormClick.bind(this)), this.on(d, "keyup", this.handleTextboxKeyup.bind(this)), this.on(b, "click", this.handleCloseClick.bind(this)), this.on(c, "click", this.handleSaveClick.bind(this), !0);
            },
            createForm: function() {
                var a = this.document, b = a.createElement("div");
                return b.className = "medium-editor-toolbar-form", b.id = "medium-editor-toolbar-form-anchor-" + this.getEditorId(), b.innerHTML = this.getTemplate(), this.attachFormEvents(b), b;
            },
            getInput: function() {
                return this.getForm().querySelector("input.medium-editor-toolbar-input");
            },
            getAnchorTargetCheckbox: function() {
                return this.getForm().querySelector(".medium-editor-toolbar-anchor-target");
            },
            getAnchorButtonCheckbox: function() {
                return this.getForm().querySelector(".medium-editor-toolbar-anchor-button");
            },
            handleTextboxKeyup: function(b) {
                return b.keyCode === a.util.keyCode.ENTER ? (b.preventDefault(), void this.doFormSave()) : void (b.keyCode === a.util.keyCode.ESCAPE && (b.preventDefault(), this.doFormCancel()));
            },
            handleFormClick: function(a) {
                a.stopPropagation();
            },
            handleSaveClick: function(a) {
                a.preventDefault(), this.doFormSave();
            },
            handleCloseClick: function(a) {
                a.preventDefault(), this.doFormCancel();
            }
        });
        a.extensions.anchor = b;
    }(), function() {
        var b = a.Extension.extend({
            name: "anchor-preview",
            hideDelay: 500,
            previewValueSelector: "a",
            showWhenToolbarIsVisible: !1,
            showOnEmptyLinks: !0,
            init: function() {
                this.anchorPreview = this.createPreview(), this.getEditorOption("elementsContainer").appendChild(this.anchorPreview), this.attachToEditables();
            },
            getInteractionElements: function() {
                return this.getPreviewElement();
            },
            getPreviewElement: function() {
                return this.anchorPreview;
            },
            createPreview: function() {
                var a = this.document.createElement("div");
                return a.id = "medium-editor-anchor-preview-" + this.getEditorId(), a.className = "medium-editor-anchor-preview", a.innerHTML = this.getTemplate(), this.on(a, "click", this.handleClick.bind(this)), a;
            },
            getTemplate: function() {
                return '<div class="medium-editor-toolbar-anchor-preview" id="medium-editor-toolbar-anchor-preview">    <a class="medium-editor-toolbar-anchor-preview-inner"></a></div>';
            },
            destroy: function() {
                this.anchorPreview && (this.anchorPreview.parentNode && this.anchorPreview.parentNode.removeChild(this.anchorPreview), delete this.anchorPreview);
            },
            hidePreview: function() {
                this.anchorPreview && this.anchorPreview.classList.remove("medium-editor-anchor-preview-active"), this.activeAnchor = null;
            },
            showPreview: function(a) {
                return this.anchorPreview.classList.contains("medium-editor-anchor-preview-active") || a.getAttribute("data-disable-preview") ? !0 : (this.previewValueSelector && (this.anchorPreview.querySelector(this.previewValueSelector).textContent = a.attributes.href.value, this.anchorPreview.querySelector(this.previewValueSelector).href = a.attributes.href.value), this.anchorPreview.classList.add("medium-toolbar-arrow-over"), this.anchorPreview.classList.remove("medium-toolbar-arrow-under"), this.anchorPreview.classList.contains("medium-editor-anchor-preview-active") || this.anchorPreview.classList.add("medium-editor-anchor-preview-active"), this.activeAnchor = a, this.positionPreview(), this.attachPreviewHandlers(), this);
            },
            positionPreview: function(a) {
                a = a || this.activeAnchor;
                var b, c, d, e, f, g = this.window.innerWidth, h = this.anchorPreview.offsetHeight, i = a.getBoundingClientRect(), j = this.diffLeft, k = this.diffTop, l = this.getEditorOption("elementsContainer"), m = [
                    "absolute",
                    "fixed"
                ].indexOf(window.getComputedStyle(l).getPropertyValue("position")) > -1, n = {};
                b = this.anchorPreview.offsetWidth / 2;
                var o = this.base.getExtensionByName("toolbar");
                o && (j = o.diffLeft, k = o.diffTop), c = j - b, m ? (e = l.getBoundingClientRect(), [
                    "top",
                    "left"
                ].forEach(function(a) {
                    n[a] = i[a] - e[a];
                }), n.width = i.width, n.height = i.height, i = n, g = e.width, f = l.scrollTop) : f = this.window.pageYOffset, d = i.left + i.width / 2, f += h + i.top + i.height - k - this.anchorPreview.offsetHeight, this.anchorPreview.style.top = Math.round(f) + "px", this.anchorPreview.style.right = "initial", b > d ? (this.anchorPreview.style.left = c + b + "px", this.anchorPreview.style.right = "initial") : b > g - d ? (this.anchorPreview.style.left = "auto", this.anchorPreview.style.right = 0) : (this.anchorPreview.style.left = c + d + "px", this.anchorPreview.style.right = "initial");
            },
            attachToEditables: function() {
                this.subscribe("editableMouseover", this.handleEditableMouseover.bind(this)), this.subscribe("positionedToolbar", this.handlePositionedToolbar.bind(this));
            },
            handlePositionedToolbar: function() {
                this.showWhenToolbarIsVisible || this.hidePreview();
            },
            handleClick: function(a) {
                var b = this.base.getExtensionByName("anchor"), c = this.activeAnchor;
                b && c && (a.preventDefault(), this.base.selectElement(this.activeAnchor), this.base.delay((function() {
                    if (c) {
                        var a = {
                            value: c.attributes.href.value,
                            target: c.getAttribute("target"),
                            buttonClass: c.getAttribute("class")
                        };
                        b.showForm(a), c = null;
                    }
                }).bind(this))), this.hidePreview();
            },
            handleAnchorMouseout: function() {
                this.anchorToPreview = null, this.off(this.activeAnchor, "mouseout", this.instanceHandleAnchorMouseout), this.instanceHandleAnchorMouseout = null;
            },
            handleEditableMouseover: function(b) {
                var c = a.util.getClosestTag(b.target, "a");
                if (!1 !== c) {
                    if (!this.showOnEmptyLinks && (!/href=["']\S+["']/.test(c.outerHTML) || /href=["']#\S+["']/.test(c.outerHTML))) return !0;
                    var d = this.base.getExtensionByName("toolbar");
                    if (!this.showWhenToolbarIsVisible && d && d.isDisplayed && d.isDisplayed()) return !0;
                    this.activeAnchor && this.activeAnchor !== c && this.detachPreviewHandlers(), this.anchorToPreview = c, this.instanceHandleAnchorMouseout = this.handleAnchorMouseout.bind(this), this.on(this.anchorToPreview, "mouseout", this.instanceHandleAnchorMouseout), this.base.delay((function() {
                        this.anchorToPreview && this.showPreview(this.anchorToPreview);
                    }).bind(this));
                }
            },
            handlePreviewMouseover: function() {
                this.lastOver = (new Date).getTime(), this.hovering = !0;
            },
            handlePreviewMouseout: function(a) {
                a.relatedTarget && /anchor-preview/.test(a.relatedTarget.className) || (this.hovering = !1);
            },
            updatePreview: function() {
                if (this.hovering) return !0;
                var a = (new Date).getTime() - this.lastOver;
                a > this.hideDelay && this.detachPreviewHandlers();
            },
            detachPreviewHandlers: function() {
                clearInterval(this.intervalTimer), this.instanceHandlePreviewMouseover && (this.off(this.anchorPreview, "mouseover", this.instanceHandlePreviewMouseover), this.off(this.anchorPreview, "mouseout", this.instanceHandlePreviewMouseout), this.activeAnchor && (this.off(this.activeAnchor, "mouseover", this.instanceHandlePreviewMouseover), this.off(this.activeAnchor, "mouseout", this.instanceHandlePreviewMouseout))), this.hidePreview(), this.hovering = this.instanceHandlePreviewMouseover = this.instanceHandlePreviewMouseout = null;
            },
            attachPreviewHandlers: function() {
                this.lastOver = (new Date).getTime(), this.hovering = !0, this.instanceHandlePreviewMouseover = this.handlePreviewMouseover.bind(this), this.instanceHandlePreviewMouseout = this.handlePreviewMouseout.bind(this), this.intervalTimer = setInterval(this.updatePreview.bind(this), 200), this.on(this.anchorPreview, "mouseover", this.instanceHandlePreviewMouseover), this.on(this.anchorPreview, "mouseout", this.instanceHandlePreviewMouseout), this.on(this.activeAnchor, "mouseover", this.instanceHandlePreviewMouseover), this.on(this.activeAnchor, "mouseout", this.instanceHandlePreviewMouseout);
            }
        });
        a.extensions.anchorPreview = b;
    }(), function() {
        function b(b) {
            return !a.util.getClosestTag(b, "a");
        }
        var c, d, e, f, g;
        c = [
            " ",
            "	",
            "\n",
            "\r",
            "\xa0",
            "\u2000",
            "\u2001",
            "\u2002",
            "\u2003",
            "\u2028",
            "\u2029"
        ], d = "com|net|org|edu|gov|mil|aero|asia|biz|cat|coop|info|int|jobs|mobi|museum|name|post|pro|tel|travel|xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cs|cu|cv|cx|cy|cz|dd|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|ja|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw", e = "(((?:(https?://|ftps?://|nntp://)|www\\d{0,3}[.]|[a-z0-9.\\-]+[.](" + d + ")\\/)\\S+(?:[^\\s`!\\[\\]{};:'\".,?\xab\xbb\u201C\u201D\u2018\u2019])))|(([a-z0-9\\-]+\\.)?[a-z0-9\\-]+\\.(" + d + "))", f = new RegExp("^(" + d + ")$", "i"), g = new RegExp(e, "gi");
        var h = a.Extension.extend({
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.disableEventHandling = !1, this.subscribe("editableKeypress", this.onKeypress.bind(this)), this.subscribe("editableBlur", this.onBlur.bind(this)), this.document.execCommand("AutoUrlDetect", !1, !1);
            },
            isLastInstance: function() {
                for(var a = 0, b = 0; b < this.window._mediumEditors.length; b++){
                    var c = this.window._mediumEditors[b];
                    null !== c && void 0 !== c.getExtensionByName("autoLink") && a++;
                }
                return 1 === a;
            },
            destroy: function() {
                this.document.queryCommandSupported("AutoUrlDetect") && this.isLastInstance() && this.document.execCommand("AutoUrlDetect", !1, !0);
            },
            onBlur: function(a, b) {
                this.performLinking(b);
            },
            onKeypress: function(b) {
                this.disableEventHandling || a.util.isKey(b, [
                    a.util.keyCode.SPACE,
                    a.util.keyCode.ENTER
                ]) && (clearTimeout(this.performLinkingTimeout), this.performLinkingTimeout = setTimeout((function() {
                    try {
                        var a = this.base.exportSelection();
                        this.performLinking(b.target) && this.base.importSelection(a, !0);
                    } catch (c) {
                        window.console && window.console.error("Failed to perform linking", c), this.disableEventHandling = !0;
                    }
                }).bind(this), 0));
            },
            performLinking: function(b) {
                var c = a.util.splitByBlockElements(b), d = !1;
                0 === c.length && (c = [
                    b
                ]);
                for(var e = 0; e < c.length; e++)d = this.removeObsoleteAutoLinkSpans(c[e]) || d, d = this.performLinkingWithinElement(c[e]) || d;
                return this.base.events.updateInput(b, {
                    target: b,
                    currentTarget: b
                }), d;
            },
            removeObsoleteAutoLinkSpans: function(c) {
                if (!c || 3 === c.nodeType) return !1;
                for(var d = c.querySelectorAll('span[data-auto-link="true"]'), e = !1, f = 0; f < d.length; f++){
                    var g = d[f].textContent;
                    if (-1 === g.indexOf("://") && (g = a.util.ensureUrlHasProtocol(g)), d[f].getAttribute("data-href") !== g && b(d[f])) {
                        e = !0;
                        var h = g.replace(/\s+$/, "");
                        if (d[f].getAttribute("data-href") === h) {
                            var i = g.length - h.length, j = a.util.splitOffDOMTree(d[f], this.splitTextBeforeEnd(d[f], i));
                            d[f].parentNode.insertBefore(j, d[f].nextSibling);
                        } else a.util.unwrap(d[f], this.document);
                    }
                }
                return e;
            },
            splitTextBeforeEnd: function(a, b) {
                for(var c = this.document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null, !1), d = !0; d;)d = null !== c.lastChild();
                for(var e, f, g; b > 0 && null !== g;)e = c.currentNode, f = e.nodeValue, f.length > b ? (g = e.splitText(f.length - b), b = 0) : (g = c.previousNode(), b -= f.length);
                return g;
            },
            performLinkingWithinElement: function(b) {
                for(var c = this.findLinkableText(b), d = !1, e = 0; e < c.length; e++){
                    var f = a.util.findOrCreateMatchingTextNodes(this.document, b, c[e]);
                    this.shouldNotLink(f) || this.createAutoLink(f, c[e].href);
                }
                return d;
            },
            shouldNotLink: function(b) {
                for(var c = !1, d = 0; d < b.length && c === !1; d++)c = !!a.util.traverseUp(b[d], function(a) {
                    return "a" === a.nodeName.toLowerCase() || a.getAttribute && "true" === a.getAttribute("data-auto-link");
                });
                return c;
            },
            findLinkableText: function(a) {
                for(var b = a.textContent, d = null, e = []; null !== (d = g.exec(b));){
                    var h = !0, i = d.index + d[0].length;
                    h = !(0 !== d.index && -1 === c.indexOf(b[d.index - 1]) || i !== b.length && -1 === c.indexOf(b[i])), h = h && (-1 !== d[0].indexOf("/") || f.test(d[0].split(".").pop().split("?").shift())), h && e.push({
                        href: d[0],
                        start: d.index,
                        end: i
                    });
                }
                return e;
            },
            createAutoLink: function(b, c) {
                c = a.util.ensureUrlHasProtocol(c);
                var d = a.util.createLink(this.document, b, c, this.getEditorOption("targetBlank") ? "_blank" : null), e = this.document.createElement("span");
                for(e.setAttribute("data-auto-link", "true"), e.setAttribute("data-href", c), d.insertBefore(e, d.firstChild); d.childNodes.length > 1;)e.appendChild(d.childNodes[1]);
            }
        });
        a.extensions.autoLink = h;
    }(), function() {
        function b(b) {
            var d = a.util.getContainerEditorElement(b), e = Array.prototype.slice.call(d.parentElement.querySelectorAll("." + c));
            e.forEach(function(a) {
                a.classList.remove(c);
            });
        }
        var c = "medium-editor-dragover", d = a.Extension.extend({
            name: "fileDragging",
            allowedTypes: [
                "image"
            ],
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.subscribe("editableDrag", this.handleDrag.bind(this)), this.subscribe("editableDrop", this.handleDrop.bind(this));
            },
            handleDrag: function(a) {
                a.preventDefault(), a.dataTransfer.dropEffect = "copy";
                var d = a.target.classList ? a.target : a.target.parentElement;
                b(d), "dragover" === a.type && d.classList.add(c);
            },
            handleDrop: function(a) {
                a.preventDefault(), a.stopPropagation(), this.base.selectElement(a.target);
                var c = this.base.exportSelection();
                c.start = c.end, this.base.importSelection(c), a.dataTransfer.files && Array.prototype.slice.call(a.dataTransfer.files).forEach(function(a) {
                    this.isAllowedFile(a) && a.type.match("image") && this.insertImageFile(a);
                }, this), b(a.target);
            },
            isAllowedFile: function(a) {
                return this.allowedTypes.some(function(b) {
                    return !!a.type.match(b);
                });
            },
            insertImageFile: function(b) {
                if ("function" == typeof FileReader) {
                    var c = new FileReader;
                    c.readAsDataURL(b), c.addEventListener("load", (function(b) {
                        var c = this.document.createElement("img");
                        c.src = b.target.result, a.util.insertHTMLCommand(this.document, c.outerHTML);
                    }).bind(this));
                }
            }
        });
        a.extensions.fileDragging = d;
    }(), function() {
        var b = a.Extension.extend({
            name: "keyboard-commands",
            commands: [
                {
                    command: "bold",
                    key: "B",
                    meta: !0,
                    shift: !1,
                    alt: !1
                },
                {
                    command: "italic",
                    key: "I",
                    meta: !0,
                    shift: !1,
                    alt: !1
                },
                {
                    command: "underline",
                    key: "U",
                    meta: !0,
                    shift: !1,
                    alt: !1
                }
            ],
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.subscribe("editableKeydown", this.handleKeydown.bind(this)), this.keys = {}, this.commands.forEach(function(a) {
                    var b = a.key.charCodeAt(0);
                    this.keys[b] || (this.keys[b] = []), this.keys[b].push(a);
                }, this);
            },
            handleKeydown: function(b) {
                var c = a.util.getKeyCode(b);
                if (this.keys[c]) {
                    var d = a.util.isMetaCtrlKey(b), e = !!b.shiftKey, f = !!b.altKey;
                    this.keys[c].forEach(function(a) {
                        a.meta !== d || a.shift !== e || a.alt !== f && void 0 !== a.alt || (b.preventDefault(), b.stopPropagation(), "function" == typeof a.command ? a.command.apply(this) : !1 !== a.command && this.execAction(a.command));
                    }, this);
                }
            }
        });
        a.extensions.keyboardCommands = b;
    }(), function() {
        var b = a.extensions.form.extend({
            name: "fontname",
            action: "fontName",
            aria: "change font name",
            contentDefault: "&#xB1;",
            contentFA: '<i class="fa fa-font"></i>',
            fonts: [
                "",
                "Arial",
                "Verdana",
                "Times New Roman"
            ],
            init: function() {
                a.extensions.form.prototype.init.apply(this, arguments);
            },
            handleClick: function(a) {
                if (a.preventDefault(), a.stopPropagation(), !this.isDisplayed()) {
                    var b = this.document.queryCommandValue("fontName") + "";
                    this.showForm(b);
                }
                return !1;
            },
            getForm: function() {
                return this.form || (this.form = this.createForm()), this.form;
            },
            isDisplayed: function() {
                return "block" === this.getForm().style.display;
            },
            hideForm: function() {
                this.getForm().style.display = "none", this.getSelect().value = "";
            },
            showForm: function(a) {
                var b = this.getSelect();
                this.base.saveSelection(), this.hideToolbarDefaultActions(), this.getForm().style.display = "block", this.setToolbarPosition(), b.value = a || "", b.focus();
            },
            destroy: function() {
                return this.form ? (this.form.parentNode && this.form.parentNode.removeChild(this.form), void delete this.form) : !1;
            },
            doFormSave: function() {
                this.base.restoreSelection(), this.base.checkSelection();
            },
            doFormCancel: function() {
                this.base.restoreSelection(), this.clearFontName(), this.base.checkSelection();
            },
            createForm: function() {
                var a, b = this.document, c = b.createElement("div"), d = b.createElement("select"), e = b.createElement("a"), f = b.createElement("a");
                c.className = "medium-editor-toolbar-form", c.id = "medium-editor-toolbar-form-fontname-" + this.getEditorId(), this.on(c, "click", this.handleFormClick.bind(this));
                for(var g = 0; g < this.fonts.length; g++)a = b.createElement("option"), a.innerHTML = this.fonts[g], a.value = this.fonts[g], d.appendChild(a);
                return d.className = "medium-editor-toolbar-select", c.appendChild(d), this.on(d, "change", this.handleFontChange.bind(this)), f.setAttribute("href", "#"), f.className = "medium-editor-toobar-save", f.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-check"></i>' : "&#10003;", c.appendChild(f), this.on(f, "click", this.handleSaveClick.bind(this), !0), e.setAttribute("href", "#"), e.className = "medium-editor-toobar-close", e.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-times"></i>' : "&times;", c.appendChild(e), this.on(e, "click", this.handleCloseClick.bind(this)), c;
            },
            getSelect: function() {
                return this.getForm().querySelector("select.medium-editor-toolbar-select");
            },
            clearFontName: function() {
                a.selection.getSelectedElements(this.document).forEach(function(a) {
                    "font" === a.nodeName.toLowerCase() && a.hasAttribute("face") && a.removeAttribute("face");
                });
            },
            handleFontChange: function() {
                var a = this.getSelect().value;
                "" === a ? this.clearFontName() : this.execAction("fontName", {
                    value: a
                });
            },
            handleFormClick: function(a) {
                a.stopPropagation();
            },
            handleSaveClick: function(a) {
                a.preventDefault(), this.doFormSave();
            },
            handleCloseClick: function(a) {
                a.preventDefault(), this.doFormCancel();
            }
        });
        a.extensions.fontName = b;
    }(), function() {
        var b = a.extensions.form.extend({
            name: "fontsize",
            action: "fontSize",
            aria: "increase/decrease font size",
            contentDefault: "&#xB1;",
            contentFA: '<i class="fa fa-text-height"></i>',
            init: function() {
                a.extensions.form.prototype.init.apply(this, arguments);
            },
            handleClick: function(a) {
                if (a.preventDefault(), a.stopPropagation(), !this.isDisplayed()) {
                    var b = this.document.queryCommandValue("fontSize") + "";
                    this.showForm(b);
                }
                return !1;
            },
            getForm: function() {
                return this.form || (this.form = this.createForm()), this.form;
            },
            isDisplayed: function() {
                return "block" === this.getForm().style.display;
            },
            hideForm: function() {
                this.getForm().style.display = "none", this.getInput().value = "";
            },
            showForm: function(a) {
                var b = this.getInput();
                this.base.saveSelection(), this.hideToolbarDefaultActions(), this.getForm().style.display = "block", this.setToolbarPosition(), b.value = a || "", b.focus();
            },
            destroy: function() {
                return this.form ? (this.form.parentNode && this.form.parentNode.removeChild(this.form), void delete this.form) : !1;
            },
            doFormSave: function() {
                this.base.restoreSelection(), this.base.checkSelection();
            },
            doFormCancel: function() {
                this.base.restoreSelection(), this.clearFontSize(), this.base.checkSelection();
            },
            createForm: function() {
                var a = this.document, b = a.createElement("div"), c = a.createElement("input"), d = a.createElement("a"), e = a.createElement("a");
                return b.className = "medium-editor-toolbar-form", b.id = "medium-editor-toolbar-form-fontsize-" + this.getEditorId(), this.on(b, "click", this.handleFormClick.bind(this)), c.setAttribute("type", "range"), c.setAttribute("min", "1"), c.setAttribute("max", "7"), c.className = "medium-editor-toolbar-input", b.appendChild(c), this.on(c, "change", this.handleSliderChange.bind(this)), e.setAttribute("href", "#"), e.className = "medium-editor-toobar-save", e.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-check"></i>' : "&#10003;", b.appendChild(e), this.on(e, "click", this.handleSaveClick.bind(this), !0), d.setAttribute("href", "#"), d.className = "medium-editor-toobar-close", d.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-times"></i>' : "&times;", b.appendChild(d), this.on(d, "click", this.handleCloseClick.bind(this)), b;
            },
            getInput: function() {
                return this.getForm().querySelector("input.medium-editor-toolbar-input");
            },
            clearFontSize: function() {
                a.selection.getSelectedElements(this.document).forEach(function(a) {
                    "font" === a.nodeName.toLowerCase() && a.hasAttribute("size") && a.removeAttribute("size");
                });
            },
            handleSliderChange: function() {
                var a = this.getInput().value;
                "4" === a ? this.clearFontSize() : this.execAction("fontSize", {
                    value: a
                });
            },
            handleFormClick: function(a) {
                a.stopPropagation();
            },
            handleSaveClick: function(a) {
                a.preventDefault(), this.doFormSave();
            },
            handleCloseClick: function(a) {
                a.preventDefault(), this.doFormCancel();
            }
        });
        a.extensions.fontSize = b;
    }(), function() {
        function b() {
            return [
                [
                    new RegExp(/^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/g),
                    ""
                ],
                [
                    new RegExp(/<!--StartFragment-->|<!--EndFragment-->/g),
                    ""
                ],
                [
                    new RegExp(/<br>$/i),
                    ""
                ],
                [
                    new RegExp(/<[^>]*docs-internal-guid[^>]*>/gi),
                    ""
                ],
                [
                    new RegExp(/<\/b>(<br[^>]*>)?$/gi),
                    ""
                ],
                [
                    new RegExp(/<span class="Apple-converted-space">\s+<\/span>/g),
                    " "
                ],
                [
                    new RegExp(/<br class="Apple-interchange-newline">/g),
                    "<br>"
                ],
                [
                    new RegExp(/<span[^>]*(font-style:italic;font-weight:(bold|700)|font-weight:(bold|700);font-style:italic)[^>]*>/gi),
                    '<span class="replace-with italic bold">'
                ],
                [
                    new RegExp(/<span[^>]*font-style:italic[^>]*>/gi),
                    '<span class="replace-with italic">'
                ],
                [
                    new RegExp(/<span[^>]*font-weight:(bold|700)[^>]*>/gi),
                    '<span class="replace-with bold">'
                ],
                [
                    new RegExp(/&lt;(\/?)(i|b|a)&gt;/gi),
                    "<$1$2>"
                ],
                [
                    new RegExp(/&lt;a(?:(?!href).)+href=(?:&quot;|&rdquo;|&ldquo;|"|“|”)(((?!&quot;|&rdquo;|&ldquo;|"|“|”).)*)(?:&quot;|&rdquo;|&ldquo;|"|“|”)(?:(?!&gt;).)*&gt;/gi),
                    '<a href="$1">'
                ],
                [
                    new RegExp(/<\/p>\n+/gi),
                    "</p>"
                ],
                [
                    new RegExp(/\n+<p/gi),
                    "<p"
                ],
                [
                    new RegExp(/<\/?o:[a-z]*>/gi),
                    ""
                ],
                [
                    new RegExp(/<!\[if !supportLists\]>(((?!<!).)*)<!\[endif]\>/gi),
                    "$1"
                ]
            ];
        }
        function c(a, b, c) {
            var d = a.clipboardData || b.clipboardData || c.dataTransfer, e = {};
            if (!d) return e;
            if (d.getData) {
                var f = d.getData("Text");
                f && f.length > 0 && (e["text/plain"] = f);
            }
            if (d.types) for(var g = 0; g < d.types.length; g++){
                var h = d.types[g];
                e[h] = d.getData(h);
            }
            return e;
        }
        var d = "%ME_PASTEBIN%", e = null, f = null, g = function(a) {
            a.stopPropagation();
        }, h = a.Extension.extend({
            forcePlainText: !0,
            cleanPastedHTML: !1,
            preCleanReplacements: [],
            cleanReplacements: [],
            cleanAttrs: [
                "class",
                "style",
                "dir"
            ],
            cleanTags: [
                "meta"
            ],
            unwrapTags: [],
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), (this.forcePlainText || this.cleanPastedHTML) && (this.subscribe("editableKeydown", this.handleKeydown.bind(this)), this.getEditorElements().forEach(function(a) {
                    this.on(a, "paste", this.handlePaste.bind(this));
                }, this), this.subscribe("addElement", this.handleAddElement.bind(this)));
            },
            handleAddElement: function(a, b) {
                this.on(b, "paste", this.handlePaste.bind(this));
            },
            destroy: function() {
                (this.forcePlainText || this.cleanPastedHTML) && this.removePasteBin();
            },
            handlePaste: function(a, b) {
                if (!a.defaultPrevented) {
                    var d = c(a, this.window, this.document), e = d["text/html"], f = d["text/plain"];
                    this.window.clipboardData && void 0 === a.clipboardData && !e && (e = f), (e || f) && (a.preventDefault(), this.doPaste(e, f, b));
                }
            },
            doPaste: function(b, c, d) {
                var e, f, g = "";
                if (this.cleanPastedHTML && b) return this.cleanPaste(b);
                if (c) {
                    if (this.getEditorOption("disableReturn") || d && d.getAttribute("data-disable-return")) g = a.util.htmlEntities(c);
                    else if (e = c.split(/[\r\n]+/g), e.length > 1) for(f = 0; f < e.length; f += 1)"" !== e[f] && (g += "<p>" + a.util.htmlEntities(e[f]) + "</p>");
                    else g = a.util.htmlEntities(e[0]);
                    a.util.insertHTMLCommand(this.document, g);
                }
            },
            handlePasteBinPaste: function(a) {
                if (a.defaultPrevented) return void this.removePasteBin();
                var b = c(a, this.window, this.document), d = b["text/html"], e = b["text/plain"], g = f;
                return !this.cleanPastedHTML || d ? (a.preventDefault(), this.removePasteBin(), this.doPaste(d, e, g), void this.trigger("editablePaste", {
                    currentTarget: g,
                    target: g
                }, g)) : void setTimeout((function() {
                    this.cleanPastedHTML && (d = this.getPasteBinHtml()), this.removePasteBin(), this.doPaste(d, e, g), this.trigger("editablePaste", {
                        currentTarget: g,
                        target: g
                    }, g);
                }).bind(this), 0);
            },
            handleKeydown: function(b, c) {
                a.util.isKey(b, a.util.keyCode.V) && a.util.isMetaCtrlKey(b) && (b.stopImmediatePropagation(), this.removePasteBin(), this.createPasteBin(c));
            },
            createPasteBin: function(b) {
                var c, h = a.selection.getSelectionRange(this.document), i = this.window.pageYOffset;
                f = b, h && (c = h.getClientRects(), i += c.length ? c[0].top : void 0 !== h.startContainer.getBoundingClientRect ? h.startContainer.getBoundingClientRect().top : h.getBoundingClientRect().top), e = h;
                var j = this.document.createElement("div");
                j.id = this.pasteBinId = "medium-editor-pastebin-" + +Date.now(), j.setAttribute("style", "border: 1px red solid; position: absolute; top: " + i + "px; width: 10px; height: 10px; overflow: hidden; opacity: 0"), j.setAttribute("contentEditable", !0), j.innerHTML = d, this.document.body.appendChild(j), this.on(j, "focus", g), this.on(j, "focusin", g), this.on(j, "focusout", g), j.focus(), a.selection.selectNode(j, this.document), this.boundHandlePaste || (this.boundHandlePaste = this.handlePasteBinPaste.bind(this)), this.on(j, "paste", this.boundHandlePaste);
            },
            removePasteBin: function() {
                null !== e && (a.selection.selectRange(this.document, e), e = null), null !== f && (f = null);
                var b = this.getPasteBin();
                b && b && (this.off(b, "focus", g), this.off(b, "focusin", g), this.off(b, "focusout", g), this.off(b, "paste", this.boundHandlePaste), b.parentElement.removeChild(b));
            },
            getPasteBin: function() {
                return this.document.getElementById(this.pasteBinId);
            },
            getPasteBinHtml: function() {
                var a = this.getPasteBin();
                if (!a) return !1;
                if (a.firstChild && "mcepastebin" === a.firstChild.id) return !1;
                var b = a.innerHTML;
                return b && b !== d ? b : !1;
            },
            cleanPaste: function(a) {
                var c, d, e, f, g = /<p|<br|<div/.test(a), h = [].concat(this.preCleanReplacements || [], b(), this.cleanReplacements || []);
                for(c = 0; c < h.length; c += 1)a = a.replace(h[c][0], h[c][1]);
                if (!g) return this.pasteHTML(a);
                for(e = this.document.createElement("div"), e.innerHTML = "<p>" + a.split("<br><br>").join("</p><p>") + "</p>", d = e.querySelectorAll("a,p,div,br"), c = 0; c < d.length; c += 1)switch(f = d[c], f.innerHTML = f.innerHTML.replace(/\n/gi, " "), f.nodeName.toLowerCase()){
                    case "p":
                    case "div":
                        this.filterCommonBlocks(f);
                        break;
                    case "br":
                        this.filterLineBreak(f);
                }
                this.pasteHTML(e.innerHTML);
            },
            pasteHTML: function(b, c) {
                c = a.util.defaults({}, c, {
                    cleanAttrs: this.cleanAttrs,
                    cleanTags: this.cleanTags,
                    unwrapTags: this.unwrapTags
                });
                var d, e, f, g, h = this.document.createDocumentFragment();
                for(h.appendChild(this.document.createElement("body")), g = h.querySelector("body"), g.innerHTML = b, this.cleanupSpans(g), d = g.querySelectorAll("*"), f = 0; f < d.length; f += 1)e = d[f], "a" === e.nodeName.toLowerCase() && this.getEditorOption("targetBlank") && a.util.setTargetBlank(e), a.util.cleanupAttrs(e, c.cleanAttrs), a.util.cleanupTags(e, c.cleanTags), a.util.unwrapTags(e, c.unwrapTags);
                a.util.insertHTMLCommand(this.document, g.innerHTML.replace(/&nbsp;/g, " "));
            },
            isCommonBlock: function(a) {
                return a && ("p" === a.nodeName.toLowerCase() || "div" === a.nodeName.toLowerCase());
            },
            filterCommonBlocks: function(a) {
                /^\s*$/.test(a.textContent) && a.parentNode && a.parentNode.removeChild(a);
            },
            filterLineBreak: function(a) {
                this.isCommonBlock(a.previousElementSibling) ? this.removeWithParent(a) : !this.isCommonBlock(a.parentNode) || a.parentNode.firstChild !== a && a.parentNode.lastChild !== a ? a.parentNode && 1 === a.parentNode.childElementCount && "" === a.parentNode.textContent && this.removeWithParent(a) : this.removeWithParent(a);
            },
            removeWithParent: function(a) {
                a && a.parentNode && (a.parentNode.parentNode && 1 === a.parentNode.childElementCount ? a.parentNode.parentNode.removeChild(a.parentNode) : a.parentNode.removeChild(a));
            },
            cleanupSpans: function(b) {
                var c, d, e, f = b.querySelectorAll(".replace-with"), g = function(a) {
                    return a && "#text" !== a.nodeName && "false" === a.getAttribute("contenteditable");
                };
                for(c = 0; c < f.length; c += 1)d = f[c], e = this.document.createElement(d.classList.contains("bold") ? "b" : "i"), d.classList.contains("bold") && d.classList.contains("italic") ? e.innerHTML = "<i>" + d.innerHTML + "</i>" : e.innerHTML = d.innerHTML, d.parentNode.replaceChild(e, d);
                for(f = b.querySelectorAll("span"), c = 0; c < f.length; c += 1){
                    if (d = f[c], a.util.traverseUp(d, g)) return !1;
                    a.util.unwrap(d, this.document);
                }
            }
        });
        a.extensions.paste = h;
    }(), function() {
        var b = a.Extension.extend({
            name: "placeholder",
            text: "Type your text",
            hideOnClick: !0,
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.initPlaceholders(), this.attachEventHandlers();
            },
            initPlaceholders: function() {
                this.getEditorElements().forEach(this.initElement, this);
            },
            handleAddElement: function(a, b) {
                this.initElement(b);
            },
            initElement: function(a) {
                a.getAttribute("data-placeholder") || a.setAttribute("data-placeholder", this.text), this.updatePlaceholder(a);
            },
            destroy: function() {
                this.getEditorElements().forEach(this.cleanupElement, this);
            },
            handleRemoveElement: function(a, b) {
                this.cleanupElement(b);
            },
            cleanupElement: function(a) {
                a.getAttribute("data-placeholder") === this.text && a.removeAttribute("data-placeholder");
            },
            showPlaceholder: function(b) {
                b && (a.util.isFF && 0 === b.childNodes.length ? (b.classList.add("medium-editor-placeholder-relative"), b.classList.remove("medium-editor-placeholder")) : (b.classList.add("medium-editor-placeholder"), b.classList.remove("medium-editor-placeholder-relative")));
            },
            hidePlaceholder: function(a) {
                a && (a.classList.remove("medium-editor-placeholder"), a.classList.remove("medium-editor-placeholder-relative"));
            },
            updatePlaceholder: function(a, b) {
                return a.querySelector("img, blockquote, ul, ol, table") || "" !== a.textContent.replace(/^\s+|\s+$/g, "") ? this.hidePlaceholder(a) : void (b || this.showPlaceholder(a));
            },
            attachEventHandlers: function() {
                this.hideOnClick && this.subscribe("focus", this.handleFocus.bind(this)), this.subscribe("editableInput", this.handleInput.bind(this)), this.subscribe("blur", this.handleBlur.bind(this)), this.subscribe("addElement", this.handleAddElement.bind(this)), this.subscribe("removeElement", this.handleRemoveElement.bind(this));
            },
            handleInput: function(a, b) {
                var c = this.hideOnClick && b === this.base.getFocusedElement();
                this.updatePlaceholder(b, c);
            },
            handleFocus: function(a, b) {
                this.hidePlaceholder(b);
            },
            handleBlur: function(a, b) {
                this.updatePlaceholder(b);
            }
        });
        a.extensions.placeholder = b;
    }(), function() {
        var b = a.Extension.extend({
            name: "toolbar",
            align: "center",
            allowMultiParagraphSelection: !0,
            buttons: [
                "bold",
                "italic",
                "underline",
                "anchor",
                "h2",
                "h3",
                "quote"
            ],
            diffLeft: 0,
            diffTop: -10,
            firstButtonClass: "medium-editor-button-first",
            lastButtonClass: "medium-editor-button-last",
            standardizeSelectionStart: !1,
            "static": !1,
            sticky: !1,
            stickyTopOffset: 0,
            updateOnEmptySelection: !1,
            relativeContainer: null,
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.initThrottledMethods(), this.relativeContainer ? this.relativeContainer.appendChild(this.getToolbarElement()) : this.getEditorOption("elementsContainer").appendChild(this.getToolbarElement());
            },
            forEachExtension: function(a, b) {
                return this.base.extensions.forEach(function(c) {
                    return c !== this ? a.apply(b || this, arguments) : void 0;
                }, this);
            },
            createToolbar: function() {
                var a = this.document.createElement("div");
                return a.id = "medium-editor-toolbar-" + this.getEditorId(), a.className = "medium-editor-toolbar", this["static"] ? a.className += " static-toolbar" : this.relativeContainer ? a.className += " medium-editor-relative-toolbar" : a.className += " medium-editor-stalker-toolbar", a.appendChild(this.createToolbarButtons()), this.forEachExtension(function(b) {
                    b.hasForm && a.appendChild(b.getForm());
                }), this.attachEventHandlers(), a;
            },
            createToolbarButtons: function() {
                var b, c, d, e, f, g, h = this.document.createElement("ul");
                return h.id = "medium-editor-toolbar-actions" + this.getEditorId(), h.className = "medium-editor-toolbar-actions", h.style.display = "block", this.buttons.forEach(function(d) {
                    "string" == typeof d ? (f = d, g = null) : (f = d.name, g = d), e = this.base.addBuiltInExtension(f, g), e && "function" == typeof e.getButton && (c = e.getButton(this.base), b = this.document.createElement("li"), a.util.isElement(c) ? b.appendChild(c) : b.innerHTML = c, h.appendChild(b));
                }, this), d = h.querySelectorAll("button"), d.length > 0 && (d[0].classList.add(this.firstButtonClass), d[d.length - 1].classList.add(this.lastButtonClass)), h;
            },
            destroy: function() {
                this.toolbar && (this.toolbar.parentNode && this.toolbar.parentNode.removeChild(this.toolbar), delete this.toolbar);
            },
            getInteractionElements: function() {
                return this.getToolbarElement();
            },
            getToolbarElement: function() {
                return this.toolbar || (this.toolbar = this.createToolbar()), this.toolbar;
            },
            getToolbarActionsElement: function() {
                return this.getToolbarElement().querySelector(".medium-editor-toolbar-actions");
            },
            initThrottledMethods: function() {
                this.throttledPositionToolbar = a.util.throttle((function() {
                    this.base.isActive && this.positionToolbarIfShown();
                }).bind(this));
            },
            attachEventHandlers: function() {
                this.subscribe("blur", this.handleBlur.bind(this)), this.subscribe("focus", this.handleFocus.bind(this)), this.subscribe("editableClick", this.handleEditableClick.bind(this)), this.subscribe("editableKeyup", this.handleEditableKeyup.bind(this)), this.on(this.document.documentElement, "mouseup", this.handleDocumentMouseup.bind(this)), this["static"] && this.sticky && this.on(this.window, "scroll", this.handleWindowScroll.bind(this), !0), this.on(this.window, "resize", this.handleWindowResize.bind(this));
            },
            handleWindowScroll: function() {
                this.positionToolbarIfShown();
            },
            handleWindowResize: function() {
                this.throttledPositionToolbar();
            },
            handleDocumentMouseup: function(b) {
                return b && b.target && a.util.isDescendant(this.getToolbarElement(), b.target) ? !1 : void this.checkState();
            },
            handleEditableClick: function() {
                setTimeout((function() {
                    this.checkState();
                }).bind(this), 0);
            },
            handleEditableKeyup: function() {
                this.checkState();
            },
            handleBlur: function() {
                clearTimeout(this.hideTimeout), clearTimeout(this.delayShowTimeout), this.hideTimeout = setTimeout((function() {
                    this.hideToolbar();
                }).bind(this), 1);
            },
            handleFocus: function() {
                this.checkState();
            },
            isDisplayed: function() {
                return this.getToolbarElement().classList.contains("medium-editor-toolbar-active");
            },
            showToolbar: function() {
                clearTimeout(this.hideTimeout), this.isDisplayed() || (this.getToolbarElement().classList.add("medium-editor-toolbar-active"), this.trigger("showToolbar", {}, this.base.getFocusedElement()));
            },
            hideToolbar: function() {
                this.isDisplayed() && (this.getToolbarElement().classList.remove("medium-editor-toolbar-active"), this.trigger("hideToolbar", {}, this.base.getFocusedElement()));
            },
            isToolbarDefaultActionsDisplayed: function() {
                return "block" === this.getToolbarActionsElement().style.display;
            },
            hideToolbarDefaultActions: function() {
                this.isToolbarDefaultActionsDisplayed() && (this.getToolbarActionsElement().style.display = "none");
            },
            showToolbarDefaultActions: function() {
                this.hideExtensionForms(), this.isToolbarDefaultActionsDisplayed() || (this.getToolbarActionsElement().style.display = "block"), this.delayShowTimeout = this.base.delay((function() {
                    this.showToolbar();
                }).bind(this));
            },
            hideExtensionForms: function() {
                this.forEachExtension(function(a) {
                    a.hasForm && a.isDisplayed() && a.hideForm();
                });
            },
            multipleBlockElementsSelected: function() {
                var b = /<[^\/>][^>]*><\/[^>]+>/gim, c = new RegExp("<(" + a.util.blockContainerElementNames.join("|") + ")[^>]*>", "g"), d = a.selection.getSelectionHtml(this.document).replace(b, ""), e = d.match(c);
                return !!e && e.length > 1;
            },
            modifySelection: function() {
                var b = this.window.getSelection(), c = b.getRangeAt(0);
                if (this.standardizeSelectionStart && c.startContainer.nodeValue && c.startOffset === c.startContainer.nodeValue.length) {
                    var d = a.util.findAdjacentTextNodeWithContent(a.selection.getSelectionElement(this.window), c.startContainer, this.document);
                    if (d) {
                        for(var e = 0; 0 === d.nodeValue.substr(e, 1).trim().length;)e += 1;
                        c = a.selection.select(this.document, d, e, c.endContainer, c.endOffset);
                    }
                }
            },
            checkState: function() {
                if (!this.base.preventSelectionUpdates) {
                    if (!this.base.getFocusedElement() || a.selection.selectionInContentEditableFalse(this.window)) return this.hideToolbar();
                    var b = a.selection.getSelectionElement(this.window);
                    return !b || -1 === this.getEditorElements().indexOf(b) || b.getAttribute("data-disable-toolbar") ? this.hideToolbar() : this.updateOnEmptySelection && this["static"] ? this.showAndUpdateToolbar() : !a.selection.selectionContainsContent(this.document) || this.allowMultiParagraphSelection === !1 && this.multipleBlockElementsSelected() ? this.hideToolbar() : void this.showAndUpdateToolbar();
                }
            },
            showAndUpdateToolbar: function() {
                this.modifySelection(), this.setToolbarButtonStates(), this.trigger("positionToolbar", {}, this.base.getFocusedElement()), this.showToolbarDefaultActions(), this.setToolbarPosition();
            },
            setToolbarButtonStates: function() {
                this.forEachExtension(function(a) {
                    "function" == typeof a.isActive && "function" == typeof a.setInactive && a.setInactive();
                }), this.checkActiveButtons();
            },
            checkActiveButtons: function() {
                var b, c = [], d = null, e = a.selection.getSelectionRange(this.document), f = function(a) {
                    "function" == typeof a.checkState ? a.checkState(b) : "function" == typeof a.isActive && "function" == typeof a.isAlreadyApplied && "function" == typeof a.setActive && !a.isActive() && a.isAlreadyApplied(b) && a.setActive();
                };
                if (e && (this.forEachExtension(function(a) {
                    return "function" == typeof a.queryCommandState && (d = a.queryCommandState(), null !== d) ? void (d && "function" == typeof a.setActive && a.setActive()) : void c.push(a);
                }), b = a.selection.getSelectedParentElement(e), this.getEditorElements().some(function(c) {
                    return a.util.isDescendant(c, b, !0);
                }))) for(; b && (c.forEach(f), !a.util.isMediumEditorElement(b));)b = b.parentNode;
            },
            positionToolbarIfShown: function() {
                this.isDisplayed() && this.setToolbarPosition();
            },
            setToolbarPosition: function() {
                var a = this.base.getFocusedElement(), b = this.window.getSelection();
                return a ? void (!this["static"] && b.isCollapsed || (this.showToolbar(), this.relativeContainer || (this["static"] ? this.positionStaticToolbar(a) : this.positionToolbar(b)), this.trigger("positionedToolbar", {}, this.base.getFocusedElement()))) : this;
            },
            positionStaticToolbar: function(a) {
                this.getToolbarElement().style.left = "0";
                var b, c = this.document.documentElement && this.document.documentElement.scrollTop || this.document.body.scrollTop, d = this.window.innerWidth, e = this.getToolbarElement(), f = a.getBoundingClientRect(), g = f.top + c, h = f.left + f.width / 2, i = e.offsetHeight, j = e.offsetWidth, k = j / 2;
                switch(this.sticky ? c > g + a.offsetHeight - i - this.stickyTopOffset ? (e.style.top = g + a.offsetHeight - i + "px", e.classList.remove("medium-editor-sticky-toolbar")) : c > g - i - this.stickyTopOffset ? (e.classList.add("medium-editor-sticky-toolbar"), e.style.top = this.stickyTopOffset + "px") : (e.classList.remove("medium-editor-sticky-toolbar"), e.style.top = g - i + "px") : e.style.top = g - i + "px", this.align){
                    case "left":
                        b = f.left;
                        break;
                    case "right":
                        b = f.right - j;
                        break;
                    case "center":
                        b = h - k;
                }
                0 > b ? b = 0 : b + j > d && (b = d - Math.ceil(j) - 1), e.style.left = b + "px";
            },
            positionToolbar: function(a) {
                this.getToolbarElement().style.left = "0", this.getToolbarElement().style.right = "initial";
                var b = a.getRangeAt(0), c = b.getBoundingClientRect();
                (!c || 0 === c.height && 0 === c.width && b.startContainer === b.endContainer) && (c = 1 === b.startContainer.nodeType && b.startContainer.querySelector("img") ? b.startContainer.querySelector("img").getBoundingClientRect() : b.startContainer.getBoundingClientRect());
                var d, e, f = this.window.innerWidth, g = this.getToolbarElement(), h = g.offsetHeight, i = g.offsetWidth, j = i / 2, k = 50, l = this.diffLeft - j, m = this.getEditorOption("elementsContainer"), n = [
                    "absolute",
                    "fixed"
                ].indexOf(window.getComputedStyle(m).getPropertyValue("position")) > -1, o = {}, p = {};
                n ? (e = m.getBoundingClientRect(), [
                    "top",
                    "left"
                ].forEach(function(a) {
                    p[a] = c[a] - e[a];
                }), p.width = c.width, p.height = c.height, c = p, f = e.width, o.top = m.scrollTop) : o.top = this.window.pageYOffset, d = c.left + c.width / 2, o.top += c.top - h, c.top < k ? (g.classList.add("medium-toolbar-arrow-over"), g.classList.remove("medium-toolbar-arrow-under"), o.top += k + c.height - this.diffTop) : (g.classList.add("medium-toolbar-arrow-under"), g.classList.remove("medium-toolbar-arrow-over"), o.top += this.diffTop), j > d ? (o.left = l + j, o.right = "initial") : j > f - d ? (o.left = "auto", o.right = 0) : (o.left = l + d, o.right = "initial"), [
                    "top",
                    "left",
                    "right"
                ].forEach(function(a) {
                    g.style[a] = o[a] + (isNaN(o[a]) ? "" : "px");
                });
            }
        });
        a.extensions.toolbar = b;
    }(), function() {
        var b = a.Extension.extend({
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.subscribe("editableDrag", this.handleDrag.bind(this)), this.subscribe("editableDrop", this.handleDrop.bind(this));
            },
            handleDrag: function(a) {
                var b = "medium-editor-dragover";
                a.preventDefault(), a.dataTransfer.dropEffect = "copy", "dragover" === a.type ? a.target.classList.add(b) : "dragleave" === a.type && a.target.classList.remove(b);
            },
            handleDrop: function(b) {
                var c, d = "medium-editor-dragover";
                b.preventDefault(), b.stopPropagation(), b.dataTransfer.files && (c = Array.prototype.slice.call(b.dataTransfer.files, 0), c.some((function(b) {
                    if (b.type.match("image")) {
                        var c, d;
                        c = new FileReader, c.readAsDataURL(b), d = "medium-img-" + +new Date, a.util.insertHTMLCommand(this.document, '<img class="medium-editor-image-loading" id="' + d + '" />'), c.onload = (function() {
                            var a = this.document.getElementById(d);
                            a && (a.removeAttribute("id"), a.removeAttribute("class"), a.src = c.result);
                        }).bind(this);
                    }
                }).bind(this))), b.target.classList.remove(d);
            }
        });
        a.extensions.imageDragging = b;
    }(), function() {
        function b(b) {
            var c = a.selection.getSelectionStart(this.options.ownerDocument), d = c.textContent, e = a.selection.getCaretOffsets(c);
            (void 0 === d[e.left - 1] || "" === d[e.left - 1].trim() || void 0 !== d[e.left] && "" === d[e.left].trim()) && b.preventDefault();
        }
        function c(b, c) {
            if (this.options.disableReturn || c.getAttribute("data-disable-return")) b.preventDefault();
            else if (this.options.disableDoubleReturn || c.getAttribute("data-disable-double-return")) {
                var d = a.selection.getSelectionStart(this.options.ownerDocument);
                (d && "" === d.textContent.trim() && "li" !== d.nodeName.toLowerCase() || d.previousElementSibling && "br" !== d.previousElementSibling.nodeName.toLowerCase() && "" === d.previousElementSibling.textContent.trim()) && b.preventDefault();
            }
        }
        function d(b) {
            var c = a.selection.getSelectionStart(this.options.ownerDocument), d = c && c.nodeName.toLowerCase();
            "pre" === d && (b.preventDefault(), a.util.insertHTMLCommand(this.options.ownerDocument, "    ")), a.util.isListItem(c) && (b.preventDefault(), b.shiftKey ? this.options.ownerDocument.execCommand("outdent", !1, null) : this.options.ownerDocument.execCommand("indent", !1, null));
        }
        function e(b) {
            var c, d = a.selection.getSelectionStart(this.options.ownerDocument), e = d.nodeName.toLowerCase(), f = /^(\s+|<br\/?>)?$/i, g = /h\d/i;
            a.util.isKey(b, [
                a.util.keyCode.BACKSPACE,
                a.util.keyCode.ENTER
            ]) && d.previousElementSibling && g.test(e) && 0 === a.selection.getCaretOffsets(d).left ? a.util.isKey(b, a.util.keyCode.BACKSPACE) && f.test(d.previousElementSibling.innerHTML) ? (d.previousElementSibling.parentNode.removeChild(d.previousElementSibling), b.preventDefault()) : !this.options.disableDoubleReturn && a.util.isKey(b, a.util.keyCode.ENTER) && (c = this.options.ownerDocument.createElement("p"), c.innerHTML = "<br>", d.previousElementSibling.parentNode.insertBefore(c, d), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.DELETE) && d.nextElementSibling && d.previousElementSibling && !g.test(e) && f.test(d.innerHTML) && g.test(d.nextElementSibling.nodeName.toLowerCase()) ? (a.selection.moveCursor(this.options.ownerDocument, d.nextElementSibling), d.previousElementSibling.parentNode.removeChild(d), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.BACKSPACE) && "li" === e && f.test(d.innerHTML) && !d.previousElementSibling && !d.parentElement.previousElementSibling && d.nextElementSibling && "li" === d.nextElementSibling.nodeName.toLowerCase() ? (c = this.options.ownerDocument.createElement("p"), c.innerHTML = "<br>", d.parentElement.parentElement.insertBefore(c, d.parentElement), a.selection.moveCursor(this.options.ownerDocument, c), d.parentElement.removeChild(d), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.BACKSPACE) && a.util.getClosestTag(d, "blockquote") !== !1 && 0 === a.selection.getCaretOffsets(d).left ? (b.preventDefault(), a.util.execFormatBlock(this.options.ownerDocument, "p")) : a.util.isKey(b, a.util.keyCode.ENTER) && a.util.getClosestTag(d, "blockquote") !== !1 && 0 === a.selection.getCaretOffsets(d).right ? (c = this.options.ownerDocument.createElement("p"), c.innerHTML = "<br>", d.parentElement.insertBefore(c, d.nextSibling), a.selection.moveCursor(this.options.ownerDocument, c), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.BACKSPACE) && a.util.isMediumEditorElement(d.parentElement) && !d.previousElementSibling && d.nextElementSibling && f.test(d.innerHTML) && (b.preventDefault(), a.selection.moveCursor(this.options.ownerDocument, d.nextSibling), d.parentElement.removeChild(d));
        }
        function f(b) {
            var c, d = a.selection.getSelectionStart(this.options.ownerDocument);
            d && (a.util.isMediumEditorElement(d) && 0 === d.children.length && !a.util.isBlockContainer(d) && this.options.ownerDocument.execCommand("formatBlock", !1, "p"), !a.util.isKey(b, a.util.keyCode.ENTER) || a.util.isListItem(d) || a.util.isBlockContainer(d) || (c = d.nodeName.toLowerCase(), "a" === c ? this.options.ownerDocument.execCommand("unlink", !1, null) : b.shiftKey || b.ctrlKey || this.options.ownerDocument.execCommand("formatBlock", !1, "p")));
        }
        function g(a, b) {
            var c = b.parentNode.querySelector('textarea[medium-editor-textarea-id="' + b.getAttribute("medium-editor-textarea-id") + '"]');
            c && (c.value = b.innerHTML.trim());
        }
        function h(a) {
            a._mediumEditors || (a._mediumEditors = [
                null
            ]), this.id || (this.id = a._mediumEditors.length), a._mediumEditors[this.id] = this;
        }
        function i(a) {
            a._mediumEditors && a._mediumEditors[this.id] && (a._mediumEditors[this.id] = null);
        }
        function j(b, c, d) {
            var e = [];
            if (b || (b = []), "string" == typeof b && (b = c.querySelectorAll(b)), a.util.isElement(b) && (b = [
                b
            ]), d) for(var f = 0; f < b.length; f++){
                var g = b[f];
                !a.util.isElement(g) || g.getAttribute("data-medium-editor-element") || g.getAttribute("medium-editor-textarea-id") || e.push(g);
            }
            else e = Array.prototype.slice.apply(b);
            return e;
        }
        function k(a) {
            var b = a.parentNode.querySelector('textarea[medium-editor-textarea-id="' + a.getAttribute("medium-editor-textarea-id") + '"]');
            b && (b.classList.remove("medium-editor-hidden"), b.removeAttribute("medium-editor-textarea-id")), a.parentNode && a.parentNode.removeChild(a);
        }
        function l(a, b) {
            return Object.keys(b).forEach(function(c) {
                void 0 === a[c] && (a[c] = b[c]);
            }), a;
        }
        function m(a, b, c) {
            var d = {
                window: c.options.contentWindow,
                document: c.options.ownerDocument,
                base: c
            };
            return a = l(a, d), "function" == typeof a.init && a.init(), a.name || (a.name = b), a;
        }
        function n() {
            return this.elements.every(function(a) {
                return !!a.getAttribute("data-disable-toolbar");
            }) ? !1 : this.options.toolbar !== !1;
        }
        function o() {
            return n.call(this) ? this.options.anchorPreview !== !1 : !1;
        }
        function p() {
            return this.options.placeholder !== !1;
        }
        function q() {
            return this.options.autoLink !== !1;
        }
        function r() {
            return this.options.imageDragging !== !1;
        }
        function s() {
            return this.options.keyboardCommands !== !1;
        }
        function t() {
            return !this.options.extensions.imageDragging;
        }
        function u(a) {
            for(var b = this.options.ownerDocument.createElement("div"), c = Date.now(), d = "medium-editor-" + c, e = a.attributes; this.options.ownerDocument.getElementById(d);)c++, d = "medium-editor-" + c;
            b.className = a.className, b.id = d, b.innerHTML = a.value, a.setAttribute("medium-editor-textarea-id", d);
            for(var f = 0, g = e.length; g > f; f++)b.hasAttribute(e[f].nodeName) || b.setAttribute(e[f].nodeName, e[f].value);
            return a.form && this.on(a.form, "reset", (function(a) {
                a.defaultPrevented || this.resetContent(this.options.ownerDocument.getElementById(d));
            }).bind(this)), a.classList.add("medium-editor-hidden"), a.parentNode.insertBefore(b, a), b;
        }
        function v(b, d) {
            if (!b.getAttribute("data-medium-editor-element")) {
                "textarea" === b.nodeName.toLowerCase() && (b = u.call(this, b), this.instanceHandleEditableInput || (this.instanceHandleEditableInput = g.bind(this), this.subscribe("editableInput", this.instanceHandleEditableInput))), this.options.disableEditing || b.getAttribute("data-disable-editing") || (b.setAttribute("contentEditable", !0), b.setAttribute("spellcheck", this.options.spellcheck)), this.instanceHandleEditableKeydownEnter || (b.getAttribute("data-disable-return") || b.getAttribute("data-disable-double-return")) && (this.instanceHandleEditableKeydownEnter = c.bind(this), this.subscribe("editableKeydownEnter", this.instanceHandleEditableKeydownEnter)), this.options.disableReturn || b.getAttribute("data-disable-return") || this.on(b, "keyup", f.bind(this));
                var e = a.util.guid();
                b.setAttribute("data-medium-editor-element", !0), b.classList.add("medium-editor-element"), b.setAttribute("role", "textbox"), b.setAttribute("aria-multiline", !0), b.setAttribute("data-medium-editor-editor-index", d), b.setAttribute("medium-editor-index", e), B[e] = b.innerHTML, this.events.attachAllEventsToElement(b);
            }
            return b;
        }
        function w() {
            this.subscribe("editableKeydownTab", d.bind(this)), this.subscribe("editableKeydownDelete", e.bind(this)), this.subscribe("editableKeydownEnter", e.bind(this)), this.options.disableExtraSpaces && this.subscribe("editableKeydownSpace", b.bind(this)), this.instanceHandleEditableKeydownEnter || (this.options.disableReturn || this.options.disableDoubleReturn) && (this.instanceHandleEditableKeydownEnter = c.bind(this), this.subscribe("editableKeydownEnter", this.instanceHandleEditableKeydownEnter));
        }
        function x() {
            if (this.extensions = [], Object.keys(this.options.extensions).forEach(function(a) {
                "toolbar" !== a && this.options.extensions[a] && this.extensions.push(m(this.options.extensions[a], a, this));
            }, this), t.call(this)) {
                var b = this.options.fileDragging;
                b || (b = {}, r.call(this) || (b.allowedTypes = [])), this.addBuiltInExtension("fileDragging", b);
            }
            var c = {
                paste: !0,
                "anchor-preview": o.call(this),
                autoLink: q.call(this),
                keyboardCommands: s.call(this),
                placeholder: p.call(this)
            };
            Object.keys(c).forEach(function(a) {
                c[a] && this.addBuiltInExtension(a);
            }, this);
            var d = this.options.extensions.toolbar;
            if (!d && n.call(this)) {
                var e = a.util.extend({}, this.options.toolbar, {
                    allowMultiParagraphSelection: this.options.allowMultiParagraphSelection
                });
                d = new a.extensions.toolbar(e);
            }
            d && this.extensions.push(m(d, "toolbar", this));
        }
        function y(b, c) {
            var d = [
                [
                    "allowMultiParagraphSelection",
                    "toolbar.allowMultiParagraphSelection"
                ]
            ];
            return c && d.forEach(function(b) {
                c.hasOwnProperty(b[0]) && void 0 !== c[b[0]] && a.util.deprecated(b[0], b[1], "v6.0.0");
            }), a.util.defaults({}, c, b);
        }
        function z(b, c) {
            var d, e, f = /^append-(.+)$/gi, g = /justify([A-Za-z]*)$/g;
            if (d = f.exec(b)) return a.util.execFormatBlock(this.options.ownerDocument, d[1]);
            if ("fontSize" === b) return c.size && a.util.deprecated(".size option for fontSize command", ".value", "6.0.0"), e = c.value || c.size, this.options.ownerDocument.execCommand("fontSize", !1, e);
            if ("fontName" === b) return c.name && a.util.deprecated(".name option for fontName command", ".value", "6.0.0"), e = c.value || c.name, this.options.ownerDocument.execCommand("fontName", !1, e);
            if ("createLink" === b) return this.createLink(c);
            if ("image" === b) {
                var h = this.options.contentWindow.getSelection().toString().trim();
                return this.options.ownerDocument.execCommand("insertImage", !1, h);
            }
            if ("html" === b) {
                var i = this.options.contentWindow.getSelection().toString().trim();
                return a.util.insertHTMLCommand(this.options.ownerDocument, i);
            }
            if (g.exec(b)) {
                var j = this.options.ownerDocument.execCommand(b, !1, null), k = a.selection.getSelectedParentElement(a.selection.getSelectionRange(this.options.ownerDocument));
                return k && A.call(this, a.util.getTopBlockContainer(k)), j;
            }
            return e = c && c.value, this.options.ownerDocument.execCommand(b, !1, e);
        }
        function A(b) {
            if (b) {
                var c, d = Array.prototype.slice.call(b.childNodes).filter(function(a) {
                    var b = "div" === a.nodeName.toLowerCase();
                    return b && !c && (c = a.style.textAlign), b;
                });
                d.length && (this.saveSelection(), d.forEach(function(b) {
                    if (b.style.textAlign === c) {
                        var d = b.lastChild;
                        if (d) {
                            a.util.unwrap(b, this.options.ownerDocument);
                            var e = this.options.ownerDocument.createElement("BR");
                            d.parentNode.insertBefore(e, d.nextSibling);
                        }
                    }
                }, this), b.style.textAlign = c, this.restoreSelection());
            }
        }
        var B = {};
        a.prototype = {
            init: function(a, b) {
                return this.options = y.call(this, this.defaults, b), this.origElements = a, this.options.elementsContainer || (this.options.elementsContainer = this.options.ownerDocument.body), this.setup();
            },
            setup: function() {
                this.isActive || (h.call(this, this.options.contentWindow), this.events = new a.Events(this), this.elements = [], this.addElements(this.origElements), 0 !== this.elements.length && (this.isActive = !0, x.call(this), w.call(this)));
            },
            destroy: function() {
                this.isActive && (this.isActive = !1, this.extensions.forEach(function(a) {
                    "function" == typeof a.destroy && a.destroy();
                }, this), this.events.destroy(), this.elements.forEach(function(a) {
                    this.options.spellcheck && (a.innerHTML = a.innerHTML), a.removeAttribute("contentEditable"), a.removeAttribute("spellcheck"), a.removeAttribute("data-medium-editor-element"), a.classList.remove("medium-editor-element"), a.removeAttribute("role"), a.removeAttribute("aria-multiline"), a.removeAttribute("medium-editor-index"), a.removeAttribute("data-medium-editor-editor-index"), a.getAttribute("medium-editor-textarea-id") && k(a);
                }, this), this.elements = [], this.instanceHandleEditableKeydownEnter = null, this.instanceHandleEditableInput = null, i.call(this, this.options.contentWindow));
            },
            on: function(a, b, c, d) {
                return this.events.attachDOMEvent(a, b, c, d), this;
            },
            off: function(a, b, c, d) {
                return this.events.detachDOMEvent(a, b, c, d), this;
            },
            subscribe: function(a, b) {
                return this.events.attachCustomEvent(a, b), this;
            },
            unsubscribe: function(a, b) {
                return this.events.detachCustomEvent(a, b), this;
            },
            trigger: function(a, b, c) {
                return this.events.triggerCustomEvent(a, b, c), this;
            },
            delay: function(a) {
                var b = this;
                return setTimeout(function() {
                    b.isActive && a();
                }, this.options.delay);
            },
            serialize: function() {
                var a, b, c = {}, d = this.elements.length;
                for(a = 0; d > a; a += 1)b = "" !== this.elements[a].id ? this.elements[a].id : "element-" + a, c[b] = {
                    value: this.elements[a].innerHTML.trim()
                };
                return c;
            },
            getExtensionByName: function(a) {
                var b;
                return this.extensions && this.extensions.length && this.extensions.some(function(c) {
                    return c.name === a ? (b = c, !0) : !1;
                }), b;
            },
            addBuiltInExtension: function(b, c) {
                var d, e = this.getExtensionByName(b);
                if (e) return e;
                switch(b){
                    case "anchor":
                        d = a.util.extend({}, this.options.anchor, c), e = new a.extensions.anchor(d);
                        break;
                    case "anchor-preview":
                        e = new a.extensions.anchorPreview(this.options.anchorPreview);
                        break;
                    case "autoLink":
                        e = new a.extensions.autoLink;
                        break;
                    case "fileDragging":
                        e = new a.extensions.fileDragging(c);
                        break;
                    case "fontname":
                        e = new a.extensions.fontName(this.options.fontName);
                        break;
                    case "fontsize":
                        e = new a.extensions.fontSize(c);
                        break;
                    case "keyboardCommands":
                        e = new a.extensions.keyboardCommands(this.options.keyboardCommands);
                        break;
                    case "paste":
                        e = new a.extensions.paste(this.options.paste);
                        break;
                    case "placeholder":
                        e = new a.extensions.placeholder(this.options.placeholder);
                        break;
                    default:
                        a.extensions.button.isBuiltInButton(b) && (c ? (d = a.util.defaults({}, c, a.extensions.button.prototype.defaults[b]), e = new a.extensions.button(d)) : e = new a.extensions.button(b));
                }
                return e && this.extensions.push(m(e, b, this)), e;
            },
            stopSelectionUpdates: function() {
                this.preventSelectionUpdates = !0;
            },
            startSelectionUpdates: function() {
                this.preventSelectionUpdates = !1;
            },
            checkSelection: function() {
                var a = this.getExtensionByName("toolbar");
                return a && a.checkState(), this;
            },
            queryCommandState: function(a) {
                var b, c = /^full-(.+)$/gi, d = null;
                b = c.exec(a), b && (a = b[1]);
                try {
                    d = this.options.ownerDocument.queryCommandState(a);
                } catch (e) {
                    d = null;
                }
                return d;
            },
            execAction: function(b, c) {
                var d, e, f = /^full-(.+)$/gi;
                return d = f.exec(b), d ? (this.saveSelection(), this.selectAllContents(), e = z.call(this, d[1], c), this.restoreSelection()) : e = z.call(this, b, c), "insertunorderedlist" !== b && "insertorderedlist" !== b || a.util.cleanListDOM(this.options.ownerDocument, this.getSelectedParentElement()), this.checkSelection(), e;
            },
            getSelectedParentElement: function(b) {
                return void 0 === b && (b = this.options.contentWindow.getSelection().getRangeAt(0)), a.selection.getSelectedParentElement(b);
            },
            selectAllContents: function() {
                var b = a.selection.getSelectionElement(this.options.contentWindow);
                if (b) {
                    for(; 1 === b.children.length;)b = b.children[0];
                    this.selectElement(b);
                }
            },
            selectElement: function(b) {
                a.selection.selectNode(b, this.options.ownerDocument);
                var c = a.selection.getSelectionElement(this.options.contentWindow);
                c && this.events.focusElement(c);
            },
            getFocusedElement: function() {
                var a;
                return this.elements.some(function(b) {
                    return !a && b.getAttribute("data-medium-focused") && (a = b), !!a;
                }, this), a;
            },
            exportSelection: function() {
                var b = a.selection.getSelectionElement(this.options.contentWindow), c = this.elements.indexOf(b), d = null;
                return c >= 0 && (d = a.selection.exportSelection(b, this.options.ownerDocument)), null !== d && 0 !== c && (d.editableElementIndex = c), d;
            },
            saveSelection: function() {
                this.selectionState = this.exportSelection();
            },
            importSelection: function(b, c) {
                if (b) {
                    var d = this.elements[b.editableElementIndex || 0];
                    a.selection.importSelection(b, d, this.options.ownerDocument, c);
                }
            },
            restoreSelection: function() {
                this.importSelection(this.selectionState);
            },
            createLink: function(b) {
                var c, d = a.selection.getSelectionElement(this.options.contentWindow), e = {};
                if (-1 !== this.elements.indexOf(d)) {
                    try {
                        if (this.events.disableCustomEvent("editableInput"), b.url && a.util.deprecated(".url option for createLink", ".value", "6.0.0"), c = b.url || b.value, c && c.trim().length > 0) {
                            var f = this.options.contentWindow.getSelection();
                            if (f) {
                                var g, h, i, j, k = f.getRangeAt(0), l = k.commonAncestorContainer;
                                if (3 === k.endContainer.nodeType && 3 !== k.startContainer.nodeType && 0 === k.startOffset && k.startContainer.firstChild === k.endContainer && (l = k.endContainer), h = a.util.getClosestBlockContainer(k.startContainer), i = a.util.getClosestBlockContainer(k.endContainer), 3 !== l.nodeType && 0 !== l.textContent.length && h === i) {
                                    var m = h || d, n = this.options.ownerDocument.createDocumentFragment();
                                    this.execAction("unlink"), g = this.exportSelection(), n.appendChild(m.cloneNode(!0)), d === m ? a.selection.select(this.options.ownerDocument, m.firstChild, 0, m.lastChild, 3 === m.lastChild.nodeType ? m.lastChild.nodeValue.length : m.lastChild.childNodes.length) : a.selection.select(this.options.ownerDocument, m, 0, m, m.childNodes.length);
                                    var o = this.exportSelection();
                                    j = a.util.findOrCreateMatchingTextNodes(this.options.ownerDocument, n, {
                                        start: g.start - o.start,
                                        end: g.end - o.start,
                                        editableElementIndex: g.editableElementIndex
                                    }), 0 === j.length && (n = this.options.ownerDocument.createDocumentFragment(), n.appendChild(l.cloneNode(!0)), j = [
                                        n.firstChild.firstChild,
                                        n.firstChild.lastChild
                                    ]), a.util.createLink(this.options.ownerDocument, j, c.trim());
                                    var p = (n.firstChild.innerHTML.match(/^\s+/) || [
                                        ""
                                    ])[0].length;
                                    a.util.insertHTMLCommand(this.options.ownerDocument, n.firstChild.innerHTML.replace(/^\s+/, "")), g.start -= p, g.end -= p, this.importSelection(g);
                                } else this.options.ownerDocument.execCommand("createLink", !1, c);
                                this.options.targetBlank || "_blank" === b.target ? a.util.setTargetBlank(a.selection.getSelectionStart(this.options.ownerDocument), c) : a.util.removeTargetBlank(a.selection.getSelectionStart(this.options.ownerDocument), c), b.buttonClass && a.util.addClassToAnchors(a.selection.getSelectionStart(this.options.ownerDocument), b.buttonClass);
                            }
                        }
                        if (this.options.targetBlank || "_blank" === b.target || b.buttonClass) {
                            e = this.options.ownerDocument.createEvent("HTMLEvents"), e.initEvent("input", !0, !0, this.options.contentWindow);
                            for(var q = 0, r = this.elements.length; r > q; q += 1)this.elements[q].dispatchEvent(e);
                        }
                    } finally{
                        this.events.enableCustomEvent("editableInput");
                    }
                    this.events.triggerCustomEvent("editableInput", e, d);
                }
            },
            cleanPaste: function(a) {
                this.getExtensionByName("paste").cleanPaste(a);
            },
            pasteHTML: function(a, b) {
                this.getExtensionByName("paste").pasteHTML(a, b);
            },
            setContent: function(a, b) {
                if (b = b || 0, this.elements[b]) {
                    var c = this.elements[b];
                    c.innerHTML = a, this.checkContentChanged(c);
                }
            },
            getContent: function(a) {
                return a = a || 0, this.elements[a] ? this.elements[a].innerHTML.trim() : null;
            },
            checkContentChanged: function(b) {
                b = b || a.selection.getSelectionElement(this.options.contentWindow), this.events.updateInput(b, {
                    target: b,
                    currentTarget: b
                });
            },
            resetContent: function(a) {
                if (a) {
                    var b = this.elements.indexOf(a);
                    return void (-1 !== b && this.setContent(B[a.getAttribute("medium-editor-index")], b));
                }
                this.elements.forEach(function(a, b) {
                    this.setContent(B[a.getAttribute("medium-editor-index")], b);
                }, this);
            },
            addElements: function(a) {
                var b = j(a, this.options.ownerDocument, !0);
                return 0 === b.length ? !1 : void b.forEach(function(a) {
                    a = v.call(this, a, this.id), this.elements.push(a), this.trigger("addElement", {
                        target: a,
                        currentTarget: a
                    }, a);
                }, this);
            },
            removeElements: function(a) {
                var b = j(a, this.options.ownerDocument), c = b.map(function(a) {
                    return a.getAttribute("medium-editor-textarea-id") && a.parentNode ? a.parentNode.querySelector('div[medium-editor-textarea-id="' + a.getAttribute("medium-editor-textarea-id") + '"]') : a;
                });
                this.elements = this.elements.filter(function(a) {
                    return -1 !== c.indexOf(a) ? (this.events.cleanupElement(a), a.getAttribute("medium-editor-textarea-id") && k(a), this.trigger("removeElement", {
                        target: a,
                        currentTarget: a
                    }, a), !1) : !0;
                }, this);
            }
        }, a.getEditorFromElement = function(a) {
            var b = a.getAttribute("data-medium-editor-editor-index"), c = a && a.ownerDocument && (a.ownerDocument.defaultView || a.ownerDocument.parentWindow);
            return c && c._mediumEditors && c._mediumEditors[b] ? c._mediumEditors[b] : null;
        };
    }(), function() {
        a.prototype.defaults = {
            activeButtonClass: "medium-editor-button-active",
            buttonLabels: !1,
            delay: 0,
            disableReturn: !1,
            disableDoubleReturn: !1,
            disableExtraSpaces: !1,
            disableEditing: !1,
            autoLink: !1,
            elementsContainer: !1,
            contentWindow: window,
            ownerDocument: document,
            targetBlank: !1,
            extensions: {},
            spellcheck: !0
        };
    }(), a.parseVersionString = function(a) {
        var b = a.split("-"), c = b[0].split("."), d = b.length > 1 ? b[1] : "";
        return {
            major: parseInt(c[0], 10),
            minor: parseInt(c[1], 10),
            revision: parseInt(c[2], 10),
            preRelease: d,
            toString: function() {
                return [
                    c[0],
                    c[1],
                    c[2]
                ].join(".") + (d ? "-" + d : "");
            }
        };
    }, a.version = a.parseVersionString.call(this, "5.23.3"), a;
}());




class $5b7e74f852b2f3a3$export$144fe67517e25632 {
    constructor(){
        this.getPageId = ()=>"edit-post";
        this.execute = ()=>{
            new (0, (/*@__PURE__*/$parcel$interopDefault($9b19a0a83ad61f86$exports)))('textarea[name="description"]', {});
            new (0, (/*@__PURE__*/$parcel$interopDefault($9b19a0a83ad61f86$exports)))('textarea[name="content"]', {
                toolbar: {
                    buttons: [
                        "bold",
                        "italic",
                        "underline",
                        "strikethrough",
                        "subscript",
                        "superscript",
                        "anchor",
                        "image",
                        "quote",
                        "pre",
                        "orderedlist",
                        "unorderedlist",
                        "indent",
                        "outdent",
                        "justifyLeft",
                        "justifyCenter",
                        "justifyRight",
                        "justifyFull",
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6",
                        "removeFormat",
                        "html"
                    ]
                }
            });
        };
        this.onPageClose = ()=>{};
    }
}





class $e24adf5565053909$export$597baf776692ed1e {
    constructor(){
        this.getPageId = ()=>"edit-job-offer";
        this.execute = ()=>{
            new (0, (/*@__PURE__*/$parcel$interopDefault($9b19a0a83ad61f86$exports)))('textarea[name="content"]', {});
        };
        this.onPageClose = ()=>{};
    }
}


/* -------------------------------------------------------------------------- */ /*                                    Utils                                   */ /* -------------------------------------------------------------------------- */ const $4858a93c3dafa7ec$var$docReady = (fn)=>{
    // see if DOM is already available
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else setTimeout(fn, 1);
};
const $4858a93c3dafa7ec$var$resize = (fn)=>window.addEventListener("resize", fn);
const $4858a93c3dafa7ec$var$isIterableArray = (array)=>Array.isArray(array) && !!array.length;
const $4858a93c3dafa7ec$var$camelize = (str)=>{
    const text = str.replace(/[-_\s.]+(.)?/g, (_, c)=>c ? c.toUpperCase() : "");
    return `${text.substr(0, 1).toLowerCase()}${text.substr(1)}`;
};
const $4858a93c3dafa7ec$var$getData = (el, data)=>{
    try {
        return JSON.parse(el.dataset[$4858a93c3dafa7ec$var$camelize(data)]);
    } catch (e) {
        return el.dataset[$4858a93c3dafa7ec$var$camelize(data)];
    }
};
/* ----------------------------- Colors function ---------------------------- */ const $4858a93c3dafa7ec$var$hexToRgb = (hexValue)=>{
    let hex;
    hexValue.indexOf("#") === 0 ? hex = hexValue.substring(1) : hex = hexValue;
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.replace(shorthandRegex, (m, r, g, b)=>r + r + g + g + b + b));
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ] : null;
};
const $4858a93c3dafa7ec$var$rgbaColor = (color = "#fff", alpha = 0.5)=>`rgba(${$4858a93c3dafa7ec$var$hexToRgb(color)}, ${alpha})`;
/* --------------------------------- Colors --------------------------------- */ const $4858a93c3dafa7ec$var$getColor = (name, dom = document.documentElement)=>getComputedStyle(dom).getPropertyValue(`--app-${name}`).trim();
const $4858a93c3dafa7ec$var$getColors = (dom)=>({
        primary: $4858a93c3dafa7ec$var$getColor("primary", dom),
        secondary: $4858a93c3dafa7ec$var$getColor("secondary", dom),
        success: $4858a93c3dafa7ec$var$getColor("success", dom),
        info: $4858a93c3dafa7ec$var$getColor("info", dom),
        warning: $4858a93c3dafa7ec$var$getColor("warning", dom),
        danger: $4858a93c3dafa7ec$var$getColor("danger", dom),
        light: $4858a93c3dafa7ec$var$getColor("light", dom),
        dark: $4858a93c3dafa7ec$var$getColor("dark", dom)
    });
const $4858a93c3dafa7ec$var$getSoftColors = (dom)=>({
        primary: $4858a93c3dafa7ec$var$getColor("soft-primary", dom),
        secondary: $4858a93c3dafa7ec$var$getColor("soft-secondary", dom),
        success: $4858a93c3dafa7ec$var$getColor("soft-success", dom),
        info: $4858a93c3dafa7ec$var$getColor("soft-info", dom),
        warning: $4858a93c3dafa7ec$var$getColor("soft-warning", dom),
        danger: $4858a93c3dafa7ec$var$getColor("soft-danger", dom),
        light: $4858a93c3dafa7ec$var$getColor("soft-light", dom),
        dark: $4858a93c3dafa7ec$var$getColor("soft-dark", dom)
    });
const $4858a93c3dafa7ec$var$getGrays = (dom)=>({
        white: $4858a93c3dafa7ec$var$getColor("gray-white", dom),
        100: $4858a93c3dafa7ec$var$getColor("gray-100", dom),
        200: $4858a93c3dafa7ec$var$getColor("gray-200", dom),
        300: $4858a93c3dafa7ec$var$getColor("gray-300", dom),
        400: $4858a93c3dafa7ec$var$getColor("gray-400", dom),
        500: $4858a93c3dafa7ec$var$getColor("gray-500", dom),
        600: $4858a93c3dafa7ec$var$getColor("gray-600", dom),
        700: $4858a93c3dafa7ec$var$getColor("gray-700", dom),
        800: $4858a93c3dafa7ec$var$getColor("gray-800", dom),
        900: $4858a93c3dafa7ec$var$getColor("gray-900", dom),
        1000: $4858a93c3dafa7ec$var$getColor("gray-1000", dom),
        1100: $4858a93c3dafa7ec$var$getColor("gray-1100", dom),
        black: $4858a93c3dafa7ec$var$getColor("gray-black", dom)
    });
const $4858a93c3dafa7ec$var$hasClass = (el, className)=>{
    el;
    return el.classList.value.includes(className);
};
const $4858a93c3dafa7ec$var$addClass = (el, className)=>{
    el.classList.add(className);
};
const $4858a93c3dafa7ec$var$removeClass = (el, className)=>{
    el.classList.remove(className);
};
const $4858a93c3dafa7ec$var$getOffset = (el)=>{
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    };
};
function $4858a93c3dafa7ec$var$isScrolledIntoView(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
    return vertInView && horInView;
}
const $4858a93c3dafa7ec$var$breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1540
};
const $4858a93c3dafa7ec$var$getBreakpoint = (el)=>{
    const classes = el && el.classList.value;
    let breakpoint;
    if (classes) breakpoint = $4858a93c3dafa7ec$var$breakpoints[classes.split(" ").filter((cls)=>cls.includes("navbar-expand-")).pop().split("-").pop()];
    return breakpoint;
};
/* --------------------------------- Cookie --------------------------------- */ const $4858a93c3dafa7ec$var$setCookie = (name, value, expire)=>{
    const expires = new Date();
    expires.setTime(expires.getTime() + expire);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()}`;
};
const $4858a93c3dafa7ec$var$getCookie = (name)=>{
    const keyValue = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return keyValue ? keyValue[2] : keyValue;
};
const $4858a93c3dafa7ec$var$settings = {
    tinymce: {
        theme: "oxide"
    },
    chart: {
        borderColor: "rgba(255, 255, 255, 0.8)"
    }
};
/* -------------------------- Chart Initialization -------------------------- */ const $4858a93c3dafa7ec$var$newChart = (chart, config)=>{
    const ctx = chart.getContext("2d");
    return new window.Chart(ctx, config);
};
/* ---------------------------------- Store --------------------------------- */ const $4858a93c3dafa7ec$var$getItemFromStore = (key, defaultValue, store = localStorage)=>{
    try {
        return JSON.parse(store.getItem(key)) || defaultValue;
    } catch  {
        return store.getItem(key) || defaultValue;
    }
};
const $4858a93c3dafa7ec$var$setItemToStore = (key, payload, store = localStorage)=>store.setItem(key, payload);
const $4858a93c3dafa7ec$var$getStoreSpace = (store = localStorage)=>parseFloat((escape(encodeURIComponent(JSON.stringify(store))).length / 1048576).toFixed(2));
/* get Dates between */ const $4858a93c3dafa7ec$var$getDates = (startDate, endDate, interval = 86400000)=>{
    const duration = endDate - startDate;
    const steps = duration / interval;
    return Array.from({
        length: steps + 1
    }, (v, i)=>new Date(startDate.valueOf() + interval * i));
};
const $4858a93c3dafa7ec$var$getPastDates = (duration)=>{
    let days;
    switch(duration){
        case "week":
            days = 7;
            break;
        case "month":
            days = 30;
            break;
        case "year":
            days = 365;
            break;
        default:
            days = duration;
    }
    const date = new Date();
    const endDate = date;
    const startDate = new Date(new Date().setDate(date.getDate() - (days - 1)));
    return $4858a93c3dafa7ec$var$getDates(startDate, endDate);
};
/* Get Random Number */ const $4858a93c3dafa7ec$var$getRandomNumber = (min, max)=>Math.floor(Math.random() * (max - min) + min);
const $4858a93c3dafa7ec$var$utils = {
    docReady: $4858a93c3dafa7ec$var$docReady,
    breakpoints: $4858a93c3dafa7ec$var$breakpoints,
    resize: $4858a93c3dafa7ec$var$resize,
    isIterableArray: $4858a93c3dafa7ec$var$isIterableArray,
    camelize: $4858a93c3dafa7ec$var$camelize,
    getData: $4858a93c3dafa7ec$var$getData,
    hasClass: $4858a93c3dafa7ec$var$hasClass,
    addClass: $4858a93c3dafa7ec$var$addClass,
    hexToRgb: $4858a93c3dafa7ec$var$hexToRgb,
    rgbaColor: $4858a93c3dafa7ec$var$rgbaColor,
    getColor: $4858a93c3dafa7ec$var$getColor,
    getColors: $4858a93c3dafa7ec$var$getColors,
    getSoftColors: $4858a93c3dafa7ec$var$getSoftColors,
    getGrays: $4858a93c3dafa7ec$var$getGrays,
    getOffset: $4858a93c3dafa7ec$var$getOffset,
    isScrolledIntoView: $4858a93c3dafa7ec$var$isScrolledIntoView,
    getBreakpoint: $4858a93c3dafa7ec$var$getBreakpoint,
    setCookie: $4858a93c3dafa7ec$var$setCookie,
    getCookie: $4858a93c3dafa7ec$var$getCookie,
    newChart: $4858a93c3dafa7ec$var$newChart,
    settings: $4858a93c3dafa7ec$var$settings,
    getItemFromStore: $4858a93c3dafa7ec$var$getItemFromStore,
    setItemToStore: $4858a93c3dafa7ec$var$setItemToStore,
    getStoreSpace: $4858a93c3dafa7ec$var$getStoreSpace,
    getDates: $4858a93c3dafa7ec$var$getDates,
    getPastDates: $4858a93c3dafa7ec$var$getPastDates,
    getRandomNumber: $4858a93c3dafa7ec$var$getRandomNumber,
    removeClass: $4858a93c3dafa7ec$var$removeClass
};
var $4858a93c3dafa7ec$export$2e2bcd8739ae039 = $4858a93c3dafa7ec$var$utils;


var $b6bb99d014f3ee95$exports = {};
/*! choices.js v9.1.0 | © 2021 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $b6bb99d014f3ee95$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(70));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        var _this = this;
                        if (element === void 0) element = "[data-choice]";
                        if (userConfig === void 0) userConfig = {};
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn("Unknown config option(s) passed", invalidConfigOptions.join(", "));
                        var passedElement = typeof element === "string" ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError("Expected one of the following types text|select-one|select-multiple");
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            "auto",
                            "always"
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = "auto";
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== "function") {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = "";
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, "choices-");
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: "item-choice"
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups; // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        } // Assign preset choices from passed object
                        this._presetChoices = this.config.choices; // Assign preset items from passed object first
                        this._presetItems = this.config.items; // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        } // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === "" || option.hasAttribute("placeholder"),
                                customProperties: option.dataset["custom-properties"]
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this); // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn("Trying to initialise Choices on element already initialised", {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        } // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute("disabled");
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit; // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === "function") callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item); // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                         // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ]; // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = "value";
                        if (label === void 0) label = "label";
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== "string" || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                         // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === "function") {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === "function" && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                             // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                             // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                         // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                         // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value); // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate("notice", canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === "function" ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate("notice", notice, "no-results");
                            } else {
                                notice = typeof this.config.noChoicesText === "function" ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate("notice", notice, "no-choices");
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear(); // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems); // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === "always" || !choice.selected);
                            });
                        }; // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate("choiceGroup", group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                         // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === "auto" ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate("choice", choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === "auto" && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                         // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices; // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length; // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                         // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                         // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton; // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate("item", item, removeItemButton); // Append it to list
                            fragment.appendChild(listItem);
                        }; // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                         // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id; // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        }); // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                         // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive; // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput(); // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        }); // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate("placeholder", this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || "";
                            } else this.input.placeholder = this._placeholderValue || "";
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!value || !this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        }); // Check that we have a value to search and the input was an alphanumeric character
                        if (value && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0; // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === "function" ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === "function" ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === "function" ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === "function" && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === "function" ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === "string" ? value.trim() : value;
                        var currentValue = typeof this._currentValue === "string" ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                         // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var keys = __spreadArray([], this.config.searchFields, true);
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: keys,
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement; // capture events - can cancel event processing or propagation
                        documentElement.addEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.addEventListener("mousedown", this._onMouseDown, true); // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener("click", this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener("touchmove", this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener("focus", this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener("blur", this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener("keyup", this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener("reset", this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener("mousedown", this._onMouseDown, true);
                        documentElement.removeEventListener("click", this._onClick);
                        documentElement.removeEventListener("touchmove", this._onTouchMove);
                        this.dropdown.element.removeEventListener("mouseover", this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener("focus", this._onFocus);
                            this.containerOuter.element.removeEventListener("blur", this._onBlur);
                        }
                        this.input.element.removeEventListener("keyup", this._onKeyUp);
                        this.input.element.removeEventListener("focus", this._onFocus);
                        this.input.element.removeEventListener("blur", this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener("reset", this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        var wasAlphaNumericChar = /[a-zA-Z0-9-_ ]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasAlphaNumericChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += keyString.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY; // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate("notice", canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.value);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey; // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute("data-button");
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY; // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = "[data-choice-selectable]";
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            } // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target; // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            } // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                         // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === "ltr" ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest("[data-button],[data-item],[data-choice]");
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ("button" in dataset) this._handleButtonAction(activeItems, item);
                            else if ("item" in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ("choice" in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && "choice" in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true); // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState))); // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute("aria-selected", "false");
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute("aria-selected", "true");
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === "string" ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1; // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                         // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                         // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === "undefined" || value === null) return;
                         // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? "value" : _b, _c = _a.labelKey, labelKey = _c === void 0 ? "label" : _c;
                        var groupChoices = (0, utils_1.isType)("Object", group) ? group.choices : Array.from(group.getElementsByTagName("OPTION"));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)("Object", choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        var classNames = this.config.classNames;
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            classNames
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === "function") userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate("containerInner"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate("input", this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate("choiceList", this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate("itemList", this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate("dropdown"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal(); // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element); // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || "";
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this; // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === "SELECT") this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this; // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? "" : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === "object" && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === "string") _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                 // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices; // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener("focus", this._onFocus);
                        this.element.addEventListener("blur", this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== "number") return false;
                         // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === "auto") shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === "top") shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.removeActiveDescendant();
                        this.isOpen = false; // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute("aria-disabled");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "0");
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute("aria-disabled", "true");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "-1");
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element); // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute("aria-busy", "true");
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute("aria-busy");
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener("paste", this._onPaste);
                        this.element.addEventListener("input", this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("input", this._onInput);
                        this.element.removeEventListener("paste", this._onPaste);
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = "";
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = "";
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight; // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight; // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight; // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError("Invalid element passed");
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === "active";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true; // Remove element from tab index
                        this.element.tabIndex = -1; // Backup original styles if any
                        var origStyle = this.element.getAttribute("style");
                        if (origStyle) this.element.setAttribute("data-choice-orig-style", origStyle);
                        this.element.setAttribute("data-choice", "active");
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute("tabindex"); // Recover original styles if any
                        var origStyle = this.element.getAttribute("data-choice-orig-style");
                        if (origStyle) {
                            this.element.removeAttribute("data-choice-orig-style");
                            this.element.setAttribute("style", origStyle);
                        } else this.element.removeAttribute("style");
                        this.element.removeAttribute("data-choice"); // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute("value", value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector("option[placeholder]");
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName("OPTGROUP"));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data); // Append it to fragment
                                fragment.appendChild(option);
                            }; // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = "";
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: "showDropdown",
                    hideDropdown: "hideDropdown",
                    change: "change",
                    choice: "choice",
                    search: "search",
                    addItem: "addItem",
                    removeItem: "removeItem",
                    highlightItem: "highlightItem",
                    highlightChoice: "highlightChoice",
                    unhighlightItem: "unhighlightItem"
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: "ADD_CHOICE",
                    FILTER_CHOICES: "FILTER_CHOICES",
                    ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
                    CLEAR_CHOICES: "CLEAR_CHOICES",
                    ADD_GROUP: "ADD_GROUP",
                    ADD_ITEM: "ADD_ITEM",
                    REMOVE_ITEM: "REMOVE_ITEM",
                    HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM",
                    CLEAR_ALL: "CLEAR_ALL",
                    RESET_TO: "RESET_TO",
                    SET_IS_LOADING: "SET_IS_LOADING"
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = "text";
                exports.SELECT_ONE_TYPE = "select-one";
                exports.SELECT_MULTIPLE_TYPE = "select-multiple";
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: "choices",
                    containerInner: "choices__inner",
                    input: "choices__input",
                    inputCloned: "choices__input--cloned",
                    list: "choices__list",
                    listItems: "choices__list--multiple",
                    listSingle: "choices__list--single",
                    listDropdown: "choices__list--dropdown",
                    item: "choices__item",
                    itemSelectable: "choices__item--selectable",
                    itemDisabled: "choices__item--disabled",
                    itemChoice: "choices__item--choice",
                    placeholder: "choices__placeholder",
                    group: "choices__group",
                    groupHeading: "choices__heading",
                    button: "choices__button",
                    activeState: "is-active",
                    focusState: "is-focused",
                    openState: "is-open",
                    disabledState: "is-disabled",
                    highlightedState: "is-highlighted",
                    selectedState: "is-selected",
                    flippedState: "is-flipped",
                    loadingState: "is-loading",
                    noResults: "has-no-results",
                    noChoices: "has-no-choices"
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    duplicateItemsAllowed: true,
                    delimiter: ",",
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        "label",
                        "value"
                    ],
                    position: "auto",
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: "auto",
                    loadingText: "Loading...",
                    noResultsText: "No results found",
                    noChoicesText: "No choices to choose from",
                    itemSelectText: "Press to select",
                    uniqueItemText: "Only unique values can be added",
                    customAddItemText: "Only values matching specific conditions can be added",
                    addItemText: function(value) {
                        return 'Press Enter to add <b>"'.concat((0, utils_1.sanitise)(value), '"</b>');
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join("");
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, "");
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement("div");
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? "next" : "previous", "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== "string") return value;
                    return value.replace(/&/g, "&amp;").replace(/>/g, "&rt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement("div");
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: "base",
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = "value";
                    return array.some(function(item) {
                        if (typeof value === "string") return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_CHOICE":
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case "ADD_ITEM":
                            var addItemAction_1 = action; // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case "REMOVE_ITEM":
                            var removeItemAction_1 = action; // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case "FILTER_CHOICES":
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj; // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case "ACTIVATE_CHOICES":
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case "CLEAR_CHOICES":
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_GROUP":
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case "CLEAR_CHOICES":
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(857);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState; // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === "CLEAR_ALL") state = exports.defaultState;
                    else if (action.type === "RESET_TO") return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_ITEM":
                            var addItemAction = action; // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case "REMOVE_ITEM":
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case "HIGHLIGHT_ITEM":
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "SET_IS_LOADING":
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(857);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType) {
                        var containerOuter = _a.containerOuter;
                        var div = Object.assign(document.createElement("div"), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute("role", searchEnabled ? "combobox" : "listbox");
                            if (searchEnabled) div.setAttribute("aria-autocomplete", "list");
                        }
                        div.setAttribute("aria-haspopup", "true");
                        div.setAttribute("aria-expanded", "false");
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.containerInner;
                        return Object.assign(document.createElement("div"), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var list = _a.list, listSingle = _a.listSingle, listItems = _a.listItems;
                        return Object.assign(document.createElement("div"), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var placeholder = _a.placeholder;
                        return Object.assign(document.createElement("div"), {
                            className: placeholder,
                            innerHTML: value
                        });
                    },
                    item: function(_a, _b, removeItemButton) {
                        var item = _a.item, button = _a.button, highlightedState = _a.highlightedState, itemSelectable = _a.itemSelectable, placeholder = _a.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), {
                            className: item,
                            innerHTML: label
                        });
                        Object.assign(div.dataset, {
                            item: "",
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute("aria-selected", "true");
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = "";
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = "Remove item";
                            var removeButton = Object.assign(document.createElement("button"), {
                                type: "button",
                                className: button,
                                innerHTML: REMOVE_ITEM_TEXT
                            });
                            removeButton.setAttribute("aria-label", "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = "";
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.list;
                        var div = Object.assign(document.createElement("div"), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute("aria-multiselectable", "true");
                        div.setAttribute("role", "listbox");
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var group = _a.group, groupHeading = _a.groupHeading, itemDisabled = _a.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement("div"), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : "")
                        });
                        div.setAttribute("role", "group");
                        Object.assign(div.dataset, {
                            group: "",
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        div.appendChild(Object.assign(document.createElement("div"), {
                            className: groupHeading,
                            innerHTML: value
                        }));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var item = _a.item, itemChoice = _a.itemChoice, itemSelectable = _a.itemSelectable, selectedState = _a.selectedState, itemDisabled = _a.itemDisabled, placeholder = _a.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), {
                            id: elementId,
                            innerHTML: label,
                            className: "".concat(item, " ").concat(itemChoice)
                        });
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute("role", groupId && groupId > 0 ? "treeitem" : "option");
                        Object.assign(div.dataset, {
                            choice: "",
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = "";
                            div.setAttribute("aria-disabled", "true");
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = "";
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var input = _a.input, inputCloned = _a.inputCloned;
                        var inp = Object.assign(document.createElement("input"), {
                            type: "text",
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: "off",
                            autocapitalize: "off",
                            spellcheck: false
                        });
                        inp.setAttribute("role", "textbox");
                        inp.setAttribute("aria-autocomplete", "list");
                        inp.setAttribute("aria-label", placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var list = _a.list, listDropdown = _a.listDropdown;
                        var div = document.createElement("div");
                        div.classList.add(list, listDropdown);
                        div.setAttribute("aria-expanded", "false");
                        return div;
                    },
                    notice: function(_a, innerHTML, type) {
                        var item = _a.item, itemChoice = _a.itemChoice, noResults = _a.noResults, noChoices = _a.noChoices;
                        if (type === void 0) type = "";
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === "no-choices") classes.push(noChoices);
                        else if (type === "no-results") classes.push(noResults);
                        return Object.assign(document.createElement("div"), {
                            innerHTML: innerHTML,
                            className: classes.join(" ")
                        });
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                "use strict";
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === "object";
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === "function" && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === "function" ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error("first argument should be an array");
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 70: /***/ function(module1) {
                /*!
 * Fuse.js v3.4.6 - Lightweight fuzzy-search (http://fusejs.io)
 * 
 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 */ !function(e, t) {
                    module1.exports = t();
                }(this, function() {
                    return function(e) {
                        var t = {};
                        function n(r) {
                            if (t[r]) return t[r].exports;
                            var o = t[r] = {
                                i: r,
                                l: !1,
                                exports: {}
                            };
                            return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
                        }
                        return n.m = e, n.c = t, n.d = function(e, t, r) {
                            n.o(e, t) || Object.defineProperty(e, t, {
                                enumerable: !0,
                                get: r
                            });
                        }, n.r = function(e) {
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e, "__esModule", {
                                value: !0
                            });
                        }, n.t = function(e, t) {
                            if (1 & t && (e = n(e)), 8 & t) return e;
                            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                            var r = Object.create(null);
                            if (n.r(r), Object.defineProperty(r, "default", {
                                enumerable: !0,
                                value: e
                            }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
                                return e[t];
                            }).bind(null, o));
                            return r;
                        }, n.n = function(e) {
                            var t = e && e.__esModule ? function() {
                                return e.default;
                            } : function() {
                                return e;
                            };
                            return n.d(t, "a", t), t;
                        }, n.o = function(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }, n.p = "", n(n.s = 1);
                    }([
                        function(e, t) {
                            e.exports = function(e) {
                                return Array.isArray ? Array.isArray(e) : "[object Array]" === Object.prototype.toString.call(e);
                            };
                        },
                        function(e, t, n) {
                            function r(e) {
                                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                })(e);
                            }
                            function o(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            var i = n(2), a = n(8), s = n(0), c = function() {
                                function e(t, n) {
                                    var r = n.location, o = void 0 === r ? 0 : r, i = n.distance, s = void 0 === i ? 100 : i, c = n.threshold, h = void 0 === c ? .6 : c, l = n.maxPatternLength, u = void 0 === l ? 32 : l, f = n.caseSensitive, d = void 0 !== f && f, v = n.tokenSeparator, p = void 0 === v ? / +/g : v, g = n.findAllMatches, y = void 0 !== g && g, m = n.minMatchCharLength, k = void 0 === m ? 1 : m, S = n.id, x = void 0 === S ? null : S, b = n.keys, M = void 0 === b ? [] : b, _ = n.shouldSort, L = void 0 === _ || _, w = n.getFn, A = void 0 === w ? a : w, C = n.sortFn, I = void 0 === C ? function(e, t) {
                                        return e.score - t.score;
                                    } : C, O = n.tokenize, j = void 0 !== O && O, P = n.matchAllTokens, F = void 0 !== P && P, T = n.includeMatches, z = void 0 !== T && T, E = n.includeScore, K = void 0 !== E && E, $ = n.verbose, J = void 0 !== $ && $;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.options = {
                                        location: o,
                                        distance: s,
                                        threshold: h,
                                        maxPatternLength: u,
                                        isCaseSensitive: d,
                                        tokenSeparator: p,
                                        findAllMatches: y,
                                        minMatchCharLength: k,
                                        id: x,
                                        keys: M,
                                        includeMatches: z,
                                        includeScore: K,
                                        shouldSort: L,
                                        getFn: A,
                                        sortFn: I,
                                        verbose: J,
                                        tokenize: j,
                                        matchAllTokens: F
                                    }, this.setCollection(t);
                                }
                                var t, n, c;
                                return t = e, n = [
                                    {
                                        key: "setCollection",
                                        value: function(e) {
                                            return this.list = e, e;
                                        }
                                    },
                                    {
                                        key: "search",
                                        value: function(e) {
                                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                                limit: !1
                                            };
                                            this._log('---------\nSearch pattern: "'.concat(e, '"'));
                                            var n = this._prepareSearchers(e), r = n.tokenSearchers, o = n.fullSearcher, i = this._search(r, o), a = i.weights, s = i.results;
                                            return this._computeScore(a, s), this.options.shouldSort && this._sort(s), t.limit && "number" == typeof t.limit && (s = s.slice(0, t.limit)), this._format(s);
                                        }
                                    },
                                    {
                                        key: "_prepareSearchers",
                                        value: function() {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = [];
                                            if (this.options.tokenize) for(var n = e.split(this.options.tokenSeparator), r = 0, o = n.length; r < o; r += 1)t.push(new i(n[r], this.options));
                                            return {
                                                tokenSearchers: t,
                                                fullSearcher: new i(e, this.options)
                                            };
                                        }
                                    },
                                    {
                                        key: "_search",
                                        value: function() {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 ? arguments[1] : void 0, n = this.list, r = {}, o = [];
                                            if ("string" == typeof n[0]) {
                                                for(var i = 0, a = n.length; i < a; i += 1)this._analyze({
                                                    key: "",
                                                    value: n[i],
                                                    record: i,
                                                    index: i
                                                }, {
                                                    resultMap: r,
                                                    results: o,
                                                    tokenSearchers: e,
                                                    fullSearcher: t
                                                });
                                                return {
                                                    weights: null,
                                                    results: o
                                                };
                                            }
                                            for(var s = {}, c = 0, h = n.length; c < h; c += 1)for(var l = n[c], u = 0, f = this.options.keys.length; u < f; u += 1){
                                                var d = this.options.keys[u];
                                                if ("string" != typeof d) {
                                                    if (s[d.name] = {
                                                        weight: 1 - d.weight || 1
                                                    }, d.weight <= 0 || d.weight > 1) throw new Error("Key weight has to be > 0 and <= 1");
                                                    d = d.name;
                                                } else s[d] = {
                                                    weight: 1
                                                };
                                                this._analyze({
                                                    key: d,
                                                    value: this.options.getFn(l, d),
                                                    record: l,
                                                    index: c
                                                }, {
                                                    resultMap: r,
                                                    results: o,
                                                    tokenSearchers: e,
                                                    fullSearcher: t
                                                });
                                            }
                                            return {
                                                weights: s,
                                                results: o
                                            };
                                        }
                                    },
                                    {
                                        key: "_analyze",
                                        value: function(e, t) {
                                            var n = e.key, r = e.arrayIndex, o = void 0 === r ? -1 : r, i = e.value, a = e.record, c = e.index, h = t.tokenSearchers, l = void 0 === h ? [] : h, u = t.fullSearcher, f = void 0 === u ? [] : u, d = t.resultMap, v = void 0 === d ? {} : d, p = t.results, g = void 0 === p ? [] : p;
                                            if (null != i) {
                                                var y = !1, m = -1, k = 0;
                                                if ("string" == typeof i) {
                                                    this._log("\nKey: ".concat("" === n ? "-" : n));
                                                    var S = f.search(i);
                                                    if (this._log('Full text: "'.concat(i, '", score: ').concat(S.score)), this.options.tokenize) {
                                                        for(var x = i.split(this.options.tokenSeparator), b = [], M = 0; M < l.length; M += 1){
                                                            var _ = l[M];
                                                            this._log('\nPattern: "'.concat(_.pattern, '"'));
                                                            for(var L = !1, w = 0; w < x.length; w += 1){
                                                                var A = x[w], C = _.search(A), I = {};
                                                                C.isMatch ? (I[A] = C.score, y = !0, L = !0, b.push(C.score)) : (I[A] = 1, this.options.matchAllTokens || b.push(1)), this._log('Token: "'.concat(A, '", score: ').concat(I[A]));
                                                            }
                                                            L && (k += 1);
                                                        }
                                                        m = b[0];
                                                        for(var O = b.length, j = 1; j < O; j += 1)m += b[j];
                                                        m /= O, this._log("Token score average:", m);
                                                    }
                                                    var P = S.score;
                                                    m > -1 && (P = (P + m) / 2), this._log("Score average:", P);
                                                    var F = !this.options.tokenize || !this.options.matchAllTokens || k >= l.length;
                                                    if (this._log("\nCheck Matches: ".concat(F)), (y || S.isMatch) && F) {
                                                        var T = v[c];
                                                        T ? T.output.push({
                                                            key: n,
                                                            arrayIndex: o,
                                                            value: i,
                                                            score: P,
                                                            matchedIndices: S.matchedIndices
                                                        }) : (v[c] = {
                                                            item: a,
                                                            output: [
                                                                {
                                                                    key: n,
                                                                    arrayIndex: o,
                                                                    value: i,
                                                                    score: P,
                                                                    matchedIndices: S.matchedIndices
                                                                }
                                                            ]
                                                        }, g.push(v[c]));
                                                    }
                                                } else if (s(i)) for(var z = 0, E = i.length; z < E; z += 1)this._analyze({
                                                    key: n,
                                                    arrayIndex: z,
                                                    value: i[z],
                                                    record: a,
                                                    index: c
                                                }, {
                                                    resultMap: v,
                                                    results: g,
                                                    tokenSearchers: l,
                                                    fullSearcher: f
                                                });
                                            }
                                        }
                                    },
                                    {
                                        key: "_computeScore",
                                        value: function(e, t) {
                                            this._log("\n\nComputing score:\n");
                                            for(var n = 0, r = t.length; n < r; n += 1){
                                                for(var o = t[n].output, i = o.length, a = 1, s = 1, c = 0; c < i; c += 1){
                                                    var h = e ? e[o[c].key].weight : 1, l = (1 === h ? o[c].score : o[c].score || .001) * h;
                                                    1 !== h ? s = Math.min(s, l) : (o[c].nScore = l, a *= l);
                                                }
                                                t[n].score = 1 === s ? a : s, this._log(t[n]);
                                            }
                                        }
                                    },
                                    {
                                        key: "_sort",
                                        value: function(e) {
                                            this._log("\n\nSorting...."), e.sort(this.options.sortFn);
                                        }
                                    },
                                    {
                                        key: "_format",
                                        value: function(e) {
                                            var t = [];
                                            if (this.options.verbose) {
                                                var n = [];
                                                this._log("\n\nOutput:\n\n", JSON.stringify(e, function(e, t) {
                                                    if ("object" === r(t) && null !== t) {
                                                        if (-1 !== n.indexOf(t)) return;
                                                        n.push(t);
                                                    }
                                                    return t;
                                                })), n = null;
                                            }
                                            var o = [];
                                            this.options.includeMatches && o.push(function(e, t) {
                                                var n = e.output;
                                                t.matches = [];
                                                for(var r = 0, o = n.length; r < o; r += 1){
                                                    var i = n[r];
                                                    if (0 !== i.matchedIndices.length) {
                                                        var a = {
                                                            indices: i.matchedIndices,
                                                            value: i.value
                                                        };
                                                        i.key && (a.key = i.key), i.hasOwnProperty("arrayIndex") && i.arrayIndex > -1 && (a.arrayIndex = i.arrayIndex), t.matches.push(a);
                                                    }
                                                }
                                            }), this.options.includeScore && o.push(function(e, t) {
                                                t.score = e.score;
                                            });
                                            for(var i = 0, a = e.length; i < a; i += 1){
                                                var s = e[i];
                                                if (this.options.id && (s.item = this.options.getFn(s.item, this.options.id)[0]), o.length) {
                                                    for(var c = {
                                                        item: s.item
                                                    }, h = 0, l = o.length; h < l; h += 1)o[h](s, c);
                                                    t.push(c);
                                                } else t.push(s.item);
                                            }
                                            return t;
                                        }
                                    },
                                    {
                                        key: "_log",
                                        value: function() {
                                            var e;
                                            this.options.verbose && (e = console).log.apply(e, arguments);
                                        }
                                    }
                                ], o(t.prototype, n), c && o(t, c), e;
                            }();
                            e.exports = c;
                        },
                        function(e, t, n) {
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            var o = n(3), i = n(4), a = n(7), s = function() {
                                function e(t, n) {
                                    var r = n.location, o = void 0 === r ? 0 : r, i = n.distance, s = void 0 === i ? 100 : i, c = n.threshold, h = void 0 === c ? .6 : c, l = n.maxPatternLength, u = void 0 === l ? 32 : l, f = n.isCaseSensitive, d = void 0 !== f && f, v = n.tokenSeparator, p = void 0 === v ? / +/g : v, g = n.findAllMatches, y = void 0 !== g && g, m = n.minMatchCharLength, k = void 0 === m ? 1 : m;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.options = {
                                        location: o,
                                        distance: s,
                                        threshold: h,
                                        maxPatternLength: u,
                                        isCaseSensitive: d,
                                        tokenSeparator: p,
                                        findAllMatches: y,
                                        minMatchCharLength: k
                                    }, this.pattern = this.options.isCaseSensitive ? t : t.toLowerCase(), this.pattern.length <= u && (this.patternAlphabet = a(this.pattern));
                                }
                                var t, n, s;
                                return t = e, n = [
                                    {
                                        key: "search",
                                        value: function(e) {
                                            if (this.options.isCaseSensitive || (e = e.toLowerCase()), this.pattern === e) return {
                                                isMatch: !0,
                                                score: 0,
                                                matchedIndices: [
                                                    [
                                                        0,
                                                        e.length - 1
                                                    ]
                                                ]
                                            };
                                            var t = this.options, n = t.maxPatternLength, r = t.tokenSeparator;
                                            if (this.pattern.length > n) return o(e, this.pattern, r);
                                            var a = this.options, s = a.location, c = a.distance, h = a.threshold, l = a.findAllMatches, u = a.minMatchCharLength;
                                            return i(e, this.pattern, this.patternAlphabet, {
                                                location: s,
                                                distance: c,
                                                threshold: h,
                                                findAllMatches: l,
                                                minMatchCharLength: u
                                            });
                                        }
                                    }
                                ], r(t.prototype, n), s && r(t, s), e;
                            }();
                            e.exports = s;
                        },
                        function(e, t) {
                            var n = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
                            e.exports = function(e, t) {
                                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : / +/g, o = new RegExp(t.replace(n, "\\$&").replace(r, "|")), i = e.match(o), a = !!i, s = [];
                                if (a) for(var c = 0, h = i.length; c < h; c += 1){
                                    var l = i[c];
                                    s.push([
                                        e.indexOf(l),
                                        l.length - 1
                                    ]);
                                }
                                return {
                                    score: a ? .5 : 1,
                                    isMatch: a,
                                    matchedIndices: s
                                };
                            };
                        },
                        function(e, t, n) {
                            var r = n(5), o = n(6);
                            e.exports = function(e, t, n, i) {
                                for(var a = i.location, s = void 0 === a ? 0 : a, c = i.distance, h = void 0 === c ? 100 : c, l = i.threshold, u = void 0 === l ? .6 : l, f = i.findAllMatches, d = void 0 !== f && f, v = i.minMatchCharLength, p = void 0 === v ? 1 : v, g = s, y = e.length, m = u, k = e.indexOf(t, g), S = t.length, x = [], b = 0; b < y; b += 1)x[b] = 0;
                                if (-1 !== k) {
                                    var M = r(t, {
                                        errors: 0,
                                        currentLocation: k,
                                        expectedLocation: g,
                                        distance: h
                                    });
                                    if (m = Math.min(M, m), -1 !== (k = e.lastIndexOf(t, g + S))) {
                                        var _ = r(t, {
                                            errors: 0,
                                            currentLocation: k,
                                            expectedLocation: g,
                                            distance: h
                                        });
                                        m = Math.min(_, m);
                                    }
                                }
                                k = -1;
                                for(var L = [], w = 1, A = S + y, C = 1 << (S <= 31 ? S - 1 : 30), I = 0; I < S; I += 1){
                                    for(var O = 0, j = A; O < j;)r(t, {
                                        errors: I,
                                        currentLocation: g + j,
                                        expectedLocation: g,
                                        distance: h
                                    }) <= m ? O = j : A = j, j = Math.floor((A - O) / 2 + O);
                                    A = j;
                                    var P = Math.max(1, g - j + 1), F = d ? y : Math.min(g + j, y) + S, T = Array(F + 2);
                                    T[F + 1] = (1 << I) - 1;
                                    for(var z = F; z >= P; z -= 1){
                                        var E = z - 1, K = n[e.charAt(E)];
                                        if (K && (x[E] = 1), T[z] = (T[z + 1] << 1 | 1) & K, 0 !== I && (T[z] |= (L[z + 1] | L[z]) << 1 | 1 | L[z + 1]), T[z] & C && (w = r(t, {
                                            errors: I,
                                            currentLocation: E,
                                            expectedLocation: g,
                                            distance: h
                                        })) <= m) {
                                            if (m = w, (k = E) <= g) break;
                                            P = Math.max(1, 2 * g - k);
                                        }
                                    }
                                    if (r(t, {
                                        errors: I + 1,
                                        currentLocation: g,
                                        expectedLocation: g,
                                        distance: h
                                    }) > m) break;
                                    L = T;
                                }
                                return {
                                    isMatch: k >= 0,
                                    score: 0 === w ? .001 : w,
                                    matchedIndices: o(x, p)
                                };
                            };
                        },
                        function(e, t) {
                            e.exports = function(e, t) {
                                var n = t.errors, r = void 0 === n ? 0 : n, o = t.currentLocation, i = void 0 === o ? 0 : o, a = t.expectedLocation, s = void 0 === a ? 0 : a, c = t.distance, h = void 0 === c ? 100 : c, l = r / e.length, u = Math.abs(s - i);
                                return h ? l + u / h : u ? 1 : l;
                            };
                        },
                        function(e, t) {
                            e.exports = function() {
                                for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = [], r = -1, o = -1, i = 0, a = e.length; i < a; i += 1){
                                    var s = e[i];
                                    s && -1 === r ? r = i : s || -1 === r || ((o = i - 1) - r + 1 >= t && n.push([
                                        r,
                                        o
                                    ]), r = -1);
                                }
                                return e[i - 1] && i - r >= t && n.push([
                                    r,
                                    i - 1
                                ]), n;
                            };
                        },
                        function(e, t) {
                            e.exports = function(e) {
                                for(var t = {}, n = e.length, r = 0; r < n; r += 1)t[e.charAt(r)] = 0;
                                for(var o = 0; o < n; o += 1)t[e.charAt(o)] |= 1 << n - o - 1;
                                return t;
                            };
                        },
                        function(e, t, n) {
                            var r = n(0);
                            e.exports = function(e, t) {
                                return function e(t, n, o) {
                                    if (n) {
                                        var i = n.indexOf("."), a = n, s = null;
                                        -1 !== i && (a = n.slice(0, i), s = n.slice(i + 1));
                                        var c = t[a];
                                        if (null != c) {
                                            if (s || "string" != typeof c && "number" != typeof c) {
                                                if (r(c)) for(var h = 0, l = c.length; h < l; h += 1)e(c[h], s, o);
                                                else s && e(c, s, o);
                                            } else o.push(c.toString());
                                        }
                                    } else o.push(t);
                                    return o;
                                }(e, t, []);
                            };
                        }
                    ]);
                });
            /***/ },
            /***/ 857: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    }
                });
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === "function" && Symbol.observable || "@@observable";
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split("").join(".");
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== "object" || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return "undefined";
                    if (val === null) return "null";
                    var type = typeof val;
                    switch(type){
                        case "boolean":
                        case "string":
                        case "number":
                        case "symbol":
                        case "function":
                            return type;
                    }
                    if (Array.isArray(val)) return "array";
                    if (isDate(val)) return "date";
                    if (isError(val)) return "error";
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case "Symbol":
                        case "Promise":
                        case "WeakMap":
                        case "WeakSet":
                        case "Map":
                        case "Set":
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
                }
                function ctorName(val) {
                    return typeof val.constructor === "function" ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== "undefined") {
                        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === "undefined") throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === "undefined") {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(373);
        /******/ __webpack_exports__ = __webpack_exports__["default"];
        /******/ /******/ return __webpack_exports__;
    /******/ }();
});


const $0a18fe21f97a9265$export$e50f980c0075fdab = ()=>{
    // Forms validation
    const forms = document.querySelectorAll(".needs-validation");
    for (const form of forms){
        const selectFormValidation = ()=>{
            form.querySelectorAll(".choices").forEach((choicesItem)=>{
                const singleSelect = choicesItem.querySelector(".choices__list--single");
                const multipleSelect = choicesItem.querySelector(".choices__list--multiple");
                if (choicesItem.querySelector("[required]")) {
                    if (singleSelect) {
                        var _singleSelect_querySelector;
                        const dataValue = (_singleSelect_querySelector = singleSelect.querySelector(".choices__item--selectable")) === null || _singleSelect_querySelector === void 0 ? void 0 : _singleSelect_querySelector.getAttribute("data-value");
                        if (dataValue && dataValue !== "") {
                            choicesItem.classList.remove("invalid");
                            choicesItem.classList.add("valid");
                        } else {
                            choicesItem.classList.remove("valid");
                            choicesItem.classList.add("invalid");
                        }
                    }
                    //----- for multiple select only ----------
                    if (multipleSelect) {
                        if (choicesItem.getElementsByTagName("option").length) {
                            choicesItem.classList.remove("invalid");
                            choicesItem.classList.add("valid");
                        } else {
                            choicesItem.classList.remove("valid");
                            choicesItem.classList.add("invalid");
                        }
                    }
                //------ select end ---------------
                }
            });
        };
        var _form_querySelectorAll;
        const submitButtons = (_form_querySelectorAll = form.querySelectorAll("button[type=submit]")) !== null && _form_querySelectorAll !== void 0 ? _form_querySelectorAll : [];
        for (const button of submitButtons)// Handle submit event
        button.addEventListener("click", (event)=>{
            selectFormValidation();
        }, true);
        const selects = form.querySelectorAll(".js-choice");
        for (const item of selects){
            const userOptions = (0, $4858a93c3dafa7ec$export$2e2bcd8739ae039).getData(item, "options");
            const choices = new (0, (/*@__PURE__*/$parcel$interopDefault($b6bb99d014f3ee95$exports)))(item, {
                itemSelectText: "",
                ...userOptions
            });
            item.addEventListener("change", ()=>{
                selectFormValidation();
            });
        }
        form.addEventListener("submit", ()=>{
            selectFormValidation();
        }, true);
    }
};


var $cd7affb418098dd5$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $cd7affb418098dd5$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $21aeaf39ac2b50f7$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $21aeaf39ac2b50f7$export$2e2bcd8739ae039 = $21aeaf39ac2b50f7$export$33e6c23ebe2ee669;


var $9536ac4278ccdd46$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $9536ac4278ccdd46$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $9536ac4278ccdd46$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $9536ac4278ccdd46$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $7f874903e55090f0$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $7f874903e55090f0$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $7f874903e55090f0$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $7f874903e55090f0$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $7f874903e55090f0$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $7f874903e55090f0$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $7f874903e55090f0$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $7f874903e55090f0$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $7f874903e55090f0$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $7f874903e55090f0$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $7f874903e55090f0$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $089f4fa70811013f$var$doNothing = function() {
    return undefined;
};
var $089f4fa70811013f$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $089f4fa70811013f$export$9490b78b888a863f = {
    D: $089f4fa70811013f$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $089f4fa70811013f$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $089f4fa70811013f$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $089f4fa70811013f$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $089f4fa70811013f$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$089f4fa70811013f$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $089f4fa70811013f$export$27a2dd9af757e89c($089f4fa70811013f$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)($089f4fa70811013f$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $089f4fa70811013f$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $c3514b523292dcd9$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $cd7affb418098dd5$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $21aeaf39ac2b50f7$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $089f4fa70811013f$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $089f4fa70811013f$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $c3514b523292dcd9$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $cd7affb418098dd5$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $21aeaf39ac2b50f7$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $cd7affb418098dd5$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $089f4fa70811013f$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $089f4fa70811013f$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $089f4fa70811013f$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $c3514b523292dcd9$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $c3514b523292dcd9$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $c3514b523292dcd9$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $c3514b523292dcd9$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $c3514b523292dcd9$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $c3514b523292dcd9$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $c3514b523292dcd9$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $d87571cf20aeb966$var$__assign = undefined && undefined.__assign || function() {
    $d87571cf20aeb966$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d87571cf20aeb966$var$__assign.apply(this, arguments);
};
var $d87571cf20aeb966$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $d87571cf20aeb966$var$DEBOUNCED_CHANGE_MS = 300;
function $d87571cf20aeb966$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $d87571cf20aeb966$var$__assign($d87571cf20aeb966$var$__assign({}, (0, $cd7affb418098dd5$export$ebe90cb607ad99e)), $d87571cf20aeb966$var$flatpickr.defaultConfig),
        l10n: (0, $21aeaf39ac2b50f7$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $c3514b523292dcd9$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $7f874903e55090f0$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $c3514b523292dcd9$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $c3514b523292dcd9$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $c3514b523292dcd9$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $c3514b523292dcd9$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $c3514b523292dcd9$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $c3514b523292dcd9$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $c3514b523292dcd9$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $c3514b523292dcd9$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $9536ac4278ccdd46$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $9536ac4278ccdd46$export$61fc7d43ac8f84b0)(triggerChange, $d87571cf20aeb966$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $c3514b523292dcd9$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $7f874903e55090f0$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $c3514b523292dcd9$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $7f874903e55090f0$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $c3514b523292dcd9$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $7f874903e55090f0$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $7f874903e55090f0$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $089f4fa70811013f$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $7f874903e55090f0$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $7f874903e55090f0$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $c3514b523292dcd9$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $7f874903e55090f0$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $7f874903e55090f0$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $7f874903e55090f0$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $7f874903e55090f0$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $d87571cf20aeb966$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $d87571cf20aeb966$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $7f874903e55090f0$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $c3514b523292dcd9$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $c3514b523292dcd9$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $c3514b523292dcd9$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $c3514b523292dcd9$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $c3514b523292dcd9$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $d87571cf20aeb966$var$__assign($d87571cf20aeb966$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $d87571cf20aeb966$var$flatpickr.defaultConfig.dateFormat || (0, $cd7affb418098dd5$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $d87571cf20aeb966$var$flatpickr.defaultConfig.altFormat || (0, $cd7affb418098dd5$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $cd7affb418098dd5$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $9536ac4278ccdd46$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $cd7affb418098dd5$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $9536ac4278ccdd46$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $d87571cf20aeb966$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $d87571cf20aeb966$var$__assign($d87571cf20aeb966$var$__assign({}, $d87571cf20aeb966$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $d87571cf20aeb966$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $089f4fa70811013f$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $089f4fa70811013f$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $089f4fa70811013f$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $089f4fa70811013f$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $089f4fa70811013f$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $d87571cf20aeb966$var$__assign($d87571cf20aeb966$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $d87571cf20aeb966$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $c3514b523292dcd9$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $c3514b523292dcd9$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $7f874903e55090f0$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $7f874903e55090f0$export$25245567f53f158f)((0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $c3514b523292dcd9$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $cd7affb418098dd5$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $9536ac4278ccdd46$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $7f874903e55090f0$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $c3514b523292dcd9$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $c3514b523292dcd9$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $c3514b523292dcd9$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $089f4fa70811013f$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $7f874903e55090f0$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(isHourElem) && (0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $9536ac4278ccdd46$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $9536ac4278ccdd46$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $d87571cf20aeb966$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $d87571cf20aeb966$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $d87571cf20aeb966$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $d87571cf20aeb966$var$_flatpickr([
            this
        ], config);
    };
}
var $d87571cf20aeb966$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $d87571cf20aeb966$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $d87571cf20aeb966$var$_flatpickr([
        selector
    ], config);
    else return $d87571cf20aeb966$var$_flatpickr(selector, config);
};
$d87571cf20aeb966$var$flatpickr.defaultConfig = {};
$d87571cf20aeb966$var$flatpickr.l10ns = {
    en: $d87571cf20aeb966$var$__assign({}, (0, $21aeaf39ac2b50f7$export$2e2bcd8739ae039)),
    default: $d87571cf20aeb966$var$__assign({}, (0, $21aeaf39ac2b50f7$export$2e2bcd8739ae039))
};
$d87571cf20aeb966$var$flatpickr.localize = function(l10n) {
    $d87571cf20aeb966$var$flatpickr.l10ns.default = $d87571cf20aeb966$var$__assign($d87571cf20aeb966$var$__assign({}, $d87571cf20aeb966$var$flatpickr.l10ns.default), l10n);
};
$d87571cf20aeb966$var$flatpickr.setDefaults = function(config) {
    $d87571cf20aeb966$var$flatpickr.defaultConfig = $d87571cf20aeb966$var$__assign($d87571cf20aeb966$var$__assign({}, $d87571cf20aeb966$var$flatpickr.defaultConfig), config);
};
$d87571cf20aeb966$var$flatpickr.parseDate = (0, $c3514b523292dcd9$export$cfa2ef2687faeda2)({});
$d87571cf20aeb966$var$flatpickr.formatDate = (0, $c3514b523292dcd9$export$ff1a0b75284ac636)({});
$d87571cf20aeb966$var$flatpickr.compareDates = (0, $c3514b523292dcd9$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $d87571cf20aeb966$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $d87571cf20aeb966$var$flatpickr;
var $d87571cf20aeb966$export$2e2bcd8739ae039 = $d87571cf20aeb966$var$flatpickr;


var $ebcbb05de948363e$exports = {};
(function(global, factory) {
    factory($ebcbb05de948363e$exports);
})($ebcbb05de948363e$exports, function(exports1) {
    "use strict";
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Bangla = {
        weekdays: {
            shorthand: [
                "\u09B0\u09AC\u09BF",
                "\u09B8\u09CB\u09AE",
                "\u09AE\u0999\u09CD\u0997\u09B2",
                "\u09AC\u09C1\u09A7",
                "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF",
                "\u09B6\u09C1\u0995\u09CD\u09B0",
                "\u09B6\u09A8\u09BF"
            ],
            longhand: [
                "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
                "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
                "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
                "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
                "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0",
                "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
                "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
            ]
        },
        months: {
            shorthand: [
                "\u099C\u09BE\u09A8\u09C1",
                "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
                "\u09AE\u09BE\u09B0\u09CD\u099A",
                "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
                "\u09AE\u09C7",
                "\u099C\u09C1\u09A8",
                "\u099C\u09C1\u09B2\u09BE\u0987",
                "\u0986\u0997",
                "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7",
                "\u0985\u0995\u09CD\u099F\u09CB",
                "\u09A8\u09AD\u09C7",
                "\u09A1\u09BF\u09B8\u09C7"
            ],
            longhand: [
                "\u099C\u09BE\u09A8\u09C1\u09AF\u09BC\u09BE\u09B0\u09C0",
                "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09AF\u09BC\u09BE\u09B0\u09C0",
                "\u09AE\u09BE\u09B0\u09CD\u099A",
                "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
                "\u09AE\u09C7",
                "\u099C\u09C1\u09A8",
                "\u099C\u09C1\u09B2\u09BE\u0987",
                "\u0986\u0997\u09B8\u09CD\u099F",
                "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
                "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
                "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
                "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
            ]
        }
    };
    fp.l10ns.bn = Bangla;
    var bn = fp.l10ns;
    exports1.Bangla = Bangla;
    exports1.default = bn;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


/* -------------------------------------------------------------------------- */ /*                                    Utils                                   */ /* -------------------------------------------------------------------------- */ const $53bcafe1e92564e5$var$camelize = (str)=>{
    const text = str.replace(/[-_\s.]+(.)?/g, (_, c)=>c ? c.toUpperCase() : "");
    return `${text.substr(0, 1).toLowerCase()}${text.substr(1)}`;
};
const $53bcafe1e92564e5$var$getData = (el, data)=>{
    try {
        return JSON.parse(el.dataset[$53bcafe1e92564e5$var$camelize(data)]);
    } catch (e) {
        return el.dataset[$53bcafe1e92564e5$var$camelize(data)];
    }
};
const $53bcafe1e92564e5$export$85b261bbf29b40ad = ()=>{
    document.querySelectorAll(".datetimepicker").forEach((item)=>{
        (0, $d87571cf20aeb966$export$2e2bcd8739ae039)(item, $53bcafe1e92564e5$var$getData(item, "options"));
    });
};


var $5a075e5df43f8e0c$export$2e2bcd8739ae039 = $5a075e5df43f8e0c$var$extend;
/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/ function $5a075e5df43f8e0c$var$extend() {
    var args = [].slice.call(arguments);
    var deep = false;
    if (typeof args[0] == "boolean") deep = args.shift();
    var result = args[0];
    if ($5a075e5df43f8e0c$var$isUnextendable(result)) throw new Error("extendee must be an object");
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (Object.prototype.hasOwnProperty.call(extender, key)) {
            var value = extender[key];
            if (deep && $5a075e5df43f8e0c$var$isCloneable(value)) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $5a075e5df43f8e0c$var$extend(true, Object.prototype.hasOwnProperty.call(result, key) && !$5a075e5df43f8e0c$var$isUnextendable(result[key]) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
}
function $5a075e5df43f8e0c$var$isCloneable(obj) {
    return Array.isArray(obj) || ({}).toString.call(obj) == "[object Object]";
}
function $5a075e5df43f8e0c$var$isUnextendable(val) {
    return !val || typeof val != "object" && typeof val != "function";
}


function $c180364cf43a262f$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
class $c180364cf43a262f$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    // Add an event listener for given event
    on(event, fn) {
        this._callbacks = this._callbacks || {};
        // Create namespace for this event
        if (!this._callbacks[event]) this._callbacks[event] = [];
        this._callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        this._callbacks = this._callbacks || {};
        let callbacks = this._callbacks[event];
        if (callbacks) for (let callback of callbacks)callback.apply(this, args);
        // trigger a corresponding DOM event
        if (this.element) this.element.dispatchEvent(this.makeEvent("dropzone:" + event, {
            args: args
        }));
        return this;
    }
    makeEvent(eventName, detail) {
        let params = {
            bubbles: true,
            cancelable: true,
            detail: detail
        };
        if (typeof window.CustomEvent === "function") return new CustomEvent(eventName, params);
        else {
            // IE 11 support
            // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
    }
    // Remove event listener for given event. If fn is not provided, all event
    // listeners for that event will be removed. If neither is provided, all
    // event listeners will be removed.
    off(event, fn) {
        if (!this._callbacks || arguments.length === 0) {
            this._callbacks = {};
            return this;
        }
        // specific event
        let callbacks = this._callbacks[event];
        if (!callbacks) return this;
        // remove all handlers
        if (arguments.length === 1) {
            delete this._callbacks[event];
            return this;
        }
        // remove specific handler
        for(let i = 0; i < callbacks.length; i++){
            let callback = callbacks[i];
            if (callback === fn) {
                callbacks.splice(i, 1);
                break;
            }
        }
        return this;
    }
}
var $c180364cf43a262f$var$$fd6031f88dce2e32$exports = {};
$c180364cf43a262f$var$$fd6031f88dce2e32$exports = '<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail=""></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size=""></span></div>\n    <div class="dz-filename"><span data-dz-name=""></span></div>\n  </div>\n  <div class="dz-progress">\n    <span class="dz-upload" data-dz-uploadprogress=""></span>\n  </div>\n  <div class="dz-error-message"><span data-dz-errormessage=""></span></div>\n  <div class="dz-success-mark">\n    <svg width="54" height="54" viewBox="0 0 54 54" fill="white" xmlns="http://www.w3.org/2000/svg">\n      <path d="M10.2071 29.7929L14.2929 25.7071C14.6834 25.3166 15.3166 25.3166 15.7071 25.7071L21.2929 31.2929C21.6834 31.6834 22.3166 31.6834 22.7071 31.2929L38.2929 15.7071C38.6834 15.3166 39.3166 15.3166 39.7071 15.7071L43.7929 19.7929C44.1834 20.1834 44.1834 20.8166 43.7929 21.2071L22.7071 42.2929C22.3166 42.6834 21.6834 42.6834 21.2929 42.2929L10.2071 31.2071C9.81658 30.8166 9.81658 30.1834 10.2071 29.7929Z"></path>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54" height="54" viewBox="0 0 54 54" fill="white" xmlns="http://www.w3.org/2000/svg">\n      <path d="M26.2929 20.2929L19.2071 13.2071C18.8166 12.8166 18.1834 12.8166 17.7929 13.2071L13.2071 17.7929C12.8166 18.1834 12.8166 18.8166 13.2071 19.2071L20.2929 26.2929C20.6834 26.6834 20.6834 27.3166 20.2929 27.7071L13.2071 34.7929C12.8166 35.1834 12.8166 35.8166 13.2071 36.2071L17.7929 40.7929C18.1834 41.1834 18.8166 41.1834 19.2071 40.7929L26.2929 33.7071C26.6834 33.3166 27.3166 33.3166 27.7071 33.7071L34.7929 40.7929C35.1834 41.1834 35.8166 41.1834 36.2071 40.7929L40.7929 36.2071C41.1834 35.8166 41.1834 35.1834 40.7929 34.7929L33.7071 27.7071C33.3166 27.3166 33.3166 26.6834 33.7071 26.2929L40.7929 19.2071C41.1834 18.8166 41.1834 18.1834 40.7929 17.7929L36.2071 13.2071C35.8166 12.8166 35.1834 12.8166 34.7929 13.2071L27.7071 20.2929C27.3166 20.6834 26.6834 20.6834 26.2929 20.2929Z"></path>\n    </svg>\n  </div>\n</div>\n';
let $c180364cf43a262f$var$$4ca367182776f80b$var$defaultOptions = {
    /**
   * Has to be specified on elements other than form (or when the form doesn't
   * have an `action` attribute).
   *
   * You can also provide a function that will be called with `files` and
   * `dataBlocks`  and must return the url as string.
   */ url: null,
    /**
   * Can be changed to `"put"` if necessary. You can also provide a function
   * that will be called with `files` and must return the method (since `v3.12.0`).
   */ method: "post",
    /**
   * Will be set on the XHRequest.
   */ withCredentials: false,
    /**
   * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
   * If set to null or 0, no timeout is going to be set.
   */ timeout: null,
    /**
   * How many file uploads to process in parallel (See the
   * Enqueuing file uploads documentation section for more info)
   */ parallelUploads: 2,
    /**
   * Whether to send multiple files in one request. If
   * this it set to true, then the fallback file input element will
   * have the `multiple` attribute as well. This option will
   * also trigger additional events (like `processingmultiple`). See the events
   * documentation section for more information.
   */ uploadMultiple: false,
    /**
   * Whether you want files to be uploaded in chunks to your server. This can't be
   * used in combination with `uploadMultiple`.
   *
   * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
   */ chunking: false,
    /**
   * If `chunking` is enabled, this defines whether **every** file should be chunked,
   * even if the file size is below chunkSize. This means, that the additional chunk
   * form data will be submitted and the `chunksUploaded` callback will be invoked.
   */ forceChunking: false,
    /**
   * If `chunking` is `true`, then this defines the chunk size in bytes.
   */ chunkSize: 2097152,
    /**
   * If `true`, the individual chunks of a file are being uploaded simultaneously.
   */ parallelChunkUploads: false,
    /**
   * Whether a chunk should be retried if it fails.
   */ retryChunks: false,
    /**
   * If `retryChunks` is true, how many times should it be retried.
   */ retryChunksLimit: 3,
    /**
   * The maximum filesize (in MiB) that is allowed to be uploaded.
   */ maxFilesize: 256,
    /**
   * The name of the file param that gets transferred.
   * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
   * Dropzone will append `[]` to the name.
   */ paramName: "file",
    /**
   * Whether thumbnails for images should be generated
   */ createImageThumbnails: true,
    /**
   * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
   */ maxThumbnailFilesize: 10,
    /**
   * If `null`, the ratio of the image will be used to calculate it.
   */ thumbnailWidth: 120,
    /**
   * The same as `thumbnailWidth`. If both are null, images will not be resized.
   */ thumbnailHeight: 120,
    /**
   * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
   * Can be either `contain` or `crop`.
   */ thumbnailMethod: "crop",
    /**
   * If set, images will be resized to these dimensions before being **uploaded**.
   * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
   * ratio of the file will be preserved.
   *
   * The `options.transformFile` function uses these options, so if the `transformFile` function
   * is overridden, these options don't do anything.
   */ resizeWidth: null,
    /**
   * See `resizeWidth`.
   */ resizeHeight: null,
    /**
   * The mime type of the resized image (before it gets uploaded to the server).
   * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
   * See `resizeWidth` for more information.
   */ resizeMimeType: null,
    /**
   * The quality of the resized images. See `resizeWidth`.
   */ resizeQuality: 0.8,
    /**
   * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
   * Can be either `contain` or `crop`.
   */ resizeMethod: "contain",
    /**
   * The base that is used to calculate the **displayed** filesize. You can
   * change this to 1024 if you would rather display kibibytes, mebibytes,
   * etc... 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte`
   * not `1 kilobyte`. You can change this to `1024` if you don't care about
   * validity.
   */ filesizeBase: 1000,
    /**
   * If not `null` defines how many files this Dropzone handles. If it exceeds,
   * the event `maxfilesexceeded` will be called. The dropzone element gets the
   * class `dz-max-files-reached` accordingly so you can provide visual
   * feedback.
   */ maxFiles: null,
    /**
   * An optional object to send additional headers to the server. Eg:
   * `{ "My-Awesome-Header": "header value" }`
   */ headers: null,
    /**
   * Should the default headers be set or not?
   * Accept: application/json <- for requesting json response
   * Cache-Control: no-cache <- Request shouldnt be cached
   * X-Requested-With: XMLHttpRequest <- We sent the request via XMLHttpRequest
   */ defaultHeaders: true,
    /**
   * If `true`, the dropzone element itself will be clickable, if `false`
   * nothing will be clickable.
   *
   * You can also pass an HTML element, a CSS selector (for multiple elements)
   * or an array of those. In that case, all of those elements will trigger an
   * upload when clicked.
   */ clickable: true,
    /**
   * Whether hidden files in directories should be ignored.
   */ ignoreHiddenFiles: true,
    /**
   * The default implementation of `accept` checks the file's mime type or
   * extension against this list. This is a comma separated list of mime
   * types or file extensions.
   *
   * Eg.: `image/*,application/pdf,.psd`
   *
   * If the Dropzone is `clickable` this option will also be used as
   * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
   * parameter on the hidden file input as well.
   */ acceptedFiles: null,
    /**
   * **Deprecated!**
   * Use acceptedFiles instead.
   */ acceptedMimeTypes: null,
    /**
   * If false, files will be added to the queue but the queue will not be
   * processed automatically.
   * This can be useful if you need some additional user input before sending
   * files (or if you want want all files sent at once).
   * If you're ready to send the file simply call `myDropzone.processQueue()`.
   *
   * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
   * section for more information.
   */ autoProcessQueue: true,
    /**
   * If false, files added to the dropzone will not be queued by default.
   * You'll have to call `enqueueFile(file)` manually.
   */ autoQueue: true,
    /**
   * If `true`, this will add a link to every file preview to remove or cancel (if
   * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
   * and `dictRemoveFile` options are used for the wording.
   */ addRemoveLinks: false,
    /**
   * Defines where to display the file previews – if `null` the
   * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
   * selector. The element should have the `dropzone-previews` class so
   * the previews are displayed properly.
   */ previewsContainer: null,
    /**
   * Set this to `true` if you don't want previews to be shown.
   */ disablePreviews: false,
    /**
   * This is the element the hidden input field (which is used when clicking on the
   * dropzone to trigger file selection) will be appended to. This might
   * be important in case you use frameworks to switch the content of your page.
   *
   * Can be a selector string, or an element directly.
   */ hiddenInputContainer: "body",
    /**
   * If null, no capture type will be specified
   * If camera, mobile devices will skip the file selection and choose camera
   * If microphone, mobile devices will skip the file selection and choose the microphone
   * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
   * On apple devices multiple must be set to false.  AcceptedFiles may need to
   * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
   */ capture: null,
    /**
   * **Deprecated**. Use `renameFile` instead.
   */ renameFilename: null,
    /**
   * A function that is invoked before the file is uploaded to the server and renames the file.
   * This function gets the `File` as argument and can use the `file.name`. The actual name of the
   * file that gets used during the upload can be accessed through `file.upload.filename`.
   */ renameFile: null,
    /**
   * If `true` the fallback will be forced. This is very useful to test your server
   * implementations first and make sure that everything works as
   * expected without dropzone if you experience problems, and to test
   * how your fallbacks will look.
   */ forceFallback: false,
    /**
   * The text used before any files are dropped.
   */ dictDefaultMessage: "Drop files here to upload",
    /**
   * The text that replaces the default message text it the browser is not supported.
   */ dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    /**
   * The text that will be added before the fallback form.
   * If you provide a  fallback element yourself, or if this option is `null` this will
   * be ignored.
   */ dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    /**
   * If the filesize is too big.
   * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
   */ dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    /**
   * If the file doesn't match the file type.
   */ dictInvalidFileType: "You can't upload files of this type.",
    /**
   * If the server response was invalid.
   * `{{statusCode}}` will be replaced with the servers status code.
   */ dictResponseError: "Server responded with {{statusCode}} code.",
    /**
   * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
   */ dictCancelUpload: "Cancel upload",
    /**
   * The text that is displayed if an upload was manually canceled
   */ dictUploadCanceled: "Upload canceled.",
    /**
   * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
   */ dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    /**
   * If `addRemoveLinks` is true, the text to be used to remove a file.
   */ dictRemoveFile: "Remove file",
    /**
   * If this is not null, then the user will be prompted before removing a file.
   */ dictRemoveFileConfirmation: null,
    /**
   * Displayed if `maxFiles` is st and exceeded.
   * The string `{{maxFiles}}` will be replaced by the configuration value.
   */ dictMaxFilesExceeded: "You can not upload any more files.",
    /**
   * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
   * `b` for bytes.
   */ dictFileSizeUnits: {
        tb: "TB",
        gb: "GB",
        mb: "MB",
        kb: "KB",
        b: "b"
    },
    /**
   * Called when dropzone initialized
   * You can add event listeners here
   */ init () {},
    /**
   * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
   * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
   * of a function, this needs to return a map.
   *
   * The default implementation does nothing for normal uploads, but adds relevant information for
   * chunked uploads.
   *
   * This is the same as adding hidden input fields in the form element.
   */ params (files, xhr, chunk) {
        if (chunk) return {
            dzuuid: chunk.file.upload.uuid,
            dzchunkindex: chunk.index,
            dztotalfilesize: chunk.file.size,
            dzchunksize: this.options.chunkSize,
            dztotalchunkcount: chunk.file.upload.totalChunkCount,
            dzchunkbyteoffset: chunk.index * this.options.chunkSize
        };
    },
    /**
   * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
   * and a `done` function as parameters.
   *
   * If the done function is invoked without arguments, the file is "accepted" and will
   * be processed. If you pass an error message, the file is rejected, and the error
   * message will be displayed.
   * This function will not be called if the file is too big or doesn't match the mime types.
   */ accept (file, done) {
        return done();
    },
    /**
   * The callback that will be invoked when all chunks have been uploaded for a file.
   * It gets the file for which the chunks have been uploaded as the first parameter,
   * and the `done` function as second. `done()` needs to be invoked when everything
   * needed to finish the upload process is done.
   */ chunksUploaded: function(file, done) {
        done();
    },
    /**
   * Sends the file as binary blob in body instead of form data.
   * If this is set, the `params` option will be ignored.
   * It's an error to set this to `true` along with `uploadMultiple` since
   * multiple files cannot be in a single binary body.
   */ binaryBody: false,
    /**
   * Gets called when the browser is not supported.
   * The default implementation shows the fallback input field and adds
   * a text.
   */ fallback () {
        // This code should pass in IE7... :(
        let messageElement;
        this.element.className = `${this.element.className} dz-browser-not-supported`;
        for (let child of this.element.getElementsByTagName("div"))if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message"; // Removes the 'dz-default' class
            break;
        }
        if (!messageElement) {
            messageElement = $c180364cf43a262f$export$2e2bcd8739ae039.createElement('<div class="dz-message"><span></span></div>');
            this.element.appendChild(messageElement);
        }
        let span = messageElement.getElementsByTagName("span")[0];
        if (span) {
            if (span.textContent != null) span.textContent = this.options.dictFallbackMessage;
            else if (span.innerText != null) span.innerText = this.options.dictFallbackMessage;
        }
        return this.element.appendChild(this.getFallbackForm());
    },
    /**
   * Gets called to calculate the thumbnail dimensions.
   *
   * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
   *
   *  - `srcWidth` & `srcHeight` (required)
   *  - `trgWidth` & `trgHeight` (required)
   *  - `srcX` & `srcY` (optional, default `0`)
   *  - `trgX` & `trgY` (optional, default `0`)
   *
   * Those values are going to be used by `ctx.drawImage()`.
   */ resize (file, width, height, resizeMethod) {
        let info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
        };
        let srcRatio = file.width / file.height;
        // Automatically calculate dimensions if not specified
        if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
        } else if (width == null) width = height * srcRatio;
        else if (height == null) height = width / srcRatio;
        // Make sure images aren't upscaled
        width = Math.min(width, info.srcWidth);
        height = Math.min(height, info.srcHeight);
        let trgRatio = width / height;
        if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === "crop") {
                if (srcRatio > trgRatio) {
                    info.srcHeight = file.height;
                    info.srcWidth = info.srcHeight * trgRatio;
                } else {
                    info.srcWidth = file.width;
                    info.srcHeight = info.srcWidth / trgRatio;
                }
            } else if (resizeMethod === "contain") {
                // Method 'contain'
                if (srcRatio > trgRatio) height = width / srcRatio;
                else width = height * srcRatio;
            } else throw new Error(`Unknown resizeMethod '${resizeMethod}'`);
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        info.trgWidth = width;
        info.trgHeight = height;
        return info;
    },
    /**
   * Can be used to transform the file (for example, resize an image if necessary).
   *
   * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
   * images according to those dimensions.
   *
   * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
   * to be invoked with the file when the transformation is done.
   */ transformFile (file, done) {
        if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
        else return done(file);
    },
    /**
   * A string that contains the template used for each dropped
   * file. Change it to fulfill your needs but make sure to properly
   * provide all elements.
   *
   * If you want to use an actual HTML element instead of providing a String
   * as a config option, you could create a div with the id `tpl`,
   * put the template inside it and provide the element like this:
   *
   *     document
   *       .querySelector('#tpl')
   *       .innerHTML
   *
   */ previewTemplate: /*@__PURE__*/ $c180364cf43a262f$var$$parcel$interopDefault($c180364cf43a262f$var$$fd6031f88dce2e32$exports),
    /*
   Those functions register themselves to the events on init and handle all
   the user interface specific stuff. Overwriting them won't break the upload
   but can break the way it's displayed.
   You can overwrite them if you don't like the default behavior. If you just
   want to add an additional event handler, register it on the dropzone object
   and don't overwrite those options.
   */ // Those are self explanatory and simply concern the DragnDrop.
    drop (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragstart (e) {},
    dragend (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragenter (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragover (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragleave (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    paste (e) {},
    // Called whenever there are no files left in the dropzone anymore, and the
    // dropzone should be displayed as if in the initial state.
    reset () {
        return this.element.classList.remove("dz-started");
    },
    // Called when a file is added to the queue
    // Receives `file`
    addedfile (file) {
        if (this.element === this.previewsContainer) this.element.classList.add("dz-started");
        if (this.previewsContainer && !this.options.disablePreviews) {
            file.previewElement = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility
            this.previewsContainer.appendChild(file.previewElement);
            for (var node of file.previewElement.querySelectorAll("[data-dz-name]"))node.textContent = file.name;
            for (node of file.previewElement.querySelectorAll("[data-dz-size]"))node.innerHTML = this.filesize(file.size);
            if (this.options.addRemoveLinks) {
                file._removeLink = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(`<a class="dz-remove" href="javascript:undefined;" data-dz-remove>${this.options.dictRemoveFile}</a>`);
                file.previewElement.appendChild(file._removeLink);
            }
            let removeFileEvent = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING) return $c180364cf43a262f$export$2e2bcd8739ae039.confirm(this.options.dictCancelUploadConfirmation, ()=>this.removeFile(file));
                else {
                    if (this.options.dictRemoveFileConfirmation) return $c180364cf43a262f$export$2e2bcd8739ae039.confirm(this.options.dictRemoveFileConfirmation, ()=>this.removeFile(file));
                    else return this.removeFile(file);
                }
            };
            for (let removeLink of file.previewElement.querySelectorAll("[data-dz-remove]"))removeLink.addEventListener("click", removeFileEvent);
        }
    },
    // Called whenever a file is removed.
    removedfile (file) {
        if (file.previewElement != null && file.previewElement.parentNode != null) file.previewElement.parentNode.removeChild(file.previewElement);
        return this._updateMaxFilesReachedClass();
    },
    // Called when a thumbnail has been generated
    // Receives `file` and `dataUrl`
    thumbnail (file, dataUrl) {
        if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            for (let thumbnailElement of file.previewElement.querySelectorAll("[data-dz-thumbnail]")){
                thumbnailElement.alt = file.name;
                thumbnailElement.src = dataUrl;
            }
            return setTimeout(()=>file.previewElement.classList.add("dz-image-preview"), 1);
        }
    },
    // Called whenever an error occurs
    // Receives `file` and `message`
    error (file, message) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "string" && message.error) message = message.error;
            for (let node of file.previewElement.querySelectorAll("[data-dz-errormessage]"))node.textContent = message;
        }
    },
    errormultiple () {},
    // Called when a file gets processed. Since there is a cue, not all added
    // files are processed immediately.
    // Receives `file`
    processing (file) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) return file._removeLink.innerHTML = this.options.dictCancelUpload;
        }
    },
    processingmultiple () {},
    // Called whenever the upload progress gets updated.
    // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
    // To get the total number of bytes of the file, use `file.size`
    uploadprogress (file, progress, bytesSent) {
        if (file.previewElement) for (let node of file.previewElement.querySelectorAll("[data-dz-uploadprogress]"))node.nodeName === "PROGRESS" ? node.value = progress : node.style.width = `${progress}%`;
    },
    // Called whenever the total upload progress gets updated.
    // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
    totaluploadprogress () {},
    // Called just before the file is sent. Gets the `xhr` object as second
    // parameter, so you can modify it (for example to add a CSRF token) and a
    // `formData` object to add additional information.
    sending () {},
    sendingmultiple () {},
    // When the complete upload is finished and successful
    // Receives `file`
    success (file) {
        if (file.previewElement) return file.previewElement.classList.add("dz-success");
    },
    successmultiple () {},
    // When the upload is canceled.
    canceled (file) {
        return this.emit("error", file, this.options.dictUploadCanceled);
    },
    canceledmultiple () {},
    // When the upload is finished, either with success or an error.
    // Receives `file`
    complete (file) {
        if (file._removeLink) file._removeLink.innerHTML = this.options.dictRemoveFile;
        if (file.previewElement) return file.previewElement.classList.add("dz-complete");
    },
    completemultiple () {},
    maxfilesexceeded () {},
    maxfilesreached () {},
    queuecomplete () {},
    addedfiles () {}
};
var $c180364cf43a262f$var$$4ca367182776f80b$export$2e2bcd8739ae039 = $c180364cf43a262f$var$$4ca367182776f80b$var$defaultOptions;
class $c180364cf43a262f$export$2e2bcd8739ae039 extends $c180364cf43a262f$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    static initClass() {
        // Exposing the emitter class, mainly for tests
        this.prototype.Emitter = $c180364cf43a262f$var$$4040acfd8584338d$export$2e2bcd8739ae039;
        /*
     This is a list of all available events you can register on a dropzone object.

     You can register an event handler like this:

     dropzone.on("dragEnter", function() { });

     */ this.prototype.events = [
            "drop",
            "dragstart",
            "dragend",
            "dragenter",
            "dragover",
            "dragleave",
            "addedfile",
            "addedfiles",
            "removedfile",
            "thumbnail",
            "error",
            "errormultiple",
            "processing",
            "processingmultiple",
            "uploadprogress",
            "totaluploadprogress",
            "sending",
            "sendingmultiple",
            "success",
            "successmultiple",
            "canceled",
            "canceledmultiple",
            "complete",
            "completemultiple",
            "reset",
            "maxfilesexceeded",
            "maxfilesreached",
            "queuecomplete"
        ];
        this.prototype._thumbnailQueue = [];
        this.prototype._processingThumbnail = false;
    }
    // Returns all files that have been accepted
    getAcceptedFiles() {
        return this.files.filter((file)=>file.accepted).map((file)=>file);
    }
    // Returns all files that have been rejected
    // Not sure when that's going to be useful, but added for completeness.
    getRejectedFiles() {
        return this.files.filter((file)=>!file.accepted).map((file)=>file);
    }
    getFilesWithStatus(status) {
        return this.files.filter((file)=>file.status === status).map((file)=>file);
    }
    // Returns all files that are in the queue
    getQueuedFiles() {
        return this.getFilesWithStatus($c180364cf43a262f$export$2e2bcd8739ae039.QUEUED);
    }
    getUploadingFiles() {
        return this.getFilesWithStatus($c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING);
    }
    getAddedFiles() {
        return this.getFilesWithStatus($c180364cf43a262f$export$2e2bcd8739ae039.ADDED);
    }
    // Files that are either queued or uploading
    getActiveFiles() {
        return this.files.filter((file)=>file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING || file.status === $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED).map((file)=>file);
    }
    // The function that gets called when Dropzone is initialized. You
    // can (and should) setup event listeners inside this function.
    init() {
        // In case it isn't set already
        if (this.element.tagName === "form") this.element.setAttribute("enctype", "multipart/form-data");
        if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) this.element.appendChild($c180364cf43a262f$export$2e2bcd8739ae039.createElement(`<div class="dz-default dz-message"><button class="dz-button" type="button">${this.options.dictDefaultMessage}</button></div>`));
        if (this.clickableElements.length) {
            let setupHiddenFileInput = ()=>{
                if (this.hiddenFileInput) this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
                this.hiddenFileInput = document.createElement("input");
                this.hiddenFileInput.setAttribute("type", "file");
                if (this.options.maxFiles === null || this.options.maxFiles > 1) this.hiddenFileInput.setAttribute("multiple", "multiple");
                this.hiddenFileInput.className = "dz-hidden-input";
                if (this.options.acceptedFiles !== null) this.hiddenFileInput.setAttribute("accept", this.options.acceptedFiles);
                if (this.options.capture !== null) this.hiddenFileInput.setAttribute("capture", this.options.capture);
                // Making sure that no one can "tab" into this field.
                this.hiddenFileInput.setAttribute("tabindex", "-1");
                // Not setting `display="none"` because some browsers don't accept clicks
                // on elements that aren't displayed.
                this.hiddenFileInput.style.visibility = "hidden";
                this.hiddenFileInput.style.position = "absolute";
                this.hiddenFileInput.style.top = "0";
                this.hiddenFileInput.style.left = "0";
                this.hiddenFileInput.style.height = "0";
                this.hiddenFileInput.style.width = "0";
                $c180364cf43a262f$export$2e2bcd8739ae039.getElement(this.options.hiddenInputContainer, "hiddenInputContainer").appendChild(this.hiddenFileInput);
                this.hiddenFileInput.addEventListener("change", ()=>{
                    let { files: files } = this.hiddenFileInput;
                    if (files.length) for (let file of files)this.addFile(file);
                    this.emit("addedfiles", files);
                    setupHiddenFileInput();
                });
            };
            setupHiddenFileInput();
        }
        this.URL = window.URL !== null ? window.URL : window.webkitURL;
        // Setup all event listeners on the Dropzone object itself.
        // They're not in @setupEventListeners() because they shouldn't be removed
        // again when the dropzone gets disabled.
        for (let eventName of this.events)this.on(eventName, this.options[eventName]);
        this.on("uploadprogress", ()=>this.updateTotalUploadProgress());
        this.on("removedfile", ()=>this.updateTotalUploadProgress());
        this.on("canceled", (file)=>this.emit("complete", file));
        // Emit a `queuecomplete` event if all files finished uploading.
        this.on("complete", (file)=>{
            if (this.getAddedFiles().length === 0 && this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) return setTimeout(()=>this.emit("queuecomplete"), 0);
        });
        const containsFiles = function(e) {
            if (e.dataTransfer.types) // IE, we need to iterate like this instead of
            // using e.dataTransfer.types.some()
            for(var i = 0; i < e.dataTransfer.types.length; i++){
                if (e.dataTransfer.types[i] === "Files") return true;
            }
            return false;
        };
        let noPropagation = function(e) {
            // If there are no files, we don't want to stop
            // propagation so we don't interfere with other
            // drag and drop behaviour.
            if (!containsFiles(e)) return;
            e.stopPropagation();
            if (e.preventDefault) return e.preventDefault();
            else return e.returnValue = false;
        };
        // Create the listeners
        this.listeners = [
            {
                element: this.element,
                events: {
                    dragstart: (e)=>{
                        return this.emit("dragstart", e);
                    },
                    dragenter: (e)=>{
                        noPropagation(e);
                        return this.emit("dragenter", e);
                    },
                    dragover: (e)=>{
                        // Makes it possible to drag files from chrome's download bar
                        // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
                        // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
                        let efct;
                        try {
                            efct = e.dataTransfer.effectAllowed;
                        } catch (error) {}
                        e.dataTransfer.dropEffect = "move" === efct || "linkMove" === efct ? "move" : "copy";
                        noPropagation(e);
                        return this.emit("dragover", e);
                    },
                    dragleave: (e)=>{
                        return this.emit("dragleave", e);
                    },
                    drop: (e)=>{
                        noPropagation(e);
                        return this.drop(e);
                    },
                    dragend: (e)=>{
                        return this.emit("dragend", e);
                    }
                }
            }
        ];
        this.clickableElements.forEach((clickableElement)=>{
            return this.listeners.push({
                element: clickableElement,
                events: {
                    click: (evt)=>{
                        // Only the actual dropzone or the message element should trigger file selection
                        if (clickableElement !== this.element || evt.target === this.element || $c180364cf43a262f$export$2e2bcd8739ae039.elementInside(evt.target, this.element.querySelector(".dz-message"))) this.hiddenFileInput.click(); // Forward the click
                        return true;
                    }
                }
            });
        });
        this.enable();
        return this.options.init.call(this);
    }
    // Not fully tested yet
    destroy() {
        this.disable();
        this.removeAllFiles(true);
        if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
            this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
            this.hiddenFileInput = null;
        }
        delete this.element.dropzone;
        return $c180364cf43a262f$export$2e2bcd8739ae039.instances.splice($c180364cf43a262f$export$2e2bcd8739ae039.instances.indexOf(this), 1);
    }
    updateTotalUploadProgress() {
        let totalUploadProgress;
        let totalBytesSent = 0;
        let totalBytes = 0;
        let activeFiles = this.getActiveFiles();
        if (activeFiles.length) {
            for (let file of this.getActiveFiles()){
                totalBytesSent += file.upload.bytesSent;
                totalBytes += file.upload.total;
            }
            totalUploadProgress = 100 * totalBytesSent / totalBytes;
        } else totalUploadProgress = 100;
        return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    }
    // @options.paramName can be a function taking one parameter rather than a string.
    // A parameter name for a file is obtained simply by calling this with an index number.
    _getParamName(n) {
        if (typeof this.options.paramName === "function") return this.options.paramName(n);
        else return `${this.options.paramName}${this.options.uploadMultiple ? `[${n}]` : ""}`;
    }
    // If @options.renameFile is a function,
    // the function will be used to rename the file.name before appending it to the formData
    _renameFile(file) {
        if (typeof this.options.renameFile !== "function") return file.name;
        return this.options.renameFile(file);
    }
    // Returns a form that can be used as fallback if the browser does not support DragnDrop
    //
    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
    // This code has to pass in IE7 :(
    getFallbackForm() {
        let existingFallback, form;
        if (existingFallback = this.getExistingFallback()) return existingFallback;
        let fieldsString = '<div class="dz-fallback">';
        if (this.options.dictFallbackText) fieldsString += `<p>${this.options.dictFallbackText}</p>`;
        fieldsString += `<input type="file" name="${this._getParamName(0)}" ${this.options.uploadMultiple ? 'multiple="multiple"' : undefined} /><input type="submit" value="Upload!"></div>`;
        let fields = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(fieldsString);
        if (this.element.tagName !== "FORM") {
            form = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(`<form action="${this.options.url}" enctype="multipart/form-data" method="${this.options.method}"></form>`);
            form.appendChild(fields);
        } else {
            // Make sure that the enctype and method attributes are set properly
            this.element.setAttribute("enctype", "multipart/form-data");
            this.element.setAttribute("method", this.options.method);
        }
        return form != null ? form : fields;
    }
    // Returns the fallback elements if they exist already
    //
    // This code has to pass in IE7 :(
    getExistingFallback() {
        let getFallback = function(elements) {
            for (let el of elements){
                if (/(^| )fallback($| )/.test(el.className)) return el;
            }
        };
        for (let tagName of [
            "div",
            "form"
        ]){
            var fallback;
            if (fallback = getFallback(this.element.getElementsByTagName(tagName))) return fallback;
        }
    }
    // Activates all listeners stored in @listeners
    setupEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.addEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Deactivates all listeners stored in @listeners
    removeEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.removeEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Removes all event listeners and cancels all files in the queue or being processed.
    disable() {
        this.clickableElements.forEach((element)=>element.classList.remove("dz-clickable"));
        this.removeEventListeners();
        this.disabled = true;
        return this.files.map((file)=>this.cancelUpload(file));
    }
    enable() {
        delete this.disabled;
        this.clickableElements.forEach((element)=>element.classList.add("dz-clickable"));
        return this.setupEventListeners();
    }
    // Returns a nicely formatted filesize
    filesize(size) {
        let selectedSize = 0;
        let selectedUnit = "b";
        if (size > 0) {
            let units = [
                "tb",
                "gb",
                "mb",
                "kb",
                "b"
            ];
            for(let i = 0; i < units.length; i++){
                let unit = units[i];
                let cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
                if (size >= cutoff) {
                    selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }
            selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
        }
        return `<strong>${selectedSize}</strong> ${this.options.dictFileSizeUnits[selectedUnit]}`;
    }
    // Adds or removes the `dz-max-files-reached` class from the form.
    _updateMaxFilesReachedClass() {
        if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            if (this.getAcceptedFiles().length === this.options.maxFiles) this.emit("maxfilesreached", this.files);
            return this.element.classList.add("dz-max-files-reached");
        } else return this.element.classList.remove("dz-max-files-reached");
    }
    drop(e) {
        if (!e.dataTransfer) return;
        this.emit("drop", e);
        // Convert the FileList to an Array
        // This is necessary for IE11
        let files = [];
        for(let i = 0; i < e.dataTransfer.files.length; i++)files[i] = e.dataTransfer.files[i];
        // Even if it's a folder, files.length will contain the folders.
        if (files.length) {
            let { items: items } = e.dataTransfer;
            if (items && items.length && items[0].webkitGetAsEntry != null) this._addFilesFromItems(items);
            else this.handleFiles(files);
        }
        this.emit("addedfiles", files);
    }
    paste(e) {
        if ($c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guard__(e != null ? e.clipboardData : undefined, (x)=>x.items) == null) return;
        this.emit("paste", e);
        let { items: items } = e.clipboardData;
        if (items.length) return this._addFilesFromItems(items);
    }
    handleFiles(files) {
        for (let file of files)this.addFile(file);
    }
    // When a folder is dropped (or files are pasted), items must be handled
    // instead of files.
    _addFilesFromItems(items) {
        return (()=>{
            let result = [];
            for (let item of items){
                var entry;
                if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
                    if (entry.isFile) result.push(this.addFile(item.getAsFile()));
                    else if (entry.isDirectory) result.push(this._addFilesFromDirectory(entry, entry.name));
                    else result.push(undefined);
                } else if (item.getAsFile != null) {
                    if (item.kind == null || item.kind === "file") result.push(this.addFile(item.getAsFile()));
                    else result.push(undefined);
                } else result.push(undefined);
            }
            return result;
        })();
    }
    // Goes through the directory, and adds each file it finds recursively
    _addFilesFromDirectory(directory, path) {
        let dirReader = directory.createReader();
        let errorHandler = (error)=>$c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guardMethod__(console, "log", (o)=>o.log(error));
        var readEntries = ()=>{
            return dirReader.readEntries((entries)=>{
                if (entries.length > 0) {
                    for (let entry of entries){
                        if (entry.isFile) entry.file((file)=>{
                            if (this.options.ignoreHiddenFiles && file.name.substring(0, 1) === ".") return;
                            file.fullPath = `${path}/${file.name}`;
                            return this.addFile(file);
                        });
                        else if (entry.isDirectory) this._addFilesFromDirectory(entry, `${path}/${entry.name}`);
                    }
                    // Recursively call readEntries() again, since browser only handle
                    // the first 100 entries.
                    // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
                    readEntries();
                }
                return null;
            }, errorHandler);
        };
        return readEntries();
    }
    // If `done()` is called without argument the file is accepted
    // If you call it with an error message, the file is rejected
    // (This allows for asynchronous validation)
    //
    // This function checks the filesize, and if the file.type passes the
    // `acceptedFiles` check.
    accept(file, done) {
        if (this.options.maxFilesize && file.size > this.options.maxFilesize * 1048576) done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
        else if (!$c180364cf43a262f$export$2e2bcd8739ae039.isValidFile(file, this.options.acceptedFiles)) done(this.options.dictInvalidFileType);
        else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
            this.emit("maxfilesexceeded", file);
        } else this.options.accept.call(this, file, done);
    }
    addFile(file) {
        file.upload = {
            uuid: $c180364cf43a262f$export$2e2bcd8739ae039.uuidv4(),
            progress: 0,
            // Setting the total upload size to file.size for the beginning
            // It's actual different than the size to be transmitted.
            total: file.size,
            bytesSent: 0,
            filename: this._renameFile(file)
        };
        this.files.push(file);
        file.status = $c180364cf43a262f$export$2e2bcd8739ae039.ADDED;
        this.emit("addedfile", file);
        this._enqueueThumbnail(file);
        this.accept(file, (error)=>{
            if (error) {
                file.accepted = false;
                this._errorProcessing([
                    file
                ], error); // Will set the file.status
            } else {
                file.accepted = true;
                if (this.options.autoQueue) this.enqueueFile(file);
            // Will set .accepted = true
            }
            this._updateMaxFilesReachedClass();
        });
    }
    // Wrapper for enqueueFile
    enqueueFiles(files) {
        for (let file of files)this.enqueueFile(file);
        return null;
    }
    enqueueFile(file) {
        if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.ADDED && file.accepted === true) {
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED;
            if (this.options.autoProcessQueue) return setTimeout(()=>this.processQueue(), 0); // Deferring the call
        } else throw new Error("This file can't be queued because it has already been processed or was rejected.");
    }
    _enqueueThumbnail(file) {
        if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1048576) {
            this._thumbnailQueue.push(file);
            return setTimeout(()=>this._processThumbnailQueue(), 0); // Deferring the call
        }
    }
    _processThumbnailQueue() {
        if (this._processingThumbnail || this._thumbnailQueue.length === 0) return;
        this._processingThumbnail = true;
        let file = this._thumbnailQueue.shift();
        return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, (dataUrl)=>{
            this.emit("thumbnail", file, dataUrl);
            this._processingThumbnail = false;
            return this._processThumbnailQueue();
        });
    }
    // Can be called by the user to remove a file
    removeFile(file) {
        if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING) this.cancelUpload(file);
        this.files = $c180364cf43a262f$var$$3ed269f2f0fb224b$var$without(this.files, file);
        this.emit("removedfile", file);
        if (this.files.length === 0) return this.emit("reset");
    }
    // Removes all files that aren't currently processed from the list
    removeAllFiles(cancelIfNecessary) {
        // Create a copy of files since removeFile() changes the @files array.
        if (cancelIfNecessary == null) cancelIfNecessary = false;
        for (let file of this.files.slice())if (file.status !== $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING || cancelIfNecessary) this.removeFile(file);
        return null;
    }
    // Resizes an image before it gets sent to the server. This function is the default behavior of
    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
    // the resized blob.
    resizeImage(file, width, height, resizeMethod, callback) {
        return this.createThumbnail(file, width, height, resizeMethod, true, (dataUrl, canvas)=>{
            if (canvas == null) return callback(file);
            else {
                let { resizeMimeType: resizeMimeType } = this.options;
                if (resizeMimeType == null) resizeMimeType = file.type;
                let resizedDataURL = canvas.toDataURL(resizeMimeType, this.options.resizeQuality);
                if (resizeMimeType === "image/jpeg" || resizeMimeType === "image/jpg") resizedDataURL = $c180364cf43a262f$var$$3ed269f2f0fb224b$var$ExifRestore.restore(file.dataURL, resizedDataURL);
                return callback($c180364cf43a262f$export$2e2bcd8739ae039.dataURItoBlob(resizedDataURL));
            }
        });
    }
    createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
        let fileReader = new FileReader();
        fileReader.onload = ()=>{
            file.dataURL = fileReader.result;
            // Don't bother creating a thumbnail for SVG images since they're vector
            if (file.type === "image/svg+xml") {
                if (callback != null) callback(fileReader.result);
                return;
            }
            this.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
        };
        fileReader.readAsDataURL(file);
    }
    // `mockFile` needs to have these attributes:
    //
    //     { name: 'name', size: 12345, imageUrl: '' }
    //
    // `callback` will be invoked when the image has been downloaded and displayed.
    // `crossOrigin` will be added to the `img` tag when accessing the file.
    displayExistingFile(mockFile, imageUrl, callback, crossOrigin, resizeThumbnail = true) {
        this.emit("addedfile", mockFile);
        this.emit("complete", mockFile);
        if (!resizeThumbnail) {
            this.emit("thumbnail", mockFile, imageUrl);
            if (callback) callback();
        } else {
            let onDone = (thumbnail)=>{
                this.emit("thumbnail", mockFile, thumbnail);
                if (callback) callback();
            };
            mockFile.dataURL = imageUrl;
            this.createThumbnailFromUrl(mockFile, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, onDone, crossOrigin);
        }
    }
    createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
        // Not using `new Image` here because of a bug in latest Chrome versions.
        // See https://github.com/enyo/dropzone/pull/226
        let img = document.createElement("img");
        if (crossOrigin) img.crossOrigin = crossOrigin;
        // fixOrientation is not needed anymore with browsers handling imageOrientation
        fixOrientation = getComputedStyle(document.body)["imageOrientation"] == "from-image" ? false : fixOrientation;
        img.onload = ()=>{
            let loadExif = (callback)=>callback(1);
            if (typeof EXIF !== "undefined" && EXIF !== null && fixOrientation) loadExif = (callback)=>EXIF.getData(img, function() {
                    return callback(EXIF.getTag(this, "Orientation"));
                });
            return loadExif((orientation)=>{
                file.width = img.width;
                file.height = img.height;
                let resizeInfo = this.options.resize.call(this, file, width, height, resizeMethod);
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                canvas.width = resizeInfo.trgWidth;
                canvas.height = resizeInfo.trgHeight;
                if (orientation > 4) {
                    canvas.width = resizeInfo.trgHeight;
                    canvas.height = resizeInfo.trgWidth;
                }
                switch(orientation){
                    case 2:
                        // horizontal flip
                        ctx.translate(canvas.width, 0);
                        ctx.scale(-1, 1);
                        break;
                    case 3:
                        // 180° rotate left
                        ctx.translate(canvas.width, canvas.height);
                        ctx.rotate(Math.PI);
                        break;
                    case 4:
                        // vertical flip
                        ctx.translate(0, canvas.height);
                        ctx.scale(1, -1);
                        break;
                    case 5:
                        // vertical flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.scale(1, -1);
                        break;
                    case 6:
                        // 90° rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(0, -canvas.width);
                        break;
                    case 7:
                        // horizontal flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(canvas.height, -canvas.width);
                        ctx.scale(-1, 1);
                        break;
                    case 8:
                        // 90° rotate left
                        ctx.rotate(-0.5 * Math.PI);
                        ctx.translate(-canvas.height, 0);
                        break;
                }
                // This is a bugfix for iOS' scaling bug.
                $c180364cf43a262f$var$$3ed269f2f0fb224b$var$drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
                let thumbnail = canvas.toDataURL("image/png");
                if (callback != null) return callback(thumbnail, canvas);
            });
        };
        if (callback != null) img.onerror = callback;
        return img.src = file.dataURL;
    }
    // Goes through the queue and processes files if there aren't too many already.
    processQueue() {
        let { parallelUploads: parallelUploads } = this.options;
        let processingLength = this.getUploadingFiles().length;
        let i = processingLength;
        // There are already at least as many files uploading than should be
        if (processingLength >= parallelUploads) return;
        let queuedFiles = this.getQueuedFiles();
        if (!(queuedFiles.length > 0)) return;
        if (this.options.uploadMultiple) return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
        else while(i < parallelUploads){
            if (!queuedFiles.length) return;
            // Nothing left to process
            this.processFile(queuedFiles.shift());
            i++;
        }
    }
    // Wrapper for `processFiles`
    processFile(file) {
        return this.processFiles([
            file
        ]);
    }
    // Loads the file, then calls finishedLoading()
    processFiles(files) {
        for (let file of files){
            file.processing = true; // Backwards compatibility
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING;
            this.emit("processing", file);
        }
        if (this.options.uploadMultiple) this.emit("processingmultiple", files);
        return this.uploadFiles(files);
    }
    _getFilesWithXhr(xhr) {
        let files;
        return files = this.files.filter((file)=>file.xhr === xhr).map((file)=>file);
    }
    // Cancels the file upload and sets the status to CANCELED
    // **if** the file is actually being uploaded.
    // If it's still in the queue, the file is being removed from it and the status
    // set to CANCELED.
    cancelUpload(file) {
        if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING) {
            let groupedFiles = this._getFilesWithXhr(file.xhr);
            for (let groupedFile of groupedFiles)groupedFile.status = $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED;
            if (typeof file.xhr !== "undefined") file.xhr.abort();
            for (let groupedFile1 of groupedFiles)this.emit("canceled", groupedFile1);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", groupedFiles);
        } else if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.ADDED || file.status === $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED) {
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED;
            this.emit("canceled", file);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", [
                file
            ]);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    resolveOption(option, ...args) {
        if (typeof option === "function") return option.apply(this, args);
        return option;
    }
    uploadFile(file) {
        return this.uploadFiles([
            file
        ]);
    }
    uploadFiles(files) {
        this._transformFiles(files, (transformedFiles)=>{
            if (this.options.chunking) {
                // Chunking is not allowed to be used with `uploadMultiple` so we know
                // that there is only __one__file.
                let transformedFile = transformedFiles[0];
                files[0].upload.chunked = this.options.chunking && (this.options.forceChunking || transformedFile.size > this.options.chunkSize);
                files[0].upload.totalChunkCount = Math.ceil(transformedFile.size / this.options.chunkSize);
            }
            if (files[0].upload.chunked) {
                // This file should be sent in chunks!
                // If the chunking option is set, we **know** that there can only be **one** file, since
                // uploadMultiple is not allowed with this option.
                let file = files[0];
                let transformedFile = transformedFiles[0];
                let startedChunkCount = 0;
                file.upload.chunks = [];
                let handleNextChunk = ()=>{
                    let chunkIndex = 0;
                    // Find the next item in file.upload.chunks that is not defined yet.
                    while(file.upload.chunks[chunkIndex] !== undefined)chunkIndex++;
                    // This means, that all chunks have already been started.
                    if (chunkIndex >= file.upload.totalChunkCount) return;
                    startedChunkCount++;
                    let start = chunkIndex * this.options.chunkSize;
                    let end = Math.min(start + this.options.chunkSize, transformedFile.size);
                    let dataBlock = {
                        name: this._getParamName(0),
                        data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
                        filename: file.upload.filename,
                        chunkIndex: chunkIndex
                    };
                    file.upload.chunks[chunkIndex] = {
                        file: file,
                        index: chunkIndex,
                        dataBlock: dataBlock,
                        status: $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING,
                        progress: 0,
                        retries: 0
                    };
                    this._uploadData(files, [
                        dataBlock
                    ]);
                };
                file.upload.finishedChunkUpload = (chunk, response)=>{
                    let allFinished = true;
                    chunk.status = $c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS;
                    // Clear the data from the chunk
                    chunk.dataBlock = null;
                    chunk.response = chunk.xhr.responseText;
                    chunk.responseHeaders = chunk.xhr.getAllResponseHeaders();
                    // Leaving this reference to xhr will cause memory leaks.
                    chunk.xhr = null;
                    for(let i = 0; i < file.upload.totalChunkCount; i++){
                        if (file.upload.chunks[i] === undefined) return handleNextChunk();
                        if (file.upload.chunks[i].status !== $c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS) allFinished = false;
                    }
                    if (allFinished) this.options.chunksUploaded(file, ()=>{
                        this._finished(files, response, null);
                    });
                };
                if (this.options.parallelChunkUploads) for(let i = 0; i < file.upload.totalChunkCount; i++)handleNextChunk();
                else handleNextChunk();
            } else {
                let dataBlocks = [];
                for(let i = 0; i < files.length; i++)dataBlocks[i] = {
                    name: this._getParamName(i),
                    data: transformedFiles[i],
                    filename: files[i].upload.filename
                };
                this._uploadData(files, dataBlocks);
            }
        });
    }
    /// Returns the right chunk for given file and xhr
    _getChunk(file, xhr) {
        for(let i = 0; i < file.upload.totalChunkCount; i++){
            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) return file.upload.chunks[i];
        }
    }
    // This function actually uploads the file(s) to the server.
    //
    //  If dataBlocks contains the actual data to upload (meaning, that this could
    // either be transformed files, or individual chunks for chunked upload) then
    // they will be used for the actual data to upload.
    _uploadData(files, dataBlocks) {
        let xhr = new XMLHttpRequest();
        // Put the xhr object in the file objects to be able to reference it later.
        for (let file of files)file.xhr = xhr;
        if (files[0].upload.chunked) // later, and found with _getChunk.
        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
        let method = this.resolveOption(this.options.method, files, dataBlocks);
        let url = this.resolveOption(this.options.url, files, dataBlocks);
        xhr.open(method, url, true);
        // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
        let timeout = this.resolveOption(this.options.timeout, files);
        if (timeout) xhr.timeout = this.resolveOption(this.options.timeout, files);
        // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
        xhr.withCredentials = !!this.options.withCredentials;
        xhr.onload = (e)=>{
            this._finishedUploading(files, xhr, e);
        };
        xhr.ontimeout = ()=>{
            this._handleUploadError(files, xhr, `Request timedout after ${this.options.timeout / 1000} seconds`);
        };
        xhr.onerror = ()=>{
            this._handleUploadError(files, xhr);
        };
        // Some browsers do not have the .upload property
        let progressObj = xhr.upload != null ? xhr.upload : xhr;
        progressObj.onprogress = (e)=>this._updateFilesUploadProgress(files, xhr, e);
        let headers = this.options.defaultHeaders ? {
            Accept: "application/json",
            "Cache-Control": "no-cache",
            "X-Requested-With": "XMLHttpRequest"
        } : {};
        if (this.options.binaryBody) headers["Content-Type"] = files[0].type;
        if (this.options.headers) (0, $5a075e5df43f8e0c$export$2e2bcd8739ae039)(headers, this.options.headers);
        for(let headerName in headers){
            let headerValue = headers[headerName];
            if (headerValue) xhr.setRequestHeader(headerName, headerValue);
        }
        if (this.options.binaryBody) {
            // Since the file is going to be sent as binary body, it doesn't make
            // any sense to generate `FormData` for it.
            for (let file of files)this.emit("sending", file, xhr);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr);
            this.submitRequest(xhr, null, files);
        } else {
            let formData = new FormData();
            // Adding all @options parameters
            if (this.options.params) {
                let additionalParams = this.options.params;
                if (typeof additionalParams === "function") additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
                for(let key in additionalParams){
                    let value = additionalParams[key];
                    if (Array.isArray(value)) // so lets iterate over it to attach each value
                    // individually.
                    for(let i = 0; i < value.length; i++)formData.append(key, value[i]);
                    else formData.append(key, value);
                }
            }
            // Let the user add additional data if necessary
            for (let file of files)this.emit("sending", file, xhr, formData);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr, formData);
            this._addFormElementData(formData);
            // Finally add the files
            // Has to be last because some servers (eg: S3) expect the file to be the last parameter
            for(let i = 0; i < dataBlocks.length; i++){
                let dataBlock = dataBlocks[i];
                formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
            }
            this.submitRequest(xhr, formData, files);
        }
    }
    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.
    _transformFiles(files, done) {
        let transformedFiles = [];
        // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
        let doneCounter = 0;
        for(let i = 0; i < files.length; i++)this.options.transformFile.call(this, files[i], (transformedFile)=>{
            transformedFiles[i] = transformedFile;
            if (++doneCounter === files.length) done(transformedFiles);
        });
    }
    // Takes care of adding other input elements of the form to the AJAX request
    _addFormElementData(formData) {
        // Take care of other input elements
        if (this.element.tagName === "FORM") for (let input of this.element.querySelectorAll("input, textarea, select, button")){
            let inputName = input.getAttribute("name");
            let inputType = input.getAttribute("type");
            if (inputType) inputType = inputType.toLowerCase();
            // If the input doesn't have a name, we can't use it.
            if (typeof inputName === "undefined" || inputName === null) continue;
            if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
                // Possibly multiple values
                for (let option of input.options)if (option.selected) formData.append(inputName, option.value);
            } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) formData.append(inputName, input.value);
        }
    }
    // Invoked when there is new progress information about given files.
    // If e is not provided, it is assumed that the upload is finished.
    _updateFilesUploadProgress(files, xhr, e) {
        if (!files[0].upload.chunked) for (let file of files){
            if (file.upload.total && file.upload.bytesSent && file.upload.bytesSent == file.upload.total) continue;
            if (e) {
                file.upload.progress = 100 * e.loaded / e.total;
                file.upload.total = e.total;
                file.upload.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                file.upload.progress = 100;
                file.upload.bytesSent = file.upload.total;
            }
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
        else {
            // Handle chunked file uploads
            // Chunked upload is not compatible with uploading multiple files in one
            // request, so we know there's only one file.
            let file = files[0];
            // Since this is a chunked upload, we need to update the appropriate chunk
            // progress.
            let chunk = this._getChunk(file, xhr);
            if (e) {
                chunk.progress = 100 * e.loaded / e.total;
                chunk.total = e.total;
                chunk.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                chunk.progress = 100;
                chunk.bytesSent = chunk.total;
            }
            // Now tally the *file* upload progress from its individual chunks
            file.upload.progress = 0;
            file.upload.total = 0;
            file.upload.bytesSent = 0;
            for(let i = 0; i < file.upload.totalChunkCount; i++)if (file.upload.chunks[i] && typeof file.upload.chunks[i].progress !== "undefined") {
                file.upload.progress += file.upload.chunks[i].progress;
                file.upload.total += file.upload.chunks[i].total;
                file.upload.bytesSent += file.upload.chunks[i].bytesSent;
            }
            // Since the process is a percentage, we need to divide by the amount of
            // chunks we've used.
            file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
    }
    _finishedUploading(files, xhr, e) {
        let response;
        if (files[0].status === $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED) return;
        if (xhr.readyState !== 4) return;
        if (xhr.responseType !== "arraybuffer" && xhr.responseType !== "blob") {
            response = xhr.responseText;
            if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) try {
                response = JSON.parse(response);
            } catch (error) {
                e = error;
                response = "Invalid JSON response from server.";
            }
        }
        this._updateFilesUploadProgress(files, xhr);
        if (!(200 <= xhr.status && xhr.status < 300)) this._handleUploadError(files, xhr, response);
        else if (files[0].upload.chunked) files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr), response);
        else this._finished(files, response, e);
    }
    _handleUploadError(files, xhr, response) {
        if (files[0].status === $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED) return;
        if (files[0].upload.chunked && this.options.retryChunks) {
            let chunk = this._getChunk(files[0], xhr);
            if (chunk.retries++ < this.options.retryChunksLimit) {
                this._uploadData(files, [
                    chunk.dataBlock
                ]);
                return;
            } else console.warn("Retried this chunk too often. Giving up.");
        }
        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
    }
    submitRequest(xhr, formData, files) {
        if (xhr.readyState != 1) {
            console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.");
            return;
        }
        if (this.options.binaryBody) {
            if (files[0].upload.chunked) {
                const chunk = this._getChunk(files[0], xhr);
                xhr.send(chunk.dataBlock.data);
            } else xhr.send(files[0]);
        } else xhr.send(formData);
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _finished(files, responseText, e) {
        for (let file of files){
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS;
            this.emit("success", file, responseText, e);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("successmultiple", files, responseText, e);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _errorProcessing(files, message, xhr) {
        for (let file of files){
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.ERROR;
            this.emit("error", file, message, xhr);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("errormultiple", files, message, xhr);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    static uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }
    constructor(el, options){
        super();
        let fallback, left;
        this.element = el;
        this.clickableElements = [];
        this.listeners = [];
        this.files = []; // All files
        if (typeof this.element === "string") this.element = document.querySelector(this.element);
        // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
        if (!this.element || this.element.nodeType == null) throw new Error("Invalid dropzone element.");
        if (this.element.dropzone) throw new Error("Dropzone already attached.");
        // Now add this dropzone to the instances.
        $c180364cf43a262f$export$2e2bcd8739ae039.instances.push(this);
        // Put the dropzone inside the element itself.
        this.element.dropzone = this;
        let elementOptions = (left = $c180364cf43a262f$export$2e2bcd8739ae039.optionsForElement(this.element)) != null ? left : {};
        this.options = (0, $5a075e5df43f8e0c$export$2e2bcd8739ae039)(true, {}, $c180364cf43a262f$var$$4ca367182776f80b$export$2e2bcd8739ae039, elementOptions, options != null ? options : {});
        this.options.previewTemplate = this.options.previewTemplate.replace(/\n*/g, "");
        // If the browser failed, just call the fallback and leave
        if (this.options.forceFallback || !$c180364cf43a262f$export$2e2bcd8739ae039.isBrowserSupported()) return this.options.fallback.call(this);
        // @options.url = @element.getAttribute "action" unless @options.url?
        if (this.options.url == null) this.options.url = this.element.getAttribute("action");
        if (!this.options.url) throw new Error("No URL provided.");
        if (this.options.acceptedFiles && this.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
        if (this.options.uploadMultiple && this.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
        if (this.options.binaryBody && this.options.uploadMultiple) throw new Error("You cannot set both: binaryBody and uploadMultiple.");
        // Backwards compatibility
        if (this.options.acceptedMimeTypes) {
            this.options.acceptedFiles = this.options.acceptedMimeTypes;
            delete this.options.acceptedMimeTypes;
        }
        // Backwards compatibility
        if (this.options.renameFilename != null) this.options.renameFile = (file)=>this.options.renameFilename.call(this, file.name, file);
        if (typeof this.options.method === "string") this.options.method = this.options.method.toUpperCase();
        if ((fallback = this.getExistingFallback()) && fallback.parentNode) fallback.parentNode.removeChild(fallback);
        // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
        if (this.options.previewsContainer !== false) {
            if (this.options.previewsContainer) this.previewsContainer = $c180364cf43a262f$export$2e2bcd8739ae039.getElement(this.options.previewsContainer, "previewsContainer");
            else this.previewsContainer = this.element;
        }
        if (this.options.clickable) {
            if (this.options.clickable === true) this.clickableElements = [
                this.element
            ];
            else this.clickableElements = $c180364cf43a262f$export$2e2bcd8739ae039.getElements(this.options.clickable, "clickable");
        }
        this.init();
    }
}
$c180364cf43a262f$export$2e2bcd8739ae039.initClass();
// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
$c180364cf43a262f$export$2e2bcd8739ae039.options = {};
// Returns the options for an element or undefined if none available.
$c180364cf43a262f$export$2e2bcd8739ae039.optionsForElement = function(element) {
    // Get the `Dropzone.options.elementId` for this element if it exists
    if (element.getAttribute("id")) return $c180364cf43a262f$export$2e2bcd8739ae039.options[$c180364cf43a262f$var$$3ed269f2f0fb224b$var$camelize(element.getAttribute("id"))];
    else return undefined;
};
// Holds a list of all dropzone instances
$c180364cf43a262f$export$2e2bcd8739ae039.instances = [];
// Returns the dropzone for given element if any
$c180364cf43a262f$export$2e2bcd8739ae039.forElement = function(element) {
    if (typeof element === "string") element = document.querySelector(element);
    if ((element != null ? element.dropzone : undefined) == null) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    return element.dropzone;
};
// Looks for all .dropzone elements and creates a dropzone for them
$c180364cf43a262f$export$2e2bcd8739ae039.discover = function() {
    let dropzones;
    if (document.querySelectorAll) dropzones = document.querySelectorAll(".dropzone");
    else {
        dropzones = [];
        // IE :(
        let checkElements = (elements)=>(()=>{
                let result = [];
                for (let el of elements)if (/(^| )dropzone($| )/.test(el.className)) result.push(dropzones.push(el));
                else result.push(undefined);
                return result;
            })();
        checkElements(document.getElementsByTagName("div"));
        checkElements(document.getElementsByTagName("form"));
    }
    return (()=>{
        let result = [];
        for (let dropzone of dropzones)if ($c180364cf43a262f$export$2e2bcd8739ae039.optionsForElement(dropzone) !== false) result.push(new $c180364cf43a262f$export$2e2bcd8739ae039(dropzone));
        else result.push(undefined);
        return result;
    })();
};
// Some browsers support drag and drog functionality, but not correctly.
//
// So I created a blocklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
$c180364cf43a262f$export$2e2bcd8739ae039.blockedBrowsers = [
    // The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
    /opera.*(Macintosh|Windows Phone).*version\/12/i
];
// Checks if the browser is supported
$c180364cf43a262f$export$2e2bcd8739ae039.isBrowserSupported = function() {
    let capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
        if (!("classList" in document.createElement("a"))) capableBrowser = false;
        else {
            if ($c180364cf43a262f$export$2e2bcd8739ae039.blacklistedBrowsers !== undefined) // configuration.
            $c180364cf43a262f$export$2e2bcd8739ae039.blockedBrowsers = $c180364cf43a262f$export$2e2bcd8739ae039.blacklistedBrowsers;
            // The browser supports the API, but may be blocked.
            for (let regex of $c180364cf43a262f$export$2e2bcd8739ae039.blockedBrowsers)if (regex.test(navigator.userAgent)) {
                capableBrowser = false;
                continue;
            }
        }
    } else capableBrowser = false;
    return capableBrowser;
};
$c180364cf43a262f$export$2e2bcd8739ae039.dataURItoBlob = function(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    let byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for(let i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--)ia[i] = byteString.charCodeAt(i);
    // write the ArrayBuffer to a blob
    return new Blob([
        ab
    ], {
        type: mimeString
    });
};
// Returns an array without the rejected item
const $c180364cf43a262f$var$$3ed269f2f0fb224b$var$without = (list, rejectedItem)=>list.filter((item)=>item !== rejectedItem).map((item)=>item);
// abc-def_ghi -> abcDefGhi
const $c180364cf43a262f$var$$3ed269f2f0fb224b$var$camelize = (str)=>str.replace(/[\-_](\w)/g, (match)=>match.charAt(1).toUpperCase());
// Creates an element from string
$c180364cf43a262f$export$2e2bcd8739ae039.createElement = function(string) {
    let div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
};
// Tests if given element is inside (or simply is) the container
$c180364cf43a262f$export$2e2bcd8739ae039.elementInside = function(element, container) {
    if (element === container) return true;
    // Coffeescript doesn't support do/while loops
    while(element = element.parentNode){
        if (element === container) return true;
    }
    return false;
};
$c180364cf43a262f$export$2e2bcd8739ae039.getElement = function(el, name) {
    let element;
    if (typeof el === "string") element = document.querySelector(el);
    else if (el.nodeType != null) element = el;
    if (element == null) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector or a plain HTML element.`);
    return element;
};
$c180364cf43a262f$export$2e2bcd8739ae039.getElements = function(els, name) {
    let el, elements;
    if (els instanceof Array) {
        elements = [];
        try {
            for (el of els)elements.push(this.getElement(el, name));
        } catch (e) {
            elements = null;
        }
    } else if (typeof els === "string") {
        elements = [];
        for (el of document.querySelectorAll(els))elements.push(el);
    } else if (els.nodeType != null) elements = [
        els
    ];
    if (elements == null || !elements.length) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector, a plain HTML element or a list of those.`);
    return elements;
};
// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
$c180364cf43a262f$export$2e2bcd8739ae039.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) return accepted();
    else if (rejected != null) return rejected();
};
// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
$c180364cf43a262f$export$2e2bcd8739ae039.isValidFile = function(file, acceptedFiles) {
    if (!acceptedFiles) return true;
    // If there are no accepted mime types, it's OK
    acceptedFiles = acceptedFiles.split(",");
    let mimeType = file.type;
    let baseMimeType = mimeType.replace(/\/.*$/, "");
    for (let validType of acceptedFiles){
        validType = validType.trim();
        if (validType.charAt(0) === ".") {
            if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) return true;
        } else if (/\/\*$/.test(validType)) {
            // This is something like a image/* mime type
            if (baseMimeType === validType.replace(/\/.*$/, "")) return true;
        } else {
            if (mimeType === validType) return true;
        }
    }
    return false;
};
// Augment jQuery
if (typeof jQuery !== "undefined" && jQuery !== null) jQuery.fn.dropzone = function(options) {
    return this.each(function() {
        return new $c180364cf43a262f$export$2e2bcd8739ae039(this, options);
    });
};
// Dropzone file status codes
$c180364cf43a262f$export$2e2bcd8739ae039.ADDED = "added";
$c180364cf43a262f$export$2e2bcd8739ae039.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
$c180364cf43a262f$export$2e2bcd8739ae039.ACCEPTED = $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED;
$c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING = "uploading";
$c180364cf43a262f$export$2e2bcd8739ae039.PROCESSING = $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING; // alias
$c180364cf43a262f$export$2e2bcd8739ae039.CANCELED = "canceled";
$c180364cf43a262f$export$2e2bcd8739ae039.ERROR = "error";
$c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS = "success";
/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */ // Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
let $c180364cf43a262f$var$$3ed269f2f0fb224b$var$detectVerticalSquash = function(img) {
    let iw = img.naturalWidth;
    let ih = img.naturalHeight;
    let canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let { data: data } = ctx.getImageData(1, 0, 1, ih);
    // search image edge pixel position in case it is squashed vertically.
    let sy = 0;
    let ey = ih;
    let py = ih;
    while(py > sy){
        let alpha = data[(py - 1) * 4 + 3];
        if (alpha === 0) ey = py;
        else sy = py;
        py = ey + sy >> 1;
    }
    let ratio = py / ih;
    if (ratio === 0) return 1;
    else return ratio;
};
// A replacement for context.drawImage
// (args are for source and destination).
var $c180364cf43a262f$var$$3ed269f2f0fb224b$var$drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    let vertSquashRatio = $c180364cf43a262f$var$$3ed269f2f0fb224b$var$detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};
// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html
class $c180364cf43a262f$var$$3ed269f2f0fb224b$var$ExifRestore {
    static initClass() {
        this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    }
    static encode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        while(true){
            chr1 = input[i++];
            chr2 = input[i++];
            chr3 = input[i++];
            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;
            if (isNaN(chr2)) enc3 = enc4 = 64;
            else if (isNaN(chr3)) enc4 = 64;
            output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return output;
    }
    static restore(origFileBase64, resizedFileBase64) {
        if (!origFileBase64.match("data:image/jpeg;base64,")) return resizedFileBase64;
        let rawImage = this.decode64(origFileBase64.replace("data:image/jpeg;base64,", ""));
        let segments = this.slice2Segments(rawImage);
        let image = this.exifManipulation(resizedFileBase64, segments);
        return `data:image/jpeg;base64,${this.encode64(image)}`;
    }
    static exifManipulation(resizedFileBase64, segments) {
        let exifArray = this.getExifArray(segments);
        let newImageArray = this.insertExif(resizedFileBase64, exifArray);
        let aBuffer = new Uint8Array(newImageArray);
        return aBuffer;
    }
    static getExifArray(segments) {
        let seg = undefined;
        let x = 0;
        while(x < segments.length){
            seg = segments[x];
            if (seg[0] === 255 & seg[1] === 225) return seg;
            x++;
        }
        return [];
    }
    static insertExif(resizedFileBase64, exifArray) {
        let imageData = resizedFileBase64.replace("data:image/jpeg;base64,", "");
        let buf = this.decode64(imageData);
        let separatePoint = buf.indexOf(255, 3);
        let mae = buf.slice(0, separatePoint);
        let ato = buf.slice(separatePoint);
        let array = mae;
        array = array.concat(exifArray);
        array = array.concat(ato);
        return array;
    }
    static slice2Segments(rawImageArray) {
        let head = 0;
        let segments = [];
        while(true){
            var length;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) break;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) head += 2;
            else {
                length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
                let endPoint = head + length + 2;
                let seg = rawImageArray.slice(head, endPoint);
                segments.push(seg);
                head = endPoint;
            }
            if (head > rawImageArray.length) break;
        }
        return segments;
    }
    static decode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        let buf = [];
        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        let base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while(true){
            enc1 = this.KEY_STR.indexOf(input.charAt(i++));
            enc2 = this.KEY_STR.indexOf(input.charAt(i++));
            enc3 = this.KEY_STR.indexOf(input.charAt(i++));
            enc4 = this.KEY_STR.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            buf.push(chr1);
            if (enc3 !== 64) buf.push(chr2);
            if (enc4 !== 64) buf.push(chr3);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return buf;
    }
}
$c180364cf43a262f$var$$3ed269f2f0fb224b$var$ExifRestore.initClass();
/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */ // @win window reference
// @fn function reference
let $c180364cf43a262f$var$$3ed269f2f0fb224b$var$contentLoaded = function(win, fn) {
    let done = false;
    let top = true;
    let doc = win.document;
    let root = doc.documentElement;
    let add = doc.addEventListener ? "addEventListener" : "attachEvent";
    let rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
    let pre = doc.addEventListener ? "" : "on";
    var init = function(e) {
        if (e.type === "readystatechange" && doc.readyState !== "complete") return;
        (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) return fn.call(win, e.type || e);
    };
    var poll = function() {
        try {
            root.doScroll("left");
        } catch (e) {
            setTimeout(poll, 50);
            return;
        }
        return init("poll");
    };
    if (doc.readyState !== "complete") {
        if (doc.createEventObject && root.doScroll) {
            try {
                top = !win.frameElement;
            } catch (error) {}
            if (top) poll();
        }
        doc[add](pre + "DOMContentLoaded", init, false);
        doc[add](pre + "readystatechange", init, false);
        return win[add](pre + "load", init, false);
    }
};
function $c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guard__(value, transform) {
    return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
function $c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guardMethod__(obj, methodName, transform) {
    if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") return transform(obj, methodName);
    else return undefined;
}


/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $864e3137db0bdda5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $864e3137db0bdda5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $864e3137db0bdda5$var$ownKeys(Object(source), true).forEach(function(key) {
            $864e3137db0bdda5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $864e3137db0bdda5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $864e3137db0bdda5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $864e3137db0bdda5$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $864e3137db0bdda5$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $864e3137db0bdda5$var$_typeof(obj);
}
function $864e3137db0bdda5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $864e3137db0bdda5$var$_extends() {
    $864e3137db0bdda5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $864e3137db0bdda5$var$_extends.apply(this, arguments);
}
function $864e3137db0bdda5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $864e3137db0bdda5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $864e3137db0bdda5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $864e3137db0bdda5$var$_toConsumableArray(arr) {
    return $864e3137db0bdda5$var$_arrayWithoutHoles(arr) || $864e3137db0bdda5$var$_iterableToArray(arr) || $864e3137db0bdda5$var$_unsupportedIterableToArray(arr) || $864e3137db0bdda5$var$_nonIterableSpread();
}
function $864e3137db0bdda5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $864e3137db0bdda5$var$_arrayLikeToArray(arr);
}
function $864e3137db0bdda5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $864e3137db0bdda5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $864e3137db0bdda5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $864e3137db0bdda5$var$_arrayLikeToArray(o, minLen);
}
function $864e3137db0bdda5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $864e3137db0bdda5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $864e3137db0bdda5$var$version = "1.15.2";
function $864e3137db0bdda5$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $864e3137db0bdda5$var$IE11OrLess = $864e3137db0bdda5$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $864e3137db0bdda5$var$Edge = $864e3137db0bdda5$var$userAgent(/Edge/i);
var $864e3137db0bdda5$var$FireFox = $864e3137db0bdda5$var$userAgent(/firefox/i);
var $864e3137db0bdda5$var$Safari = $864e3137db0bdda5$var$userAgent(/safari/i) && !$864e3137db0bdda5$var$userAgent(/chrome/i) && !$864e3137db0bdda5$var$userAgent(/android/i);
var $864e3137db0bdda5$var$IOS = $864e3137db0bdda5$var$userAgent(/iP(ad|od|hone)/i);
var $864e3137db0bdda5$var$ChromeForAndroid = $864e3137db0bdda5$var$userAgent(/chrome/i) && $864e3137db0bdda5$var$userAgent(/android/i);
var $864e3137db0bdda5$var$captureMode = {
    capture: false,
    passive: false
};
function $864e3137db0bdda5$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$864e3137db0bdda5$var$IE11OrLess && $864e3137db0bdda5$var$captureMode);
}
function $864e3137db0bdda5$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$864e3137db0bdda5$var$IE11OrLess && $864e3137db0bdda5$var$captureMode);
}
function $864e3137db0bdda5$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $864e3137db0bdda5$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $864e3137db0bdda5$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $864e3137db0bdda5$var$matches(el, selector) : $864e3137db0bdda5$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $864e3137db0bdda5$var$getParentOrHost(el));
    }
    return null;
}
var $864e3137db0bdda5$var$R_SPACE = /\s+/g;
function $864e3137db0bdda5$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($864e3137db0bdda5$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($864e3137db0bdda5$var$R_SPACE, " ");
        }
    }
}
function $864e3137db0bdda5$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $864e3137db0bdda5$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $864e3137db0bdda5$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $864e3137db0bdda5$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $864e3137db0bdda5$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $864e3137db0bdda5$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $864e3137db0bdda5$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$864e3137db0bdda5$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($864e3137db0bdda5$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $864e3137db0bdda5$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($864e3137db0bdda5$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($864e3137db0bdda5$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $864e3137db0bdda5$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $864e3137db0bdda5$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $864e3137db0bdda5$var$getParentAutoScrollElement(el, true), elSideVal = $864e3137db0bdda5$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $864e3137db0bdda5$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $864e3137db0bdda5$var$getWindowScrollingElement()) break;
        parent = $864e3137db0bdda5$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $864e3137db0bdda5$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $864e3137db0bdda5$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $864e3137db0bdda5$export$31b3ca70d8f57423.dragged) && $864e3137db0bdda5$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $864e3137db0bdda5$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $864e3137db0bdda5$export$31b3ca70d8f57423.ghost || $864e3137db0bdda5$var$css(last, "display") === "none" || selector && !$864e3137db0bdda5$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $864e3137db0bdda5$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $864e3137db0bdda5$export$31b3ca70d8f57423.clone && (!selector || $864e3137db0bdda5$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $864e3137db0bdda5$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $864e3137db0bdda5$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $864e3137db0bdda5$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $864e3137db0bdda5$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $864e3137db0bdda5$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $864e3137db0bdda5$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $864e3137db0bdda5$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $864e3137db0bdda5$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $864e3137db0bdda5$var$getWindowScrollingElement();
}
function $864e3137db0bdda5$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $864e3137db0bdda5$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $864e3137db0bdda5$var$_throttleTimeout;
function $864e3137db0bdda5$var$throttle(callback, ms) {
    return function() {
        if (!$864e3137db0bdda5$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $864e3137db0bdda5$var$_throttleTimeout = setTimeout(function() {
                $864e3137db0bdda5$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $864e3137db0bdda5$var$cancelThrottle() {
    clearTimeout($864e3137db0bdda5$var$_throttleTimeout);
    $864e3137db0bdda5$var$_throttleTimeout = void 0;
}
function $864e3137db0bdda5$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $864e3137db0bdda5$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $864e3137db0bdda5$var$setRect(el, rect) {
    $864e3137db0bdda5$var$css(el, "position", "absolute");
    $864e3137db0bdda5$var$css(el, "top", rect.top);
    $864e3137db0bdda5$var$css(el, "left", rect.left);
    $864e3137db0bdda5$var$css(el, "width", rect.width);
    $864e3137db0bdda5$var$css(el, "height", rect.height);
}
function $864e3137db0bdda5$var$unsetRect(el) {
    $864e3137db0bdda5$var$css(el, "position", "");
    $864e3137db0bdda5$var$css(el, "top", "");
    $864e3137db0bdda5$var$css(el, "left", "");
    $864e3137db0bdda5$var$css(el, "width", "");
    $864e3137db0bdda5$var$css(el, "height", "");
}
function $864e3137db0bdda5$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$864e3137db0bdda5$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $864e3137db0bdda5$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $864e3137db0bdda5$var$expando = "Sortable" + new Date().getTime();
function $864e3137db0bdda5$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($864e3137db0bdda5$var$css(child, "display") === "none" || child === $864e3137db0bdda5$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $864e3137db0bdda5$var$getRect(child)
                });
                var fromRect = $864e3137db0bdda5$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $864e3137db0bdda5$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($864e3137db0bdda5$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $864e3137db0bdda5$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $864e3137db0bdda5$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($864e3137db0bdda5$var$isRectEqual(prevFromRect, toRect) && !$864e3137db0bdda5$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $864e3137db0bdda5$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$864e3137db0bdda5$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $864e3137db0bdda5$var$css(target, "transition", "");
                $864e3137db0bdda5$var$css(target, "transform", "");
                var elMatrix = $864e3137db0bdda5$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $864e3137db0bdda5$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $864e3137db0bdda5$var$repaint(target); // repaint
                $864e3137db0bdda5$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $864e3137db0bdda5$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $864e3137db0bdda5$var$css(target, "transition", "");
                    $864e3137db0bdda5$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $864e3137db0bdda5$var$repaint(target) {
    return target.offsetWidth;
}
function $864e3137db0bdda5$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $864e3137db0bdda5$var$plugins = [];
var $864e3137db0bdda5$var$defaults = {
    initializeByDefault: true
};
var $864e3137db0bdda5$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $864e3137db0bdda5$var$defaults)if ($864e3137db0bdda5$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $864e3137db0bdda5$var$defaults[option];
        $864e3137db0bdda5$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $864e3137db0bdda5$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($864e3137db0bdda5$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($864e3137db0bdda5$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $864e3137db0bdda5$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $864e3137db0bdda5$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $864e3137db0bdda5$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$864e3137db0bdda5$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$864e3137db0bdda5$var$IE11OrLess && !$864e3137db0bdda5$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $864e3137db0bdda5$var$_objectSpread2($864e3137db0bdda5$var$_objectSpread2({}, extraEventProperties), $864e3137db0bdda5$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $864e3137db0bdda5$var$_excluded = [
    "evt"
];
var $864e3137db0bdda5$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $864e3137db0bdda5$var$_objectWithoutProperties(_ref, $864e3137db0bdda5$var$_excluded);
    $864e3137db0bdda5$var$PluginManager.pluginEvent.bind($864e3137db0bdda5$export$31b3ca70d8f57423)(eventName, sortable, $864e3137db0bdda5$var$_objectSpread2({
        dragEl: $864e3137db0bdda5$var$dragEl,
        parentEl: $864e3137db0bdda5$var$parentEl,
        ghostEl: $864e3137db0bdda5$var$ghostEl,
        rootEl: $864e3137db0bdda5$var$rootEl,
        nextEl: $864e3137db0bdda5$var$nextEl,
        lastDownEl: $864e3137db0bdda5$var$lastDownEl,
        cloneEl: $864e3137db0bdda5$var$cloneEl,
        cloneHidden: $864e3137db0bdda5$var$cloneHidden,
        dragStarted: $864e3137db0bdda5$var$moved,
        putSortable: $864e3137db0bdda5$var$putSortable,
        activeSortable: $864e3137db0bdda5$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $864e3137db0bdda5$var$oldIndex,
        oldDraggableIndex: $864e3137db0bdda5$var$oldDraggableIndex,
        newIndex: $864e3137db0bdda5$var$newIndex,
        newDraggableIndex: $864e3137db0bdda5$var$newDraggableIndex,
        hideGhostForTarget: $864e3137db0bdda5$var$_hideGhostForTarget,
        unhideGhostForTarget: $864e3137db0bdda5$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $864e3137db0bdda5$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $864e3137db0bdda5$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $864e3137db0bdda5$var$_dispatchEvent(info) {
    $864e3137db0bdda5$var$dispatchEvent($864e3137db0bdda5$var$_objectSpread2({
        putSortable: $864e3137db0bdda5$var$putSortable,
        cloneEl: $864e3137db0bdda5$var$cloneEl,
        targetEl: $864e3137db0bdda5$var$dragEl,
        rootEl: $864e3137db0bdda5$var$rootEl,
        oldIndex: $864e3137db0bdda5$var$oldIndex,
        oldDraggableIndex: $864e3137db0bdda5$var$oldDraggableIndex,
        newIndex: $864e3137db0bdda5$var$newIndex,
        newDraggableIndex: $864e3137db0bdda5$var$newDraggableIndex
    }, info));
}
var $864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$parentEl, $864e3137db0bdda5$var$ghostEl, $864e3137db0bdda5$var$rootEl, $864e3137db0bdda5$var$nextEl, $864e3137db0bdda5$var$lastDownEl, $864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$cloneHidden, $864e3137db0bdda5$var$oldIndex, $864e3137db0bdda5$var$newIndex, $864e3137db0bdda5$var$oldDraggableIndex, $864e3137db0bdda5$var$newDraggableIndex, $864e3137db0bdda5$var$activeGroup, $864e3137db0bdda5$var$putSortable, $864e3137db0bdda5$var$awaitingDragStarted = false, $864e3137db0bdda5$var$ignoreNextClick = false, $864e3137db0bdda5$var$sortables = [], $864e3137db0bdda5$var$tapEvt, $864e3137db0bdda5$var$touchEvt, $864e3137db0bdda5$var$lastDx, $864e3137db0bdda5$var$lastDy, $864e3137db0bdda5$var$tapDistanceLeft, $864e3137db0bdda5$var$tapDistanceTop, $864e3137db0bdda5$var$moved, $864e3137db0bdda5$var$lastTarget, $864e3137db0bdda5$var$lastDirection, $864e3137db0bdda5$var$pastFirstInvertThresh = false, $864e3137db0bdda5$var$isCircumstantialInvert = false, $864e3137db0bdda5$var$targetMoveDistance, // For positioning ghost absolutely
$864e3137db0bdda5$var$ghostRelativeParent, $864e3137db0bdda5$var$ghostRelativeParentInitialScroll = [], // (left, top)
$864e3137db0bdda5$var$_silent = false, $864e3137db0bdda5$var$savedInputChecked = [];
/** @const */ var $864e3137db0bdda5$var$documentExists = typeof document !== "undefined", $864e3137db0bdda5$var$PositionGhostAbsolutely = $864e3137db0bdda5$var$IOS, $864e3137db0bdda5$var$CSSFloatProperty = $864e3137db0bdda5$var$Edge || $864e3137db0bdda5$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$864e3137db0bdda5$var$supportDraggable = $864e3137db0bdda5$var$documentExists && !$864e3137db0bdda5$var$ChromeForAndroid && !$864e3137db0bdda5$var$IOS && "draggable" in document.createElement("div"), $864e3137db0bdda5$var$supportCssPointerEvents = function() {
    if (!$864e3137db0bdda5$var$documentExists) return;
    // false when <= IE11
    if ($864e3137db0bdda5$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $864e3137db0bdda5$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $864e3137db0bdda5$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $864e3137db0bdda5$var$getChild(el, 0, options), child2 = $864e3137db0bdda5$var$getChild(el, 1, options), firstChildCSS = child1 && $864e3137db0bdda5$var$css(child1), secondChildCSS = child2 && $864e3137db0bdda5$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $864e3137db0bdda5$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $864e3137db0bdda5$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$864e3137db0bdda5$var$CSSFloatProperty] === "none" || child2 && elCSS[$864e3137db0bdda5$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $864e3137db0bdda5$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $864e3137db0bdda5$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $864e3137db0bdda5$var$sortables.some(function(sortable) {
        var threshold = sortable[$864e3137db0bdda5$var$expando].options.emptyInsertThreshold;
        if (!threshold || $864e3137db0bdda5$var$lastChild(sortable)) return;
        var rect = $864e3137db0bdda5$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $864e3137db0bdda5$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $864e3137db0bdda5$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $864e3137db0bdda5$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$864e3137db0bdda5$var$supportCssPointerEvents && $864e3137db0bdda5$var$ghostEl) $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "display", "none");
}, $864e3137db0bdda5$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$864e3137db0bdda5$var$supportCssPointerEvents && $864e3137db0bdda5$var$ghostEl) $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($864e3137db0bdda5$var$documentExists && !$864e3137db0bdda5$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($864e3137db0bdda5$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $864e3137db0bdda5$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($864e3137db0bdda5$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $864e3137db0bdda5$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$864e3137db0bdda5$var$expando]._onDragOver(event);
        }
    }
};
var $864e3137db0bdda5$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($864e3137db0bdda5$var$dragEl) $864e3137db0bdda5$var$dragEl.parentNode[$864e3137db0bdda5$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $864e3137db0bdda5$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $864e3137db0bdda5$var$_extends({}, options);
    // Export instance
    el[$864e3137db0bdda5$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $864e3137db0bdda5$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $864e3137db0bdda5$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$864e3137db0bdda5$var$Safari,
        emptyInsertThreshold: 5
    };
    $864e3137db0bdda5$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $864e3137db0bdda5$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $864e3137db0bdda5$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $864e3137db0bdda5$var$on(el, "pointerdown", this._onTapStart);
    else {
        $864e3137db0bdda5$var$on(el, "mousedown", this._onTapStart);
        $864e3137db0bdda5$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $864e3137db0bdda5$var$on(el, "dragover", this);
        $864e3137db0bdda5$var$on(el, "dragenter", this);
    }
    $864e3137db0bdda5$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $864e3137db0bdda5$var$_extends(this, $864e3137db0bdda5$var$AnimationStateManager());
}
$864e3137db0bdda5$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $864e3137db0bdda5$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $864e3137db0bdda5$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $864e3137db0bdda5$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $864e3137db0bdda5$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($864e3137db0bdda5$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $864e3137db0bdda5$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $864e3137db0bdda5$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($864e3137db0bdda5$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $864e3137db0bdda5$var$oldIndex = $864e3137db0bdda5$var$index(target);
        $864e3137db0bdda5$var$oldDraggableIndex = $864e3137db0bdda5$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $864e3137db0bdda5$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $864e3137db0bdda5$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $864e3137db0bdda5$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $864e3137db0bdda5$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $864e3137db0bdda5$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$864e3137db0bdda5$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$864e3137db0bdda5$var$dragEl && target.parentNode === el) {
            var dragRect = $864e3137db0bdda5$var$getRect(target);
            $864e3137db0bdda5$var$rootEl = el;
            $864e3137db0bdda5$var$dragEl = target;
            $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$dragEl.parentNode;
            $864e3137db0bdda5$var$nextEl = $864e3137db0bdda5$var$dragEl.nextSibling;
            $864e3137db0bdda5$var$lastDownEl = target;
            $864e3137db0bdda5$var$activeGroup = options.group;
            $864e3137db0bdda5$export$31b3ca70d8f57423.dragged = $864e3137db0bdda5$var$dragEl;
            $864e3137db0bdda5$var$tapEvt = {
                target: $864e3137db0bdda5$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $864e3137db0bdda5$var$tapDistanceLeft = $864e3137db0bdda5$var$tapEvt.clientX - dragRect.left;
            $864e3137db0bdda5$var$tapDistanceTop = $864e3137db0bdda5$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $864e3137db0bdda5$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $864e3137db0bdda5$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$864e3137db0bdda5$var$FireFox && _this.nativeDraggable) $864e3137db0bdda5$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $864e3137db0bdda5$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $864e3137db0bdda5$var$find($864e3137db0bdda5$var$dragEl, criteria.trim(), $864e3137db0bdda5$var$_disableDraggable);
            });
            $864e3137db0bdda5$var$on(ownerDocument, "dragover", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
            $864e3137db0bdda5$var$on(ownerDocument, "mousemove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
            $864e3137db0bdda5$var$on(ownerDocument, "touchmove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
            $864e3137db0bdda5$var$on(ownerDocument, "mouseup", _this._onDrop);
            $864e3137db0bdda5$var$on(ownerDocument, "touchend", _this._onDrop);
            $864e3137db0bdda5$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($864e3137db0bdda5$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $864e3137db0bdda5$var$dragEl.draggable = true;
            }
            $864e3137db0bdda5$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($864e3137db0bdda5$var$Edge || $864e3137db0bdda5$var$IE11OrLess))) {
                if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $864e3137db0bdda5$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $864e3137db0bdda5$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $864e3137db0bdda5$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $864e3137db0bdda5$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $864e3137db0bdda5$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $864e3137db0bdda5$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $864e3137db0bdda5$var$dragEl && $864e3137db0bdda5$var$_disableDraggable($864e3137db0bdda5$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $864e3137db0bdda5$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $864e3137db0bdda5$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $864e3137db0bdda5$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $864e3137db0bdda5$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $864e3137db0bdda5$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $864e3137db0bdda5$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $864e3137db0bdda5$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $864e3137db0bdda5$var$on(document, "touchmove", this._onTouchMove);
            else $864e3137db0bdda5$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $864e3137db0bdda5$var$on($864e3137db0bdda5$var$dragEl, "dragend", this);
            $864e3137db0bdda5$var$on($864e3137db0bdda5$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $864e3137db0bdda5$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $864e3137db0bdda5$var$awaitingDragStarted = false;
        if ($864e3137db0bdda5$var$rootEl && $864e3137db0bdda5$var$dragEl) {
            $864e3137db0bdda5$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $864e3137db0bdda5$var$on(document, "dragover", $864e3137db0bdda5$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.dragClass, false);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.ghostClass, true);
            $864e3137db0bdda5$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($864e3137db0bdda5$var$touchEvt) {
            this._lastX = $864e3137db0bdda5$var$touchEvt.clientX;
            this._lastY = $864e3137db0bdda5$var$touchEvt.clientY;
            $864e3137db0bdda5$var$_hideGhostForTarget();
            var target = document.elementFromPoint($864e3137db0bdda5$var$touchEvt.clientX, $864e3137db0bdda5$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($864e3137db0bdda5$var$touchEvt.clientX, $864e3137db0bdda5$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $864e3137db0bdda5$var$dragEl.parentNode[$864e3137db0bdda5$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$864e3137db0bdda5$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$864e3137db0bdda5$var$expando]._onDragOver({
                        clientX: $864e3137db0bdda5$var$touchEvt.clientX,
                        clientY: $864e3137db0bdda5$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $864e3137db0bdda5$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($864e3137db0bdda5$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $864e3137db0bdda5$var$ghostEl && $864e3137db0bdda5$var$matrix($864e3137db0bdda5$var$ghostEl, true), scaleX = $864e3137db0bdda5$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $864e3137db0bdda5$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $864e3137db0bdda5$var$PositionGhostAbsolutely && $864e3137db0bdda5$var$ghostRelativeParent && $864e3137db0bdda5$var$getRelativeScrollOffset($864e3137db0bdda5$var$ghostRelativeParent), dx = (touch.clientX - $864e3137db0bdda5$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $864e3137db0bdda5$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $864e3137db0bdda5$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $864e3137db0bdda5$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$864e3137db0bdda5$export$31b3ca70d8f57423.active && !$864e3137db0bdda5$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($864e3137db0bdda5$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($864e3137db0bdda5$var$lastDx || 0);
                    ghostMatrix.f += dy - ($864e3137db0bdda5$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "webkitTransform", cssMatrix);
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "mozTransform", cssMatrix);
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "msTransform", cssMatrix);
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transform", cssMatrix);
                $864e3137db0bdda5$var$lastDx = dx;
                $864e3137db0bdda5$var$lastDy = dy;
                $864e3137db0bdda5$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$864e3137db0bdda5$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $864e3137db0bdda5$var$rootEl, rect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl, true, $864e3137db0bdda5$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($864e3137db0bdda5$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $864e3137db0bdda5$var$ghostRelativeParent = container;
                while($864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostRelativeParent, "position") === "static" && $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostRelativeParent, "transform") === "none" && $864e3137db0bdda5$var$ghostRelativeParent !== document)$864e3137db0bdda5$var$ghostRelativeParent = $864e3137db0bdda5$var$ghostRelativeParent.parentNode;
                if ($864e3137db0bdda5$var$ghostRelativeParent !== document.body && $864e3137db0bdda5$var$ghostRelativeParent !== document.documentElement) {
                    if ($864e3137db0bdda5$var$ghostRelativeParent === document) $864e3137db0bdda5$var$ghostRelativeParent = $864e3137db0bdda5$var$getWindowScrollingElement();
                    rect.top += $864e3137db0bdda5$var$ghostRelativeParent.scrollTop;
                    rect.left += $864e3137db0bdda5$var$ghostRelativeParent.scrollLeft;
                } else $864e3137db0bdda5$var$ghostRelativeParent = $864e3137db0bdda5$var$getWindowScrollingElement();
                $864e3137db0bdda5$var$ghostRelativeParentInitialScroll = $864e3137db0bdda5$var$getRelativeScrollOffset($864e3137db0bdda5$var$ghostRelativeParent);
            }
            $864e3137db0bdda5$var$ghostEl = $864e3137db0bdda5$var$dragEl.cloneNode(true);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$ghostEl, options.ghostClass, false);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$ghostEl, options.fallbackClass, true);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$ghostEl, options.dragClass, true);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transition", "");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transform", "");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "box-sizing", "border-box");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "margin", 0);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "top", rect.top);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "left", rect.left);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "width", rect.width);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "height", rect.height);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "opacity", "0.8");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "position", $864e3137db0bdda5$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "zIndex", "100000");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "pointerEvents", "none");
            $864e3137db0bdda5$export$31b3ca70d8f57423.ghost = $864e3137db0bdda5$var$ghostEl;
            container.appendChild($864e3137db0bdda5$var$ghostEl);
            // Set transform-origin
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transform-origin", $864e3137db0bdda5$var$tapDistanceLeft / parseInt($864e3137db0bdda5$var$ghostEl.style.width) * 100 + "% " + $864e3137db0bdda5$var$tapDistanceTop / parseInt($864e3137db0bdda5$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $864e3137db0bdda5$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $864e3137db0bdda5$var$pluginEvent("setupClone", this);
        if (!$864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
            $864e3137db0bdda5$var$cloneEl = $864e3137db0bdda5$var$clone($864e3137db0bdda5$var$dragEl);
            $864e3137db0bdda5$var$cloneEl.removeAttribute("id");
            $864e3137db0bdda5$var$cloneEl.draggable = false;
            $864e3137db0bdda5$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$cloneEl, this.options.chosenClass, false);
            $864e3137db0bdda5$export$31b3ca70d8f57423.clone = $864e3137db0bdda5$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $864e3137db0bdda5$var$_nextTick(function() {
            $864e3137db0bdda5$var$pluginEvent("clone", _this);
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$dragEl);
            _this._hideClone();
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $864e3137db0bdda5$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $864e3137db0bdda5$var$off(document, "mouseup", _this._onDrop);
            $864e3137db0bdda5$var$off(document, "touchend", _this._onDrop);
            $864e3137db0bdda5$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $864e3137db0bdda5$var$dragEl);
            }
            $864e3137db0bdda5$var$on(document, "drop", _this);
            // #1276 fix:
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$dragEl, "transform", "translateZ(0)");
        }
        $864e3137db0bdda5$var$awaitingDragStarted = true;
        _this._dragStartId = $864e3137db0bdda5$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $864e3137db0bdda5$var$on(document, "selectstart", _this);
        $864e3137db0bdda5$var$moved = true;
        if ($864e3137db0bdda5$var$Safari) $864e3137db0bdda5$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $864e3137db0bdda5$export$31b3ca70d8f57423.active, isOwner = $864e3137db0bdda5$var$activeGroup === group, canSort = options.sort, fromSortable = $864e3137db0bdda5$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($864e3137db0bdda5$var$_silent) return;
        function dragOverEvent(name, extra) {
            $864e3137db0bdda5$var$pluginEvent(name, _this, $864e3137db0bdda5$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, $864e3137db0bdda5$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$putSortable ? $864e3137db0bdda5$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.ghostClass, true);
                }
                if ($864e3137db0bdda5$var$putSortable !== _this && _this !== $864e3137db0bdda5$export$31b3ca70d8f57423.active) $864e3137db0bdda5$var$putSortable = _this;
                else if (_this === $864e3137db0bdda5$export$31b3ca70d8f57423.active && $864e3137db0bdda5$var$putSortable) $864e3137db0bdda5$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $864e3137db0bdda5$var$dragEl && !$864e3137db0bdda5$var$dragEl.animated || target === el && !target.animated) $864e3137db0bdda5$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $864e3137db0bdda5$var$dragEl.parentNode[$864e3137db0bdda5$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
            $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl, options.draggable);
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $864e3137db0bdda5$var$newIndex,
                newDraggableIndex: $864e3137db0bdda5$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $864e3137db0bdda5$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($864e3137db0bdda5$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $864e3137db0bdda5$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $864e3137db0bdda5$var$parentEl !== $864e3137db0bdda5$var$rootEl // Reverting item into the original list
        ) : $864e3137db0bdda5$var$putSortable === this || (this.lastPutMode = $864e3137db0bdda5$var$activeGroup.checkPull(this, activeSortable, $864e3137db0bdda5$var$dragEl, evt)) && group.checkPut(this, activeSortable, $864e3137db0bdda5$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
                    if ($864e3137db0bdda5$var$nextEl) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$nextEl);
                    else $864e3137db0bdda5$var$rootEl.appendChild($864e3137db0bdda5$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $864e3137db0bdda5$var$lastChild(el, options.draggable);
            if (!elLastChild || $864e3137db0bdda5$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $864e3137db0bdda5$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $864e3137db0bdda5$var$getRect(target);
                if ($864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($864e3137db0bdda5$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($864e3137db0bdda5$var$dragEl);
                    $864e3137db0bdda5$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $864e3137db0bdda5$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $864e3137db0bdda5$var$getChild(el, 0, options, true);
                if (firstChild === $864e3137db0bdda5$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $864e3137db0bdda5$var$getRect(target);
                if ($864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($864e3137db0bdda5$var$dragEl, firstChild);
                    $864e3137db0bdda5$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $864e3137db0bdda5$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $864e3137db0bdda5$var$dragEl.parentNode !== el, differentRowCol = !$864e3137db0bdda5$var$_dragElInRowColumn($864e3137db0bdda5$var$dragEl.animated && $864e3137db0bdda5$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $864e3137db0bdda5$var$isScrolledPast(target, "top", "top") || $864e3137db0bdda5$var$isScrolledPast($864e3137db0bdda5$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($864e3137db0bdda5$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $864e3137db0bdda5$var$pastFirstInvertThresh = false;
                    $864e3137db0bdda5$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $864e3137db0bdda5$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $864e3137db0bdda5$var$isCircumstantialInvert, $864e3137db0bdda5$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $864e3137db0bdda5$var$parentEl.children[dragIndex];
                    }while (sibling && ($864e3137db0bdda5$var$css(sibling, "display") === "none" || sibling === $864e3137db0bdda5$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $864e3137db0bdda5$var$lastTarget = target;
                $864e3137db0bdda5$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $864e3137db0bdda5$var$_silent = true;
                    setTimeout($864e3137db0bdda5$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($864e3137db0bdda5$var$dragEl);
                    else target.parentNode.insertBefore($864e3137db0bdda5$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $864e3137db0bdda5$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$864e3137db0bdda5$var$isCircumstantialInvert) $864e3137db0bdda5$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $864e3137db0bdda5$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($864e3137db0bdda5$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $864e3137db0bdda5$var$off(document, "mousemove", this._onTouchMove);
        $864e3137db0bdda5$var$off(document, "touchmove", this._onTouchMove);
        $864e3137db0bdda5$var$off(document, "pointermove", this._onTouchMove);
        $864e3137db0bdda5$var$off(document, "dragover", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
        $864e3137db0bdda5$var$off(document, "mousemove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
        $864e3137db0bdda5$var$off(document, "touchmove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $864e3137db0bdda5$var$off(ownerDocument, "mouseup", this._onDrop);
        $864e3137db0bdda5$var$off(ownerDocument, "touchend", this._onDrop);
        $864e3137db0bdda5$var$off(ownerDocument, "pointerup", this._onDrop);
        $864e3137db0bdda5$var$off(ownerDocument, "touchcancel", this._onDrop);
        $864e3137db0bdda5$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
        $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl, options.draggable);
        $864e3137db0bdda5$var$pluginEvent("drop", this, {
            evt: evt
        });
        $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$dragEl && $864e3137db0bdda5$var$dragEl.parentNode;
        // Get again after plugin event
        $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
        $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl, options.draggable);
        if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $864e3137db0bdda5$var$awaitingDragStarted = false;
        $864e3137db0bdda5$var$isCircumstantialInvert = false;
        $864e3137db0bdda5$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $864e3137db0bdda5$var$_cancelNextTick(this.cloneId);
        $864e3137db0bdda5$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $864e3137db0bdda5$var$off(document, "drop", this);
            $864e3137db0bdda5$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($864e3137db0bdda5$var$Safari) $864e3137db0bdda5$var$css(document.body, "user-select", "");
        $864e3137db0bdda5$var$css($864e3137db0bdda5$var$dragEl, "transform", "");
        if (evt) {
            if ($864e3137db0bdda5$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $864e3137db0bdda5$var$ghostEl && $864e3137db0bdda5$var$ghostEl.parentNode && $864e3137db0bdda5$var$ghostEl.parentNode.removeChild($864e3137db0bdda5$var$ghostEl);
            if ($864e3137db0bdda5$var$rootEl === $864e3137db0bdda5$var$parentEl || $864e3137db0bdda5$var$putSortable && $864e3137db0bdda5$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $864e3137db0bdda5$var$cloneEl && $864e3137db0bdda5$var$cloneEl.parentNode && $864e3137db0bdda5$var$cloneEl.parentNode.removeChild($864e3137db0bdda5$var$cloneEl);
            if ($864e3137db0bdda5$var$dragEl) {
                if (this.nativeDraggable) $864e3137db0bdda5$var$off($864e3137db0bdda5$var$dragEl, "dragend", this);
                $864e3137db0bdda5$var$_disableDraggable($864e3137db0bdda5$var$dragEl);
                $864e3137db0bdda5$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($864e3137db0bdda5$var$moved && !$864e3137db0bdda5$var$awaitingDragStarted) $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$putSortable ? $864e3137db0bdda5$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $864e3137db0bdda5$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $864e3137db0bdda5$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($864e3137db0bdda5$var$rootEl !== $864e3137db0bdda5$var$parentEl) {
                    if ($864e3137db0bdda5$var$newIndex >= 0) {
                        // Add event
                        $864e3137db0bdda5$var$_dispatchEvent({
                            rootEl: $864e3137db0bdda5$var$parentEl,
                            name: "add",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            fromEl: $864e3137db0bdda5$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $864e3137db0bdda5$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $864e3137db0bdda5$var$_dispatchEvent({
                            rootEl: $864e3137db0bdda5$var$parentEl,
                            name: "sort",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            fromEl: $864e3137db0bdda5$var$rootEl,
                            originalEvent: evt
                        });
                        $864e3137db0bdda5$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $864e3137db0bdda5$var$putSortable && $864e3137db0bdda5$var$putSortable.save();
                } else {
                    if ($864e3137db0bdda5$var$newIndex !== $864e3137db0bdda5$var$oldIndex) {
                        if ($864e3137db0bdda5$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $864e3137db0bdda5$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $864e3137db0bdda5$var$parentEl,
                                originalEvent: evt
                            });
                            $864e3137db0bdda5$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $864e3137db0bdda5$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($864e3137db0bdda5$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($864e3137db0bdda5$var$newIndex == null || $864e3137db0bdda5$var$newIndex === -1) {
                        $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$oldIndex;
                        $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$oldDraggableIndex;
                    }
                    $864e3137db0bdda5$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $864e3137db0bdda5$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $864e3137db0bdda5$var$pluginEvent("nulling", this);
        $864e3137db0bdda5$var$rootEl = $864e3137db0bdda5$var$dragEl = $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$ghostEl = $864e3137db0bdda5$var$nextEl = $864e3137db0bdda5$var$cloneEl = $864e3137db0bdda5$var$lastDownEl = $864e3137db0bdda5$var$cloneHidden = $864e3137db0bdda5$var$tapEvt = $864e3137db0bdda5$var$touchEvt = $864e3137db0bdda5$var$moved = $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$oldIndex = $864e3137db0bdda5$var$oldDraggableIndex = $864e3137db0bdda5$var$lastTarget = $864e3137db0bdda5$var$lastDirection = $864e3137db0bdda5$var$putSortable = $864e3137db0bdda5$var$activeGroup = $864e3137db0bdda5$export$31b3ca70d8f57423.dragged = $864e3137db0bdda5$export$31b3ca70d8f57423.ghost = $864e3137db0bdda5$export$31b3ca70d8f57423.clone = $864e3137db0bdda5$export$31b3ca70d8f57423.active = null;
        $864e3137db0bdda5$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $864e3137db0bdda5$var$savedInputChecked.length = $864e3137db0bdda5$var$lastDx = $864e3137db0bdda5$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($864e3137db0bdda5$var$dragEl) {
                    this._onDragOver(evt);
                    $864e3137db0bdda5$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($864e3137db0bdda5$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $864e3137db0bdda5$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($864e3137db0bdda5$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $864e3137db0bdda5$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $864e3137db0bdda5$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $864e3137db0bdda5$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $864e3137db0bdda5$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$864e3137db0bdda5$var$expando] = null;
        $864e3137db0bdda5$var$off(el, "mousedown", this._onTapStart);
        $864e3137db0bdda5$var$off(el, "touchstart", this._onTapStart);
        $864e3137db0bdda5$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $864e3137db0bdda5$var$off(el, "dragover", this);
            $864e3137db0bdda5$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $864e3137db0bdda5$var$sortables.splice($864e3137db0bdda5$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$864e3137db0bdda5$var$cloneHidden) {
            $864e3137db0bdda5$var$pluginEvent("hideClone", this);
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return;
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $864e3137db0bdda5$var$cloneEl.parentNode) $864e3137db0bdda5$var$cloneEl.parentNode.removeChild($864e3137db0bdda5$var$cloneEl);
            $864e3137db0bdda5$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($864e3137db0bdda5$var$cloneHidden) {
            $864e3137db0bdda5$var$pluginEvent("showClone", this);
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($864e3137db0bdda5$var$dragEl.parentNode == $864e3137db0bdda5$var$rootEl && !this.options.group.revertClone) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$dragEl);
            else if ($864e3137db0bdda5$var$nextEl) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$nextEl);
            else $864e3137db0bdda5$var$rootEl.appendChild($864e3137db0bdda5$var$cloneEl);
            if (this.options.group.revertClone) this.animate($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$cloneEl);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$cloneEl, "display", "");
            $864e3137db0bdda5$var$cloneHidden = false;
        }
    }
};
function $864e3137db0bdda5$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $864e3137db0bdda5$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$864e3137db0bdda5$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$864e3137db0bdda5$var$IE11OrLess && !$864e3137db0bdda5$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $864e3137db0bdda5$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $864e3137db0bdda5$var$_disableDraggable(el) {
    el.draggable = false;
}
function $864e3137db0bdda5$var$_unsilent() {
    $864e3137db0bdda5$var$_silent = false;
}
function $864e3137db0bdda5$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $864e3137db0bdda5$var$getChildContainingRectFromElement(sortable.el, sortable.options, $864e3137db0bdda5$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $864e3137db0bdda5$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $864e3137db0bdda5$var$getChildContainingRectFromElement(sortable.el, sortable.options, $864e3137db0bdda5$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $864e3137db0bdda5$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $864e3137db0bdda5$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$864e3137db0bdda5$var$pastFirstInvertThresh && ($864e3137db0bdda5$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $864e3137db0bdda5$var$pastFirstInvertThresh = true;
            if (!$864e3137db0bdda5$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($864e3137db0bdda5$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $864e3137db0bdda5$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $864e3137db0bdda5$var$targetMoveDistance) return -$864e3137db0bdda5$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $864e3137db0bdda5$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $864e3137db0bdda5$var$_getInsertDirection(target) {
    if ($864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl) < $864e3137db0bdda5$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $864e3137db0bdda5$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $864e3137db0bdda5$var$_saveInputCheckedState(root) {
    $864e3137db0bdda5$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $864e3137db0bdda5$var$savedInputChecked.push(el);
    }
}
function $864e3137db0bdda5$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $864e3137db0bdda5$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($864e3137db0bdda5$var$documentExists) $864e3137db0bdda5$var$on(document, "touchmove", function(evt) {
    if (($864e3137db0bdda5$export$31b3ca70d8f57423.active || $864e3137db0bdda5$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$864e3137db0bdda5$export$31b3ca70d8f57423.utils = {
    on: $864e3137db0bdda5$var$on,
    off: $864e3137db0bdda5$var$off,
    css: $864e3137db0bdda5$var$css,
    find: $864e3137db0bdda5$var$find,
    is: function is(el, selector) {
        return !!$864e3137db0bdda5$var$closest(el, selector, el, false);
    },
    extend: $864e3137db0bdda5$var$extend,
    throttle: $864e3137db0bdda5$var$throttle,
    closest: $864e3137db0bdda5$var$closest,
    toggleClass: $864e3137db0bdda5$var$toggleClass,
    clone: $864e3137db0bdda5$var$clone,
    index: $864e3137db0bdda5$var$index,
    nextTick: $864e3137db0bdda5$var$_nextTick,
    cancelNextTick: $864e3137db0bdda5$var$_cancelNextTick,
    detectDirection: $864e3137db0bdda5$var$_detectDirection,
    getChild: $864e3137db0bdda5$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $864e3137db0bdda5$export$31b3ca70d8f57423.get = function(element) {
    return element[$864e3137db0bdda5$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $864e3137db0bdda5$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $864e3137db0bdda5$export$31b3ca70d8f57423.utils = $864e3137db0bdda5$var$_objectSpread2($864e3137db0bdda5$var$_objectSpread2({}, $864e3137db0bdda5$export$31b3ca70d8f57423.utils), plugin.utils);
        $864e3137db0bdda5$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $864e3137db0bdda5$export$31b3ca70d8f57423.create = function(el, options) {
    return new $864e3137db0bdda5$export$31b3ca70d8f57423(el, options);
};
// Export
$864e3137db0bdda5$export$31b3ca70d8f57423.version = $864e3137db0bdda5$var$version;
var $864e3137db0bdda5$var$autoScrolls = [], $864e3137db0bdda5$var$scrollEl, $864e3137db0bdda5$var$scrollRootEl, $864e3137db0bdda5$var$scrolling = false, $864e3137db0bdda5$var$lastAutoScrollX, $864e3137db0bdda5$var$lastAutoScrollY, $864e3137db0bdda5$var$touchEvt$1, $864e3137db0bdda5$var$pointerElemChangedInterval;
function $864e3137db0bdda5$export$3fb39aee5567f02e() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $864e3137db0bdda5$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $864e3137db0bdda5$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $864e3137db0bdda5$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $864e3137db0bdda5$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $864e3137db0bdda5$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $864e3137db0bdda5$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $864e3137db0bdda5$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $864e3137db0bdda5$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $864e3137db0bdda5$var$clearPointerElemChangedInterval();
            $864e3137db0bdda5$var$clearAutoScrolls();
            $864e3137db0bdda5$var$cancelThrottle();
        },
        nulling: function nulling() {
            $864e3137db0bdda5$var$touchEvt$1 = $864e3137db0bdda5$var$scrollRootEl = $864e3137db0bdda5$var$scrollEl = $864e3137db0bdda5$var$scrolling = $864e3137db0bdda5$var$pointerElemChangedInterval = $864e3137db0bdda5$var$lastAutoScrollX = $864e3137db0bdda5$var$lastAutoScrollY = null;
            $864e3137db0bdda5$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $864e3137db0bdda5$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $864e3137db0bdda5$var$Edge || $864e3137db0bdda5$var$IE11OrLess || $864e3137db0bdda5$var$Safari) {
                $864e3137db0bdda5$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $864e3137db0bdda5$var$getParentAutoScrollElement(elem, true);
                if ($864e3137db0bdda5$var$scrolling && (!$864e3137db0bdda5$var$pointerElemChangedInterval || x !== $864e3137db0bdda5$var$lastAutoScrollX || y !== $864e3137db0bdda5$var$lastAutoScrollY)) {
                    $864e3137db0bdda5$var$pointerElemChangedInterval && $864e3137db0bdda5$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $864e3137db0bdda5$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $864e3137db0bdda5$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $864e3137db0bdda5$var$clearAutoScrolls();
                        }
                        $864e3137db0bdda5$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $864e3137db0bdda5$var$lastAutoScrollX = x;
                    $864e3137db0bdda5$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $864e3137db0bdda5$var$getParentAutoScrollElement(elem, true) === $864e3137db0bdda5$var$getWindowScrollingElement()) {
                    $864e3137db0bdda5$var$clearAutoScrolls();
                    return;
                }
                $864e3137db0bdda5$var$autoScroll(evt, this.options, $864e3137db0bdda5$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $864e3137db0bdda5$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $864e3137db0bdda5$var$clearAutoScrolls() {
    $864e3137db0bdda5$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $864e3137db0bdda5$var$autoScrolls = [];
}
function $864e3137db0bdda5$var$clearPointerElemChangedInterval() {
    clearInterval($864e3137db0bdda5$var$pointerElemChangedInterval);
}
var $864e3137db0bdda5$var$autoScroll = $864e3137db0bdda5$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $864e3137db0bdda5$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($864e3137db0bdda5$var$scrollRootEl !== rootEl) {
        $864e3137db0bdda5$var$scrollRootEl = rootEl;
        $864e3137db0bdda5$var$clearAutoScrolls();
        $864e3137db0bdda5$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($864e3137db0bdda5$var$scrollEl === true) $864e3137db0bdda5$var$scrollEl = $864e3137db0bdda5$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $864e3137db0bdda5$var$scrollEl;
    do {
        var el = currentParent, rect = $864e3137db0bdda5$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $864e3137db0bdda5$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$864e3137db0bdda5$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$864e3137db0bdda5$var$autoScrolls[i]) $864e3137db0bdda5$var$autoScrolls[i] = {};
        }
        if ($864e3137db0bdda5$var$autoScrolls[layersOut].vx != vx || $864e3137db0bdda5$var$autoScrolls[layersOut].vy != vy || $864e3137db0bdda5$var$autoScrolls[layersOut].el !== el) {
            $864e3137db0bdda5$var$autoScrolls[layersOut].el = el;
            $864e3137db0bdda5$var$autoScrolls[layersOut].vx = vx;
            $864e3137db0bdda5$var$autoScrolls[layersOut].vy = vy;
            clearInterval($864e3137db0bdda5$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $864e3137db0bdda5$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $864e3137db0bdda5$export$31b3ca70d8f57423.active._onTouchMove($864e3137db0bdda5$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $864e3137db0bdda5$var$autoScrolls[this.layer].vy ? $864e3137db0bdda5$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $864e3137db0bdda5$var$autoScrolls[this.layer].vx ? $864e3137db0bdda5$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($864e3137db0bdda5$export$31b3ca70d8f57423.dragged.parentNode[$864e3137db0bdda5$var$expando], scrollOffsetX, scrollOffsetY, evt, $864e3137db0bdda5$var$touchEvt$1, $864e3137db0bdda5$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $864e3137db0bdda5$var$scrollBy($864e3137db0bdda5$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $864e3137db0bdda5$var$getParentAutoScrollElement(currentParent, false)));
    $864e3137db0bdda5$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $864e3137db0bdda5$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $864e3137db0bdda5$var$Revert() {}
$864e3137db0bdda5$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $864e3137db0bdda5$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $864e3137db0bdda5$var$drop
};
$864e3137db0bdda5$var$_extends($864e3137db0bdda5$var$Revert, {
    pluginName: "revertOnSpill"
});
function $864e3137db0bdda5$var$Remove() {}
$864e3137db0bdda5$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $864e3137db0bdda5$var$drop
};
$864e3137db0bdda5$var$_extends($864e3137db0bdda5$var$Remove, {
    pluginName: "removeOnSpill"
});
var $864e3137db0bdda5$export$55b3d9f7b2513474 = [
    $864e3137db0bdda5$var$Remove,
    $864e3137db0bdda5$var$Revert
];
var $864e3137db0bdda5$var$lastSwapEl;
function $864e3137db0bdda5$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $864e3137db0bdda5$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $864e3137db0bdda5$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $864e3137db0bdda5$var$toggleClass(target, options.swapClass, true);
                    $864e3137db0bdda5$var$lastSwapEl = target;
                } else $864e3137db0bdda5$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $864e3137db0bdda5$var$lastSwapEl) $864e3137db0bdda5$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $864e3137db0bdda5$var$lastSwapEl && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$lastSwapEl, options.swapClass, false);
            if ($864e3137db0bdda5$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $864e3137db0bdda5$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $864e3137db0bdda5$var$swapNodes(dragEl, $864e3137db0bdda5$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $864e3137db0bdda5$var$lastSwapEl = null;
        }
    };
    return $864e3137db0bdda5$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $864e3137db0bdda5$var$lastSwapEl
            };
        }
    });
}
function $864e3137db0bdda5$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $864e3137db0bdda5$var$index(n1);
    i2 = $864e3137db0bdda5$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $864e3137db0bdda5$var$multiDragElements = [], $864e3137db0bdda5$var$multiDragClones = [], $864e3137db0bdda5$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$864e3137db0bdda5$var$multiDragSortable, $864e3137db0bdda5$var$initialFolding = false, // Initial multi-drag fold when drag started
$864e3137db0bdda5$var$folding = false, // Folding any other time
$864e3137db0bdda5$var$dragStarted = false, $864e3137db0bdda5$var$dragEl$1, $864e3137db0bdda5$var$clonesFromRect, $864e3137db0bdda5$var$clonesHidden;
function $864e3137db0bdda5$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $864e3137db0bdda5$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $864e3137db0bdda5$var$on(document, "mouseup", this._deselectMultiDrag);
                $864e3137db0bdda5$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $864e3137db0bdda5$var$on(document, "keydown", this._checkKeyDown);
        $864e3137db0bdda5$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($864e3137db0bdda5$var$multiDragElements.length && $864e3137db0bdda5$var$multiDragSortable === sortable) $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $864e3137db0bdda5$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $864e3137db0bdda5$var$multiDragElements.length; i++){
                $864e3137db0bdda5$var$multiDragClones.push($864e3137db0bdda5$var$clone($864e3137db0bdda5$var$multiDragElements[i]));
                $864e3137db0bdda5$var$multiDragClones[i].sortableIndex = $864e3137db0bdda5$var$multiDragElements[i].sortableIndex;
                $864e3137db0bdda5$var$multiDragClones[i].draggable = false;
                $864e3137db0bdda5$var$multiDragClones[i].style["will-change"] = "";
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$multiDragClones[i], this.options.selectedClass, false);
                $864e3137db0bdda5$var$multiDragElements[i] === $864e3137db0bdda5$var$dragEl$1 && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($864e3137db0bdda5$var$multiDragElements.length && $864e3137db0bdda5$var$multiDragSortable === sortable) {
                    $864e3137db0bdda5$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $864e3137db0bdda5$var$insertMultiDragClones(false, rootEl);
            $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                $864e3137db0bdda5$var$css(clone, "display", "");
            });
            cloneNowShown();
            $864e3137db0bdda5$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                $864e3137db0bdda5$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $864e3137db0bdda5$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $864e3137db0bdda5$var$multiDragSortable) $864e3137db0bdda5$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $864e3137db0bdda5$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $864e3137db0bdda5$var$multiDragElements = $864e3137db0bdda5$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $864e3137db0bdda5$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
                        $864e3137db0bdda5$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl$1, false, true, true);
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
                        $864e3137db0bdda5$var$setRect(multiDragElement, dragRect);
                    });
                    $864e3137db0bdda5$var$folding = true;
                    $864e3137db0bdda5$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $864e3137db0bdda5$var$folding = false;
                $864e3137db0bdda5$var$initialFolding = false;
                if (_this2.options.animation) $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                    $864e3137db0bdda5$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $864e3137db0bdda5$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($864e3137db0bdda5$var$folding && ~$864e3137db0bdda5$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($864e3137db0bdda5$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $864e3137db0bdda5$var$folding ? $864e3137db0bdda5$var$getRect(multiDragElement) : dragRect
                    });
                    $864e3137db0bdda5$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $864e3137db0bdda5$var$folding = false;
                $864e3137db0bdda5$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $864e3137db0bdda5$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $864e3137db0bdda5$var$multiDragElements.length > 1 && ($864e3137db0bdda5$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl$1, false, true, true);
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
                        $864e3137db0bdda5$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $864e3137db0bdda5$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$864e3137db0bdda5$var$folding) $864e3137db0bdda5$var$removeMultiDragElements();
                    if ($864e3137db0bdda5$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $864e3137db0bdda5$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$864e3137db0bdda5$var$clonesHidden && clonesHiddenBefore) $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $864e3137db0bdda5$var$clonesFromRect
                            });
                            clone.fromRect = $864e3137db0bdda5$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $864e3137db0bdda5$var$clonesFromRect = $864e3137db0bdda5$var$_extends({}, dragRect);
                var dragMatrix = $864e3137db0bdda5$var$matrix($864e3137db0bdda5$var$dragEl$1, true);
                $864e3137db0bdda5$var$clonesFromRect.top -= dragMatrix.f;
                $864e3137db0bdda5$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($864e3137db0bdda5$var$folding) {
                $864e3137db0bdda5$var$folding = false;
                $864e3137db0bdda5$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$864e3137db0bdda5$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl$1, options.selectedClass, !~$864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1));
                if (!~$864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1)) {
                    $864e3137db0bdda5$var$multiDragElements.push($864e3137db0bdda5$var$dragEl$1);
                    $864e3137db0bdda5$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $864e3137db0bdda5$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $864e3137db0bdda5$var$lastMultiDragSelect && sortable.el.contains($864e3137db0bdda5$var$lastMultiDragSelect)) {
                        var lastIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$lastMultiDragSelect), currentIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$864e3137db0bdda5$var$multiDragElements.indexOf(children[i])) continue;
                                $864e3137db0bdda5$var$toggleClass(children[i], options.selectedClass, true);
                                $864e3137db0bdda5$var$multiDragElements.push(children[i]);
                                $864e3137db0bdda5$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $864e3137db0bdda5$var$lastMultiDragSelect = $864e3137db0bdda5$var$dragEl$1;
                    $864e3137db0bdda5$var$multiDragSortable = toSortable;
                } else {
                    $864e3137db0bdda5$var$multiDragElements.splice($864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1), 1);
                    $864e3137db0bdda5$var$lastMultiDragSelect = null;
                    $864e3137db0bdda5$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $864e3137db0bdda5$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($864e3137db0bdda5$var$dragStarted && this.isMultiDrag) {
                $864e3137db0bdda5$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$864e3137db0bdda5$var$expando].options.sort || parentEl !== rootEl) && $864e3137db0bdda5$var$multiDragElements.length > 1) {
                    var dragRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl$1), multiDragIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$864e3137db0bdda5$var$initialFolding && options.animation) $864e3137db0bdda5$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$864e3137db0bdda5$var$initialFolding) {
                        if (options.animation) {
                            $864e3137db0bdda5$var$dragEl$1.fromRect = dragRect;
                            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $864e3137db0bdda5$var$dragEl$1) {
                                    var rect = $864e3137db0bdda5$var$folding ? $864e3137db0bdda5$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $864e3137db0bdda5$var$removeMultiDragElements();
                        $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl$1)) {
                            var update = false;
                            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $864e3137db0bdda5$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        $864e3137db0bdda5$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $864e3137db0bdda5$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $864e3137db0bdda5$var$dragStarted = false;
            $864e3137db0bdda5$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $864e3137db0bdda5$var$off(document, "pointerup", this._deselectMultiDrag);
            $864e3137db0bdda5$var$off(document, "mouseup", this._deselectMultiDrag);
            $864e3137db0bdda5$var$off(document, "touchend", this._deselectMultiDrag);
            $864e3137db0bdda5$var$off(document, "keydown", this._checkKeyDown);
            $864e3137db0bdda5$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $864e3137db0bdda5$var$dragStarted !== "undefined" && $864e3137db0bdda5$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($864e3137db0bdda5$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $864e3137db0bdda5$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($864e3137db0bdda5$var$multiDragElements.length){
                var el = $864e3137db0bdda5$var$multiDragElements[0];
                $864e3137db0bdda5$var$toggleClass(el, this.options.selectedClass, false);
                $864e3137db0bdda5$var$multiDragElements.shift();
                $864e3137db0bdda5$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $864e3137db0bdda5$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$864e3137db0bdda5$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$864e3137db0bdda5$var$multiDragElements.indexOf(el)) return;
                if ($864e3137db0bdda5$var$multiDragSortable && $864e3137db0bdda5$var$multiDragSortable !== sortable) {
                    $864e3137db0bdda5$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $864e3137db0bdda5$var$multiDragSortable = sortable;
                }
                $864e3137db0bdda5$var$toggleClass(el, sortable.options.selectedClass, true);
                $864e3137db0bdda5$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$864e3137db0bdda5$var$expando], index = $864e3137db0bdda5$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $864e3137db0bdda5$var$toggleClass(el, sortable.options.selectedClass, false);
                $864e3137db0bdda5$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($864e3137db0bdda5$var$folding && multiDragElement !== $864e3137db0bdda5$var$dragEl$1) newIndex = -1;
                else if ($864e3137db0bdda5$var$folding) newIndex = $864e3137db0bdda5$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $864e3137db0bdda5$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $864e3137db0bdda5$var$_toConsumableArray($864e3137db0bdda5$var$multiDragElements),
                clones: [].concat($864e3137db0bdda5$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $864e3137db0bdda5$var$insertMultiDragElements(clonesInserted, rootEl) {
    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $864e3137db0bdda5$var$insertMultiDragClones(elementsInserted, rootEl) {
    $864e3137db0bdda5$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $864e3137db0bdda5$var$removeMultiDragElements() {
    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
var $864e3137db0bdda5$export$2e2bcd8739ae039 = $864e3137db0bdda5$export$31b3ca70d8f57423;





class $00e16369510e6292$export$3f10bfc286408f86 {
    constructor(){
        this.init = (dropzoneElement, dropzoneOptions, csrf, dataToLoad, onDataSave)=>{
            this.url = dropzoneOptions.url;
            this.urlPreview = dropzoneOptions.urlPreview || dropzoneOptions.url;
            this.onDataSave = onDataSave;
            this.uploadPhotos = dropzoneElement;
            this.uploadPhotosDropzone = new (0, $c180364cf43a262f$export$2e2bcd8739ae039)(this.uploadPhotos, dropzoneOptions);
            this.populateExistingData(dataToLoad);
            this.addSortability();
            this.uploadPhotosDropzone.on("sending", (file, xhr, formData)=>{
                formData.append("_csrf", csrf);
            });
            this.uploadPhotosDropzone.on("success", (file, response)=>{
                file.upload.key = response;
                let thumbnailUrl = this.urlPreview + "/" + response;
                file.dataURL = thumbnailUrl;
                this.uploadPhotosDropzone.emit("thumbnail", file, thumbnailUrl);
                this.updatePhotoData();
            });
            this.uploadPhotosDropzone.on("removedfile", (file)=>{
                this.updatePhotoData();
                if (!file || !file.upload || !file.upload.key) return;
                // Call endpoint and remove photo if it's not used anywhere else
                fetch(this.url + "/" + file.upload.key, {
                    method: "DELETE",
                    body: JSON.stringify({
                        _csrf: csrf
                    })
                }).then((response)=>{
                // Ignore
                }).catch((error)=>{
                // Ignore
                });
            });
        };
        this.updatePhotoData = ()=>{
            let photos = [];
            for (let file of this.uploadPhotosDropzone.files){
                if (!file || !file.upload || !file.upload.key) continue;
                let data = {
                    key: file.upload.key,
                    name: file.upload.filename,
                    sizeBytes: file.upload.total
                };
                photos.push(data);
            }
            if ($00e16369510e6292$export$3f10bfc286408f86.DEBUG) console.info("Dropzone keys order: ", photos);
            let photosData = JSON.stringify(photos);
            if (this.onDataSave) this.onDataSave(photosData);
        };
        this.populateExistingData = (dataToLoad)=>{
            if (!!dataToLoad && dataToLoad.length > 0) {
                if (typeof dataToLoad === "string") dataToLoad = JSON.parse(dataToLoad);
            } else dataToLoad = [];
            for (let data of dataToLoad){
                let url = this.urlPreview + "/" + data.key;
                let mimeType = data.mimetype;
                if (mimeType) {
                    if (!mimeType.includes("image")) mimeType = "image/" + mimeType;
                } else mimeType = "image/*";
                let file = {
                    key: data.key,
                    name: data.name,
                    size: data.sizeBytes,
                    type: mimeType,
                    status: (0, $c180364cf43a262f$export$2e2bcd8739ae039).ADDED,
                    url: url,
                    upload: {
                        key: data.key,
                        filename: data.name,
                        total: data.sizeBytes
                    }
                };
                this.uploadPhotosDropzone.files.push(file);
                this.uploadPhotosDropzone.emit("addedfile", file);
                this.uploadPhotosDropzone.emit("thumbnail", file, url);
                this.uploadPhotosDropzone.emit("complete", file);
            }
        };
        this.addSortability = ()=>{
            let sortable = new (0, $864e3137db0bdda5$export$2e2bcd8739ae039)(this.uploadPhotos, {
                draggable: ".dz-preview",
                animation: 150,
                onStart: (evt)=>{
                    evt.item.dataset.dragStartPos = evt.oldIndex.toString();
                },
                onSort: (evt)=>{
                    evt.item.dataset.dragFinishPos = evt.newIndex.toString();
                    let startPos = Number(evt.item.dataset.dragStartPos) - 1;
                    let finishPos = Number(evt.item.dataset.dragFinishPos) - 1;
                    startPos = Math.max(0, startPos);
                    finishPos = Math.min(this.uploadPhotosDropzone.files.length - 1, finishPos);
                    if ($00e16369510e6292$export$3f10bfc286408f86.DEBUG) console.info("Moved from:: ", startPos, " to ", finishPos);
                    // Move files
                    let element = this.uploadPhotosDropzone.files[startPos];
                    this.uploadPhotosDropzone.files.splice(startPos, 1);
                    this.uploadPhotosDropzone.files.splice(finishPos, 0, element);
                    this.updatePhotoData();
                }
            });
        };
    }
}
$00e16369510e6292$export$3f10bfc286408f86.DEBUG = false;
$00e16369510e6292$export$3f10bfc286408f86.setupDropzones = ()=>{
    const dropzones = document.querySelectorAll(".component-dropzone");
    if (dropzones && dropzones.length > 0) {
        const csrf = document.querySelector("input[name='_csrf']").getAttribute("value");
        for (const dropzone of dropzones){
            const dropzoneOrdered = new $00e16369510e6292$export$3f10bfc286408f86();
            const name = dropzone.getAttribute("data-name");
            var _dropzone_getAttribute, _dropzone_getAttribute1, _dropzone_getAttribute2, _dropzone_getAttribute3, _dropzone_getAttribute4;
            dropzoneOrdered.init(dropzone, {
                url: (_dropzone_getAttribute = dropzone.getAttribute("data-url")) !== null && _dropzone_getAttribute !== void 0 ? _dropzone_getAttribute : location.pathname,
                acceptedFiles: (_dropzone_getAttribute1 = dropzone.getAttribute("data-accepted-files")) !== null && _dropzone_getAttribute1 !== void 0 ? _dropzone_getAttribute1 : "*/*",
                paramName: dropzone.getAttribute("data-name"),
                addRemoveLinks: dropzone.getAttribute("data-add-remove-links") == "true",
                parallelUploads: parseInt((_dropzone_getAttribute2 = dropzone.getAttribute("data-parallel-uploads")) !== null && _dropzone_getAttribute2 !== void 0 ? _dropzone_getAttribute2 : "5"),
                maxFilesize: parseInt((_dropzone_getAttribute3 = dropzone.getAttribute("data-max-file-size-mb")) !== null && _dropzone_getAttribute3 !== void 0 ? _dropzone_getAttribute3 : "1"),
                maxFiles: parseInt((_dropzone_getAttribute4 = dropzone.getAttribute("data-max-files")) !== null && _dropzone_getAttribute4 !== void 0 ? _dropzone_getAttribute4 : "10")
            }, csrf, document.querySelector("input[name='" + name + "']").getAttribute("value"), (data)=>{
                document.querySelector("input[name='" + name + "']").setAttribute("value", data);
            });
        }
    }
};





var $23aee52180e1383d$exports = {};
/** Cookies EU banner v2.0.1 by Alex-D - alex-d.github.io/Cookies-EU-banner/ - MIT License */ !function(e, t) {
    "use strict";
    "function" == typeof define && define.amd ? define([], t) : $23aee52180e1383d$exports = t();
}(window, function() {
    "use strict";
    var i, u = window.document;
    return (i = function(e, t, o, n) {
        if (!(this instanceof i)) return new i(e);
        this.cookieTimeout = 33696e6, this.bots = /bot|crawler|spider|crawling/i, this.cookieName = "hasConsent", this.trackingCookiesNames = [
            "__utma",
            "__utmb",
            "__utmc",
            "__utmt",
            "__utmv",
            "__utmz",
            "_ga",
            "_gat",
            "_gid"
        ], this.launchFunction = e, this.waitAccept = t || !1, this.useLocalStorage = o || !1, this.init();
    }).prototype = {
        init: function() {
            var e = this.bots.test(navigator.userAgent), t = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
            return e || !(null == t || t && "yes" !== t && 1 !== t && "1" !== t) || !1 === this.hasConsent() ? (this.removeBanner(0), !1) : !0 === this.hasConsent() ? (this.launchFunction(), !0) : (this.showBanner(), void (this.waitAccept || this.setConsent(!0)));
        },
        showBanner: function() {
            var e = this, t = u.getElementById.bind(u), o = t("cookies-eu-banner"), n = t("cookies-eu-reject"), i = t("cookies-eu-accept"), s = t("cookies-eu-more"), a = void 0 === o.dataset.waitRemove ? 0 : parseInt(o.dataset.waitRemove), c = this.addClickListener, r = e.removeBanner.bind(e, a);
            o.style.display = "block", s && c(s, function() {
                e.deleteCookie(e.cookieName);
            }), i && c(i, function() {
                r(), e.setConsent(!0), e.launchFunction();
            }), n && c(n, function() {
                r(), e.setConsent(!1), e.trackingCookiesNames.map(e.deleteCookie);
            });
        },
        setConsent: function(e) {
            if (this.useLocalStorage) return localStorage.setItem(this.cookieName, e);
            this.setCookie(this.cookieName, e);
        },
        hasConsent: function() {
            function e(e) {
                return -1 < u.cookie.indexOf(t + "=" + e) || localStorage.getItem(t) === e;
            }
            var t = this.cookieName;
            return !!e("true") || !e("false") && null;
        },
        setCookie: function(e, t) {
            var o = new Date;
            o.setTime(o.getTime() + this.cookieTimeout), u.cookie = e + "=" + t + ";expires=" + o.toGMTString() + ";path=/";
        },
        deleteCookie: function(e) {
            var t = u.location.hostname.replace(/^www\./, ""), o = "; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";
            u.cookie = e + "=; domain=." + t + o, u.cookie = e + "=" + o;
        },
        addClickListener: function(e, t) {
            if (e.attachEvent) return e.attachEvent("onclick", t);
            e.addEventListener("click", t);
        },
        removeBanner: function(e) {
            setTimeout(function() {
                var e = u.getElementById("cookies-eu-banner");
                e && e.parentNode && e.parentNode.removeChild(e);
            }, e);
        }
    }, i;
});


class $e73952d971edfb9c$export$9ed9778d182ca50d {
    static init(theme = "light") {
        var _0x4AAAAAAA0uFFY5b683SVm2;
        $e73952d971edfb9c$export$9ed9778d182ca50d.theme = theme;
        if (((_0x4AAAAAAA0uFFY5b683SVm2 = "0x4AAAAAAA0uFFY5b683SVm2") === null || _0x4AAAAAAA0uFFY5b683SVm2 === void 0 ? void 0 : _0x4AAAAAAA0uFFY5b683SVm2.trim().length) === 0) return;
        window.onloadTurnstileCallback = ()=>{
            this.initCloudflareTurnslide();
        };
    }
    static initCloudflareTurnslide() {
        turnstile.render("#cloudFlareTurnslide", {
            sitekey: "0x4AAAAAAA0uFFY5b683SVm2",
            theme: $e73952d971edfb9c$export$9ed9778d182ca50d.theme,
            callback: (token)=>{
            // Challenge completed successfuly
            }
        });
    }
}
$e73952d971edfb9c$export$9ed9778d182ca50d.theme = "light";


class $bd361655b21580a8$export$da8e434173032913 {
    constructor(){
        this.getPageId = ()=>"login";
        this.execute = ()=>{
            (0, $e73952d971edfb9c$export$9ed9778d182ca50d).init();
        };
        this.onPageClose = ()=>{};
    }
}



class $20b022f25952f45b$export$a2620940eeb97752 {
    constructor(){
        this.getPageId = ()=>"apply-for-job";
        this.execute = ()=>{
            (0, $e73952d971edfb9c$export$9ed9778d182ca50d).init();
        };
        this.onPageClose = ()=>{};
    }
}


const $6c481b2984ee262b$var$onPageLoaded = ()=>{
    (0, $0a18fe21f97a9265$export$e50f980c0075fdab)();
    (0, $53bcafe1e92564e5$export$85b261bbf29b40ad)();
    (0, $00e16369510e6292$export$3f10bfc286408f86).setupDropzones();
};
const $6c481b2984ee262b$var$app = new (0, $63b595d905f6b553$export$9bbedc1992a787b4)($6c481b2984ee262b$var$onPageLoaded);
const $6c481b2984ee262b$var$pages = [];
$6c481b2984ee262b$var$pages.push(new (0, $bd361655b21580a8$export$da8e434173032913)());
$6c481b2984ee262b$var$pages.push(new (0, $a5749f8efb25cf9e$export$593bf50f5d507e87)($6c481b2984ee262b$var$app));
$6c481b2984ee262b$var$pages.push(new (0, $5b7e74f852b2f3a3$export$144fe67517e25632)());
$6c481b2984ee262b$var$pages.push(new (0, $e24adf5565053909$export$597baf776692ed1e)());
$6c481b2984ee262b$var$pages.push(new (0, $20b022f25952f45b$export$a2620940eeb97752)());
$6c481b2984ee262b$var$app.start($6c481b2984ee262b$var$pages);
window.CookiesEuBanner = (0, (/*@__PURE__*/$parcel$interopDefault($23aee52180e1383d$exports)));
new (0, (/*@__PURE__*/$parcel$interopDefault($23aee52180e1383d$exports)))(()=>{
// On cookies accepted
});

})();
//# sourceMappingURL=App.js.map
